var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComingSoon = function SvgComingSoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "coming-soon_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 420.1 265.2",
    style: {
      enableBackground: "new 0 0 420.1 265.2"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".coming-soon_svg__st1,.coming-soon_svg__st2,.coming-soon_svg__st3,.coming-soon_svg__st4,.coming-soon_svg__st5{fill-rule:evenodd;clip-rule:evenodd;fill:#6da4f0}.coming-soon_svg__st2,.coming-soon_svg__st3,.coming-soon_svg__st4,.coming-soon_svg__st5{fill:#6ea2ed}.coming-soon_svg__st3,.coming-soon_svg__st4,.coming-soon_svg__st5{fill:#6fa3e9}.coming-soon_svg__st4,.coming-soon_svg__st5{fill:#70a3e8}.coming-soon_svg__st5{fill:#71a1e6}.coming-soon_svg__st10,.coming-soon_svg__st11,.coming-soon_svg__st12,.coming-soon_svg__st6,.coming-soon_svg__st7,.coming-soon_svg__st8,.coming-soon_svg__st9{fill-rule:evenodd;clip-rule:evenodd;fill:#70a1e3}.coming-soon_svg__st10,.coming-soon_svg__st11,.coming-soon_svg__st12,.coming-soon_svg__st7,.coming-soon_svg__st8,.coming-soon_svg__st9{fill:#719fe0}.coming-soon_svg__st10,.coming-soon_svg__st11,.coming-soon_svg__st12,.coming-soon_svg__st8,.coming-soon_svg__st9{fill:#729fde}.coming-soon_svg__st10,.coming-soon_svg__st11,.coming-soon_svg__st12,.coming-soon_svg__st9{fill:#739fdc}.coming-soon_svg__st10,.coming-soon_svg__st11,.coming-soon_svg__st12{fill:#749ed8}.coming-soon_svg__st11,.coming-soon_svg__st12{fill:#759cd6}.coming-soon_svg__st12{fill:#759cd4}.coming-soon_svg__st13,.coming-soon_svg__st14,.coming-soon_svg__st15,.coming-soon_svg__st16,.coming-soon_svg__st17,.coming-soon_svg__st18{fill-rule:evenodd;clip-rule:evenodd;fill:#769ad1}.coming-soon_svg__st14,.coming-soon_svg__st15,.coming-soon_svg__st16,.coming-soon_svg__st17,.coming-soon_svg__st18{fill:#769bcf}.coming-soon_svg__st15,.coming-soon_svg__st16,.coming-soon_svg__st17,.coming-soon_svg__st18{fill:#789bcd}.coming-soon_svg__st16,.coming-soon_svg__st17,.coming-soon_svg__st18{fill:#7999ca}.coming-soon_svg__st17,.coming-soon_svg__st18{fill:#7999c7}.coming-soon_svg__st18{fill:#7b98c5}.coming-soon_svg__st19,.coming-soon_svg__st20,.coming-soon_svg__st21,.coming-soon_svg__st22,.coming-soon_svg__st23,.coming-soon_svg__st24{fill-rule:evenodd;clip-rule:evenodd;fill:#7b98c3}.coming-soon_svg__st20,.coming-soon_svg__st21,.coming-soon_svg__st22,.coming-soon_svg__st23,.coming-soon_svg__st24{fill:#7c96c0}.coming-soon_svg__st21,.coming-soon_svg__st22,.coming-soon_svg__st23,.coming-soon_svg__st24{fill:#7d97be}.coming-soon_svg__st22,.coming-soon_svg__st23,.coming-soon_svg__st24{fill:#7e95bb}.coming-soon_svg__st23,.coming-soon_svg__st24{fill:#7e95b8}.coming-soon_svg__st24{fill:#8095b6}.coming-soon_svg__st25,.coming-soon_svg__st26,.coming-soon_svg__st27,.coming-soon_svg__st28,.coming-soon_svg__st29,.coming-soon_svg__st30{fill-rule:evenodd;clip-rule:evenodd;fill:#8093b4}.coming-soon_svg__st26,.coming-soon_svg__st27,.coming-soon_svg__st28,.coming-soon_svg__st29,.coming-soon_svg__st30{fill:#8193b1}.coming-soon_svg__st27,.coming-soon_svg__st28,.coming-soon_svg__st29,.coming-soon_svg__st30{fill:#8292af}.coming-soon_svg__st28,.coming-soon_svg__st29,.coming-soon_svg__st30{fill:#8290ad}.coming-soon_svg__st29,.coming-soon_svg__st30{fill:#8491aa}.coming-soon_svg__st30{fill:#8491a8}.coming-soon_svg__st31,.coming-soon_svg__st32,.coming-soon_svg__st33,.coming-soon_svg__st34,.coming-soon_svg__st35,.coming-soon_svg__st36{fill-rule:evenodd;clip-rule:evenodd;fill:#858fa5}.coming-soon_svg__st32,.coming-soon_svg__st33,.coming-soon_svg__st34,.coming-soon_svg__st35,.coming-soon_svg__st36{fill:#878fa3}.coming-soon_svg__st33,.coming-soon_svg__st34,.coming-soon_svg__st35,.coming-soon_svg__st36{fill:#878da0}.coming-soon_svg__st34,.coming-soon_svg__st35,.coming-soon_svg__st36{fill:#898d9e}.coming-soon_svg__st35,.coming-soon_svg__st36{fill:#8a8d9c}.coming-soon_svg__st36{fill:#8a8d99}.coming-soon_svg__st37,.coming-soon_svg__st38,.coming-soon_svg__st39,.coming-soon_svg__st40,.coming-soon_svg__st41,.coming-soon_svg__st42{fill-rule:evenodd;clip-rule:evenodd;fill:#8c8b97}.coming-soon_svg__st38,.coming-soon_svg__st39,.coming-soon_svg__st40,.coming-soon_svg__st41,.coming-soon_svg__st42{fill:#8d8b95}.coming-soon_svg__st39,.coming-soon_svg__st40,.coming-soon_svg__st41,.coming-soon_svg__st42{fill:#8e8992}.coming-soon_svg__st40,.coming-soon_svg__st41,.coming-soon_svg__st42{fill:#8f8990}.coming-soon_svg__st41,.coming-soon_svg__st42{fill:#8f898e}.coming-soon_svg__st42{fill:#91888b}.coming-soon_svg__st43,.coming-soon_svg__st44,.coming-soon_svg__st45,.coming-soon_svg__st46,.coming-soon_svg__st47,.coming-soon_svg__st48{fill-rule:evenodd;clip-rule:evenodd;fill:#938889}.coming-soon_svg__st44,.coming-soon_svg__st45,.coming-soon_svg__st46,.coming-soon_svg__st47,.coming-soon_svg__st48{fill:#938687}.coming-soon_svg__st45,.coming-soon_svg__st46,.coming-soon_svg__st47,.coming-soon_svg__st48{fill:#958684}.coming-soon_svg__st46,.coming-soon_svg__st47,.coming-soon_svg__st48{fill:#978582}.coming-soon_svg__st47,.coming-soon_svg__st48{fill:#968580}.coming-soon_svg__st48{fill:#98847e}.coming-soon_svg__st49,.coming-soon_svg__st50,.coming-soon_svg__st51,.coming-soon_svg__st52,.coming-soon_svg__st53,.coming-soon_svg__st54{fill-rule:evenodd;clip-rule:evenodd;fill:#99847d}.coming-soon_svg__st50,.coming-soon_svg__st51,.coming-soon_svg__st52,.coming-soon_svg__st53,.coming-soon_svg__st54{fill:#9b847b}.coming-soon_svg__st51,.coming-soon_svg__st52,.coming-soon_svg__st53,.coming-soon_svg__st54{fill:#9c8278}.coming-soon_svg__st52,.coming-soon_svg__st53,.coming-soon_svg__st54{fill:#9c8276}.coming-soon_svg__st53,.coming-soon_svg__st54{fill:#9f8174}.coming-soon_svg__st54{fill:#9f8072}.coming-soon_svg__st55,.coming-soon_svg__st56,.coming-soon_svg__st57,.coming-soon_svg__st58,.coming-soon_svg__st59,.coming-soon_svg__st60{fill-rule:evenodd;clip-rule:evenodd;fill:#a0806f}.coming-soon_svg__st56,.coming-soon_svg__st57,.coming-soon_svg__st58,.coming-soon_svg__st59,.coming-soon_svg__st60{fill:#a2806d}.coming-soon_svg__st57,.coming-soon_svg__st58,.coming-soon_svg__st59,.coming-soon_svg__st60{fill:#a47f6c}.coming-soon_svg__st58,.coming-soon_svg__st59,.coming-soon_svg__st60{fill:#a47f69}.coming-soon_svg__st59,.coming-soon_svg__st60{fill:#a47e67}.coming-soon_svg__st60{fill:#a67e65}.coming-soon_svg__st61,.coming-soon_svg__st62,.coming-soon_svg__st63,.coming-soon_svg__st64,.coming-soon_svg__st65,.coming-soon_svg__st66{fill-rule:evenodd;clip-rule:evenodd;fill:#a87e62}.coming-soon_svg__st62,.coming-soon_svg__st63,.coming-soon_svg__st64,.coming-soon_svg__st65,.coming-soon_svg__st66{fill:#aa7c61}.coming-soon_svg__st63,.coming-soon_svg__st64,.coming-soon_svg__st65,.coming-soon_svg__st66{fill:#aa7b5f}.coming-soon_svg__st64,.coming-soon_svg__st65,.coming-soon_svg__st66{fill:#ad7c5c}.coming-soon_svg__st65,.coming-soon_svg__st66{fill:#ad7c5a}.coming-soon_svg__st66{fill:#ae7a59}.coming-soon_svg__st67,.coming-soon_svg__st68,.coming-soon_svg__st69,.coming-soon_svg__st70,.coming-soon_svg__st71,.coming-soon_svg__st72{fill-rule:evenodd;clip-rule:evenodd;fill:#b07a56}.coming-soon_svg__st68,.coming-soon_svg__st69,.coming-soon_svg__st70,.coming-soon_svg__st71,.coming-soon_svg__st72{fill:#b17954}.coming-soon_svg__st69,.coming-soon_svg__st70,.coming-soon_svg__st71,.coming-soon_svg__st72{fill:#b37953}.coming-soon_svg__st70,.coming-soon_svg__st71,.coming-soon_svg__st72{fill:#b57951}.coming-soon_svg__st71,.coming-soon_svg__st72{fill:#b5774e}.coming-soon_svg__st72{fill:#b6774d}.coming-soon_svg__st73,.coming-soon_svg__st74,.coming-soon_svg__st75,.coming-soon_svg__st76,.coming-soon_svg__st77,.coming-soon_svg__st78{fill-rule:evenodd;clip-rule:evenodd;fill:#b8774b}.coming-soon_svg__st74,.coming-soon_svg__st75,.coming-soon_svg__st76,.coming-soon_svg__st77,.coming-soon_svg__st78{fill:#b97549}.coming-soon_svg__st75,.coming-soon_svg__st76,.coming-soon_svg__st77,.coming-soon_svg__st78{fill:#bb7547}.coming-soon_svg__st76,.coming-soon_svg__st77,.coming-soon_svg__st78{fill:#bb7546}.coming-soon_svg__st77,.coming-soon_svg__st78{fill:#bd7443}.coming-soon_svg__st78{fill:#bf7442}.coming-soon_svg__st79,.coming-soon_svg__st80,.coming-soon_svg__st81,.coming-soon_svg__st82,.coming-soon_svg__st83,.coming-soon_svg__st84{fill-rule:evenodd;clip-rule:evenodd;fill:#c07240}.coming-soon_svg__st80,.coming-soon_svg__st81,.coming-soon_svg__st82,.coming-soon_svg__st83,.coming-soon_svg__st84{fill:#c27340}.coming-soon_svg__st81,.coming-soon_svg__st82,.coming-soon_svg__st83,.coming-soon_svg__st84{fill:#c4733d}.coming-soon_svg__st82,.coming-soon_svg__st83,.coming-soon_svg__st84{fill:#c4723b}.coming-soon_svg__st83,.coming-soon_svg__st84{fill:#c5703a}.coming-soon_svg__st84{fill:#c67138}.coming-soon_svg__st85,.coming-soon_svg__st86,.coming-soon_svg__st87,.coming-soon_svg__st88,.coming-soon_svg__st89,.coming-soon_svg__st90{fill-rule:evenodd;clip-rule:evenodd;fill:#c87136}.coming-soon_svg__st86,.coming-soon_svg__st87,.coming-soon_svg__st88,.coming-soon_svg__st89,.coming-soon_svg__st90{fill:#ca6f36}.coming-soon_svg__st87,.coming-soon_svg__st88,.coming-soon_svg__st89,.coming-soon_svg__st90{fill:#ca6f33}.coming-soon_svg__st88,.coming-soon_svg__st89,.coming-soon_svg__st90{fill:#cd6e32}.coming-soon_svg__st89,.coming-soon_svg__st90{fill:#cd6e30}.coming-soon_svg__st90{fill:#cf6e30}.coming-soon_svg__st91,.coming-soon_svg__st92,.coming-soon_svg__st93,.coming-soon_svg__st94,.coming-soon_svg__st95,.coming-soon_svg__st96{fill-rule:evenodd;clip-rule:evenodd;fill:#d16e2e}.coming-soon_svg__st92,.coming-soon_svg__st93,.coming-soon_svg__st94,.coming-soon_svg__st95,.coming-soon_svg__st96{fill:#d36c2c}.coming-soon_svg__st93,.coming-soon_svg__st94,.coming-soon_svg__st95,.coming-soon_svg__st96{fill:#d46b2a}.coming-soon_svg__st94,.coming-soon_svg__st95,.coming-soon_svg__st96{fill:#d66b29}.coming-soon_svg__st95,.coming-soon_svg__st96{fill:#d86b28}.coming-soon_svg__st96{fill:#da6a27}.coming-soon_svg__st100,.coming-soon_svg__st101,.coming-soon_svg__st102,.coming-soon_svg__st97,.coming-soon_svg__st98,.coming-soon_svg__st99{fill-rule:evenodd;clip-rule:evenodd;fill:#da6a26}.coming-soon_svg__st100,.coming-soon_svg__st101,.coming-soon_svg__st102,.coming-soon_svg__st98,.coming-soon_svg__st99{fill:#dd6925}.coming-soon_svg__st100,.coming-soon_svg__st101,.coming-soon_svg__st102,.coming-soon_svg__st99{fill:#df6823}.coming-soon_svg__st100,.coming-soon_svg__st101,.coming-soon_svg__st102{fill:#e16823}.coming-soon_svg__st101,.coming-soon_svg__st102{fill:#e26722}.coming-soon_svg__st102{fill:#e46722}.coming-soon_svg__st103,.coming-soon_svg__st104,.coming-soon_svg__st105,.coming-soon_svg__st106,.coming-soon_svg__st107,.coming-soon_svg__st108{fill-rule:evenodd;clip-rule:evenodd;fill:#e46621}.coming-soon_svg__st104,.coming-soon_svg__st105,.coming-soon_svg__st106,.coming-soon_svg__st107,.coming-soon_svg__st108{fill:#e66621}.coming-soon_svg__st105,.coming-soon_svg__st106,.coming-soon_svg__st107,.coming-soon_svg__st108{fill:#e86620}.coming-soon_svg__st106,.coming-soon_svg__st107,.coming-soon_svg__st108{fill:#ea6520}.coming-soon_svg__st107,.coming-soon_svg__st108{fill:#ea6620}.coming-soon_svg__st108{fill:#ea6820}.coming-soon_svg__st109,.coming-soon_svg__st110,.coming-soon_svg__st111,.coming-soon_svg__st112,.coming-soon_svg__st113,.coming-soon_svg__st114{fill-rule:evenodd;clip-rule:evenodd;fill:#eb6a20}.coming-soon_svg__st110,.coming-soon_svg__st111,.coming-soon_svg__st112,.coming-soon_svg__st113,.coming-soon_svg__st114{fill:#eb6b20}.coming-soon_svg__st111,.coming-soon_svg__st112,.coming-soon_svg__st113,.coming-soon_svg__st114{fill:#eb6c20}.coming-soon_svg__st112,.coming-soon_svg__st113,.coming-soon_svg__st114{fill:#eb6e21}.coming-soon_svg__st113,.coming-soon_svg__st114{fill:#eb6f21}.coming-soon_svg__st114{fill:#eb7121}.coming-soon_svg__st115,.coming-soon_svg__st116,.coming-soon_svg__st117,.coming-soon_svg__st118,.coming-soon_svg__st119,.coming-soon_svg__st120{fill-rule:evenodd;clip-rule:evenodd;fill:#eb7221}.coming-soon_svg__st116,.coming-soon_svg__st117,.coming-soon_svg__st118,.coming-soon_svg__st119,.coming-soon_svg__st120{fill:#eb7422}.coming-soon_svg__st117,.coming-soon_svg__st118,.coming-soon_svg__st119,.coming-soon_svg__st120{fill:#eb7522}.coming-soon_svg__st118,.coming-soon_svg__st119,.coming-soon_svg__st120{fill:#eb7722}.coming-soon_svg__st119,.coming-soon_svg__st120{fill:#eb7822}.coming-soon_svg__st120{fill:#ec7a22}.coming-soon_svg__st121,.coming-soon_svg__st122,.coming-soon_svg__st123,.coming-soon_svg__st124,.coming-soon_svg__st125,.coming-soon_svg__st126{fill-rule:evenodd;clip-rule:evenodd;fill:#ec7b23}.coming-soon_svg__st122,.coming-soon_svg__st123,.coming-soon_svg__st124,.coming-soon_svg__st125,.coming-soon_svg__st126{fill:#ec7d23}.coming-soon_svg__st123,.coming-soon_svg__st124,.coming-soon_svg__st125,.coming-soon_svg__st126{fill:#ec7e23}.coming-soon_svg__st124,.coming-soon_svg__st125,.coming-soon_svg__st126{fill:#ec8023}.coming-soon_svg__st125,.coming-soon_svg__st126{fill:#ec8024}.coming-soon_svg__st126{fill:#ec8224}.coming-soon_svg__st127,.coming-soon_svg__st128,.coming-soon_svg__st129,.coming-soon_svg__st130,.coming-soon_svg__st131,.coming-soon_svg__st132{fill-rule:evenodd;clip-rule:evenodd;fill:#ec8324}.coming-soon_svg__st128,.coming-soon_svg__st129,.coming-soon_svg__st130,.coming-soon_svg__st131,.coming-soon_svg__st132{fill:#ec8524}.coming-soon_svg__st129,.coming-soon_svg__st130,.coming-soon_svg__st131,.coming-soon_svg__st132{fill:#ed8725}.coming-soon_svg__st130,.coming-soon_svg__st131,.coming-soon_svg__st132{fill:#ed8925}.coming-soon_svg__st131,.coming-soon_svg__st132{fill:#ed8a25}.coming-soon_svg__st132{fill:#ed8b25}.coming-soon_svg__st133,.coming-soon_svg__st134,.coming-soon_svg__st135,.coming-soon_svg__st136,.coming-soon_svg__st137,.coming-soon_svg__st138{fill-rule:evenodd;clip-rule:evenodd;fill:#ed8d26}.coming-soon_svg__st134,.coming-soon_svg__st135,.coming-soon_svg__st136,.coming-soon_svg__st137,.coming-soon_svg__st138{fill:#ed8f26}.coming-soon_svg__st135,.coming-soon_svg__st136,.coming-soon_svg__st137,.coming-soon_svg__st138{fill:#ed9026}.coming-soon_svg__st136,.coming-soon_svg__st137,.coming-soon_svg__st138{fill:#ee9226}.coming-soon_svg__st137,.coming-soon_svg__st138{fill:#ee9427}.coming-soon_svg__st138{fill:#ee9628}.coming-soon_svg__st139,.coming-soon_svg__st140,.coming-soon_svg__st141,.coming-soon_svg__st142,.coming-soon_svg__st143,.coming-soon_svg__st144{fill-rule:evenodd;clip-rule:evenodd;fill:#ee9828}.coming-soon_svg__st140,.coming-soon_svg__st141,.coming-soon_svg__st142,.coming-soon_svg__st143,.coming-soon_svg__st144{fill:#ee9928}.coming-soon_svg__st141,.coming-soon_svg__st142,.coming-soon_svg__st143,.coming-soon_svg__st144{fill:#ee9b29}.coming-soon_svg__st142,.coming-soon_svg__st143,.coming-soon_svg__st144{fill:#ee9d29}.coming-soon_svg__st143,.coming-soon_svg__st144{fill:#ee9c29}.coming-soon_svg__st144{fill:#ef9e2a}.coming-soon_svg__st145,.coming-soon_svg__st146,.coming-soon_svg__st147,.coming-soon_svg__st148,.coming-soon_svg__st149,.coming-soon_svg__st150{fill-rule:evenodd;clip-rule:evenodd;fill:#ef9f2a}.coming-soon_svg__st146,.coming-soon_svg__st147,.coming-soon_svg__st148,.coming-soon_svg__st149,.coming-soon_svg__st150{fill:#efa12a}.coming-soon_svg__st147,.coming-soon_svg__st148,.coming-soon_svg__st149,.coming-soon_svg__st150{fill:#efa32b}.coming-soon_svg__st148,.coming-soon_svg__st149,.coming-soon_svg__st150{fill:#efa52b}.coming-soon_svg__st149,.coming-soon_svg__st150{fill:#efa62c}.coming-soon_svg__st150{fill:#f0a82c}.coming-soon_svg__st151,.coming-soon_svg__st152,.coming-soon_svg__st153,.coming-soon_svg__st154,.coming-soon_svg__st155,.coming-soon_svg__st156{fill-rule:evenodd;clip-rule:evenodd;fill:#f0aa2d}.coming-soon_svg__st152,.coming-soon_svg__st153,.coming-soon_svg__st154,.coming-soon_svg__st155,.coming-soon_svg__st156{fill:#f0ac2d}.coming-soon_svg__st153,.coming-soon_svg__st154,.coming-soon_svg__st155,.coming-soon_svg__st156{fill:#f0ad2e}.coming-soon_svg__st154,.coming-soon_svg__st155,.coming-soon_svg__st156{fill:#f0af2e}.coming-soon_svg__st155,.coming-soon_svg__st156{fill:#fff}.coming-soon_svg__st156{fill:#fcffff}.coming-soon_svg__st157,.coming-soon_svg__st158,.coming-soon_svg__st159,.coming-soon_svg__st160,.coming-soon_svg__st161,.coming-soon_svg__st162{fill-rule:evenodd;clip-rule:evenodd;fill:#fcfcff}.coming-soon_svg__st158,.coming-soon_svg__st159,.coming-soon_svg__st160,.coming-soon_svg__st161,.coming-soon_svg__st162{fill:#fafbff}.coming-soon_svg__st159,.coming-soon_svg__st160,.coming-soon_svg__st161,.coming-soon_svg__st162{fill:#f8fbff}.coming-soon_svg__st160,.coming-soon_svg__st161,.coming-soon_svg__st162{fill:#f8f9ff}.coming-soon_svg__st161,.coming-soon_svg__st162{fill:#f5f9ff}.coming-soon_svg__st162{fill:#f2f6ff}.coming-soon_svg__st163,.coming-soon_svg__st164,.coming-soon_svg__st165,.coming-soon_svg__st166,.coming-soon_svg__st167,.coming-soon_svg__st168{fill-rule:evenodd;clip-rule:evenodd;fill:#f1f6ff}.coming-soon_svg__st164,.coming-soon_svg__st165,.coming-soon_svg__st166,.coming-soon_svg__st167,.coming-soon_svg__st168{fill:#eff6ff}.coming-soon_svg__st165,.coming-soon_svg__st166,.coming-soon_svg__st167,.coming-soon_svg__st168{fill:#edf4fd}.coming-soon_svg__st166,.coming-soon_svg__st167,.coming-soon_svg__st168{fill:#ebf3fd}.coming-soon_svg__st167,.coming-soon_svg__st168{fill:#e9f3fd}.coming-soon_svg__st168{fill:#e7f2fd}.coming-soon_svg__st169,.coming-soon_svg__st170,.coming-soon_svg__st171,.coming-soon_svg__st172,.coming-soon_svg__st174,.coming-soon_svg__st175{fill-rule:evenodd;clip-rule:evenodd;fill:#e6f0fd}.coming-soon_svg__st170,.coming-soon_svg__st171,.coming-soon_svg__st172,.coming-soon_svg__st174,.coming-soon_svg__st175{fill:#e4f0fd}.coming-soon_svg__st171,.coming-soon_svg__st172,.coming-soon_svg__st174,.coming-soon_svg__st175{fill:#e2f0fd}.coming-soon_svg__st172,.coming-soon_svg__st174,.coming-soon_svg__st175{fill:#e2eefd}.coming-soon_svg__st174,.coming-soon_svg__st175{fill:#f6f9ff}.coming-soon_svg__st175{fill:#f0f6fb}.coming-soon_svg__st176,.coming-soon_svg__st177,.coming-soon_svg__st178,.coming-soon_svg__st179,.coming-soon_svg__st180,.coming-soon_svg__st181{fill-rule:evenodd;clip-rule:evenodd;fill:#edf4fb}.coming-soon_svg__st177,.coming-soon_svg__st178,.coming-soon_svg__st179,.coming-soon_svg__st180,.coming-soon_svg__st181{fill:#ebf3fb}.coming-soon_svg__st178,.coming-soon_svg__st179,.coming-soon_svg__st180,.coming-soon_svg__st181{fill:#e9f3fb}.coming-soon_svg__st179,.coming-soon_svg__st180,.coming-soon_svg__st181{fill:#e6f0fb}.coming-soon_svg__st180,.coming-soon_svg__st181{fill:#e2eefb}.coming-soon_svg__st181{fill:#e0eefb}.coming-soon_svg__st182,.coming-soon_svg__st183,.coming-soon_svg__st184,.coming-soon_svg__st185,.coming-soon_svg__st186,.coming-soon_svg__st187{fill-rule:evenodd;clip-rule:evenodd;fill:#ddeafb}.coming-soon_svg__st183,.coming-soon_svg__st184,.coming-soon_svg__st185,.coming-soon_svg__st186,.coming-soon_svg__st187{fill:#dbeafb}.coming-soon_svg__st184,.coming-soon_svg__st185,.coming-soon_svg__st186,.coming-soon_svg__st187{fill:#d8e7fa}.coming-soon_svg__st185,.coming-soon_svg__st186,.coming-soon_svg__st187{fill:#d4e5fa}.coming-soon_svg__st186,.coming-soon_svg__st187{fill:#d2e5fa}.coming-soon_svg__st187{fill:#cde1fa}.coming-soon_svg__st188,.coming-soon_svg__st189,.coming-soon_svg__st190,.coming-soon_svg__st191,.coming-soon_svg__st192,.coming-soon_svg__st193{fill-rule:evenodd;clip-rule:evenodd;fill:#cbe1fa}.coming-soon_svg__st189,.coming-soon_svg__st190,.coming-soon_svg__st191,.coming-soon_svg__st192,.coming-soon_svg__st193{fill:#c8dffa}.coming-soon_svg__st190,.coming-soon_svg__st191,.coming-soon_svg__st192,.coming-soon_svg__st193{fill:#c4dcfa}.coming-soon_svg__st191,.coming-soon_svg__st192,.coming-soon_svg__st193{fill:#c1dafa}.coming-soon_svg__st192,.coming-soon_svg__st193{fill:#bedaf8}.coming-soon_svg__st193{fill:#bbd6f7}.coming-soon_svg__st194,.coming-soon_svg__st195,.coming-soon_svg__st196,.coming-soon_svg__st197,.coming-soon_svg__st198,.coming-soon_svg__st201{fill-rule:evenodd;clip-rule:evenodd;fill:#b7d6f7}.coming-soon_svg__st195,.coming-soon_svg__st196,.coming-soon_svg__st197,.coming-soon_svg__st198,.coming-soon_svg__st201{fill:#b4d4f7}.coming-soon_svg__st196,.coming-soon_svg__st197,.coming-soon_svg__st198,.coming-soon_svg__st201{fill:#b2d1f7}.coming-soon_svg__st197,.coming-soon_svg__st198,.coming-soon_svg__st201{fill:#aed0f7}.coming-soon_svg__st198,.coming-soon_svg__st201{fill:#accef7}.coming-soon_svg__st201{fill:#a3c9f7}.coming-soon_svg__st202,.coming-soon_svg__st203,.coming-soon_svg__st207,.coming-soon_svg__st210,.coming-soon_svg__st211,.coming-soon_svg__st212{fill-rule:evenodd;clip-rule:evenodd;fill:#a1c8f7}.coming-soon_svg__st203,.coming-soon_svg__st207,.coming-soon_svg__st210,.coming-soon_svg__st211,.coming-soon_svg__st212{fill:#9fc5f7}.coming-soon_svg__st207,.coming-soon_svg__st210,.coming-soon_svg__st211,.coming-soon_svg__st212{fill:#95c0f6}.coming-soon_svg__st210,.coming-soon_svg__st211,.coming-soon_svg__st212{fill:#90bdf4}.coming-soon_svg__st211,.coming-soon_svg__st212{fill:#8fbdf4}.coming-soon_svg__st212{fill:#8cbaf4}.coming-soon_svg__st213,.coming-soon_svg__st214,.coming-soon_svg__st215,.coming-soon_svg__st226,.coming-soon_svg__st227,.coming-soon_svg__st228{fill-rule:evenodd;clip-rule:evenodd;fill:#8bbaf4}.coming-soon_svg__st214,.coming-soon_svg__st215,.coming-soon_svg__st226,.coming-soon_svg__st227,.coming-soon_svg__st228{fill:#89b8f4}.coming-soon_svg__st215,.coming-soon_svg__st226,.coming-soon_svg__st227,.coming-soon_svg__st228{fill:#87b8f4}.coming-soon_svg__st226,.coming-soon_svg__st227,.coming-soon_svg__st228{fill:#b0d1f7}.coming-soon_svg__st227,.coming-soon_svg__st228{fill:#bcd9f7}.coming-soon_svg__st228{fill:#bfdaf8}.coming-soon_svg__st230,.coming-soon_svg__st231,.coming-soon_svg__st232,.coming-soon_svg__st233,.coming-soon_svg__st234,.coming-soon_svg__st235{fill-rule:evenodd;clip-rule:evenodd;fill:#d1e3fa}.coming-soon_svg__st231,.coming-soon_svg__st232,.coming-soon_svg__st233,.coming-soon_svg__st234,.coming-soon_svg__st235{fill:#d6e7fa}.coming-soon_svg__st232,.coming-soon_svg__st233,.coming-soon_svg__st234,.coming-soon_svg__st235{fill:#d9eafb}.coming-soon_svg__st233,.coming-soon_svg__st234,.coming-soon_svg__st235{fill:#dfebfb}.coming-soon_svg__st234,.coming-soon_svg__st235{fill:#e4f0fb}.coming-soon_svg__st235{fill:#e7f0fb}.coming-soon_svg__st236,.coming-soon_svg__st237,.coming-soon_svg__st238,.coming-soon_svg__st239,.coming-soon_svg__st240,.coming-soon_svg__st241{fill-rule:evenodd;clip-rule:evenodd;fill:#eff6fb}.coming-soon_svg__st237,.coming-soon_svg__st238,.coming-soon_svg__st239,.coming-soon_svg__st240,.coming-soon_svg__st241{fill:#ec7e25}.coming-soon_svg__st238,.coming-soon_svg__st239,.coming-soon_svg__st240,.coming-soon_svg__st241{fill:#ec8025}.coming-soon_svg__st239,.coming-soon_svg__st240,.coming-soon_svg__st241{fill:#ec8226}.coming-soon_svg__st240,.coming-soon_svg__st241{fill:#ec8326}.coming-soon_svg__st241{fill:#ed8526}.coming-soon_svg__st242,.coming-soon_svg__st243,.coming-soon_svg__st244,.coming-soon_svg__st245,.coming-soon_svg__st246,.coming-soon_svg__st247{fill-rule:evenodd;clip-rule:evenodd;fill:#ed8726}.coming-soon_svg__st243,.coming-soon_svg__st244,.coming-soon_svg__st245,.coming-soon_svg__st246,.coming-soon_svg__st247{fill:#ed8927}.coming-soon_svg__st244,.coming-soon_svg__st245,.coming-soon_svg__st246,.coming-soon_svg__st247{fill:#ed8a27}.coming-soon_svg__st245,.coming-soon_svg__st246,.coming-soon_svg__st247{fill:#ed8b27}.coming-soon_svg__st246,.coming-soon_svg__st247{fill:#ed8d27}.coming-soon_svg__st247{fill:#ed8d28}.coming-soon_svg__st248,.coming-soon_svg__st249,.coming-soon_svg__st250,.coming-soon_svg__st251,.coming-soon_svg__st252,.coming-soon_svg__st253{fill-rule:evenodd;clip-rule:evenodd;fill:#ed8f28}.coming-soon_svg__st249,.coming-soon_svg__st250,.coming-soon_svg__st251,.coming-soon_svg__st252,.coming-soon_svg__st253{fill:#ed9028}.coming-soon_svg__st250,.coming-soon_svg__st251,.coming-soon_svg__st252,.coming-soon_svg__st253{fill:#ee9228}.coming-soon_svg__st251,.coming-soon_svg__st252,.coming-soon_svg__st253{fill:#ee9429}.coming-soon_svg__st252,.coming-soon_svg__st253{fill:#ee9629}.coming-soon_svg__st253{fill:#ee9829}.coming-soon_svg__st254,.coming-soon_svg__st255,.coming-soon_svg__st256,.coming-soon_svg__st257,.coming-soon_svg__st258,.coming-soon_svg__st259{fill-rule:evenodd;clip-rule:evenodd;fill:#ee9929}.coming-soon_svg__st255,.coming-soon_svg__st256,.coming-soon_svg__st257,.coming-soon_svg__st258,.coming-soon_svg__st259{fill:#ee992a}.coming-soon_svg__st256,.coming-soon_svg__st257,.coming-soon_svg__st258,.coming-soon_svg__st259{fill:#ee9b2a}.coming-soon_svg__st257,.coming-soon_svg__st258,.coming-soon_svg__st259{fill:#ee9c2b}.coming-soon_svg__st258,.coming-soon_svg__st259{fill:#ef9e2b}.coming-soon_svg__st259{fill:#ef9f2b}.coming-soon_svg__st260,.coming-soon_svg__st261,.coming-soon_svg__st262,.coming-soon_svg__st263,.coming-soon_svg__st264,.coming-soon_svg__st265{fill-rule:evenodd;clip-rule:evenodd;fill:#efa12b}.coming-soon_svg__st261,.coming-soon_svg__st262,.coming-soon_svg__st263,.coming-soon_svg__st264,.coming-soon_svg__st265{fill:#efa32c}.coming-soon_svg__st262,.coming-soon_svg__st263,.coming-soon_svg__st264,.coming-soon_svg__st265{fill:#efa52c}.coming-soon_svg__st263,.coming-soon_svg__st264,.coming-soon_svg__st265{fill:#efa62d}.coming-soon_svg__st264,.coming-soon_svg__st265{fill:#f0a82d}.coming-soon_svg__st265{fill:#f0ac2e}.coming-soon_svg__st266,.coming-soon_svg__st267,.coming-soon_svg__st268,.coming-soon_svg__st269,.coming-soon_svg__st270,.coming-soon_svg__st271{fill-rule:evenodd;clip-rule:evenodd;fill:#ec7d24}.coming-soon_svg__st267,.coming-soon_svg__st268,.coming-soon_svg__st269,.coming-soon_svg__st270,.coming-soon_svg__st271{fill:#ec7b24}.coming-soon_svg__st268,.coming-soon_svg__st269,.coming-soon_svg__st270,.coming-soon_svg__st271{fill:#ec7a24}.coming-soon_svg__st269,.coming-soon_svg__st270,.coming-soon_svg__st271{fill:#eb7823}.coming-soon_svg__st270,.coming-soon_svg__st271{fill:#eb7723}.coming-soon_svg__st271{fill:#eb7523}.coming-soon_svg__st272,.coming-soon_svg__st273,.coming-soon_svg__st274,.coming-soon_svg__st275,.coming-soon_svg__st276,.coming-soon_svg__st277{fill-rule:evenodd;clip-rule:evenodd;fill:#eb7423}.coming-soon_svg__st273,.coming-soon_svg__st274,.coming-soon_svg__st275,.coming-soon_svg__st276,.coming-soon_svg__st277{fill:#eb7222}.coming-soon_svg__st274,.coming-soon_svg__st275,.coming-soon_svg__st276,.coming-soon_svg__st277{fill:#eb7122}.coming-soon_svg__st275,.coming-soon_svg__st276,.coming-soon_svg__st277{fill:#eb6f22}.coming-soon_svg__st276,.coming-soon_svg__st277{fill:#eb6c21}.coming-soon_svg__st277{fill:#eb6b21}.coming-soon_svg__st278,.coming-soon_svg__st279,.coming-soon_svg__st280,.coming-soon_svg__st281,.coming-soon_svg__st282,.coming-soon_svg__st283{fill-rule:evenodd;clip-rule:evenodd;fill:#eb6a21}.coming-soon_svg__st279,.coming-soon_svg__st280,.coming-soon_svg__st281,.coming-soon_svg__st282,.coming-soon_svg__st283{fill:#ea6821}.coming-soon_svg__st280,.coming-soon_svg__st281,.coming-soon_svg__st282,.coming-soon_svg__st283{fill:#ea6420}.coming-soon_svg__st281,.coming-soon_svg__st282,.coming-soon_svg__st283{fill:#ea6320}.coming-soon_svg__st282,.coming-soon_svg__st283{fill:#ea611f}.coming-soon_svg__st283{fill:#ea601f}.coming-soon_svg__st284,.coming-soon_svg__st285,.coming-soon_svg__st286,.coming-soon_svg__st287,.coming-soon_svg__st288,.coming-soon_svg__st289{fill-rule:evenodd;clip-rule:evenodd;fill:#ea5f1f}.coming-soon_svg__st285,.coming-soon_svg__st286,.coming-soon_svg__st287,.coming-soon_svg__st288,.coming-soon_svg__st289{fill:#ea5d1f}.coming-soon_svg__st286,.coming-soon_svg__st287,.coming-soon_svg__st288,.coming-soon_svg__st289{fill:#ea5c1e}.coming-soon_svg__st287,.coming-soon_svg__st288,.coming-soon_svg__st289{fill:#fcfcfc}.coming-soon_svg__st288,.coming-soon_svg__st289{fill:#457ce2}.coming-soon_svg__st289{fill:#467ee2}.coming-soon_svg__st291,.coming-soon_svg__st292,.coming-soon_svg__st293,.coming-soon_svg__st294,.coming-soon_svg__st295,.coming-soon_svg__st296{fill-rule:evenodd;clip-rule:evenodd;fill:#4780e2}.coming-soon_svg__st292,.coming-soon_svg__st293,.coming-soon_svg__st294,.coming-soon_svg__st295,.coming-soon_svg__st296{fill:#4880e2}.coming-soon_svg__st293,.coming-soon_svg__st294,.coming-soon_svg__st295,.coming-soon_svg__st296{fill:#4981e2}.coming-soon_svg__st294,.coming-soon_svg__st295,.coming-soon_svg__st296{fill:#4a81e2}.coming-soon_svg__st295,.coming-soon_svg__st296{fill:#4b83e2}.coming-soon_svg__st296{fill:#4c83e2}.coming-soon_svg__st300,.coming-soon_svg__st302,.coming-soon_svg__st303,.coming-soon_svg__st305,.coming-soon_svg__st309,.coming-soon_svg__st311{fill-rule:evenodd;clip-rule:evenodd;fill:#4f86e5}.coming-soon_svg__st302,.coming-soon_svg__st303,.coming-soon_svg__st305,.coming-soon_svg__st309,.coming-soon_svg__st311{fill:#5189e5}.coming-soon_svg__st303,.coming-soon_svg__st305,.coming-soon_svg__st309,.coming-soon_svg__st311{fill:#5289e5}.coming-soon_svg__st305,.coming-soon_svg__st309,.coming-soon_svg__st311{fill:#538be5}.coming-soon_svg__st309,.coming-soon_svg__st311{fill:#568de5}.coming-soon_svg__st311{fill:#588ee5}.coming-soon_svg__st313,.coming-soon_svg__st314,.coming-soon_svg__st317,.coming-soon_svg__st321,.coming-soon_svg__st323,.coming-soon_svg__st324{fill-rule:evenodd;clip-rule:evenodd;fill:#5a91e5}.coming-soon_svg__st314,.coming-soon_svg__st317,.coming-soon_svg__st321,.coming-soon_svg__st323,.coming-soon_svg__st324{fill:#5b91e5}.coming-soon_svg__st317,.coming-soon_svg__st321,.coming-soon_svg__st323,.coming-soon_svg__st324{fill:#5e93e7}.coming-soon_svg__st321,.coming-soon_svg__st323,.coming-soon_svg__st324{fill:#6196e7}.coming-soon_svg__st323,.coming-soon_svg__st324{fill:#6398e8}.coming-soon_svg__st324{fill:#6598e8}.coming-soon_svg__st325,.coming-soon_svg__st326,.coming-soon_svg__st328,.coming-soon_svg__st330,.coming-soon_svg__st333,.coming-soon_svg__st334{fill-rule:evenodd;clip-rule:evenodd;fill:#669be8}.coming-soon_svg__st326,.coming-soon_svg__st328,.coming-soon_svg__st330,.coming-soon_svg__st333,.coming-soon_svg__st334{fill:#689be8}.coming-soon_svg__st328,.coming-soon_svg__st330,.coming-soon_svg__st333,.coming-soon_svg__st334{fill:#6a9de8}.coming-soon_svg__st330,.coming-soon_svg__st333,.coming-soon_svg__st334{fill:#6c9ee8}.coming-soon_svg__st333,.coming-soon_svg__st334{fill:#6fa0e9}.coming-soon_svg__st334{fill:#71a3e9}.coming-soon_svg__st335,.coming-soon_svg__st337,.coming-soon_svg__st339,.coming-soon_svg__st343,.coming-soon_svg__st345,.coming-soon_svg__st346{fill-rule:evenodd;clip-rule:evenodd;fill:#72a3e9}.coming-soon_svg__st337,.coming-soon_svg__st339,.coming-soon_svg__st343,.coming-soon_svg__st345,.coming-soon_svg__st346{fill:#75a5e9}.coming-soon_svg__st339,.coming-soon_svg__st343,.coming-soon_svg__st345,.coming-soon_svg__st346{fill:#77a6eb}.coming-soon_svg__st343,.coming-soon_svg__st345,.coming-soon_svg__st346{fill:#7ba8eb}.coming-soon_svg__st345,.coming-soon_svg__st346{fill:#7dabec}.coming-soon_svg__st346{fill:#7eabec}.coming-soon_svg__st347,.coming-soon_svg__st351,.coming-soon_svg__st352,.coming-soon_svg__st353,.coming-soon_svg__st357,.coming-soon_svg__st360{fill-rule:evenodd;clip-rule:evenodd;fill:#80adec}.coming-soon_svg__st351,.coming-soon_svg__st352,.coming-soon_svg__st353,.coming-soon_svg__st357,.coming-soon_svg__st360{fill:#83b1ec}.coming-soon_svg__st352,.coming-soon_svg__st353,.coming-soon_svg__st357,.coming-soon_svg__st360{fill:#85b1ec}.coming-soon_svg__st353,.coming-soon_svg__st357,.coming-soon_svg__st360{fill:#87b3ec}.coming-soon_svg__st357,.coming-soon_svg__st360{fill:#8bb5ee}.coming-soon_svg__st360{fill:#8db6ee}.coming-soon_svg__st361,.coming-soon_svg__st362,.coming-soon_svg__st365,.coming-soon_svg__st366,.coming-soon_svg__st367,.coming-soon_svg__st369{fill-rule:evenodd;clip-rule:evenodd;fill:#8fb9ee}.coming-soon_svg__st362,.coming-soon_svg__st365,.coming-soon_svg__st366,.coming-soon_svg__st367,.coming-soon_svg__st369{fill:#91b9ee}.coming-soon_svg__st365,.coming-soon_svg__st366,.coming-soon_svg__st367,.coming-soon_svg__st369{fill:#94bbee}.coming-soon_svg__st366,.coming-soon_svg__st367,.coming-soon_svg__st369{fill:#95bbee}.coming-soon_svg__st367,.coming-soon_svg__st369{fill:#97bdee}.coming-soon_svg__st369{fill:#9ac0ef}.coming-soon_svg__st373,.coming-soon_svg__st374,.coming-soon_svg__st375,.coming-soon_svg__st377,.coming-soon_svg__st380,.coming-soon_svg__st381{fill-rule:evenodd;clip-rule:evenodd;fill:#9ec1f1}.coming-soon_svg__st374,.coming-soon_svg__st375,.coming-soon_svg__st377,.coming-soon_svg__st380,.coming-soon_svg__st381{fill:#a0c3f1}.coming-soon_svg__st375,.coming-soon_svg__st377,.coming-soon_svg__st380,.coming-soon_svg__st381{fill:#a2c3f1}.coming-soon_svg__st377,.coming-soon_svg__st380,.coming-soon_svg__st381{fill:#a4c6f1}.coming-soon_svg__st380,.coming-soon_svg__st381{fill:#a7c8f1}.coming-soon_svg__st381{fill:#a9c9f1}.coming-soon_svg__st382,.coming-soon_svg__st384,.coming-soon_svg__st387,.coming-soon_svg__st392,.coming-soon_svg__st393,.coming-soon_svg__st394{fill-rule:evenodd;clip-rule:evenodd;fill:#abc9f1}.coming-soon_svg__st384,.coming-soon_svg__st387,.coming-soon_svg__st392,.coming-soon_svg__st393,.coming-soon_svg__st394{fill:#adccf1}.coming-soon_svg__st387,.coming-soon_svg__st392,.coming-soon_svg__st393,.coming-soon_svg__st394{fill:#b1cef1}.coming-soon_svg__st392,.coming-soon_svg__st393,.coming-soon_svg__st394{fill:#b6d2f3}.coming-soon_svg__st393,.coming-soon_svg__st394{fill:#b8d2f3}.coming-soon_svg__st394{fill:#bad4f3}.coming-soon_svg__st395,.coming-soon_svg__st398,.coming-soon_svg__st400,.coming-soon_svg__st402,.coming-soon_svg__st403,.coming-soon_svg__st404{fill-rule:evenodd;clip-rule:evenodd;fill:#bbd4f3}.coming-soon_svg__st398,.coming-soon_svg__st400,.coming-soon_svg__st402,.coming-soon_svg__st403,.coming-soon_svg__st404{fill:#bfd7f5}.coming-soon_svg__st400,.coming-soon_svg__st402,.coming-soon_svg__st403,.coming-soon_svg__st404{fill:#c1d9f5}.coming-soon_svg__st402,.coming-soon_svg__st403,.coming-soon_svg__st404{fill:#c4daf5}.coming-soon_svg__st403,.coming-soon_svg__st404{fill:#c6daf5}.coming-soon_svg__st404{fill:#c8ddf6}.coming-soon_svg__st405,.coming-soon_svg__st407,.coming-soon_svg__st410,.coming-soon_svg__st413,.coming-soon_svg__st414,.coming-soon_svg__st416{fill-rule:evenodd;clip-rule:evenodd;fill:#caddf6}.coming-soon_svg__st407,.coming-soon_svg__st410,.coming-soon_svg__st413,.coming-soon_svg__st414,.coming-soon_svg__st416{fill:#cddff6}.coming-soon_svg__st410,.coming-soon_svg__st413,.coming-soon_svg__st414,.coming-soon_svg__st416{fill:#d1e2f6}.coming-soon_svg__st413,.coming-soon_svg__st414,.coming-soon_svg__st416{fill:#d6e5f8}.coming-soon_svg__st414,.coming-soon_svg__st416{fill:#d8e5f8}.coming-soon_svg__st416{fill:#dbe8f8}.coming-soon_svg__st418,.coming-soon_svg__st420,.coming-soon_svg__st421,.coming-soon_svg__st423,.coming-soon_svg__st424,.coming-soon_svg__st426{fill-rule:evenodd;clip-rule:evenodd;fill:#ddeaf8}.coming-soon_svg__st420,.coming-soon_svg__st421,.coming-soon_svg__st423,.coming-soon_svg__st424,.coming-soon_svg__st426{fill:#e0eaf8}.coming-soon_svg__st421,.coming-soon_svg__st423,.coming-soon_svg__st424,.coming-soon_svg__st426{fill:#e2ecf9}.coming-soon_svg__st423,.coming-soon_svg__st424,.coming-soon_svg__st426{fill:#e4eef9}.coming-soon_svg__st424,.coming-soon_svg__st426{fill:#e6eef9}.coming-soon_svg__st426{fill:#e9f0f9}.coming-soon_svg__st428,.coming-soon_svg__st429,.coming-soon_svg__st430,.coming-soon_svg__st431,.coming-soon_svg__st432,.coming-soon_svg__st435{fill-rule:evenodd;clip-rule:evenodd;fill:#edf3fb}.coming-soon_svg__st429,.coming-soon_svg__st430,.coming-soon_svg__st431,.coming-soon_svg__st432,.coming-soon_svg__st435{fill:#eef4fb}.coming-soon_svg__st430,.coming-soon_svg__st431,.coming-soon_svg__st432,.coming-soon_svg__st435{fill:#f0f4fb}.coming-soon_svg__st431,.coming-soon_svg__st432,.coming-soon_svg__st435{fill:#f2f7fb}.coming-soon_svg__st432,.coming-soon_svg__st435{fill:#f4f7fb}.coming-soon_svg__st435{fill:#f7f9fc}.coming-soon_svg__st437,.coming-soon_svg__st440,.coming-soon_svg__st442,.coming-soon_svg__st443,.coming-soon_svg__st444,.coming-soon_svg__st448{fill-rule:evenodd;clip-rule:evenodd;fill:#fafcfc}.coming-soon_svg__st440,.coming-soon_svg__st442,.coming-soon_svg__st443,.coming-soon_svg__st444,.coming-soon_svg__st448{fill:#faecc8}.coming-soon_svg__st442,.coming-soon_svg__st443,.coming-soon_svg__st444,.coming-soon_svg__st448{fill:#faecc5}.coming-soon_svg__st443,.coming-soon_svg__st444,.coming-soon_svg__st448{fill:#f9eac2}.coming-soon_svg__st444,.coming-soon_svg__st448{fill:#f9eac0}.coming-soon_svg__st448{fill:#f9e8bb}.coming-soon_svg__st449,.coming-soon_svg__st451,.coming-soon_svg__st454,.coming-soon_svg__st458,.coming-soon_svg__st459,.coming-soon_svg__st463{fill-rule:evenodd;clip-rule:evenodd;fill:#f9e7b9}.coming-soon_svg__st451,.coming-soon_svg__st454,.coming-soon_svg__st458,.coming-soon_svg__st459,.coming-soon_svg__st463{fill:#f9e7b6}.coming-soon_svg__st454,.coming-soon_svg__st458,.coming-soon_svg__st459,.coming-soon_svg__st463{fill:#f8e5b2}.coming-soon_svg__st458,.coming-soon_svg__st459,.coming-soon_svg__st463{fill:#f8e2ad}.coming-soon_svg__st459,.coming-soon_svg__st463{fill:#f8e3ab}.coming-soon_svg__st463{fill:#f8e1a6}.coming-soon_svg__st464,.coming-soon_svg__st465,.coming-soon_svg__st467,.coming-soon_svg__st468,.coming-soon_svg__st469,.coming-soon_svg__st471{fill-rule:evenodd;clip-rule:evenodd;fill:#f8e1a4}.coming-soon_svg__st465,.coming-soon_svg__st467,.coming-soon_svg__st468,.coming-soon_svg__st469,.coming-soon_svg__st471{fill:#f7e0a2}.coming-soon_svg__st467,.coming-soon_svg__st468,.coming-soon_svg__st469,.coming-soon_svg__st471{fill:#f7dd9f}.coming-soon_svg__st468,.coming-soon_svg__st469,.coming-soon_svg__st471{fill:#f7dd9d}.coming-soon_svg__st469,.coming-soon_svg__st471{fill:#f7de9b}.coming-soon_svg__st471{fill:#f7db98}.coming-soon_svg__st472,.coming-soon_svg__st473,.coming-soon_svg__st475,.coming-soon_svg__st478,.coming-soon_svg__st480,.coming-soon_svg__st481{fill-rule:evenodd;clip-rule:evenodd;fill:#f7db96}.coming-soon_svg__st473,.coming-soon_svg__st475,.coming-soon_svg__st478,.coming-soon_svg__st480,.coming-soon_svg__st481{fill:#f6d994}.coming-soon_svg__st475,.coming-soon_svg__st478,.coming-soon_svg__st480,.coming-soon_svg__st481{fill:#f6d991}.coming-soon_svg__st478,.coming-soon_svg__st480,.coming-soon_svg__st481{fill:#f6d88d}.coming-soon_svg__st480,.coming-soon_svg__st481{fill:#f6d68a}.coming-soon_svg__st481{fill:#f6d688}.coming-soon_svg__st485,.coming-soon_svg__st486,.coming-soon_svg__st487,.coming-soon_svg__st489,.coming-soon_svg__st494,.coming-soon_svg__st495{fill-rule:evenodd;clip-rule:evenodd;fill:#f5d483}.coming-soon_svg__st486,.coming-soon_svg__st487,.coming-soon_svg__st489,.coming-soon_svg__st494,.coming-soon_svg__st495{fill:#f5d482}.coming-soon_svg__st487,.coming-soon_svg__st489,.coming-soon_svg__st494,.coming-soon_svg__st495{fill:#f5d280}.coming-soon_svg__st489,.coming-soon_svg__st494,.coming-soon_svg__st495{fill:#f5d27e}.coming-soon_svg__st494,.coming-soon_svg__st495{fill:#f5cf78}.coming-soon_svg__st495{fill:#f5cf76}.coming-soon_svg__st496,.coming-soon_svg__st497,.coming-soon_svg__st501,.coming-soon_svg__st502,.coming-soon_svg__st504,.coming-soon_svg__st507{fill-rule:evenodd;clip-rule:evenodd;fill:#f4cd74}.coming-soon_svg__st497,.coming-soon_svg__st501,.coming-soon_svg__st502,.coming-soon_svg__st504,.coming-soon_svg__st507{fill:#f4cd72}.coming-soon_svg__st501,.coming-soon_svg__st502,.coming-soon_svg__st504,.coming-soon_svg__st507{fill:#f4cb6e}.coming-soon_svg__st502,.coming-soon_svg__st504,.coming-soon_svg__st507{fill:#f4cb6c}.coming-soon_svg__st504,.coming-soon_svg__st507{fill:#f4ca69}.coming-soon_svg__st507{fill:#f4c866}.coming-soon_svg__st509,.coming-soon_svg__st510,.coming-soon_svg__st511,.coming-soon_svg__st513,.coming-soon_svg__st514,.coming-soon_svg__st515{fill-rule:evenodd;clip-rule:evenodd;fill:#f3c863}.coming-soon_svg__st510,.coming-soon_svg__st511,.coming-soon_svg__st513,.coming-soon_svg__st514,.coming-soon_svg__st515{fill:#f3c662}.coming-soon_svg__st511,.coming-soon_svg__st513,.coming-soon_svg__st514,.coming-soon_svg__st515{fill:#f3c660}.coming-soon_svg__st513,.coming-soon_svg__st514,.coming-soon_svg__st515{fill:#f3c45d}.coming-soon_svg__st514,.coming-soon_svg__st515{fill:#f3c45c}.coming-soon_svg__st515{fill:#f3c45a}.coming-soon_svg__st516,.coming-soon_svg__st517,.coming-soon_svg__st518,.coming-soon_svg__st522,.coming-soon_svg__st523,.coming-soon_svg__st527{fill-rule:evenodd;clip-rule:evenodd;fill:#f3c258}.coming-soon_svg__st517,.coming-soon_svg__st518,.coming-soon_svg__st522,.coming-soon_svg__st523,.coming-soon_svg__st527{fill:#f3c156}.coming-soon_svg__st518,.coming-soon_svg__st522,.coming-soon_svg__st523,.coming-soon_svg__st527{fill:#f3c155}.coming-soon_svg__st522,.coming-soon_svg__st523,.coming-soon_svg__st527{fill:#f2bf51}.coming-soon_svg__st523,.coming-soon_svg__st527{fill:#f2bf4f}.coming-soon_svg__st527{fill:#f2bd4b}.coming-soon_svg__st530,.coming-soon_svg__st532,.coming-soon_svg__st533,.coming-soon_svg__st537,.coming-soon_svg__st538,.coming-soon_svg__st539{fill-rule:evenodd;clip-rule:evenodd;fill:#f2bb49}.coming-soon_svg__st532,.coming-soon_svg__st533,.coming-soon_svg__st537,.coming-soon_svg__st538,.coming-soon_svg__st539{fill:#f2ba46}.coming-soon_svg__st533,.coming-soon_svg__st537,.coming-soon_svg__st538,.coming-soon_svg__st539{fill:#f2ba45}.coming-soon_svg__st537,.coming-soon_svg__st538,.coming-soon_svg__st539{fill:#f1b842}.coming-soon_svg__st538,.coming-soon_svg__st539{fill:#f1b841}.coming-soon_svg__st539{fill:#f1b63f}.coming-soon_svg__st540,.coming-soon_svg__st543,.coming-soon_svg__st545,.coming-soon_svg__st546,.coming-soon_svg__st547,.coming-soon_svg__st548{fill-rule:evenodd;clip-rule:evenodd;fill:#f1b63d}.coming-soon_svg__st543,.coming-soon_svg__st545,.coming-soon_svg__st546,.coming-soon_svg__st547,.coming-soon_svg__st548{fill:#f1b43b}.coming-soon_svg__st545,.coming-soon_svg__st546,.coming-soon_svg__st547,.coming-soon_svg__st548{fill:#f1b339}.coming-soon_svg__st546,.coming-soon_svg__st547,.coming-soon_svg__st548{fill:#f1b338}.coming-soon_svg__st547,.coming-soon_svg__st548{fill:#f1b137}.coming-soon_svg__st548{fill:#f1b136}.coming-soon_svg__st550,.coming-soon_svg__st552,.coming-soon_svg__st553,.coming-soon_svg__st554,.coming-soon_svg__st555,.coming-soon_svg__st556{fill-rule:evenodd;clip-rule:evenodd;fill:#f0af34}.coming-soon_svg__st552,.coming-soon_svg__st553,.coming-soon_svg__st554,.coming-soon_svg__st555,.coming-soon_svg__st556{fill:#f0af32}.coming-soon_svg__st553,.coming-soon_svg__st554,.coming-soon_svg__st555,.coming-soon_svg__st556{fill:#f0ad31}.coming-soon_svg__st554,.coming-soon_svg__st555,.coming-soon_svg__st556{fill:#f0ad30}.coming-soon_svg__st555,.coming-soon_svg__st556{fill:#f0ac2f}.coming-soon_svg__st556{fill:#f0aa2e}.coming-soon_svg__st557,.coming-soon_svg__st558,.coming-soon_svg__st560,.coming-soon_svg__st561,.coming-soon_svg__st564,.coming-soon_svg__st566{fill-rule:evenodd;clip-rule:evenodd;fill:#efa62b}.coming-soon_svg__st558,.coming-soon_svg__st560,.coming-soon_svg__st561,.coming-soon_svg__st564,.coming-soon_svg__st566{fill:#efa62a}.coming-soon_svg__st560,.coming-soon_svg__st561,.coming-soon_svg__st564,.coming-soon_svg__st566{fill:#efa529}.coming-soon_svg__st561,.coming-soon_svg__st564,.coming-soon_svg__st566{fill:#f7d3bc}.coming-soon_svg__st564,.coming-soon_svg__st566{fill:#f6d1b8}.coming-soon_svg__st566{fill:#f6ceb5}.coming-soon_svg__st569,.coming-soon_svg__st571,.coming-soon_svg__st572,.coming-soon_svg__st573,.coming-soon_svg__st579,.coming-soon_svg__st585{fill-rule:evenodd;clip-rule:evenodd;fill:#f5ccb1}.coming-soon_svg__st571,.coming-soon_svg__st572,.coming-soon_svg__st573,.coming-soon_svg__st579,.coming-soon_svg__st585{fill:#f5c9ad}.coming-soon_svg__st572,.coming-soon_svg__st573,.coming-soon_svg__st579,.coming-soon_svg__st585{fill:#f5c8ab}.coming-soon_svg__st573,.coming-soon_svg__st579,.coming-soon_svg__st585{fill:#f5c6a9}.coming-soon_svg__st579,.coming-soon_svg__st585{fill:#f4c2a2}.coming-soon_svg__st585{fill:#f3bd9b}.coming-soon_svg__st586,.coming-soon_svg__st588,.coming-soon_svg__st589,.coming-soon_svg__st595,.coming-soon_svg__st601,.coming-soon_svg__st602{fill-rule:evenodd;clip-rule:evenodd;fill:#f3bb99}.coming-soon_svg__st588,.coming-soon_svg__st589,.coming-soon_svg__st595,.coming-soon_svg__st601,.coming-soon_svg__st602{fill:#f3b996}.coming-soon_svg__st589,.coming-soon_svg__st595,.coming-soon_svg__st601,.coming-soon_svg__st602{fill:#f3b894}.coming-soon_svg__st595,.coming-soon_svg__st601,.coming-soon_svg__st602{fill:#f2b48d}.coming-soon_svg__st601,.coming-soon_svg__st602{fill:#f2b086}.coming-soon_svg__st602{fill:#f1ae84}.coming-soon_svg__st604,.coming-soon_svg__st607,.coming-soon_svg__st609,.coming-soon_svg__st612,.coming-soon_svg__st613,.coming-soon_svg__st615{fill-rule:evenodd;clip-rule:evenodd;fill:#f1ac81}.coming-soon_svg__st607,.coming-soon_svg__st609,.coming-soon_svg__st612,.coming-soon_svg__st613,.coming-soon_svg__st615{fill:#f1a97e}.coming-soon_svg__st609,.coming-soon_svg__st612,.coming-soon_svg__st613,.coming-soon_svg__st615{fill:#f0a77b}.coming-soon_svg__st612,.coming-soon_svg__st613,.coming-soon_svg__st615{fill:#f0a577}.coming-soon_svg__st613,.coming-soon_svg__st615{fill:#f0a476}.coming-soon_svg__st615{fill:#f0a273}.coming-soon_svg__st616,.coming-soon_svg__st622,.coming-soon_svg__st628,.coming-soon_svg__st634,.coming-soon_svg__st635,.coming-soon_svg__st637{fill-rule:evenodd;clip-rule:evenodd;fill:#f0a071}.coming-soon_svg__st622,.coming-soon_svg__st628,.coming-soon_svg__st634,.coming-soon_svg__st635,.coming-soon_svg__st637{fill:#ef9b6a}.coming-soon_svg__st628,.coming-soon_svg__st634,.coming-soon_svg__st635,.coming-soon_svg__st637{fill:#ef9864}.coming-soon_svg__st634,.coming-soon_svg__st635,.coming-soon_svg__st637{fill:#ee935e}.coming-soon_svg__st635,.coming-soon_svg__st637{fill:#ee915c}.coming-soon_svg__st637{fill:#ee8f59}.coming-soon_svg__st638,.coming-soon_svg__st644,.coming-soon_svg__st650,.coming-soon_svg__st651,.coming-soon_svg__st653,.coming-soon_svg__st654{fill-rule:evenodd;clip-rule:evenodd;fill:#ee8e57}.coming-soon_svg__st644,.coming-soon_svg__st650,.coming-soon_svg__st651,.coming-soon_svg__st653,.coming-soon_svg__st654{fill:#ed8b52}.coming-soon_svg__st650,.coming-soon_svg__st651,.coming-soon_svg__st653,.coming-soon_svg__st654{fill:#ed864c}.coming-soon_svg__st651,.coming-soon_svg__st653,.coming-soon_svg__st654{fill:#ed844a}.coming-soon_svg__st653,.coming-soon_svg__st654{fill:#ed8348}.coming-soon_svg__st654{fill:#ed8246}.coming-soon_svg__st657,.coming-soon_svg__st661,.coming-soon_svg__st662,.coming-soon_svg__st664,.coming-soon_svg__st665,.coming-soon_svg__st667{fill-rule:evenodd;clip-rule:evenodd;fill:#ec8043}.coming-soon_svg__st661,.coming-soon_svg__st662,.coming-soon_svg__st664,.coming-soon_svg__st665,.coming-soon_svg__st667{fill:#ec7d3f}.coming-soon_svg__st662,.coming-soon_svg__st664,.coming-soon_svg__st665,.coming-soon_svg__st667{fill:#ec7d3e}.coming-soon_svg__st664,.coming-soon_svg__st665,.coming-soon_svg__st667{fill:#ec7b3b}.coming-soon_svg__st665,.coming-soon_svg__st667{fill:#ec793a}.coming-soon_svg__st667{fill:#ec7738}.coming-soon_svg__st668,.coming-soon_svg__st669,.coming-soon_svg__st672,.coming-soon_svg__st674,.coming-soon_svg__st675,.coming-soon_svg__st677{fill-rule:evenodd;clip-rule:evenodd;fill:#ec7736}.coming-soon_svg__st669,.coming-soon_svg__st672,.coming-soon_svg__st674,.coming-soon_svg__st675,.coming-soon_svg__st677{fill:#eb7535}.coming-soon_svg__st672,.coming-soon_svg__st674,.coming-soon_svg__st675,.coming-soon_svg__st677{fill:#eb7332}.coming-soon_svg__st674,.coming-soon_svg__st675,.coming-soon_svg__st677{fill:#eb7230}.coming-soon_svg__st675,.coming-soon_svg__st677{fill:#eb712f}.coming-soon_svg__st677{fill:#eb6f2d}.coming-soon_svg__st678,.coming-soon_svg__st681,.coming-soon_svg__st683,.coming-soon_svg__st684,.coming-soon_svg__st686,.coming-soon_svg__st688{fill-rule:evenodd;clip-rule:evenodd;fill:#eb6e2c}.coming-soon_svg__st681,.coming-soon_svg__st683,.coming-soon_svg__st684,.coming-soon_svg__st686,.coming-soon_svg__st688{fill:#eb6c2a}.coming-soon_svg__st683,.coming-soon_svg__st684,.coming-soon_svg__st686,.coming-soon_svg__st688{fill:#eb6a28}.coming-soon_svg__st684,.coming-soon_svg__st686,.coming-soon_svg__st688{fill:#ea6827}.coming-soon_svg__st686,.coming-soon_svg__st688{fill:#ea6625}.coming-soon_svg__st688{fill:#ea6424}.coming-soon_svg__st690,.coming-soon_svg__st691,.coming-soon_svg__st693,.coming-soon_svg__st694,.coming-soon_svg__st696,.coming-soon_svg__st697{fill-rule:evenodd;clip-rule:evenodd;fill:#ea6322}.coming-soon_svg__st691,.coming-soon_svg__st693,.coming-soon_svg__st694,.coming-soon_svg__st696,.coming-soon_svg__st697{fill:#ea6122}.coming-soon_svg__st693,.coming-soon_svg__st694,.coming-soon_svg__st696,.coming-soon_svg__st697{fill:#ea6021}.coming-soon_svg__st694,.coming-soon_svg__st696,.coming-soon_svg__st697{fill:#ea5f20}.coming-soon_svg__st696,.coming-soon_svg__st697{fill:#e4eefb}.coming-soon_svg__st697{fill:#e0ebfb}.coming-soon_svg__st698,.coming-soon_svg__st699,.coming-soon_svg__st700,.coming-soon_svg__st701,.coming-soon_svg__st702,.coming-soon_svg__st703{fill-rule:evenodd;clip-rule:evenodd;fill:#ddebfb}.coming-soon_svg__st699,.coming-soon_svg__st700,.coming-soon_svg__st701,.coming-soon_svg__st702,.coming-soon_svg__st703{fill:#d9e8fa}.coming-soon_svg__st700,.coming-soon_svg__st701,.coming-soon_svg__st702,.coming-soon_svg__st703{fill:#cfe2fa}.coming-soon_svg__st701,.coming-soon_svg__st702,.coming-soon_svg__st703{fill:#cfe1fa}.coming-soon_svg__st702,.coming-soon_svg__st703{fill:#cde1f8}.coming-soon_svg__st703{fill:#cbe1f8}.coming-soon_svg__st704,.coming-soon_svg__st705,.coming-soon_svg__st706,.coming-soon_svg__st707,.coming-soon_svg__st708,.coming-soon_svg__st709{fill-rule:evenodd;clip-rule:evenodd;fill:#cadff8}.coming-soon_svg__st705,.coming-soon_svg__st706,.coming-soon_svg__st707,.coming-soon_svg__st708,.coming-soon_svg__st709{fill:#c8dff8}.coming-soon_svg__st706,.coming-soon_svg__st707,.coming-soon_svg__st708,.coming-soon_svg__st709{fill:#c6dff8}.coming-soon_svg__st707,.coming-soon_svg__st708,.coming-soon_svg__st709{fill:#c6dcf8}.coming-soon_svg__st708,.coming-soon_svg__st709{fill:#c4dcf8}.coming-soon_svg__st709{fill:#c2dcf8}.coming-soon_svg__st710,.coming-soon_svg__st711,.coming-soon_svg__st712,.coming-soon_svg__st713,.coming-soon_svg__st714,.coming-soon_svg__st715{fill-rule:evenodd;clip-rule:evenodd;fill:#c1daf8}.coming-soon_svg__st711,.coming-soon_svg__st712,.coming-soon_svg__st713,.coming-soon_svg__st714,.coming-soon_svg__st715{fill:#bdd9f7}.coming-soon_svg__st712,.coming-soon_svg__st713,.coming-soon_svg__st714,.coming-soon_svg__st715{fill:#b9d6f7}.coming-soon_svg__st713,.coming-soon_svg__st714,.coming-soon_svg__st715{fill:#b7d4f7}.coming-soon_svg__st714,.coming-soon_svg__st715{fill:#b5d4f7}.coming-soon_svg__st715{fill:#b4d1f7}.coming-soon_svg__st719,.coming-soon_svg__st721,.coming-soon_svg__st722,.coming-soon_svg__st723,.coming-soon_svg__st724,.coming-soon_svg__st725{fill-rule:evenodd;clip-rule:evenodd;fill:#ee9627}.coming-soon_svg__st721,.coming-soon_svg__st722,.coming-soon_svg__st723,.coming-soon_svg__st724,.coming-soon_svg__st725{fill:#ee9927}.coming-soon_svg__st722,.coming-soon_svg__st723,.coming-soon_svg__st724,.coming-soon_svg__st725{fill:#ee9b28}.coming-soon_svg__st723,.coming-soon_svg__st724,.coming-soon_svg__st725{fill:#ee9d28}.coming-soon_svg__st724,.coming-soon_svg__st725{fill:#ef9e28}.coming-soon_svg__st725{fill:#ef9f28}.coming-soon_svg__st726,.coming-soon_svg__st727,.coming-soon_svg__st728,.coming-soon_svg__st729,.coming-soon_svg__st731,.coming-soon_svg__st732{fill-rule:evenodd;clip-rule:evenodd;fill:#efa129}.coming-soon_svg__st727,.coming-soon_svg__st728,.coming-soon_svg__st729,.coming-soon_svg__st731,.coming-soon_svg__st732{fill:#efa329}.coming-soon_svg__st728,.coming-soon_svg__st729,.coming-soon_svg__st731,.coming-soon_svg__st732{fill:#f0a82a}.coming-soon_svg__st729,.coming-soon_svg__st731,.coming-soon_svg__st732{fill:#f0aa2a}.coming-soon_svg__st731,.coming-soon_svg__st732{fill:#f0ad2b}.coming-soon_svg__st732{fill:#f0af2b}.coming-soon_svg__st733,.coming-soon_svg__st734,.coming-soon_svg__st736,.coming-soon_svg__st737,.coming-soon_svg__st738,.coming-soon_svg__st739{fill-rule:evenodd;clip-rule:evenodd;fill:#f0b12b}.coming-soon_svg__st734,.coming-soon_svg__st736,.coming-soon_svg__st737,.coming-soon_svg__st738,.coming-soon_svg__st739{fill:#f1b32c}.coming-soon_svg__st736,.coming-soon_svg__st737,.coming-soon_svg__st738,.coming-soon_svg__st739{fill:#f1b62c}.coming-soon_svg__st737,.coming-soon_svg__st738,.coming-soon_svg__st739{fill:#f1b82d}.coming-soon_svg__st738,.coming-soon_svg__st739{fill:#f1bb2d}.coming-soon_svg__st739{fill:#f2bc2d}.coming-soon_svg__st740,.coming-soon_svg__st741,.coming-soon_svg__st742,.coming-soon_svg__st743,.coming-soon_svg__st744,.coming-soon_svg__st745{fill-rule:evenodd;clip-rule:evenodd;fill:#f2be2d}.coming-soon_svg__st741,.coming-soon_svg__st742,.coming-soon_svg__st743,.coming-soon_svg__st744,.coming-soon_svg__st745{fill:#f2c02e}.coming-soon_svg__st742,.coming-soon_svg__st743,.coming-soon_svg__st744,.coming-soon_svg__st745{fill:#f2c22e}.coming-soon_svg__st743,.coming-soon_svg__st744,.coming-soon_svg__st745{fill:#f2c32e}.coming-soon_svg__st744,.coming-soon_svg__st745{fill:#f3c52f}.coming-soon_svg__st745{fill:#f3c72f}.coming-soon_svg__st761,.coming-soon_svg__st776,.coming-soon_svg__st784,.coming-soon_svg__st790,.coming-soon_svg__st791,.coming-soon_svg__st792{fill-rule:evenodd;clip-rule:evenodd;fill:#40679a}.coming-soon_svg__st776,.coming-soon_svg__st784,.coming-soon_svg__st790,.coming-soon_svg__st791,.coming-soon_svg__st792{fill:#5179ac}.coming-soon_svg__st784,.coming-soon_svg__st790,.coming-soon_svg__st791,.coming-soon_svg__st792{fill:#5b82b5}.coming-soon_svg__st790,.coming-soon_svg__st791,.coming-soon_svg__st792{fill:#638abb}.coming-soon_svg__st791,.coming-soon_svg__st792{fill:#658cbd}.coming-soon_svg__st792{fill:#678ebf}.coming-soon_svg__st795,.coming-soon_svg__st800,.coming-soon_svg__st801,.coming-soon_svg__st802,.coming-soon_svg__st804,.coming-soon_svg__st805{fill-rule:evenodd;clip-rule:evenodd;fill:#6a91c3}.coming-soon_svg__st800,.coming-soon_svg__st801,.coming-soon_svg__st802,.coming-soon_svg__st804,.coming-soon_svg__st805{fill:#7098c7}.coming-soon_svg__st801,.coming-soon_svg__st802,.coming-soon_svg__st804,.coming-soon_svg__st805{fill:#7299c9}.coming-soon_svg__st802,.coming-soon_svg__st804,.coming-soon_svg__st805{fill:#749bca}.coming-soon_svg__st804,.coming-soon_svg__st805{fill:#779dcd}.coming-soon_svg__st805{fill:#799fcf}.coming-soon_svg__st808,.coming-soon_svg__st809,.coming-soon_svg__st811,.coming-soon_svg__st816,.coming-soon_svg__st818,.coming-soon_svg__st819{fill-rule:evenodd;clip-rule:evenodd;fill:#7ca2d2}.coming-soon_svg__st809,.coming-soon_svg__st811,.coming-soon_svg__st816,.coming-soon_svg__st818,.coming-soon_svg__st819{fill:#7ea4d2}.coming-soon_svg__st811,.coming-soon_svg__st816,.coming-soon_svg__st818,.coming-soon_svg__st819{fill:#80a7d5}.coming-soon_svg__st816,.coming-soon_svg__st818,.coming-soon_svg__st819{fill:#85acda}.coming-soon_svg__st818,.coming-soon_svg__st819{fill:#87aedc}.coming-soon_svg__st819{fill:#89afdc}.coming-soon_svg__st821,.coming-soon_svg__st822,.coming-soon_svg__st823,.coming-soon_svg__st826,.coming-soon_svg__st827,.coming-soon_svg__st829{fill-rule:evenodd;clip-rule:evenodd;fill:#8cb2df}.coming-soon_svg__st822,.coming-soon_svg__st823,.coming-soon_svg__st826,.coming-soon_svg__st827,.coming-soon_svg__st829{fill:#8eb4e1}.coming-soon_svg__st823,.coming-soon_svg__st826,.coming-soon_svg__st827,.coming-soon_svg__st829{fill:#90b6e2}.coming-soon_svg__st826,.coming-soon_svg__st827,.coming-soon_svg__st829{fill:#93b9e7}.coming-soon_svg__st827,.coming-soon_svg__st829{fill:#95bce7}.coming-soon_svg__st829{fill:#97bee9}.coming-soon_svg__st832,.coming-soon_svg__st834,.coming-soon_svg__st835,.coming-soon_svg__st838,.coming-soon_svg__st840,.coming-soon_svg__st841{fill-rule:evenodd;clip-rule:evenodd;fill:#9cc1ec}.coming-soon_svg__st834,.coming-soon_svg__st835,.coming-soon_svg__st838,.coming-soon_svg__st840,.coming-soon_svg__st841{fill:#9ec3ef}.coming-soon_svg__st835,.coming-soon_svg__st838,.coming-soon_svg__st840,.coming-soon_svg__st841{fill:#a0c6f1}.coming-soon_svg__st838,.coming-soon_svg__st840,.coming-soon_svg__st841{fill:#a3c9f4}.coming-soon_svg__st840,.coming-soon_svg__st841{fill:#a5cbf5}.coming-soon_svg__st841{fill:#a7cbf5}.coming-soon_svg__st842,.coming-soon_svg__st843,.coming-soon_svg__st844,.coming-soon_svg__st846,.coming-soon_svg__st847,.coming-soon_svg__st848{fill-rule:evenodd;clip-rule:evenodd;fill:#a8cbf5}.coming-soon_svg__st843,.coming-soon_svg__st844,.coming-soon_svg__st846,.coming-soon_svg__st847,.coming-soon_svg__st848{fill:#aacef5}.coming-soon_svg__st844,.coming-soon_svg__st846,.coming-soon_svg__st847,.coming-soon_svg__st848{fill:#abcef5}.coming-soon_svg__st846,.coming-soon_svg__st847,.coming-soon_svg__st848{fill:#add0f5}.coming-soon_svg__st847,.coming-soon_svg__st848{fill:#aed0f5}.coming-soon_svg__st848{fill:#aed1f5}")), /*#__PURE__*/React.createElement("path", {
    d: "M185.6 162.3c-6.8-19.2-39.4-14.8-53.2-26.5-16-13.5-19.7-42.2 2.6-51.9 11.1-4.8 29.4 1.8 42.2-5.1 12.8-7 10.4-23.4 29.1-32.3 12.3-5.8 23.3-4.5 32.9 6.6 15.7 18.3 10.8 49.7 19.9 66.4 6.5 11.8 32.4 34.2 34 51.1 2.1 22.3-19.5 34.8-40 31.2-4-.7-7.8-1.3-11.2-.7-8.4 1.7-19.7 11.6-27.2 15-13.1 6-28.9-2.6-32.8-17.3-3.3-13 7.5-26 3.7-36.5z",
    style: {
      opacity: 0.5,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#c6e8fb"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st1",
    d: "m286.4 172.9-6.1-.8 1.2.6c1.6.8 3.4.8 4.9.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st2",
    d: "m286.7 172.8-6.8-.9.6.3 5.8.8c.1-.1.3-.1.4-.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st3",
    d: "m287 172.7-7.4-1 .6.3 6.4.8c.1 0 .2-.1.4-.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st4",
    d: "m287.2 172.6-8-1 .6.3 7.1.9c.1-.1.2-.2.3-.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st5",
    d: "m287.4 172.5-8.6-1.1.6.3 7.7 1c.1-.1.2-.2.3-.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st6",
    d: "m287.6 172.3-9.1-1.2.5.2 8.3 1.1c.1 0 .2 0 .3-.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st7",
    d: "m287.7 172.2-9.7-1.3.5.3 8.9 1.2c.2-.1.3-.1.3-.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st8",
    d: "m287.9 172.1-10.2-1.3.6.3 9.4 1.2c0-.1.1-.1.2-.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st9",
    d: "m288.1 172-10.8-1.4.6.3 9.9 1.3c.1-.1.2-.2.3-.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st10",
    d: "m288.3 171.8-11.3-1.5.6.3L288 172c.1 0 .2-.1.3-.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st11",
    d: "m288.4 171.7-11.9-1.6.6.3 11.1 1.4c.1 0 .1 0 .2-.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st12",
    d: "m288.5 171.6-12.3-1.6.5.2 11.6 1.5c.1 0 .2 0 .2-.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st13",
    d: "m288.7 171.5-12.8-1.7.6.3 12 1.6c0-.1.1-.1.2-.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st14",
    d: "m288.8 171.4-13.4-1.7.6.3 12.6 1.6.2-.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st15",
    d: "m289 171.2-13.7-1.8v.1l.4.2 13.1 1.7.2-.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st16",
    d: "m289.1 171.1-13.7-1.8-.1.2 13.6 1.8.1-.1.1-.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st17",
    d: "m289.2 171-13.8-1.8-.1.2 13.7 1.8.2-.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st18",
    d: "m289.3 170.9-13.8-1.8-.1.1 13.7 1.8.2-.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st19",
    d: "m289.4 170.7-13.8-1.8-.1.2 13.7 1.8.2-.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st20",
    d: "m289.5 170.6-13.8-1.8-.1.2 13.8 1.8.1-.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st21",
    d: "m289.7 170.5-13.9-1.8-.1.2 13.8 1.8.2-.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st22",
    d: "m289.8 170.3-13.9-1.8-.1.2 13.8 1.8.2-.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st23",
    d: "m289.9 170.2-13.9-1.8-.2.2 13.9 1.8.2-.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st24",
    d: "m290 170.1-14-1.8-.1.2 13.9 1.8.2-.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st25",
    d: "m290.1 170-14-1.9-.1.2 13.9 1.9.2-.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st26",
    d: "m290.2 169.8-14-1.8-.1.2L290 170l.2-.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st27",
    d: "m290.3 169.7-14-1.8-.1.2 14 1.8.1-.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st28",
    d: "m290.4 169.6-14-1.8-.1.1 14 1.9.1-.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st29",
    d: "m290.5 169.5-14.1-1.9-.1.2 14.1 1.8.1-.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st30",
    d: "m290.6 169.3-14.1-1.8-.1.2 14.1 1.8.1-.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st31",
    d: "m290.8 169.2-14.2-1.9-.1.3 14.1 1.8.2-.2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st32",
    d: "m290.9 169.1-14.2-1.9-.1.2 14.1 1.9.2-.2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st33",
    d: "m291 168.9-14.2-1.8-.1.2 14.1 1.8.2-.2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st34",
    d: "m291.1 168.8-14.3-1.8-.1.1 14.2 1.9.2-.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st35",
    d: "m291.2 168.7-14.3-1.9-.1.2 14.2 1.9.2-.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st36",
    d: "m291.3 168.5-14.3-1.8-.1.2 14.2 1.9.2-.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st37",
    d: "m291.4 168.4-14.3-1.8-.1.2 14.2 1.8.2-.2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st38",
    d: "m291.5 168.3-14.3-1.9-.2.2 14.3 1.9.2-.2z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st39",
    d: "m291.6 168.2-14.4-1.9-.1.2 14.3 1.8.2-.1z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st40",
    d: "m291.7 168-14.4-1.8-.1.2 14.3 1.8.2-.2z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st41",
    d: "m291.8 167.9-14.4-1.9-.1.2 14.3 1.9.2-.2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st42",
    d: "m291.9 167.8-14.4-1.9-.1.2 14.3 1.9.2-.2z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st43",
    d: "m292 167.6-14.4-1.8-.2.2 14.4 1.8.2-.2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st44",
    d: "m292.1 167.5-14.5-1.9-.1.2 14.4 1.9.2-.2z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st45",
    d: "m292.2 167.4-14.5-1.9-.1.2 14.4 1.9.2-.2z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st46",
    d: "m292.3 167.3-14.5-1.9-.1.2 14.4 1.9.2-.2z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st47",
    d: "m292.4 167.1-14.5-1.9-.2.2 14.5 1.9.2-.2z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st48",
    d: "m292.4 167-14.5-1.9-.1.2 14.5 1.9.1-.2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st49",
    d: "M292.5 166.8 278 165l-.1.2 14.5 1.9.1-.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st50",
    d: "m292.6 166.7-14.5-1.9-.1.2 14.5 1.9.1-.2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st51",
    d: "m292.7 166.6-14.6-1.9-.1.2 14.6 1.9.1-.2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st52",
    d: "m292.8 166.5-14.6-1.9-.1.2 14.6 1.9.1-.2z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st53",
    d: "m292.9 166.3-14.6-1.9-.1.2 14.6 1.9.1-.2z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st54",
    d: "m293 166.2-14.6-1.9-.1.2 14.6 1.9.1-.2z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st55",
    d: "m293.1 166.1-14.6-1.9-.2.2 14.7 1.9.1-.2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st56",
    d: "m293.2 166-14.7-1.9-.1.1 14.6 1.9.2-.1z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st57",
    d: "m293.3 165.8-14.7-1.9-.1.2 14.6 1.9.2-.2z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st58",
    d: "m293.3 165.7-14.6-1.9-.2.2 14.7 1.9.1-.2z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st59",
    d: "m293.4 165.5-14.7-1.9-.1.2 14.7 2 .1-.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st60",
    d: "m293.5 165.4-14.7-1.9-.1.2 14.7 1.9.1-.2z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st61",
    d: "m293.6 165.3-14.7-1.9-.1.2 14.7 1.9.1-.2z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st62",
    d: "m293.7 165.2-14.8-1.9-.1.1 14.7 2 .2-.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st63",
    d: "m293.8 165-14.8-1.9-.1.2 14.7 1.9.2-.2z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st64",
    d: "m293.8 164.9-14.7-1.9-.1.2 14.7 1.9.1-.2z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st65",
    d: "m293.9 164.8-14.7-2-.1.2 14.7 2 .1-.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st66",
    d: "m294 164.6-14.8-1.9-.1.2 14.8 1.9.1-.2z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st67",
    d: "m294.1 164.5-14.8-1.9-.1.2 14.8 1.9.1-.2z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st68",
    d: "m294.2 164.4-14.8-1.9-.1.1 14.7 2 .2-.2z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st69",
    d: "m294.3 164.2-14.9-1.9-.1.2 14.8 1.9.2-.2z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st70",
    d: "m294.3 164.1-14.8-1.9-.1.2 14.8 1.9.1-.2z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st71",
    d: "m294.4 164-14.8-2-.1.2 14.8 2 .1-.2z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st72",
    d: "m294.5 163.9-14.8-2-.2.2 14.9 1.9.1-.1z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st73",
    d: "m294.6 163.7-14.9-1.9-.1.2 14.9 1.9.1-.2z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st74",
    d: "m294.6 163.6-14.8-1.9-.1.2 14.8 1.9.1-.2z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st75",
    d: "m294.7 163.4-14.9-1.9-.1.2 14.9 2 .1-.3z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st76",
    d: "m294.8 163.3-14.9-1.9-.1.2 14.9 1.9.1-.2z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st77",
    d: "m294.9 163.2-14.9-2-.1.2 14.9 2 .1-.2z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st78",
    d: "m294.9 163.1-14.8-2-.1.2 14.8 1.9.1-.1z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st79",
    d: "m295 162.9-14.9-1.9-.1.2 14.9 1.9.1-.2z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st80",
    d: "m295.1 162.8-14.9-1.9-.1.2L295 163l.1-.2z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st81",
    d: "m295.2 162.7-14.9-2-.2.2 15 2 .1-.2z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st82",
    d: "m295.2 162.5-14.9-1.9-.1.2 14.9 1.9.1-.2z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st83",
    d: "m295.3 162.4-14.9-2-.1.2 14.9 2 .1-.2z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st84",
    d: "m295.4 162.3-15-2v.2l14.9 1.9.1-.1z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st85",
    d: "m295.4 162.1-14.9-1.9-.1.2 14.9 1.9.1-.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st86",
    d: "m295.5 162-14.9-2-.1.3 14.9 1.9.1-.2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st87",
    d: "m295.6 161.8-15-1.9-.1.2 15 2 .1-.3z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st88",
    d: "m295.7 161.7-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st89",
    d: "m295.7 161.6-14.9-2-.1.2 14.9 2 .1-.2z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st90",
    d: "m295.8 161.5-15-2-.1.2 15 2 .1-.2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st91",
    d: "m295.9 161.3-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st92",
    d: "m295.9 161.2-14.9-2-.1.3 14.9 1.9.1-.2z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st92",
    d: "m296 161-15-1.9-.1.2 15 2 .1-.3z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st93",
    d: "m296.1 160.9-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st94",
    d: "m296.1 160.8-15-1.9v.1l14.9 2 .1-.2z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st95",
    d: "m296.2 160.7-15-2-.1.2 15 2 .1-.2z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st96",
    d: "m296.3 160.5-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st97",
    d: "m296.3 160.4-15-2-.1.2 15 2 .1-.2z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st98",
    d: "m296.4 160.2-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st98",
    d: "m296.4 160.1-14.9-1.9-.1.2 15 1.9v-.2z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st99",
    d: "m296.5 160-15-2-.1.2 15 2 .1-.2z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st100",
    d: "m296.6 159.9-15-2-.1.2 15 2 .1-.2z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st101",
    d: "m296.6 159.7-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st102",
    d: "m296.7 159.6-15-2-.1.2 15 2 .1-.2z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st103",
    d: "m296.8 159.4-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st104",
    d: "m296.8 159.3-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st105",
    d: "m296.9 159.2-15-2-.1.2 15 2 .1-.2z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "m296.9 159-15-1.9-.1.2 15 2 .1-.3z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m297 158.9-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m297.1 158.8-15.1-2v.2l15 2 .1-.2z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m297.1 158.7-15-2-.1.2 15 1.9.1-.1z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st108",
    d: "m297.2 158.5-15-1.9-.1.1 15 2 .1-.2z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st108",
    d: "m297.2 158.4-15-2-.1.2 15 2 .1-.2z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st109",
    d: "m297.3 158.2-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st109",
    d: "m297.3 158.1-15-2-.1.3 15 1.9.1-.2z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st109",
    d: "m297.4 157.9-15-1.9-.1.2 15 2 .1-.3z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st110",
    d: "m297.4 157.8-15-1.9v.2l15 1.9v-.2z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st111",
    d: "m297.5 157.7-15-1.9-.1.1 15 2 .1-.2z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st111",
    d: "m297.5 157.6-14.9-2-.1.2 15 2v-.2z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st111",
    d: "m297.6 157.4-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st112",
    d: "m297.7 157.3-15-2-.1.2 15 2 .1-.2z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st112",
    d: "m297.7 157.2-15-2-.1.2 15 1.9.1-.1z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st113",
    d: "m297.8 157-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st113",
    d: "m297.8 156.9-15-2v.2l14.9 2 .1-.2z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st113",
    d: "m297.9 156.7-15-1.9-.1.2 15 2 .1-.3z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st114",
    d: "m297.9 156.6-15-1.9v.2l14.9 1.9.1-.2z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st115",
    d: "m298 156.5-15-2-.1.2 15 2 .1-.2z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st115",
    d: "m298 156.3-14.9-1.9-.1.2 14.9 1.9.1-.2z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st115",
    d: "m298.1 156.2-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st116",
    d: "m298.1 156.1-14.9-2-.1.2 14.9 2 .1-.2z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st116",
    d: "m298.2 155.9-15-1.9-.1.2 15 1.9.1-.2z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st117",
    d: "m298.2 155.8-14.9-2-.1.3 14.9 1.9.1-.2z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st117",
    d: "m298.2 155.7-14.9-2-.1.2 15 2v-.2z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st117",
    d: "m298.3 155.5-14.9-1.9-.1.2 14.9 1.9.1-.2z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st118",
    d: "m298.3 155.4-14.9-1.9-.1.1 15 2v-.2z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st119",
    d: "m298.4 155.2-14.9-1.9-.1.2 14.9 2 .1-.3z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st119",
    d: "m298.4 155.1-14.9-1.9-.1.2 15 1.9v-.2z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st119",
    d: "m298.5 155-14.9-2-.1.2 14.9 2 .1-.2z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st120",
    d: "m298.5 154.9-14.9-2v.2l14.9 1.9v-.1z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st120",
    d: "m298.6 154.7-14.9-1.9-.1.2 14.9 1.9.1-.2z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st121",
    d: "m298.6 154.6-14.9-2-.1.2 14.9 2 .1-.2z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st121",
    d: "m298.6 154.4-14.8-1.9-.1.2 14.9 1.9v-.2z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st121",
    d: "m298.7 154.3-14.9-1.9v.2l14.8 1.9.1-.2z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st122",
    d: "m298.7 154.1-14.8-1.9-.1.2 14.9 2v-.3z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st123",
    d: "m298.8 154-14.9-1.9v.2l14.8 1.9.1-.2z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st123",
    d: "M298.8 153.9 284 152l-.1.1 14.8 2 .1-.2z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st124",
    d: "m298.9 153.7-14.9-1.9v.2l14.8 2 .1-.3z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st124",
    d: "m298.9 153.6-14.8-1.9-.1.2 14.8 1.9.1-.2z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st124",
    d: "m298.9 153.5-14.8-2v.2l14.8 2v-.2z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st125",
    d: "m299 153.3-14.8-1.9-.1.2 14.8 1.9.1-.2z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st125",
    d: "m299 153.2-14.8-1.9v.2l14.8 1.9v-.2z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st125",
    d: "m299 153.1-14.7-2-.1.2 14.8 2v-.2z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st126",
    d: "m299.1 152.9-14.8-1.9-.1.2 14.8 1.9.1-.2z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st126",
    d: "m299.1 152.8-14.7-1.9-.1.2 14.8 1.9v-.2z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st127",
    d: "m299.2 152.6-14.8-1.9-.1.2 14.8 1.9.1-.2z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st128",
    d: "m299.2 152.5-14.7-1.9-.1.2 14.7 1.9.1-.2z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st128",
    d: "m299.2 152.4-14.7-1.9-.1.2 14.8 1.9v-.2z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st128",
    d: "m299.3 152.2-14.7-1.9-.1.2 14.7 2 .1-.3z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st129",
    d: "m299.3 152.1-14.7-1.9-.1.2 14.7 1.9.1-.2z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st129",
    d: "m299.3 151.9-14.6-1.9-.1.3 14.7 1.9v-.3z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st129",
    d: "m299.4 151.8-14.7-1.9-.1.2 14.7 1.9.1-.2z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st130",
    d: "m299.4 151.7-14.7-1.9v.2l14.7 1.9v-.2z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st130",
    d: "m299.4 151.6-14.6-2-.1.2 14.7 2v-.2z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st131",
    d: "m299.5 151.4-14.7-1.9v.2l14.6 1.9.1-.2z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st132",
    d: "m299.5 151.3-14.6-1.9-.1.2 14.7 1.9v-.2zM299.5 151.1l-14.6-1.9v.2l14.6 1.9v-.2z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st132",
    d: "m299.6 151-14.6-1.9-.1.2 14.6 1.9.1-.2z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st133",
    d: "M299.6 150.9 285 149l-.1.2 14.6 1.9.1-.2zM299.6 150.7l-14.5-1.9-.1.2 14.6 1.9v-.2z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st134",
    d: "m299.7 150.6-14.6-1.9-.1.2 14.6 1.9.1-.2z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st134",
    d: "m299.7 150.4-14.6-1.9v.3l14.5 1.8.1-.2z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st134",
    d: "m299.7 150.3-14.5-1.9-.1.2 14.6 1.9v-.2z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st134",
    d: "m299.7 150.2-14.5-1.9v.2l14.5 1.9v-.2z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st135",
    d: "m299.8 150-14.5-1.9-.1.2 14.5 1.9.1-.2z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st135",
    d: "m299.8 149.9-14.5-1.9-.1.2 14.6 1.9v-.2z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m299.8 149.7-14.4-1.8-.1.2 14.5 1.9v-.3z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m299.9 149.6-14.5-1.9-.1.2 14.5 1.9.1-.2z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m299.9 149.5-14.5-1.9v.2l14.4 1.9.1-.2z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m299.9 149.3-14.4-1.8-.1.1 14.5 1.9v-.2z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m299.9 149.2-14.4-1.9v.2l14.4 1.9v-.2z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m300 149.1-14.4-1.9-.1.2 14.4 1.9.1-.2z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st137",
    d: "m300 148.9-14.4-1.9-.1.3 14.5 1.8v-.2z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st137",
    d: "m300 148.8-14.3-1.9-.1.2L300 149v-.2z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st137",
    d: "m300 148.6-14.3-1.8-.1.2 14.4 1.8v-.2z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st137",
    d: "m300.1 148.5-14.4-1.9v.2l14.3 1.9.1-.2z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st137",
    d: "m300.1 148.4-14.3-1.9-.1.2 14.3 1.9.1-.2z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st138",
    d: "m300.1 148.2-14.3-1.8-.1.2 14.4 1.8v-.2z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st138",
    d: "m300.1 148.1-14.2-1.9-.1.2 14.3 1.9v-.2z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st138",
    d: "m300.2 148-14.3-1.9-.1.2 14.3 1.8.1-.1z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st138",
    d: "m300.2 147.8-14.3-1.8v.1l14.2 1.9.1-.2z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st138",
    d: "m300.2 147.7-14.2-1.9-.1.2 14.3 1.9v-.2z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st139",
    d: "m300.2 147.5-14.2-1.8-.1.2 14.3 1.8v-.2z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st139",
    d: "m300.2 147.4-14.2-1.9v.2l14.2 1.9v-.2z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st139",
    d: "m300.3 147.2-14.2-1.8-.1.2 14.2 1.8.1-.2z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st140",
    d: "m300.3 147.1-14.2-1.8v.2l14.1 1.8.1-.2z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st140",
    d: "m300.3 147-14.1-1.9-.1.2 14.2 1.9v-.2z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st140",
    d: "m300.3 146.8-14.1-1.8-.1.2 14.2 1.8v-.2z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st140",
    d: "m300.3 146.7-14.1-1.9v.3l14.1 1.8v-.2z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st140",
    d: "m300.3 146.5-14-1.8-.1.2 14.1 1.9v-.3z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st141",
    d: "m300.4 146.4-14.1-1.8v.2l14 1.8.1-.2z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st141",
    d: "m300.4 146.3-14.1-1.8v.1l14.1 1.9v-.2zM300.4 146.1l-14-1.8-.1.2 14.1 1.8v-.2z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st141",
    d: "m300.4 146-14-1.8v.2l14 1.8v-.2z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st141",
    d: "m300.4 145.8-13.9-1.8-.1.2 14 1.9v-.3z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st142",
    d: "m300.4 145.7-13.9-1.8-.1.2 14 1.8v-.2z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st142",
    d: "m300.5 145.6-14-1.9v.2l13.9 1.9.1-.2z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st142",
    d: "m300.5 145.4-13.9-1.8-.1.2 14 1.8v-.2z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st142",
    d: "m300.5 145.3-13.9-1.8-.1.2 14 1.8v-.2z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st143",
    d: "m300.5 145.1-13.9-1.8v.3l13.9 1.8v-.3z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st144",
    d: "m300.5 145-13.8-1.8-.1.2 13.9 1.8v-.2z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st144",
    d: "m300.5 144.9-13.8-1.8v.2l13.8 1.8v-.2zM300.5 144.7l-13.8-1.8v.2l13.8 1.8v-.2z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st145",
    d: "m300.5 144.6-13.7-1.8-.1.2 13.8 1.8v-.2z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st145",
    d: "m300.6 144.4-13.8-1.8-.1.3 13.8 1.8.1-.3z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st145",
    d: "m300.6 144.3-13.8-1.8v.2l13.8 1.8v-.2z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st145",
    d: "m300.6 144.1-13.7-1.7-.1.2 13.8 1.8v-.3z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st145",
    d: "m300.6 144-13.7-1.8v.2l13.7 1.8v-.2z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st146",
    d: "m300.6 143.9-13.7-1.8v.2l13.7 1.8v-.2z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st146",
    d: "M300.6 143.7 287 142l-.1.2 13.7 1.8v-.3z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st146",
    d: "m300.6 143.6-13.6-1.8v.2l13.6 1.8v-.2z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st146",
    d: "m300.6 143.4-13.6-1.7v.2l13.6 1.8v-.3z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st146",
    d: "m300.6 143.3-13.5-1.8-.1.2 13.6 1.8v-.2z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st146",
    d: "m300.6 143.2-13.5-1.8v.2l13.5 1.8v-.2z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st147",
    d: "m300.6 143-13.5-1.7v.2l13.5 1.8v-.3z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st147",
    d: "m300.7 142.9-13.5-1.8-.1.3 13.5 1.7.1-.2z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st147",
    d: "m300.7 142.7-13.5-1.7-.1.2 13.6 1.8v-.3z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st147",
    d: "m300.7 142.6-13.5-1.8v.3l13.5 1.7v-.2z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st147",
    d: "m300.7 142.5-13.4-1.8-.1.2 13.5 1.8v-.2z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st148",
    d: "m300.7 142.3-13.4-1.7-.1.2 13.5 1.7v-.2z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st148",
    d: "m300.7 142.2-13.4-1.8v.2l13.4 1.8v-.2z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st148",
    d: "m300.7 142-13.4-1.7v.2l13.4 1.8v-.3z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st149",
    d: "m300.7 141.9-13.3-1.7-.1.2 13.4 1.7v-.2z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st149",
    d: "m300.7 141.7-13.3-1.7v.2l13.3 1.8v-.3z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st149",
    d: "m300.7 141.6-13.3-1.7v.2l13.3 1.7v-.2z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st149",
    d: "m300.7 141.5-13.2-1.7-.1.2 13.3 1.7v-.2z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st149",
    d: "m300.7 141.3-13.2-1.7-.1.2 13.3 1.7v-.2z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m300.7 141.2-13.2-1.7v.2l13.2 1.7v-.2z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m300.7 141-13.1-1.7-.1.2 13.2 1.8v-.3z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m300.7 140.9-13.1-1.7-.1.2 13.2 1.7v-.2z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m300.7 140.8-13.1-1.7v.1l13.1 1.8v-.2zM300.7 140.6l-13.1-1.7v.2l13.1 1.7v-.2z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m300.7 140.5-13-1.7-.1.2 13.1 1.7v-.2z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m300.7 140.3-13-1.7-.1.3 13.1 1.6v-.2z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m300.7 140.2-13-1.7v.2l13 1.7v-.2z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m300.7 140.1-13-1.7v.2l13 1.6v-.1z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m300.7 139.9-12.9-1.7-.1.2 13 1.7v-.2z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st152",
    d: "m300.7 139.8-12.9-1.7v.2l12.9 1.7v-.2z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st152",
    d: "m300.7 139.6-12.9-1.7v.3l12.9 1.6v-.2z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st152",
    d: "m300.7 139.5-12.8-1.7-.1.2 12.9 1.7v-.2z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "m300.7 139.3-12.8-1.7-.1.3 12.9 1.6v-.2z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "m300.7 139.2-12.8-1.7v.2l12.8 1.7v-.2z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "m300.6 139-12.7-1.6v.2l12.8 1.7-.1-.3z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "m300.6 138.9-12.6-1.6-.1.2 12.8 1.6-.1-.2z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "m300.6 138.7-12.6-1.6-.1.2 12.7 1.7v-.3z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st154",
    d: "M300.6 138.6 288 137v.2l12.6 1.6v-.2z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st154",
    d: "M289.2 128.3c-.3 2.9-.7 5.8-1.2 8.7l12.6 1.6c0-.5-.1-1.1-.1-1.6-.3-2.9-2.3-4.7-4.9-5.9l-6.4-2.8z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st1",
    d: "m169.6 155.4-22.7-8.3-3.8 10.6c2.1-.9 11.8-2.2 26.5-2.3z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st2",
    d: "m170.5 155.4-23.5-8.6-.2.4 22.4 8.2h1.3z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st3",
    d: "m171.3 155.4-24.2-8.9-.1.4 23.1 8.5h1.2z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st4",
    d: "m172.2 155.4-25-9.2-.1.4 23.9 8.8h1.2z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st5",
    d: "m173.1 155.4-25.8-9.5-.2.4 24.6 9c.5.1 1 .1 1.4.1z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st6",
    d: "m173.9 155.4-26.6-9.7-.1.4 25.4 9.3h1.3z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st7",
    d: "m174.9 155.4-27.4-10-.2.4 26.3 9.6h1.3z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st8",
    d: "m175.8 155.4-28.2-10.3-.2.4 27 9.9h1.4z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st9",
    d: "m176.6 155.4-28.9-10.6-.1.4 27.8 10.2h1.2z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st10",
    d: "m177.6 155.4-29.8-10.9-.2.4 28.7 10.5h1.3z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st11",
    d: "m178.5 155.5-30.6-11.2-.2.4 29.4 10.8c.5-.1.9-.1 1.4 0z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st12",
    d: "M179.4 155.5 148 144l-.1.4 30.2 11.1c.4-.1.8 0 1.3 0z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st13",
    d: "m180.4 155.5-32.3-11.8-.1.4 31.1 11.4h1.3z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st14",
    d: "m181.3 155.5-33.2-12.1-.2.4 31.8 11.7h1.6z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st15",
    d: "m182.2 155.6-33.9-12.4-.1.4 32.7 12c.4-.1.9-.1 1.3 0z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st16",
    d: "m183.2 155.6-34.8-12.8-.1.4 33.6 12.3c.4.1.8.1 1.3.1z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st17",
    d: "m184.2 155.6-35.7-13.1-.2.4 34.4 12.6c.5.1 1 .1 1.5.1z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st18",
    d: "m185.1 155.7-36.6-13.4-.1.4 35.3 12.9c.5 0 1 0 1.4.1z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st19",
    d: "M186.2 155.7 148.7 142l-.1.4 36.2 13.2c.4.1.9.1 1.4.1z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st20",
    d: "m187.2 155.8-38.4-14.1-.2.4 37 13.6c.6 0 1.1 0 1.6.1z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st21",
    d: "m188.1 155.8-39.3-14.4-.1.4 37.9 13.9c.6.1 1 .1 1.5.1z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st22",
    d: "M189.2 155.9 149 141.1l-.1.4 38.9 14.2c.4.1.9.1 1.4.2z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st23",
    d: "m190.3 155.9-41.2-15.1-.2.4 39.7 14.6c.6.1 1.1.1 1.7.1z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st24",
    d: "m191.3 156-42.1-15.4-.2.4 40.7 14.9c.5 0 1.1.1 1.6.1z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st25",
    d: "m192.3 156.1-43-15.8-.1.4 41.7 15.3c.4 0 .9 0 1.4.1z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st26",
    d: "m193.4 156.1-44-16.1-.2.4 42.5 15.6c.6.1 1.2.1 1.7.1z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st27",
    d: "m194.6 156.2-45.1-16.5-.2.4 43.5 15.9c.6.1 1.2.2 1.8.2z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st28",
    d: "m195.6 156.3-46-16.8-.1.4 44.6 16.3c.4 0 .9 0 1.5.1z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st29",
    d: "m196.7 156.4-47-17.2-.2.4 45.5 16.6c.6.1 1.1.1 1.7.2z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st30",
    d: "m197.9 156.5-48.1-17.6-.2.4 46.5 17c.6.1 1.2.1 1.8.2z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st31",
    d: "m198.9 156.6-49-17.9-.1.4 47.5 17.4c.5 0 1.1 0 1.6.1z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st32",
    d: "M200.1 156.7 150 138.3l-.2.4 48.5 17.8c.6.1 1.2.1 1.8.2z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st33",
    d: "M201.3 156.8 150.1 138l-.2.4 49.6 18.1c.6.2 1.2.2 1.8.3z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st34",
    d: "m202.4 156.9-52.2-19.1-.1.4 50.7 18.6c.5 0 1 0 1.6.1z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st35",
    d: "m203.6 157-53.3-19.5-.2.4 51.6 18.9c.7.1 1.3.1 1.9.2z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st36",
    d: "m204.9 157.1-54.5-19.9-.2.4 52.8 19.3c.6.1 1.2.2 1.9.2z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st37",
    d: "m206 157.2-55.5-20.3-.1.4 53.9 19.7c.5.1 1.1.2 1.7.2z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st38",
    d: "m207.3 157.4-56.7-20.8-.2.4 54.9 20.1c.7.1 1.3.2 2 .3z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st39",
    d: "m208.6 157.5-57.9-21.2-.2.4 56.1 20.5c.7.2 1.3.3 2 .3z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st40",
    d: "m209.8 157.7-59-21.6-.1.4 57.3 21c.5 0 1.1.1 1.8.2z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st41",
    d: "m211.1 157.8-60.2-22-.2.4 58.4 21.4c.7.1 1.3.1 2 .2z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st42",
    d: "M212.5 158 151 135.5l-.2.4 59.6 21.8 2.1.3z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st43",
    d: "m213.7 158.2-62.6-22.9-.1.4 60.8 22.3c.6 0 1.3.1 1.9.2z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st44",
    d: "m215.1 158.3-63.9-23.4-.2.4 62 22.7c.7.2 1.4.3 2.1.3z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st45",
    d: "m216.6 158.5-65.3-23.9-.2.4 63.3 23.2c.7.1 1.4.2 2.2.3z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st46",
    d: "m217.9 158.7-66.5-24.3-.1.4 64.6 23.7c.6 0 1.3.1 2 .2z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st47",
    d: "M219.4 158.9 151.5 134l-.1.4 65.8 24.1c.7.2 1.4.3 2.2.4z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st48",
    d: "m220.9 159.2-69.3-25.4-.2.4 67.2 24.6c.8.1 1.6.3 2.3.4z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st49",
    d: "m222.3 159.4-70.6-25.9-.1.4 68.6 25.1c.7.2 1.4.3 2.1.4z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st50",
    d: "m223.9 159.6-72.1-26.4-.1.4 70 25.6c.7.2 1.4.3 2.2.4z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st51",
    d: "m225.5 159.9-73.6-27-.2.4 71.4 26.1c.8.3 1.6.4 2.4.5z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st52",
    d: "m227 160.2-75-27.5-.1.4 72.9 26.7c.7.1 1.5.2 2.2.4z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st53",
    d: "m228.8 160.5-76.7-28.1-.1.4 74.4 27.2c.8.2 1.6.3 2.4.5z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st54",
    d: "m230.5 160.8-78.3-28.7-.2.4 75.8 27.8c1 .2 1.8.3 2.7.5z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st55",
    d: "m232.2 161.1-79.9-29.2-.1.4 77.5 28.4c.8.1 1.6.2 2.5.4z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st56",
    d: "m234.1 161.5-81.7-29.9-.1.4 79.2 29c.8.1 1.7.3 2.6.5z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st57",
    d: "m236 161.8-83.5-30.6-.2.4 80.8 29.6c1 .3 1.9.4 2.9.6z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st58",
    d: "M237.8 162.2 152.6 131l-.1.4 82.5 30.2c.9.2 1.9.4 2.8.6z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st59",
    d: "m239.9 162.6-87.2-31.9-.1.4L237 162c1 .2 1.9.4 2.9.6z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st60",
    d: "m242.1 163.1-89.3-32.7-.2.4 86.2 31.6c1.1.3 2.2.5 3.3.7z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st61",
    d: "m244.2 163.6-91.3-33.4-.1.4 88.3 32.3c1 .2 2 .4 3.1.7z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st62",
    d: "m246 163.9-93-34-.1.4 90.5 33.1c.8.2 1.6.4 2.6.5z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st63",
    d: "m246.2 163.6-93.1-34-.2.4 92.5 33.9.5.1.3-.4z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st64",
    d: "m246.3 163.4-93.1-34.1-.2.4 93.1 34.1.2-.4z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st65",
    d: "M246.5 163.2 153.3 129l-.1.4 93.1 34.1.2-.3z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st66",
    d: "m246.7 162.9-93.3-34.2-.2.5 93.2 34.1.3-.4z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st67",
    d: "m246.9 162.7-93.4-34.2-.2.4 93.3 34.1.3-.3z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st68",
    d: "m247 162.4-93.4-34.2-.1.4 93.3 34.2.2-.4z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st69",
    d: "m247.2 162.1-93.5-34.2-.2.4 93.4 34.2.3-.4z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st70",
    d: "m247.4 161.9-93.6-34.3-.2.4 93.5 34.3.3-.4z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st71",
    d: "m247.6 161.6-93.7-34.3-.1.4 93.5 34.3.3-.4z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st72",
    d: "M247.7 161.4 154 127l-.2.5 93.7 34.3.2-.4z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st73",
    d: "m247.9 161.1-93.8-34.3-.2.4 93.8 34.3.2-.4z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st74",
    d: "m248.1 160.9-93.9-34.4-.1.4 93.7 34.3.3-.3z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st75",
    d: "m248.2 160.6-93.9-34.4-.2.4L248 161l.2-.4z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st76",
    d: "m248.4 160.3-94-34.4-.1.4 93.9 34.4.2-.4z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st77",
    d: "m248.6 160.1-94.1-34.5-.1.5 93.9 34.4.3-.4z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st78",
    d: "m248.8 159.8-94.2-34.4-.2.4 94.1 34.4.3-.4z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st79",
    d: "m248.9 159.6-94.2-34.5-.2.4 94.2 34.5.2-.4z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st80",
    d: "m249.1 159.3-94.3-34.5-.1.4 94.1 34.5.3-.4z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st81",
    d: "m249.2 159.1-94.3-34.6-.2.4 94.3 34.6.2-.4z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st82",
    d: "M249.4 158.8 155 124.2l-.2.5 94.4 34.5.2-.4z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st83",
    d: "M249.6 158.5 155.1 124l-.1.4 94.3 34.5.3-.4z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st84",
    d: "m249.7 158.3-94.5-34.6-.2.4 94.5 34.6.2-.4z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st85",
    d: "m249.9 158-94.6-34.6-.1.4 94.5 34.6.2-.4z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st86",
    d: "m250.1 157.8-94.7-34.7-.1.4 94.5 34.6.3-.3z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st87",
    d: "m250.2 157.5-94.7-34.7-.2.5 94.7 34.6.2-.4z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st88",
    d: "m250.4 157.2-94.8-34.7-.1.5 94.6 34.6.3-.4z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st89",
    d: "m250.5 157-94.8-34.7-.1.4 94.7 34.7.2-.4z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st90",
    d: "M250.7 156.7 155.8 122l-.2.4 94.8 34.7.3-.4z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st91",
    d: "m250.9 156.4-95-34.7-.1.4 94.8 34.7.3-.4z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st92",
    d: "m251 156.2-95-34.8-.1.4 94.9 34.8.2-.4z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st92",
    d: "m251.2 155.9-95.1-34.8-.2.5 95 34.7.3-.4z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st93",
    d: "m251.3 155.7-95.1-34.9-.1.5 95 34.8.2-.4z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st94",
    d: "m251.5 155.4-95.2-34.8-.1.4 95 34.8.3-.4z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st95",
    d: "m251.6 155.1-95.2-34.8-.1.4 95.1 34.9.2-.5z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st96",
    d: "M251.8 154.9 156.5 120l-.1.4 95.1 34.9.3-.4z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st97",
    d: "m251.9 154.6-95.3-34.9-.1.4 95.2 34.9.2-.4z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st98",
    d: "m252.1 154.3-95.4-34.9-.1.4 95.3 34.9.2-.4z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st98",
    d: "m252.2 154.1-95.4-35-.1.5 95.3 34.9.2-.4z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st99",
    d: "m252.4 153.8-95.5-34.9-.1.4 95.3 34.9.3-.4z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st100",
    d: "m252.5 153.6-95.5-35-.1.4 95.4 34.9.2-.3z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st101",
    d: "m252.7 153.3-95.6-35-.1.4 95.4 35 .3-.4z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st102",
    d: "m252.8 153-95.6-35-.1.4 95.5 35 .2-.4z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st103",
    d: "m253 152.8-95.7-35.1-.1.5 95.5 35 .3-.4z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st104",
    d: "m253.1 152.5-95.7-35-.1.4 95.6 35 .2-.4z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st105",
    d: "m253.2 152.2-95.7-35-.1.4 95.6 35 .2-.4z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "m253.4 152-95.8-35.1-.1.4 95.7 35 .2-.3z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m253.5 151.7-95.8-35.1-.1.5 95.7 35 .2-.4z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m253.7 151.4-95.9-35-.1.4 95.7 35 .3-.4z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m253.8 151.2-95.9-35.1-.1.4 95.8 35.1.2-.4z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st108",
    d: "M253.9 150.9 158 115.8l-.1.4 95.8 35.1.2-.4z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st108",
    d: "m254.1 150.6-96-35.1-.1.4 95.9 35.1.2-.4z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st109",
    d: "m254.2 150.4-96-35.2-.1.4 95.9 35.1.2-.3z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st109",
    d: "m254.4 150.1-96.1-35.2-.1.5 95.9 35.1.3-.4z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st109",
    d: "m254.5 149.8-96.1-35.1-.1.4 96 35.1.2-.4z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st110",
    d: "m254.6 149.6-96.1-35.2-.1.4 96 35.1.2-.3z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st111",
    d: "m254.8 149.3-96.2-35.2-.1.4 96 35.2.3-.4z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st111",
    d: "m254.9 149-96.2-35.2-.1.4 96.1 35.2.2-.4z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st111",
    d: "m255 148.7-96.2-35.2-.1.4 96.1 35.2.2-.4z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st112",
    d: "m255.2 148.5-96.3-35.3-.1.5 96.1 35.2.3-.4z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st112",
    d: "M255.3 148.2 159 112.9l-.1.5 96.2 35.2.2-.4z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st113",
    d: "m255.4 147.9-96.3-35.2-.1.4 96.2 35.2.2-.4z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st113",
    d: "m255.5 147.7-96.3-35.3-.1.4 96.2 35.3.2-.4z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st113",
    d: "m255.7 147.4-96.4-35.3-.1.4 96.3 35.3.2-.4z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st114",
    d: "m255.8 147.1-96.4-35.3-.1.4 96.3 35.3.2-.4z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st115",
    d: "m255.9 146.8-96.4-35.3-.1.5 96.3 35.3.2-.5z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st115",
    d: "m256 146.6-96.4-35.4-.1.5 96.4 35.3.1-.4z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st115",
    d: "M256.2 146.3 159.7 111l-.1.4 96.4 35.3.2-.4z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st116",
    d: "m256.3 146-96.5-35.3-.1.4 96.4 35.3.2-.4z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st116",
    d: "m256.4 145.7-96.5-35.3-.1.4 96.4 35.4.2-.5z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st117",
    d: "M256.5 145.5 160 110.1l-.1.4 96.5 35.4.1-.4z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st117",
    d: "m256.7 145.2-96.6-35.4-.1.5 96.5 35.3.2-.4z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st117",
    d: "m256.8 144.9-96.6-35.3-.1.4 96.5 35.3.2-.4z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st118",
    d: "m256.9 144.7-96.6-35.4-.1.4 96.5 35.4.2-.4z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st119",
    d: "M257 144.4 160.4 109l-.1.4 96.5 35.4.2-.4z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st119",
    d: "m257.1 144.1-96.6-35.4-.1.4 96.6 35.4.1-.4z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st119",
    d: "m257.2 143.8-96.6-35.3-.1.4 96.6 35.3.1-.4z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st120",
    d: "m257.4 143.5-96.7-35.3-.1.4 96.6 35.4.2-.5z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st120",
    d: "m257.5 143.3-96.7-35.4-.1.4 96.6 35.4.2-.4z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st121",
    d: "m257.6 143-96.7-35.4-.1.4 96.6 35.4.2-.4z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st121",
    d: "M257.7 142.7 161 107.3l-.1.4 96.6 35.4.2-.4z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st121",
    d: "M257.8 142.4 161.1 107l-.1.5 96.6 35.4.2-.5z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st122",
    d: "m257.9 142.2-96.7-35.4-.1.4 96.7 35.4.1-.4z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st123",
    d: "m258 141.9-96.7-35.4-.1.4 96.7 35.4.1-.4z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st123",
    d: "m258.2 141.6-96.8-35.4-.1.4L258 142l.2-.4z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st124",
    d: "m258.3 141.3-96.8-35.4-.1.4 96.7 35.4.2-.4z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st124",
    d: "m258.4 141-96.8-35.4-.1.4 96.7 35.4.2-.4z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st124",
    d: "m258.5 140.8-96.8-35.5-.1.5 96.7 35.4.2-.4z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st125",
    d: "m258.6 140.5-96.8-35.4-.1.4 96.7 35.4.2-.4z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st125",
    d: "m258.7 140.2-96.8-35.4-.1.4 96.7 35.4.2-.4z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st125",
    d: "M258.8 139.9 162 104.5l-.1.4 96.7 35.4.2-.4z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st126",
    d: "m258.9 139.6-96.8-35.4-.1.4 96.7 35.5.2-.5z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st126",
    d: "m259 139.4-96.8-35.5-.1.4 96.7 35.5.2-.4z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st127",
    d: "m259.1 139.1-96.8-35.5-.1.5 96.7 35.4.2-.4z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st128",
    d: "m259.2 138.8-96.8-35.4-.1.4 96.7 35.4.2-.4z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st128",
    d: "m259.3 138.5-96.8-35.4-.1.4 96.7 35.4.2-.4z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st128",
    d: "m259.4 138.2-96.8-35.4-.1.4 96.7 35.5.2-.5z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st129",
    d: "m259.5 138-96.8-35.5-.1.4 96.7 35.5.2-.4z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st129",
    d: "m259.6 137.7-96.8-35.5-.1.4 96.7 35.5.2-.4z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st129",
    d: "m259.7 137.4-96.8-35.5-.1.5 96.7 35.4.2-.4z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st130",
    d: "M259.8 137.1 163 101.7l-.1.4 96.7 35.4.2-.4z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st130",
    d: "m259.9 136.8-96.8-35.4-.1.4 96.7 35.4.2-.4z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st131",
    d: "m260 136.5-96.8-35.4-.1.4 96.7 35.5.2-.5z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st132",
    d: "m260 136.3-96.7-35.5-.1.4 96.7 35.5.1-.4z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st132",
    d: "m260.1 136-96.7-35.5-.1.5 96.7 35.4.1-.4z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st132",
    d: "m260.2 135.7-96.7-35.4-.1.4 96.7 35.4.1-.4z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st133",
    d: "M260.3 135.4 163.6 100l-.1.4 96.7 35.4.1-.4z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st133",
    d: "m260.4 135.1-96.7-35.4-.1.4 96.7 35.4.1-.4z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st134",
    d: "m260.5 134.8-96.7-35.4-.1.5 96.7 35.4.1-.5z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st134",
    d: "m260.6 134.5-96.7-35.4-.1.5 96.7 35.4.1-.5z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st134",
    d: "M260.7 134.2 164 98.9l-.1.4 96.6 35.4.2-.5z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st134",
    d: "m260.8 133.9-96.7-35.3-.1.4 96.6 35.4.2-.5z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st135",
    d: "m260.8 133.6-96.6-35.3-.1.4 96.6 35.4.1-.5z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st135",
    d: "M260.9 133.4 164.3 98l-.1.4 96.6 35.4.1-.4z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m261 133.1-96.6-35.4-.1.5 96.6 35.3.1-.4z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m261.1 132.8-96.6-35.4-.1.5 96.6 35.3.1-.4z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m261.2 132.5-96.6-35.3-.1.4 96.6 35.3.1-.4z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m261.3 132.2-96.6-35.3-.1.4 96.5 35.4.2-.5z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m261.3 131.9-96.5-35.3-.1.4 96.5 35.4.1-.5z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m261.4 131.7-96.5-35.4-.1.4 96.5 35.4.1-.4z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st137",
    d: "M261.5 131.4 165 96l-.1.5 96.5 35.3.1-.4z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st137",
    d: "m261.6 131-96.5-35.3-.1.5 96.4 35.3.2-.5z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st137",
    d: "m261.6 130.8-96.4-35.3-.1.4 96.4 35.3.1-.4z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st137",
    d: "m261.7 130.5-96.4-35.3-.1.4 96.4 35.3.1-.4z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st137",
    d: "m261.8 130.2-96.4-35.3-.1.4 96.4 35.3.1-.4z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st138",
    d: "m261.9 129.9-96.4-35.3-.1.5 96.3 35.2.2-.4z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st138",
    d: "m261.9 129.6-96.3-35.2-.1.4 96.3 35.3.1-.5z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st138",
    d: "m262 129.3-96.3-35.2-.1.4 96.3 35.3.1-.5z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st138",
    d: "m262.1 129-96.3-35.2-.1.4 96.3 35.3.1-.5z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st138",
    d: "m262.1 128.7-96.2-35.2-.1.4 96.2 35.3.1-.5z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st139",
    d: "M262.2 128.4 166 93.2l-.1.5 96.2 35.2.1-.5z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st139",
    d: "M262.3 128.1 166.1 93l-.1.4 96.2 35.2.1-.5z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st139",
    d: "m262.3 127.8-96.1-35.1-.1.4 96.1 35.2.1-.5z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st140",
    d: "m262.4 127.5-96.1-35.1-.1.4 96.1 35.2.1-.5z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st140",
    d: "m262.5 127.3-96.1-35.2-.1.4 96.1 35.2.1-.4z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st140",
    d: "m262.5 127-96-35.2-.1.4 96 35.2.1-.4z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st140",
    d: "m262.6 126.7-96-35.2-.1.5 96 35.1.1-.4z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st140",
    d: "m262.7 126.4-96-35.1-.1.4 96 35.1.1-.4z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st141",
    d: "M262.7 126.1 166.8 91l-.1.4 95.9 35.1.1-.4z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st141",
    d: "m262.8 125.8-95.9-35.1-.1.4 95.9 35.1.1-.4z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st141",
    d: "M262.8 125.5 167 90.4l-.1.4 95.8 35.1.1-.4z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st141",
    d: "m262.9 125.2-95.8-35.1-.1.4 95.8 35.1.1-.4z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st141",
    d: "m263 124.9-95.8-35.1-.1.5 95.8 35 .1-.4z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st142",
    d: "m263 124.6-95.7-35-.1.4 95.7 35 .1-.4z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st142",
    d: "m263.1 124.3-95.7-35-.1.4 95.7 35 .1-.4z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st142",
    d: "m263.1 124-95.6-35-.1.4 95.6 35 .1-.4z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st142",
    d: "m263.2 123.7-95.6-35-.1.4 95.6 35 .1-.4z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st143",
    d: "m263.2 123.4-95.5-35-.1.4 95.5 35 .1-.4z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st144",
    d: "m263.3 123.1-95.5-35-.1.5 95.5 35 .1-.5z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st144",
    d: "m263.3 122.8-95.4-34.9-.1.4 95.4 34.9.1-.4z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st144",
    d: "M263.4 122.5 168 87.6l-.1.4 95.4 34.9.1-.4z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st145",
    d: "m263.4 122.2-95.3-34.9-.1.4 95.3 34.9.1-.4z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st145",
    d: "M263.5 121.9 168.2 87l-.1.4 95.3 34.9.1-.4z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st145",
    d: "m263.5 121.6-95.2-34.9-.1.5 95.2 34.8.1-.4z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st145",
    d: "m263.6 121.3-95.2-34.8-.1.4 95.2 34.8.1-.4z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st145",
    d: "m263.6 121-95.1-34.8-.1.4 95.1 34.8.1-.4z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st146",
    d: "m263.7 120.7-95.1-34.8-.1.4 95.1 34.8.1-.4z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st146",
    d: "m263.7 120.4-95-34.8-.1.4 95 34.8.1-.4z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st146",
    d: "m263.7 120.1-94.9-34.8-.1.5 95 34.7v-.4z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st146",
    d: "m263.8 119.8-94.9-34.7-.1.4 94.9 34.7.1-.4z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st146",
    d: "M263.8 119.5 169 84.8l-.1.4 94.9 34.7v-.4z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st146",
    d: "m263.9 119.1-94.7-34.6-.2.4 94.8 34.7.1-.5z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st147",
    d: "m263.9 118.9-94.7-34.7-.1.4 94.7 34.7.1-.4z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st147",
    d: "m263.9 118.5-94.6-34.6-.1.5 94.7 34.6v-.5z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st147",
    d: "m264 118.2-94.5-34.6-.2.5 94.6 34.6.1-.5z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st147",
    d: "m264 118-94.5-34.6-.1.4 94.6 34.6v-.4z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st147",
    d: "m264 117.6-94.4-34.5-.1.4 94.5 34.6v-.5z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st148",
    d: "m264.1 117.3-94.3-34.5-.2.4 94.4 34.6.1-.5z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st148",
    d: "m264.1 117-94.3-34.5-.1.4 94.4 34.6v-.5z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st148",
    d: "m264.1 116.7-94.2-34.5-.1.5 94.3 34.5v-.5z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st149",
    d: "m264.2 116.4-94.1-34.5-.2.5 94.2 34.5.1-.5z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st149",
    d: "m264.2 116.1-94.1-34.4-.1.4 94.2 34.5v-.5z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st149",
    d: "m264.2 115.8-93.9-34.4-.2.4 94.1 34.5v-.5z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st149",
    d: "m264.3 115.5-93.9-34.4-.2.4 94 34.4.1-.4z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st149",
    d: "m264.3 115.2-93.9-34.4-.1.4 94 34.4v-.4z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m264.3 114.9-93.7-34.4-.2.4 93.9 34.5v-.5z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m264.3 114.6-93.6-34.4-.2.5 93.8 34.3v-.4z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "M264.4 114.3 170.7 80l-.1.4 93.7 34.3.1-.4z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m264.4 113.9-93.5-34.2-.2.4 93.7 34.3v-.5z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "M263.6 113.3 171 79.4l-.2.4 93.6 34.3v-.4l-.8-.4z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "M261.4 112.2 171 79.1l-.1.4 93.5 34.2v-.1c-1-.4-2-.9-3-1.4z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m259.1 111.1-88-32.2-.1.4 91.4 33.5c-1.1-.6-2.2-1.2-3.3-1.7z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m256.9 109.9-85.7-31.4-.2.4 89.1 32.6c-1-.4-2.1-1-3.2-1.6z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m255.1 109-83.7-30.7-.1.4 86.8 31.8c-1.1-.5-2.1-1-3-1.5z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "M253.1 107.9 171.5 78l-.1.4 84.6 31c-1.1-.5-2-1-2.9-1.5z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st152",
    d: "m251.3 106.9-79.7-29.2-.2.4 82.7 30.3c-.9-.5-1.9-1-2.8-1.5z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st152",
    d: "m249.8 106-78.1-28.6-.1.4 80.7 29.6c-.9-.4-1.7-.9-2.5-1.4z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st152",
    d: "m248 105.1-76.3-27.9-.1.4 78.8 28.9c-.8-.5-1.6-1-2.4-1.4z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "m246.4 104.1-74.5-27.3-.2.4 77.1 28.2c-.8-.3-1.6-.8-2.4-1.3z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "m245 103.3-73-26.7-.1.4 75.4 27.6c-.9-.4-1.6-.8-2.3-1.3z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "M243.4 102.4 172 76.3l-.1.4 73.7 27c-.7-.4-1.5-.8-2.2-1.3z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "M242 101.6 172.2 76l-.2.4 72.2 26.4c-.8-.3-1.5-.8-2.2-1.2z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "m240.7 100.8-68.4-25-.1.4 70.6 25.8c-.8-.4-1.5-.8-2.1-1.2z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st154",
    d: "m239.2 100-66.9-24.5-.1.4 69 25.3c-.7-.5-1.3-.9-2-1.2z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st154",
    d: "m172.3 75.6 67.6 24.8c-35.6-21.4-57.6-43.6-59.6-47.3l-8 22.5z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m259 108.4 26.3 8.6c-.3-.1-.7-.3-1-.4l-25.3-8.7v.5z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m259 108.7 27.6 9c-.7-.4-1.5-.8-2.3-1l-3.1-1.1-22.2-7.2v.3z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st156",
    d: "m259 108.9 28.5 9.3c-.4-.3-.9-.6-1.3-.8l-27.1-8.8-.1.3z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m259 109.2 29 9.5-.9-.6-28.1-9.2v.3z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m258.9 109.4 29.5 9.6c-.2-.2-.5-.4-.7-.6L259 109l-.1.4z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m258.9 109.7 29.9 9.7-.6-.6-29.3-9.5v.4z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st159",
    d: "m258.9 109.9 30.3 9.9c-.2-.2-.3-.4-.5-.6l-29.7-9.7-.1.4z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st160",
    d: "m258.9 110.1 30.6 10c-.1-.2-.3-.3-.4-.5l-30.1-9.8-.1.3z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "m258.9 110.4 30.8 10c-.1-.2-.2-.3-.4-.5l-30.4-9.9v.4z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "m258.8 110.7 31.1 10.1c-.1-.2-.2-.3-.3-.5l-30.7-10-.1.4z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st162",
    d: "m258.8 110.9 31.3 10.2c-.1-.2-.2-.3-.3-.5l-31-10.1v.4z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st163",
    d: "m258.8 111.1 31.5 10.3c-.1-.2-.2-.3-.3-.5l-31.2-10.2v.4z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st164",
    d: "m258.8 111.4 31.7 10.3c-.1-.2-.2-.3-.2-.4L258.8 111v.4z"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st165",
    d: "m258.7 111.6 31.9 10.3c-.1-.1-.1-.3-.2-.4l-31.6-10.3-.1.4z"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st166",
    d: "m258.7 111.9 32 10.4c-.1-.2-.1-.3-.2-.5l-31.8-10.3v.4z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st167",
    d: "m258.7 112.1 32.1 10.5c-.1-.1-.1-.3-.2-.4l-31.9-10.4v.3z"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st168",
    d: "m258.7 112.4 32.3 10.5c0-.1-.1-.3-.2-.4L258.7 112v.4z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st169",
    d: "m258.6 112.6 32.4 10.5c0-.1-.1-.3-.1-.4l-32.2-10.5-.1.4z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st170",
    d: "m258.6 112.8 32.5 10.6c0-.1-.1-.3-.1-.4l-32.3-10.5-.1.3z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st170",
    d: "m258.6 113.1 32.6 10.6c0-.1-.1-.3-.1-.4l-32.4-10.5-.1.3z"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st171",
    d: "m258.5 113.3 32.7 10.6c0-.1-.1-.3-.1-.4L258.6 113l-.1.3z"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st172",
    d: "m258.5 113.6 32.8 10.6c0-.1 0-.3-.1-.4l-32.6-10.6-.1.4z"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st172",
    d: "m258.5 113.8 32.8 10.7c0-.1 0-.3-.1-.4l-32.7-10.6v.3z"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st172",
    d: "m258.5 114 32.9 10.7c0-.1 0-.3-.1-.4l-32.8-10.6v.3z"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st172",
    d: "m258.4 114.3 32.9 10.7v-.4l-32.9-10.7v.4z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st172",
    d: "m258.4 114.5 33 10.8v-.4l-33-10.7v.3z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st172",
    d: "m258.4 114.8 33 10.7v-.4l-33-10.7v.4z"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st172",
    d: "m258.3 115 33.1 10.8v-.4l-33-10.7-.1.3z"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st172",
    d: "m258.3 115.3 33.1 10.8v-.4l-33.1-10.8v.4z"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st172",
    d: "m258.3 115.5 33.2 10.8-.1-.4-33.1-10.8v.4z"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st171",
    d: "m258.2 115.8 33.3 10.8v-.4l-33.2-10.8-.1.4z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st170",
    d: "m258.2 116 33.3 10.8v-.4l-33.3-10.8v.4z"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st170",
    d: "m258.2 116.2 33.3 10.9v-.4l-33.3-10.8v.3z"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st170",
    d: "m258.1 116.5 33.4 10.8v-.3l-33.3-10.9-.1.4z"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st170",
    d: "m258.1 116.7 33.4 10.9v-.4l-33.4-10.8v.3z"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st170",
    d: "m258 116.9 33.6 11-.1-.4-33.4-10.9-.1.3z"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st169",
    d: "m258 117.2 33.6 10.9-.1-.4-33.4-10.9-.1.4z"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st169",
    d: "m258 117.5 33.6 10.9v-.4L258 117.1v.4z"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st169",
    d: "m257.9 117.7 33.7 10.9v-.4L258 117.3l-.1.4z"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st168",
    d: "m257.9 117.9 33.7 11v-.4l-33.7-10.9v.3z"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st168",
    d: "m257.8 118.2 33.8 10.9v-.3l-33.7-11-.1.4z"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st167",
    d: "m257.8 118.4 33.8 11v-.4l-33.7-11-.1.4z"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st167",
    d: "m257.8 118.6 33.8 11v-.3l-33.8-11v.3z"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st166",
    d: "m257.7 118.9 33.9 11v-.4l-33.8-11-.1.4z"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st166",
    d: "m257.7 119.1 33.9 11.1v-.4l-33.9-11v.3z"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st166",
    d: "m257.6 119.4 34 11v-.4l-33.9-11-.1.4z"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st165",
    d: "m257.6 119.6 34 11v-.3l-33.9-11-.1.3z"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st165",
    d: "m257.6 119.8 34 11.1v-.4l-34-11v.3z"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st165",
    d: "m257.5 120.1 34.1 11.1v-.4l-34-11.1-.1.4z"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st164",
    d: "m257.5 120.3 34.1 11.1v-.4l-34.1-11.1v.4z"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st163",
    d: "m257.4 120.6 34.2 11.1v-.4l-34.1-11.1-.1.4z"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st163",
    d: "m257.4 120.8 34.2 11.1v-.4l-34.2-11.1v.4z"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st163",
    d: "m257.3 121 34.3 11.2v-.4l-34.2-11.1-.1.3z"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st162",
    d: "m257.3 121.3 34.3 11.1v-.4l-34.2-11.1-.1.4z"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st162",
    d: "m257.2 121.5 34.4 11.2v-.4l-34.3-11.2-.1.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f3f9ff"
    },
    d: "m257.2 121.7 34.4 11.2v-.4l-34.3-11.1-.1.3z"
  }), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "m257.1 122 34.5 11.2v-.4l-34.4-11.2-.1.4z"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "m257.1 122.2 34.4 11.2.1-.4-34.4-11.2-.1.4z"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st174",
    d: "m257 122.4 34.5 11.3v-.4l-34.4-11.2-.1.3z"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st174",
    d: "m257 122.7 34.5 11.2v-.4l-34.4-11.2-.1.4z"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st160",
    d: "m256.9 122.9 34.6 11.3v-.4L257 122.6l-.1.3z"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st159",
    d: "m256.9 123.2 34.6 11.2v-.3L257 122.8l-.1.4z"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st159",
    d: "m256.8 123.4 34.7 11.3v-.4L256.9 123l-.1.4z"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m256.8 123.6 34.7 11.3v-.4l-34.6-11.2-.1.3z"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m256.7 123.9 34.7 11.3.1-.4-34.7-11.3-.1.4z"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m256.7 124.1 34.7 11.3v-.4l-34.6-11.3-.1.4z"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m256.6 124.3 34.8 11.3v-.3L256.7 124l-.1.3z"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m256.6 124.6 34.8 11.3v-.4l-34.8-11.3v.4z"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m256.5 124.8 34.9 11.3v-.3l-34.8-11.3-.1.3z"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m256.5 125.1 34.8 11.3.1-.4-34.9-11.3v.4z"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st156",
    d: "m256.4 125.3 34.9 11.3v-.3l-34.8-11.4-.1.4z"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st156",
    d: "m256.3 125.5 35 11.4v-.4l-34.9-11.3-.1.3z"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st156",
    d: "m256.3 125.7 35 11.4v-.4l-34.9-11.3-.1.3z"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m256.2 126 35 11.4.1-.4-35-11.4-.1.4z"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m256.2 126.2 35 11.4v-.4l-34.9-11.3-.1.3z"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m256.1 126.5 35.1 11.4v-.4l-35-11.4-.1.4z"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m256.1 126.7 35.1 11.4v-.4l-35.1-11.4v.4z"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m256 126.9 35.1 11.4.1-.3-35.1-11.4-.1.3z"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.9 127.2 35.2 11.4v-.4L256 126.8l-.1.4z"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.9 127.4 35.2 11.4v-.3L256 127l-.1.4z"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.8 127.6 35.2 11.5.1-.4-35.2-11.4-.1.3z"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.8 127.8 35.2 11.5v-.3l-35.1-11.5-.1.3z"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.7 128.1 35.3 11.4v-.3l-35.2-11.5-.1.4z"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.6 128.3 35.3 11.5.1-.4-35.3-11.4-.1.3z"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.6 128.5 35.3 11.5v-.3l-35.2-11.5-.1.3z"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.5 128.8 35.4 11.5v-.4l-35.3-11.5-.1.4z"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.4 129 35.4 11.5.1-.3-35.4-11.5-.1.3z"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.4 129.2 35.4 11.6v-.4l-35.3-11.5-.1.3z"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.3 129.5 35.4 11.5.1-.4-35.4-11.5-.1.4z"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.3 129.7 35.4 11.5.1-.3-35.5-11.5v.3z"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.2 129.9 35.5 11.6v-.4l-35.4-11.5-.1.3z"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.1 130.2 35.5 11.5.1-.4-35.5-11.5-.1.4z"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.1 130.4 35.5 11.6v-.4l-35.5-11.5v.3z"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255 130.6 35.5 11.6.1-.3-35.5-11.6-.1.3z"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254.9 130.9 35.6 11.5v-.3L255 130.5l-.1.4z"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254.8 131.1 35.6 11.6.1-.4-35.6-11.5-.1.3z"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254.8 131.3 35.6 11.6.1-.4-35.6-11.5-.1.3z"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254.7 131.5 35.6 11.6.1-.3-35.6-11.6-.1.3z"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254.6 131.8 35.7 11.6.1-.4-35.7-11.6-.1.4z"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254.6 132 35.6 11.6.1-.3-35.6-11.6-.1.3z"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254.5 132.2 35.7 11.7.1-.4-35.7-11.6-.1.3z"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254.4 132.5 35.7 11.6.1-.3-35.7-11.7-.1.4z"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254.3 132.7 35.8 11.6.1-.3-35.7-11.6-.2.3z"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254.3 132.9 35.7 11.7.1-.4-35.7-11.6-.1.3z"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254.2 133.2 35.8 11.6.1-.4-35.8-11.6-.1.4z"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254.1 133.4 35.8 11.6.1-.3-35.8-11.7-.1.4z"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254 133.6 35.9 11.7.1-.4-35.8-11.6-.2.3z"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m254 133.8 35.8 11.7.1-.3-35.8-11.7-.1.3z"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253.9 134.1 35.9 11.6.1-.3-35.9-11.7-.1.4z"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253.8 134.3 35.9 11.7.1-.4-35.9-11.6-.1.3z"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253.7 134.5 35.9 11.7.1-.3-35.8-11.7-.2.3z"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253.7 134.8 35.9 11.6.1-.3-35.9-11.7-.1.4z"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253.6 135 35.9 11.7.1-.4-35.9-11.7-.1.4z"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253.5 135.2 36 11.7.1-.4-36-11.6-.1.3z"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253.4 135.4 36 11.7.1-.3-35.9-11.7-.2.3z"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253.4 135.7 35.9 11.7.1-.4-35.9-11.7-.1.4z"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253.3 135.9 36 11.7.1-.4-36-11.6-.1.3z"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253.2 136.1 36 11.7.1-.3-36-11.7-.1.3z"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253.1 136.4 36.1 11.7v-.4l-36-11.7-.1.4z"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253 136.6 36.1 11.7.1-.4-36-11.7-.2.4z"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253 136.8 36 11.7.1-.3-36-11.7-.1.3z"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m252.9 137 36 11.8.2-.4-36.1-11.7-.1.3z"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m252.8 137.2 36.1 11.8.1-.4-36.1-11.7-.1.3z"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m252.7 137.5 36.1 11.7.1-.3-36.1-11.8-.1.4z"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m252.6 137.7 36.1 11.8.1-.4-36.1-11.7-.1.3z"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m252.5 137.9 36.2 11.8.1-.4-36.1-11.7-.2.3z"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m252.5 138.1 36.1 11.8.1-.3-36.1-11.8-.1.3z"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m252.4 138.4 36.1 11.7.1-.3-36.1-11.8-.1.4z"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m252.3 138.6 36.1 11.8.2-.4-36.2-11.7-.1.3z"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m252.2 138.8 36.2 11.8.1-.4-36.2-11.7-.1.3z"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st156",
    d: "m252.1 139 36.2 11.8.1-.3-36.2-11.8-.1.3z"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m252 139.3 36.2 11.7.1-.3-36.1-11.8-.2.4z"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m251.9 139.5 36.2 11.8.2-.4-36.2-11.7-.2.3z"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m251.8 139.7 36.3 11.8.1-.3-36.2-11.8-.2.3z"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st159",
    d: "m251.8 139.9 36.2 11.8.1-.3-36.2-11.8-.1.3z"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st160",
    d: "m251.7 140.2 36.2 11.8.1-.4-36.2-11.8-.1.4z"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "m251.6 140.4 36.2 11.8.1-.4-36.2-11.7-.1.3z"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "m251.5 140.6 36.2 11.8.2-.3-36.3-11.8-.1.3z"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st162",
    d: "m251.4 140.8 36.3 11.8.1-.3-36.3-11.8-.1.3z"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st175",
    d: "m251.3 141.1 36.3 11.8.1-.4-36.3-11.8-.1.4z"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st176",
    d: "m251.2 141.3 36.3 11.8.1-.3-36.3-11.8-.1.3z"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st177",
    d: "m251.1 141.5 36.3 11.8.1-.3-36.2-11.8-.2.3z"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st178",
    d: "m251 141.7 36.3 11.8.2-.3-36.3-11.8-.2.3z"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st179",
    d: "m250.9 142 36.3 11.8.2-.4-36.3-11.8-.2.4z"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st180",
    d: "m250.8 142.2 36.4 11.8.1-.3-36.3-11.8-.2.3z"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st181",
    d: "m250.7 142.4 36.4 11.8.1-.3-36.3-11.8-.2.3z"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st182",
    d: "m250.7 142.6 36.3 11.8.1-.3-36.3-11.8-.1.3z"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st183",
    d: "m250.5 142.8 36.4 11.9.1-.4-36.3-11.8-.2.3z"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st184",
    d: "m250.5 143.1 36.3 11.8.1-.4-36.3-11.8-.1.4z"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st185",
    d: "m250.4 143.3 36.3 11.8.1-.3-36.3-11.8-.1.3z"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st186",
    d: "m250.3 143.5 36.3 11.8.1-.3-36.3-11.8-.1.3z"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st187",
    d: "m250.2 143.7 36.3 11.8.2-.3-36.4-11.8-.1.3z"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st188",
    d: "m250.1 143.9 36.3 11.9.2-.4-36.4-11.8-.1.3z"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st189",
    d: "m250 144.2 36.3 11.8.2-.3-36.4-11.9-.1.4z"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st190",
    d: "m249.9 144.4 36.3 11.8.2-.3-36.4-11.8-.1.3z"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st191",
    d: "m249.8 144.6 36.3 11.8.2-.3-36.4-11.8-.1.3z"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st192",
    d: "m249.7 144.8 36.3 11.9.2-.4-36.4-11.8-.1.3z"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st193",
    d: "m249.6 145 36.3 11.9.2-.4-36.4-11.8-.1.3z"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st194",
    d: "m249.5 145.3 36.3 11.8.2-.3-36.4-11.9-.1.4z"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st195",
    d: "m249.4 145.5 36.3 11.8.2-.3-36.4-11.9-.1.4z"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st196",
    d: "m249.3 145.7 36.3 11.8.2-.3-36.4-11.8-.1.3z"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st197",
    d: "m249.2 145.9 36.3 11.9.2-.4-36.4-11.8-.1.3z"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st198",
    d: "m249.1 146.1 36.3 11.9.2-.4-36.4-11.8-.1.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a9cbf7"
    },
    d: "m248.9 146.4 36.4 11.8.2-.3-36.4-11.9-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a7cbf7"
    },
    d: "m248.8 146.6 36.4 11.8.2-.3-36.4-11.9-.2.4z"
  }), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st201",
    d: "m248.7 146.8 36.4 11.8.2-.3-36.4-11.8-.2.3z"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st202",
    d: "m248.6 147 36.4 11.9.2-.4-36.4-11.8-.2.3z"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st203",
    d: "m248.5 147.3 36.4 11.8.2-.3-36.4-11.9-.2.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9bc5f7"
    },
    d: "m248.4 147.5 36.4 11.8.1-.3-36.3-11.9-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9ac3f6"
    },
    d: "m248.3 147.7 36.4 11.8.1-.3-36.3-11.8-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#97c0f6"
    },
    d: "m248.2 147.9 36.4 11.8.1-.3-36.3-11.8-.2.3z"
  }), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st207",
    d: "m248.1 148.1 36.4 11.8.1-.3-36.3-11.8-.2.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#93bff6"
    },
    d: "m248 148.3 36.3 11.8.2-.3-36.3-11.8-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#92bdf4"
    },
    d: "m247.9 148.5 36.3 11.9.2-.4-36.4-11.8-.1.3z"
  }), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st210",
    d: "m247.8 148.8 36.3 11.8.2-.4-36.4-11.8-.1.4z"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st211",
    d: "m247.7 149 36.3 11.8.2-.3-36.4-11.8-.1.3z"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st212",
    d: "m247.5 149.2 36.4 11.8.2-.3-36.4-11.8-.2.3z"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st212",
    d: "m247.4 149.4 36.4 11.8.1-.3-36.3-11.8-.2.3z"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st213",
    d: "m247.3 149.6 36.3 11.8.2-.3-36.3-11.8-.2.3z"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st214",
    d: "m247.2 149.8 36.3 11.9.2-.4-36.3-11.8-.2.3z"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st214",
    d: "m247.1 150.1 36.3 11.8.2-.3-36.3-11.9-.2.4z"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st214",
    d: "m247 150.3 36.3 11.8.2-.3-36.4-11.8-.1.3z"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st215",
    d: "m246.9 150.5 36.3 11.8.2-.3-36.4-11.8-.1.3z"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st215",
    d: "m246.8 150.7 36.2 11.8.2-.3-36.3-11.8-.1.3z"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st215",
    d: "m246.6 150.9 36.3 11.8.2-.3-36.3-11.8-.2.3z"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st215",
    d: "m246.5 151.1 36.3 11.8.2-.3-36.3-11.8-.2.3z"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st215",
    d: "m246.4 151.3 36.3 11.9.2-.4-36.3-11.8-.2.3z"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st214",
    d: "m246.3 151.6 36.2 11.8.2-.3-36.2-11.9-.2.4z"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st214",
    d: "m246.2 151.8 36.2 11.8.2-.3-36.2-11.9-.2.4z"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st214",
    d: "m246.1 152 36.2 11.8.2-.3-36.3-11.8-.1.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8ab8f4"
    },
    d: "m245.9 152.2 36.2 11.8.2-.3-36.2-11.8-.2.3z"
  }), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st213",
    d: "m245.8 152.4 36.2 11.8.2-.3-36.2-11.8-.2.3z"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st212",
    d: "m245.7 152.6 36.2 11.8.2-.3-36.2-11.8-.2.3z"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st212",
    d: "m245.6 152.9 36.2 11.7.2-.3-36.2-11.8-.2.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8dbaf4"
    },
    d: "m245.5 153.1 36.1 11.7.2-.3-36.2-11.7-.1.3z"
  }), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st211",
    d: "m245.3 153.3 36.2 11.7.2-.3-36.2-11.7-.2.3z"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st210",
    d: "m245.2 153.5 36.2 11.7.2-.3-36.2-11.7-.2.3z"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st210",
    d: "m245.1 153.7 36.1 11.7.2-.3-36.1-11.7-.2.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#92bff6"
    },
    d: "m245 153.9 36.1 11.8.2-.4-36.1-11.7-.2.3z"
  }), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st207",
    d: "m244.9 154.1 36 11.8.2-.3-36.1-11.8-.1.3z"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st207",
    d: "m244.7 154.4 36.1 11.7.2-.3-36.1-11.8-.2.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#97c3f6"
    },
    d: "m244.6 154.6 36.1 11.7.2-.3-36.1-11.8-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#99c3f6"
    },
    d: "m244.5 154.8 36 11.7.2-.3-36-11.7-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9bc3f6"
    },
    d: "m244.4 155 36 11.7.2-.3-36.1-11.7-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9dc5f7"
    },
    d: "m244.2 155.2 36 11.7.2-.3-36-11.7-.2.3z"
  }), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st203",
    d: "m244.1 155.4 36 11.7.2-.3-36-11.7-.2.3z"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st202",
    d: "m244 155.6 35.9 11.7.3-.3-36-11.7-.2.3z"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st201",
    d: "m243.9 155.8 35.9 11.7.2-.3-36-11.7-.1.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a5c9f7"
    },
    d: "m243.7 156.1 35.9 11.6.3-.3-36-11.7-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a8cbf7"
    },
    d: "m243.6 156.3 35.9 11.6.2-.3-35.9-11.7-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#aacef7"
    },
    d: "m243.5 156.5 35.8 11.6.3-.3-35.9-11.6-.2.3z"
  }), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st198",
    d: "m243.3 156.7 35.9 11.6.2-.3-35.9-11.6-.2.3z"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st197",
    d: "m243.2 156.9 35.8 11.6.3-.3-35.9-11.6-.2.3z"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st226",
    d: "m243.1 157.1 35.8 11.6.2-.3-35.8-11.6-.2.3z"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st196",
    d: "m243 157.3 35.7 11.7.3-.4-35.9-11.6-.1.3z"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st195",
    d: "m242.8 157.5 35.8 11.6.2-.3-35.8-11.6-.2.3z"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st194",
    d: "m242.7 157.7 35.7 11.6.2-.3-35.7-11.6-.2.3z"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st193",
    d: "m242.6 157.9 35.6 11.6.3-.3-35.7-11.6-.2.3z"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st227",
    d: "m242.4 158.1 35.7 11.7.2-.4-35.7-11.6-.2.3z"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st228",
    d: "m242.3 158.3 35.6 11.7.3-.4-35.7-11.6-.2.3z"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st191",
    d: "m242.2 158.6 35.6 11.6.2-.3-35.6-11.7-.2.4z"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st190",
    d: "m242 158.8 35.6 11.5.2-.2-35.6-11.7-.2.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#c6dffa"
    },
    d: "m241.9 159 35.5 11.6.3-.4-35.6-11.5-.2.3z"
  }), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st189",
    d: "m241.8 159.2 35.5 11.6.2-.4-35.5-11.5-.2.3z"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st188",
    d: "m241.6 159.4 35.5 11.5.2-.2-35.5-11.6-.2.3z"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st187",
    d: "m241.5 159.6 35.4 11.5.3-.3-35.5-11.5-.2.3z"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st230",
    d: "m241.3 159.8 35.4 11.6.3-.4-35.5-11.5-.2.3z"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st186",
    d: "m241.2 160 35.4 11.5.3-.3-35.5-11.5-.2.3z"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st231",
    d: "m241.1 160.2 35.3 11.5.3-.2-35.4-11.6-.2.3z"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st184",
    d: "m240.9 160.5 35.3 11.4.3-.3-35.3-11.5-.3.4z"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st232",
    d: "m240.8 160.7 35.3 11.4.2-.3-35.3-11.4-.2.3z"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st182",
    d: "m240.7 160.9 35.2 11.4.3-.3-35.3-11.4-.2.3z"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st233",
    d: "m240.5 161.1 35.2 11.4.3-.3-35.3-11.4-.2.3z"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st181",
    d: "m240.4 161.3 35.1 11.4.3-.3-35.2-11.4-.2.3z"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st180",
    d: "m240.2 161.5 35.1 11.4.3-.3-35.2-11.4-.2.3z"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st234",
    d: "m240.1 161.7 35.1 11.4.3-.3-35.2-11.4-.2.3z"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st235",
    d: "m240 161.9 35 11.4.1-.1.2-.2-35.1-11.4-.2.3z"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st178",
    d: "m239.8 162.1 35 11.4.3-.3-35-11.4-.3.3z"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st177",
    d: "m239.7 162.3 34.9 11.3.3-.3-35-11.4-.2.4z"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st176",
    d: "m239.5 162.5 34.8 11.3.3-.3-35-11.4-.1.4z"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st236",
    d: "m239.4 162.7 34.8 11.3.3-.3-34.9-11.4-.2.4z"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st175",
    d: "m239.2 162.9 34.7 11.3.3-.3-34.8-11.3-.2.3z"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st162",
    d: "m239.1 163.1 34.6 11.2.3-.3-34.7-11.3-.2.4z"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "m239 163.3 34.5 11.2c.1-.1.3-.2.4-.3L239.2 163l-.2.3z"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "m238.8 163.5 34.4 11.2c.1-.1.2-.2.4-.2L239 163.2l-.2.3z"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st174",
    d: "m238.7 163.8 34.3 11.1c.1-.1.3-.2.4-.2l-34.5-11.2-.2.3z"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st159",
    d: "m238.5 164 34.2 11.1c.1-.1.3-.2.4-.2l-34.4-11.2-.2.3z"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m239.5 164.5 32.8 10.7c.2-.1.3-.2.5-.2l-34.2-11.1-.1.2 1 .4z"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m241.7 165.5 30.4 9.9c.2-.1.3-.1.5-.2l-34.1-11.1 3.2 1.4z"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m244.2 166.6 27.6 9c.2-.1.3-.1.5-.2L240.6 165l3.6 1.6z"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m246.3 167.5 25.1 8.2c.2-.1.3-.1.5-.2l-29.1-9.5 3.5 1.5z"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m248.5 168.5 22.5 7.3c.2-.1.4-.1.6-.2l-26.4-8.6 3.3 1.5z"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st156",
    d: "m250.7 169.4 19.9 6.5c.2-.1.4-.1.6-.2l-23.7-7.7 3.2 1.4z"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m253.1 170.5 17.1 5.6c.2 0 .4-.1.6-.2l-21.2-6.9 3.5 1.5z"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m255.2 171.4 14.5 4.7c.2 0 .5-.1.7-.1l-18.6-6.1 3.4 1.5z"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m270 176.1-15.8-5.1 10.4 4.5c1.7.8 3.6.9 5.4.6z"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st237",
    d: "m171 41.8 7.8 2.3c-1-.6-2-1.2-3-1.5-1.6-.6-3.2-.8-4.8-.8z"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st237",
    d: "m169.2 41.9 11 3.3c-.8-.7-1.6-1.2-2.4-1.7l-5.5-1.7c-1.1 0-2.1 0-3.1.1z"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "m167.8 42.1 13.4 4c-.5-.5-1.1-1-1.6-1.5l-9.5-2.9c-.8.2-1.5.3-2.3.4z"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "m166.6 42.4 15.4 4.7c-.4-.5-.8-.9-1.3-1.4L168.5 42c-.7.1-1.3.2-1.9.4z"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "m165.5 42.7 17.2 5.2c-.3-.5-.7-.9-1.1-1.3l-14.5-4.4c-.5.2-1.1.3-1.6.5z"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "m164.5 43.1 5.9 1.8c.9.1 1.8.3 2.7.6.5.2 1 .4 1.5.7l8.6 2.6-.9-1.2-16.3-5c-.5.1-1 .3-1.5.5z"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "m163.5 43.4 4.7 1.4c1.7-.2 3.3 0 4.9.6 1.2.4 2.3 1.1 3.3 1.9l7.4 2.2c-.3-.4-.5-.8-.8-1.2l-18-5.4c-.5.2-1 .3-1.5.5z"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st239",
    d: "M162.7 43.8c.4-.2.9-.4 1.3-.6l5.1 1.6c-.8 0-1.6.1-2.4.3l-4-1.3zm14.7 4.5c-.6-.6-1.1-1.1-1.8-1.5l7.9 2.4c.2.4.5.8.7 1.2l-6.8-2.1z"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st239",
    d: "M161.8 44.2c.4-.2.8-.4 1.3-.6l4.4 1.3c-.6.1-1.3.2-1.9.4l-3.8-1.1zm16.4 5c-.4-.5-.8-.9-1.3-1.4L184 50l.6 1.2-6.4-2z"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st240",
    d: "m161.1 44.6 1.2-.6 3.9 1.2c-.5.1-1.1.3-1.6.5l-3.5-1.1zm17.8 5.4c-.3-.5-.7-.9-1-1.3l6.6 2 .6 1.2-6.2-1.9z"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st241",
    d: "m160.3 45.1 1.2-.6 3.6 1.1c-.5.2-1 .3-1.5.5l-3.3-1zm19.1 5.7c-.3-.4-.6-.9-.9-1.3l6.3 1.9c.2.4.4.8.5 1.2l-5.9-1.8z"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st241",
    d: "M159.6 45.5c.4-.2.7-.4 1.1-.6l3.4 1c-.4.2-.9.4-1.4.6l-3.1-1zm20.3 6.1c-.2-.4-.5-.8-.7-1.2l6.1 1.8c.2.4.3.7.5 1.1l-5.9-1.7z"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st241",
    d: "M158.9 45.9c.4-.2.7-.4 1.1-.7l3.2 1c-.4.2-.8.4-1.3.6l-3-.9zm21.4 6.5c-.2-.4-.4-.8-.7-1.2l5.9 1.8c.2.4.3.7.5 1.1l-5.7-1.7z"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st242",
    d: "M158.2 46.4c.3-.2.7-.5 1-.7l3 .9-1.2.6-2.8-.8zm22.5 6.8-.6-1.2 5.8 1.7c.1.4.3.7.4 1.1l-5.6-1.6z"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st242",
    d: "M157.5 46.8c.3-.2.7-.5 1-.7l2.9.9c-.4.2-.8.4-1.1.6l-2.8-.8zm23.5 7.1c-.2-.4-.3-.8-.5-1.1l5.7 1.7c.1.4.3.7.4 1.1l-5.6-1.7z"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st243",
    d: "M156.9 47.3c.3-.2.6-.5 1-.7l2.8.9c-.4.2-.7.4-1.1.6l-2.7-.8zm24.4 7.4c-.1-.4-.3-.8-.5-1.1l5.6 1.7c.1.4.2.7.4 1.1l-5.5-1.7z"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st243",
    d: "M156.3 47.8c.3-.2.6-.5 1-.7l2.8.8c-.3.2-.7.4-1.1.7l-2.7-.8zm25.3 7.6c-.1-.4-.3-.8-.4-1.1l5.5 1.7c.1.4.2.7.3 1.1l-5.4-1.7z"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st243",
    d: "M155.7 48.2c.3-.2.6-.5.9-.7l2.7.8c-.3.2-.7.4-1 .7l-2.6-.8zm26.1 7.9c-.1-.4-.2-.7-.4-1.1l5.4 1.6c.1.3.2.7.3 1.1l-5.3-1.6z"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st244",
    d: "M155.1 48.7c.3-.2.6-.5.9-.7l2.6.8c-.3.2-.6.5-1 .7l-2.5-.8zm27 8.2c-.1-.4-.2-.7-.3-1.1l5.4 1.6c.1.4.2.7.3 1.1l-5.4-1.6z"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st245",
    d: "M154.5 49.2c.3-.2.6-.5.9-.7l2.6.8c-.3.2-.6.5-1 .7l-2.5-.8zm27.8 8.4c-.1-.4-.2-.7-.3-1.1l5.3 1.6c.1.4.2.7.3 1.1l-5.3-1.6z"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st245",
    d: "M153.9 49.7c.3-.2.6-.5.9-.7l2.6.8c-.3.2-.6.5-.9.7l-2.6-.8zm28.5 8.6c-.1-.4-.2-.7-.3-1.1l5.3 1.6c.1.3.2.7.2 1l-5.2-1.5z"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st245",
    d: "M153.4 50.2c.3-.2.6-.5.8-.7l2.5.8c-.3.2-.6.5-.9.7l-2.4-.8zm29.2 8.8c-.1-.4-.2-.7-.3-1.1l5.3 1.6c.1.3.2.7.2 1.1l-5.2-1.6z"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st246",
    d: "M152.8 50.7c.3-.3.6-.5.8-.7l2.5.8c-.3.2-.6.5-.9.7l-2.4-.8zm30 9c-.1-.4-.2-.7-.2-1.1l5.2 1.6c.1.3.1.7.2 1.1l-5.2-1.6z"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st247",
    d: "M152.3 51.1c.3-.3.5-.5.8-.7l2.5.7c-.3.2-.6.5-.8.7l-2.5-.7zm30.6 9.3c-.1-.3-.1-.7-.2-1l5.2 1.6c.1.3.1.7.2 1l-5.2-1.6z"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st248",
    d: "M151.8 51.6c.3-.2.5-.5.8-.7l2.4.7c-.3.2-.5.5-.8.7l-2.4-.7zm31.3 9.5c-.1-.4-.1-.7-.2-1l5.2 1.6c.1.3.1.7.2 1l-5.2-1.6z"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st248",
    d: "m151.3 52.1.8-.8 2.4.7c-.3.2-.5.5-.8.8l-2.4-.7zm31.9 9.7c-.1-.4-.1-.7-.2-1.1l5.2 1.6c.1.3.1.7.2 1.1l-5.2-1.6z"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st249",
    d: "m150.8 52.6.8-.8 2.4.7c-.3.2-.5.5-.8.7l-2.4-.6zm32.5 9.8c-.1-.3-.1-.7-.2-1l5.1 1.6c.1.3.1.7.1 1l-5-1.6z"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st249",
    d: "M150.3 53.1c.2-.3.5-.5.7-.7l2.4.7c-.3.2-.5.5-.8.7l-2.3-.7zm33.1 10c0-.4-.1-.7-.2-1l5.1 1.5c0 .3.1.7.1 1l-5-1.5z"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st250",
    d: "M149.8 53.6c.2-.3.5-.5.7-.8l2.4.7-.8.8-2.3-.7zm33.7 10.2c0-.4-.1-.7-.1-1l5.1 1.5c0 .3.1.7.1 1l-5.1-1.5z"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st250",
    d: "M149.3 54.1c.2-.3.5-.5.7-.8l2.4.7c-.2.2-.5.5-.7.8l-2.4-.7zm34.2 10.4c0-.3-.1-.7-.1-1l5.1 1.5c0 .3.1.7.1 1l-5.1-1.5z"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st251",
    d: "M148.8 54.7c.2-.3.5-.5.7-.8l2.4.7c-.2.2-.5.5-.7.8l-2.4-.7zm34.8 10.5c0-.3-.1-.7-.1-1l5.1 1.5c0 .3.1.7.1 1l-5.1-1.5z"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st251",
    d: "M148.4 55.2c.2-.3.5-.5.7-.8l2.3.7c-.2.2-.5.5-.7.8l-2.3-.7zm35.3 10.6c0-.3-.1-.7-.1-1l5.1 1.5c0 .3.1.7.1 1l-5.1-1.5z"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st251",
    d: "M147.9 55.7c.2-.3.5-.5.7-.8l2.3.7c-.2.3-.5.5-.7.8l-2.3-.7zm35.8 10.8c0-.3-.1-.7-.1-1l5.1 1.5c0 .3.1.7.1 1l-5.1-1.5z"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st252",
    d: "M147.4 56.2c.2-.3.5-.5.7-.8l2.3.7c-.2.3-.5.5-.7.8l-2.3-.7zm36.4 11c0-.3 0-.7-.1-1l5.1 1.5c0 .3 0 .7.1 1l-5.1-1.5z"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st252",
    d: "M147 56.7c.2-.3.4-.5.7-.8l2.3.7c-.2.3-.4.5-.7.8l-2.3-.7zm36.8 11.1c0-.3 0-.7-.1-1l5.1 1.5c0 .3 0 .7.1 1l-5.1-1.5z"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st253",
    d: "M146.6 57.2c.2-.3.4-.5.7-.8l2.3.7c-.2.3-.5.5-.7.8l-2.3-.7zm37.2 11.3c0-.3 0-.7-.1-1l5.1 1.5v1l-5-1.5z"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st254",
    d: "M146.1 57.8c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm37.8 11.4v-1l5.1 1.5v1l-5.1-1.5z"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st254",
    d: "M145.7 58.3c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm38.2 11.5v-1l5.1 1.5v1l-5.1-1.5z"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st255",
    d: "M145.3 58.8c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm38.6 11.7v-1L189 71v1l-5.1-1.5z"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st256",
    d: "M144.9 59.3c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm39 11.8v-1l5.1 1.5v1l-5.1-1.5z"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st256",
    d: "M144.5 59.8c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm39.4 12v-1l5.1 1.5v1l-5.1-1.5z"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st257",
    d: "M144 60.4c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm39.9 12v-1L189 73v1l-5.1-1.6z"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st257",
    d: "M143.6 60.9c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm40.3 12.2v-1l5.1 1.5v1l-5.1-1.5z"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st257",
    d: "M143.3 61.4c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm40.6 12.3v-1l5.1 1.5v1l-5.1-1.5z"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st258",
    d: "M142.9 62c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm41 12.4v-1l5.1 1.5v1l-5.1-1.5z"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st259",
    d: "M142.5 62.5c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zM183.8 75v-1l5.1 1.5v1l-5.1-1.5z"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st259",
    d: "M142.1 63c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm41.7 12.7v-1l5.1 1.5v1l-5.1-1.5z"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st259",
    d: "M141.7 63.6c.2-.3.4-.6.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm42.1 12.7v-.9l5.1 1.5v.9l-5.1-1.5z"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st260",
    d: "M141.3 64.1c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm42.4 12.8c0-.3 0-.6.1-.9l5.1 1.5c0 .3 0 .6-.1.9l-5.1-1.5z"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st260",
    d: "M141 64.7c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.5.8l-2.4-.7zm42.7 12.9c0-.3 0-.6.1-1l5.1 1.5c0 .3 0 .6-.1 1l-5.1-1.5z"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st261",
    d: "M140.6 65.2c.2-.3.4-.5.6-.8l2.3.7c-.2.3-.4.5-.6.8l-2.3-.7zm43 13c0-.3 0-.6.1-.9l5.1 1.5c0 .3 0 .6-.1.9l-5.1-1.5z"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st261",
    d: "M140.2 65.8c.2-.3.4-.5.5-.8l2.3.7c-.2.3-.4.5-.5.8l-2.3-.7zm43.4 13c0-.3 0-.6.1-.9l5.1 1.5c0 .3 0 .6-.1.9l-5.1-1.5z"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st261",
    d: "M139.9 66.3c.2-.3.3-.5.5-.8l2.3.7c-.2.3-.4.5-.5.8l-2.3-.7zm43.6 13.2c0-.3.1-.6.1-1l5.1 1.5c0 .3-.1.6-.1 1l-5.1-1.5z"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st262",
    d: "M139.5 66.9c.2-.3.4-.6.5-.8l2.3.7c-.2.3-.4.6-.5.8l-2.3-.7zm44 13.2c0-.3.1-.6.1-.9l5.1 1.5c0 .3-.1.6-.1.9l-5.1-1.5z"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st263",
    d: "M139.2 67.4c.2-.3.3-.5.5-.8l2.3.7c-.2.3-.3.5-.5.8l-2.3-.7zm44.2 13.3c0-.3.1-.6.1-.9l5.1 1.5c0 .3-.1.6-.1.9l-5.1-1.5z"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st263",
    d: "M138.8 67.9c.2-.3.3-.5.5-.8l2.3.7c-.2.3-.3.5-.5.8l-2.3-.7zm44.6 13.5c0-.3.1-.6.1-1l5.1 1.5c0 .3-.1.6-.1 1l-5.1-1.5z"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st264",
    d: "M138.5 68.5c.2-.3.3-.6.5-.8l2.3.7c-.2.3-.3.6-.5.8l-2.3-.7zM183.3 82c0-.3.1-.6.1-.9l5.1 1.5c0 .3-.1.6-.1.9l-5.1-1.5z"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st264",
    d: "M138.2 69c.2-.3.3-.5.5-.8l2.3.7c-.2.3-.3.5-.5.8l-2.3-.7zm45 13.6c0-.3.1-.6.1-.9l5.1 1.5c0 .3-.1.6-.1.9l-5.1-1.5z"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st264",
    d: "M137.8 69.6c.2-.3.3-.5.5-.8l2.3.7c-.2.3-.3.5-.5.8l-2.3-.7zm45.3 13.7c0-.3.1-.6.1-1l5.1 1.5c0 .3-.1.6-.1 1l-5.1-1.5z"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "M137.5 70.2c.2-.3.3-.6.5-.8l2.3.7c-.2.3-.3.6-.5.8l-2.3-.7zM183 83.9c0-.3.1-.6.1-.9l5.1 1.5c0 .3-.1.6-.1.9l-5.1-1.5z"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "M137.2 70.7c.2-.3.3-.5.5-.8l2.3.7c-.2.3-.3.5-.5.8l-2.3-.7zM183 84.5c0-.3.1-.6.1-.9l5.1 1.5c0 .3-.1.6-.1.9l-5.1-1.5z"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st152",
    d: "M136.9 71.3c.2-.3.3-.6.5-.8l2.3.7c-.2.3-.3.5-.5.8l-2.3-.7zm46 13.9c0-.3.1-.6.1-.9l5.1 1.5c0 .3-.1.6-.1 1l-5.1-1.6z"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st265",
    d: "M136.5 71.8c.2-.3.3-.6.5-.9l2.3.7c-.2.3-.3.6-.5.9l-2.3-.7zm46.3 14c0-.3.1-.6.1-.9l5.1 1.5c0 .3-.1.6-.1.9l-5.1-1.5z"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "M136.2 72.4c.2-.3.3-.6.5-.8l2.3.7c-.2.3-.3.5-.5.8l-2.3-.7zm46.5 14c0-.3.1-.6.1-.9l5.1 1.5c0 .3-.1.6-.1.9l-5.1-1.5z"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "M135.9 72.9c.2-.3.3-.5.5-.8l2.3.7c-.2.3-.3.5-.5.8l-2.3-.7zM182.6 87c.1-.3.1-.6.1-.9l5.1 1.5c0 .3-.1.6-.1.9l-5.1-1.5z"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st154",
    d: "M135.6 73.5c.2-.3.3-.6.5-.8l2.3.7c-.2.3-.3.6-.5.8l-2.3-.7zm46.9 14.1c.1-.3.1-.6.2-.9l5.1 1.5c0 .3-.1.6-.1.9l-5.2-1.5z"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st154",
    d: "M135.3 74c.1-.3.3-.5.5-.8l2.3.7c-.1.3-.3.5-.4.8l-2.4-.7zm47.1 14.2c.1-.3.1-.6.2-.9l5.1 1.5c0 .3-.1.6-.1.9l-5.2-1.5z"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "M135 74.6c.1-.3.3-.6.4-.8l2.3.7c-.1.3-.3.5-.4.8l-2.3-.7zm47.3 14.3c.1-.3.1-.6.2-.9l5.1 1.5c-.1.3-.1.6-.2 1l-5.1-1.6z"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "M134.7 75.2c.2-.3.3-.6.5-.9l2.3.7c-.2.3-.3.6-.5.9l-2.3-.7zm47.4 14.3c.1-.3.1-.6.2-.9l5.1 1.5c-.1.3-.1.6-.2.9l-5.1-1.5z"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st265",
    d: "M134.4 75.7c.2-.3.3-.6.5-.9l2.3.7c-.2.3-.3.6-.4.9l-2.4-.7zM182 90.1c.1-.3.1-.6.2-.9l5.1 1.5c-.1.3-.1.6-.2.9l-5.1-1.5z"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st152",
    d: "M134.1 76.3c.1-.3.3-.6.4-.8l2.3.7c-.1.3-.3.6-.4.8l-2.3-.7zm47.8 14.4c.1-.3.1-.6.2-.9l5.1 1.5c-.1.3-.1.6-.2.9l-5.1-1.5z"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "M133.8 76.9c.1-.3.3-.6.4-.9l2.3.7c-.1.3-.3.6-.4.9l-2.3-.7zm48 14.5c.1-.3.1-.6.2-.9l5.1 1.5c-.1.3-.1.6-.2.9l-5.1-1.5z"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "M133.5 77.4c.1-.3.3-.6.4-.9l2.3.7c-.1.3-.3.6-.4.9l-2.3-.7zm48.2 14.5c.1-.3.1-.6.2-.9l5.1 1.6c-.1.3-.1.6-.2.9l-5.1-1.6z"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "M133.2 78c.1-.3.3-.6.4-.8l2.3.7c-.1.3-.3.6-.4.8l-2.3-.7zm48.3 14.6c.1-.3.1-.6.2-.9l5.1 1.5c-.1.3-.1.6-.2.9l-5.1-1.5z"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st264",
    d: "M132.9 78.6c.1-.3.3-.6.4-.9l2.3.7c-.1.3-.3.6-.4.9l-2.3-.7zm48.5 14.6c.1-.3.1-.6.2-.9l5.1 1.6c-.1.3-.1.6-.2.9l-5.1-1.6z"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st264",
    d: "M132.7 79.1c.1-.3.3-.6.4-.9l2.3.7c-.1.3-.3.6-.4.9l-2.3-.7zm48.6 14.7c.1-.3.1-.6.2-.9l5.1 1.6c-.1.3-.1.6-.2.9l-5.1-1.6z"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st264",
    d: "M132.4 79.7c.1-.3.3-.6.4-.8l2.3.7c-.1.3-.3.6-.4.8l-2.3-.7zm48.7 14.7c.1-.3.1-.6.2-.9l5.1 1.6c-.1.3-.1.6-.2.9l-5.1-1.6z"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st263",
    d: "M132.1 80.3c.1-.3.3-.6.4-.9l2.3.7c-.1.3-.3.6-.4.9l-2.3-.7zM181 95c.1-.3.1-.6.2-.9l5.2 1.6c-.1.3-.1.6-.2.9L181 95z"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st263",
    d: "M131.9 80.8c.1-.3.3-.6.4-.9l2.3.7c-.1.3-.3.6-.4.9l-2.3-.7zm49 14.8c.1-.3.1-.6.2-.9l5.2 1.6c-.1.3-.1.6-.2.9l-5.2-1.6z"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st263",
    d: "M131.6 81.4c.1-.3.3-.6.4-.8l2.3.7c-.1.3-.3.6-.4.8l-2.3-.7zm49.1 14.8c.1-.3.1-.6.2-.9l5.2 1.6c-.1.3-.1.6-.2.9l-5.2-1.6z"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st262",
    d: "M131.3 82c.1-.3.3-.6.4-.9l2.3.7c-.1.3-.3.6-.4.9l-2.3-.7zm49.3 14.8.2-.9 5.2 1.6c-.1.3-.1.6-.2.9l-5.2-1.6z"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st261",
    d: "M131.1 82.6c.1-.3.3-.6.4-.9l2.3.7c-.1.3-.3.6-.4.9l-2.3-.7zm49.3 14.8c.1-.3.2-.6.2-.9l5.2 1.6c-.1.3-.1.6-.2.9l-5.2-1.6z"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st261",
    d: "M130.8 83.1c.1-.3.3-.6.4-.8l2.3.7c-.1.3-.3.6-.4.8l-2.3-.7zm49.5 15c.1-.3.2-.6.2-.9l5.2 1.6c-.1.3-.2.6-.2.9l-5.2-1.6z"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st261",
    d: "M130.5 83.7c.1-.3.3-.6.4-.9l2.3.7c-.1.3-.3.6-.4.9l-2.3-.7zm49.6 15c.1-.3.2-.6.2-.9l5.2 1.6c-.1.3-.1.6-.2.9l-5.2-1.6z"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st260",
    d: "M130.3 84.3c.1-.3.3-.6.4-.9l2.3.7c-.1.3-.3.6-.4.9l-2.3-.7zm49.6 15c.1-.3.2-.6.2-.9l5.2 1.6c-.1.3-.2.6-.2.9l-5.2-1.6z"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st260",
    d: "M130.1 84.9c.1-.3.2-.6.4-.8l2.3.7c-.1.3-.2.6-.4.8l-2.3-.7zm49.7 15c.1-.3.2-.6.2-.9l5.2 1.6c-.1.3-.2.6-.2.9l-5.2-1.6z"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st260",
    d: "M129.8 85.5c.1-.3.3-.6.4-.9l2.3.7c-.1.3-.3.6-.4.9l-2.3-.7zm49.8 15c.1-.3.2-.6.2-.9l5.2 1.6c-.1.3-.2.6-.2.9l-5.2-1.6z"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st259",
    d: "M129.6 86c.1-.3.2-.6.4-.9l2.3.7c-.1.3-.3.6-.4.9l-2.3-.7zm49.9 15.1c.1-.3.2-.6.2-.9l5.2 1.6c-.1.3-.2.6-.2.9l-5.2-1.6z"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st259",
    d: "M129.3 86.6c.1-.3.2-.6.4-.9l2.3.7-.4.9-2.3-.7zm50 15.1.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st259",
    d: "M129.1 87.2c.1-.3.2-.6.4-.9l2.3.7-.4.9-2.3-.7zm50 15.1.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st258",
    d: "M128.8 87.8c.1-.3.2-.6.4-.9l2.3.7c-.1.3-.2.6-.4.9l-2.3-.7zm50.1 15.1.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st257",
    d: "m128.6 88.3.3-.9 2.3.7-.3.9-2.3-.7zm50.2 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st257",
    d: "m128.4 88.9.4-.9 2.3.7c-.1.3-.2.6-.4.9l-2.3-.7zm50.2 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st257",
    d: "m128.2 89.5.3-.9 2.3.7-.3.9-2.3-.7zm50.2 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st256",
    d: "m127.9 90.1.3-.9 2.3.7-.3.9-2.3-.7zm50.3 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st256",
    d: "m127.7 90.7.3-.9 2.3.7-.3.9-2.3-.7zm50.3 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st256",
    d: "m127.5 91.3.3-.9 2.3.7-.3.9-2.3-.7zm50.3 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st255",
    d: "m127.3 91.8.3-.9 2.3.7-.3.9-2.3-.7zm50.3 15.3.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st254",
    d: "m127 92.5.3-.9 2.3.7-.3.9-2.3-.7zm50.4 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st254",
    d: "m126.8 93 .3-.9 2.3.7-.3.9-2.3-.7zm50.4 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st253",
    d: "M126.6 93.6c.1-.2.2-.4.2-.7l.1-.2 2.3.7-.2.5-.1.4-2.3-.7zm50.4 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st253",
    d: "m126.4 94.2.3-.9 2.3.7-.3.9-2.3-.7zm50.4 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st252",
    d: "m126.2 94.8.3-.9 2.3.7-.3.9-2.3-.7zm50.4 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st252",
    d: "m126 95.4.3-.9 2.3.7-.3.9-2.3-.7zm50.4 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st252",
    d: "m125.8 96 .3-.9 2.3.7-.3.9-2.3-.7zm50.4 15.2.1-.3c.1-.2.1-.4.2-.6l5.2 1.6c-.1.2-.2.4-.2.7l-.1.2-5.2-1.6z"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st251",
    d: "m125.6 96.6.3-.9 2.3.7-.3.9-2.3-.7zm50.4 15.2.3-.9 5.2 1.6c-.1.3-.2.5-.3.8l-5.2-1.5z"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st251",
    d: "m125.4 97.2.3-.9 2.3.7-.3.9-2.3-.7zm50.4 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st251",
    d: "m125.2 97.7.3-.9 2.3.7-.3.9-2.3-.7zm50.4 15.3.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st250",
    d: "m125.1 98.4.3-.9 2.3.7-.3.9-2.3-.7zm50.2 15.1.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st250",
    d: "m124.9 98.9.3-.9 2.3.7-.3.9-2.3-.7zm50.2 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st249",
    d: "m124.7 99.5.3-.9 2.3.7-.3.9-2.3-.7zm50.2 15.2.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st249",
    d: "m124.5 100.2.3-.9 2.3.7-.3.9-2.3-.7zm50.2 15.1.3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st248",
    d: "m124.3 100.7.3-.9 2.3.7-.3.9-2.3-.7zm50.1 15.2.4-.9 5.2 1.6c-.1.3-.2.6-.4.9l-5.2-1.6z"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st248",
    d: "m124.2 101.3.3-.9 2.3.7-.3.9-2.3-.7zm50 15.2.4-.9 5.2 1.6c-.1.3-.2.6-.4.9l-5.2-1.6z"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st248",
    d: "m124 102 .3-.9 2.3.7-.3.9-2.3-.7zm50 15 .3-.9 5.2 1.6-.3.9-5.2-1.6z"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st247",
    d: "m123.8 102.5.3-.9 2.3.7-.3.9-2.3-.7zm49.9 15.1c.1-.3.2-.6.4-.9l5.2 1.6c-.1.3-.2.6-.4.9l-5.2-1.6z"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st246",
    d: "M123.7 103.1c.1-.3.2-.6.2-.9l2.3.7-.3.9-2.2-.7zm49.8 15.1c.1-.3.2-.6.4-.9l5.2 1.6-.4.9-5.2-1.6z"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st246",
    d: "m123.5 103.8.3-.9 2.3.7-.3.9-2.3-.7zm49.7 15c.1-.3.2-.6.4-.9l5.2 1.6c-.1.3-.2.6-.4.8l-5.2-1.5z"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st245",
    d: "M123.3 104.4c.1-.3.2-.6.2-.9l2.3.7c-.1.3-.2.6-.2.9l-2.3-.7zm49.7 15c.1-.3.2-.6.4-.9l5.2 1.6c-.1.3-.3.6-.4.9l-5.2-1.6z"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st245",
    d: "M123.2 105c.1-.3.2-.6.2-.9l2.3.7c-.1.3-.2.6-.2.9l-2.3-.7zm49.5 14.9c.1-.3.3-.6.4-.9l5.2 1.6c-.1.3-.3.6-.4.9l-5.2-1.6z"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st245",
    d: "M123 105.6c.1-.3.2-.6.2-.9l2.3.7c-.1.3-.2.6-.2.9l-2.3-.7zm49.5 14.9c.1-.3.2-.6.4-.8l5.2 1.6-.4.8-5.2-1.6z"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st244",
    d: "M122.9 106.2c.1-.3.1-.6.2-.9l2.3.7c-.1.3-.2.6-.2.9l-2.3-.7zm49.3 14.9c.1-.3.2-.6.4-.8l5.2 1.6c-.1.3-.2.6-.4.8l-5.2-1.6z"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st243",
    d: "M122.7 106.8c.1-.3.1-.6.2-.9l2.3.7c-.1.3-.2.6-.2.9l-2.3-.7zm49.3 14.9c.1-.3.3-.6.4-.9l5.2 1.6c-.1.3-.3.6-.4.9l-5.2-1.6z"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st243",
    d: "M122.6 107.4c.1-.3.1-.6.2-.9l2.3.7c-.1.3-.2.6-.2.9l-2.3-.7zm49.1 14.8c.1-.3.3-.6.4-.9l5.2 1.6c-.1.3-.3.6-.4.9l-5.2-1.6z"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st243",
    d: "m122.4 108 .2-.9 2.3.7c-.1.3-.1.6-.2.9l-2.3-.7zm49.1 14.8c.1-.3.3-.6.4-.8l5.2 1.6c-.1.3-.3.6-.4.8l-5.2-1.6z"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st242",
    d: "M122.3 108.6c.1-.3.1-.6.2-.9l2.3.7c-.1.3-.1.6-.2.9l-2.3-.7zm48.9 14.8c.1-.3.3-.6.4-.9l5.2 1.6c-.1.3-.3.6-.4.9l-5.2-1.6z"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st242",
    d: "M122.1 109.2c.1-.3.1-.6.2-.9l2.3.7c-.1.3-.1.6-.2.9l-2.3-.7zm48.8 14.7c.1-.3.3-.6.4-.9l5.2 1.6c-.1.3-.3.6-.4.8l-5.2-1.5z"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st242",
    d: "M122 109.8c.1-.3.1-.6.2-.9l2.3.7c-.1.3-.1.6-.2.9l-2.3-.7zm48.7 14.7.4-.8 5.2 1.6c-.1.3-.3.6-.4.8l-5.2-1.6z"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st241",
    d: "M121.9 110.4c.1-.3.1-.6.2-.9l2.3.7c-.1.3-.1.6-.2.9l-2.3-.7zm48.5 14.7c.1-.3.3-.6.4-.9l5.2 1.6c-.1.3-.3.6-.4.9l-5.2-1.6z"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st241",
    d: "M121.7 111.1c.1-.3.1-.6.2-.9l2.3.7c-.1.3-.1.6-.2.9l-2.3-.7zm48.4 14.5c.1-.3.3-.6.4-.8l5.2 1.6c-.1.3-.3.6-.4.8l-5.2-1.6z"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st241",
    d: "M121.6 111.7c.1-.3.1-.6.2-.9l2.3.7c-.1.3-.1.6-.2.9l-2.3-.7zm48.2 14.5c.1-.3.3-.6.4-.8l5.2 1.6c-.1.3-.3.6-.4.8l-5.2-1.6z"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st240",
    d: "M121.5 112.3c.1-.3.1-.6.2-.9l2.3.7c-.1.3-.1.6-.2.9l-2.3-.7zm48 14.5c.1-.3.3-.6.4-.9l5.2 1.6c-.1.3-.3.6-.4.9l-5.2-1.6z"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st239",
    d: "M121.4 112.9c.1-.3.1-.6.2-.9l2.2.7c-.1.3-.1.6-.2.9l-2.2-.7zm47.8 14.4c.1-.3.3-.6.4-.8l5.2 1.6c-.1.3-.3.6-.4.8l-5.2-1.6z"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st239",
    d: "M121.3 113.5c.1-.3.1-.6.2-.9l2.2.7c-.1.3-.1.6-.2.9l-2.2-.7zm47.7 14.4c.1-.3.3-.6.4-.8l5.2 1.6c-.1.3-.3.6-.4.8l-5.2-1.6z"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st239",
    d: "M121.1 114.1c.1-.3.1-.6.2-.9l2.2.7c-.1.3-.1.6-.2.9l-2.2-.7zm47.6 14.4c.1-.3.3-.6.4-.9l5.2 1.6c-.1.3-.3.6-.4.9l-5.2-1.6z"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "M121 114.8c.1-.3.1-.6.2-.9l2.2.7c-.1.3-.1.6-.2.9l-2.2-.7zm47.4 14.2c.1-.3.3-.6.4-.8l5.2 1.6c-.1.3-.3.6-.4.8l-5.2-1.6z"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "M120.9 115.4c.1-.3.1-.6.2-.9l2.2.7c-.1.3-.1.6-.2.9l-2.2-.7zm47.2 14.2c.1-.3.3-.6.4-.8l5.2 1.6c-.1.3-.3.6-.4.8l-5.2-1.6z"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "M120.8 116c.1-.3.1-.6.2-.9l2.2.7c-.1.3-.1.6-.2.9l-2.2-.7zm47 14.2c.2-.3.3-.6.5-.9l5.2 1.6c-.2.3-.3.6-.5.9l-5.2-1.6z"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "M120.7 116.6c.1-.3.1-.6.2-.9l2.2.7c-.1.3-.1.6-.2.9l-2.2-.7zm46.8 14.1c.2-.3.3-.6.5-.8l5.2 1.6c-.2.3-.3.6-.5.8l-5.2-1.6z"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "M120.6 117.2c0-.3.1-.6.1-.9l2.2.7c-.1.3-.1.6-.2.9l-2.1-.7zm46.6 14.1c.2-.3.3-.6.5-.8l5.2 1.6c-.2.3-.3.6-.5.8l-5.2-1.6z"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "M120.5 117.9c0-.3.1-.6.1-.9l2.2.7c-.1.3-.1.6-.1.9l-2.2-.7zm46.3 14c.2-.3.3-.6.5-.9l5.2 1.6c-.2.3-.3.6-.5.9l-5.2-1.6z"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st237",
    d: "M120.4 118.5c0-.3.1-.6.1-.9l2.2.7c-.1.3-.1.6-.1.9l-2.2-.7zm46.1 13.9c.2-.3.3-.6.5-.8l5.1 1.6c-.2.3-.3.6-.5.8l-5.1-1.6z"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st237",
    d: "M120.3 119.1c0-.3.1-.6.1-1l2.2.7c0 .3-.1.6-.1 1l-2.2-.7zm45.9 13.8c.2-.3.3-.5.5-.8l5.1 1.6c-.2.3-.3.5-.5.8l-5.1-1.6z"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st237",
    d: "M120.3 119.7c0-.3.1-.6.1-.9l2.2.7c0 .3-.1.6-.1.9l-2.2-.7zm45.6 13.8c.2-.3.3-.6.5-.8l5.1 1.6c-.2.3-.3.6-.5.8l-5.1-1.6z"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st266",
    d: "M120.2 120.4c0-.3.1-.6.1-1l2.2.7c0 .3-.1.6-.1 1l-2.2-.7zm45.4 13.7c.2-.3.3-.5.5-.8l5.1 1.6c-.2.3-.3.5-.5.8l-5.1-1.6z"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st266",
    d: "M120.1 121c0-.3.1-.6.1-1l2.2.7c0 .3-.1.6-.1 1l-2.2-.7zm45.1 13.6c.2-.3.3-.5.5-.8l5.1 1.6c-.2.3-.3.5-.5.8l-5.1-1.6z"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st267",
    d: "M120 121.6c0-.3.1-.6.1-.9l2.2.7c0 .3-.1.6-.1.9l-2.2-.7zm44.9 13.6c.2-.3.3-.6.5-.8l5.1 1.5c-.2.3-.3.6-.5.8l-5.1-1.5z"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st267",
    d: "M120 122.3c0-.3.1-.6.1-1l2.2.7c0 .3-.1.6-.1 1l-2.2-.7zm44.6 13.4c.2-.3.3-.5.5-.8l5.1 1.6c-.2.3-.3.5-.5.8l-5.1-1.6z"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st267",
    d: "M119.9 122.9c0-.3.1-.6.1-1l2.2.7c0 .3-.1.6-.1 1l-2.2-.7zm44.3 13.4c.2-.3.3-.5.5-.8l5.1 1.6c-.2.3-.3.5-.5.8l-5.1-1.6z"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st268",
    d: "M119.8 123.5c0-.3.1-.6.1-.9l2.2.7c0 .3-.1.6-.1.9l-2.2-.7zm44.1 13.3c.2-.3.3-.6.5-.8l5.1 1.5c-.2.3-.3.6-.5.8l-5.1-1.5z"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st268",
    d: "M119.8 124.2c0-.3.1-.6.1-1l2.2.7c0 .3-.1.6-.1 1l-2.2-.7zm43.7 13.2c.2-.3.3-.5.5-.8l5.1 1.5c-.2.3-.3.5-.5.8l-5.1-1.5z"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st269",
    d: "M119.7 124.8c0-.3.1-.6.1-1l2.2.7c0 .3-.1.6-.1 1l-2.2-.7zm43.5 13.1c.2-.3.3-.5.5-.8l5.1 1.5c-.2.3-.4.5-.5.8l-5.1-1.5z"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st269",
    d: "M119.7 125.4c0-.3 0-.6.1-.9l2.2.7c0 .3-.1.6-.1.9l-2.2-.7zm43.1 13.1c.2-.3.4-.6.5-.8l5.1 1.5c-.2.3-.4.6-.5.8l-5.1-1.5z"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st269",
    d: "M119.6 126.1c0-.3 0-.6.1-1l2.2.6c0 .3-.1.6-.1 1l-2.2-.6zm42.9 12.9c.2-.3.4-.5.5-.8l5.1 1.5c-.2.3-.4.5-.5.8l-5.1-1.5z"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st270",
    d: "M119.6 126.7c0-.3 0-.6.1-1l2.1.6c0 .3-.1.6-.1 1l-2.1-.6zm42.5 12.8c.2-.3.4-.5.5-.8l5.1 1.5c-.2.3-.4.5-.5.8l-5.1-1.5z"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st270",
    d: "M119.5 127.3c0-.3 0-.6.1-.9l2.1.6c0 .3 0 .6-.1.9l-2.1-.6zm42.2 12.8c.2-.3.4-.5.6-.8l5.1 1.5c-.2.3-.4.6-.6.8l-5.1-1.5z"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st271",
    d: "M119.5 128c0-.3 0-.7.1-1l2.1.6c0 .3 0 .7-.1 1l-2.1-.6zm41.9 12.6c.2-.3.4-.5.6-.8l5.1 1.5c-.2.3-.4.5-.6.8l-5.1-1.5z"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st271",
    d: "M119.5 128.6v-1l2.1.6c0 .3 0 .7-.1 1l-2-.6zm41.5 12.6c.2-.3.4-.5.6-.8l5.1 1.5c-.2.3-.4.5-.6.8l-5.1-1.5z"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st271",
    d: "M119.4 129.3v-1l2.1.6v1l-2.1-.6zm41.2 12.4c.2-.3.4-.5.6-.8l5.1 1.5c-.2.3-.4.5-.6.8l-5.1-1.5z"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st272",
    d: "M119.4 129.9v-1l2.1.6v1l-2.1-.6zm40.8 12.3c.2-.3.4-.5.6-.8l5.1 1.5c-.2.3-.4.5-.6.8l-5.1-1.5z"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st272",
    d: "M119.4 130.6v-1l2.1.6v1l-2.1-.6zm40.4 12.2c.2-.3.4-.5.6-.8l5.1 1.5c-.2.3-.4.5-.6.8l-5.1-1.5z"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st272",
    d: "M119.4 131.2v-1l2.1.6v1l-2.1-.6zm40 12.1c.2-.3.4-.5.6-.8l5.1 1.5c-.2.3-.4.5-.6.8l-5.1-1.5z"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st273",
    d: "M119.4 131.9v-1l2.1.6v1l-2.1-.6zm39.6 11.9c.2-.3.4-.5.6-.8l5.1 1.5c-.2.3-.4.5-.6.8l-5.1-1.5z"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st273",
    d: "M119.4 132.5v-1l2.1.6v1l-2.1-.6zm39.2 11.9c.2-.3.4-.5.6-.8l5.1 1.5c-.2.3-.4.5-.6.8l-5.1-1.5z"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st273",
    d: "M119.4 133.2v-1l2.1.6v1l-2.1-.6zm38.8 11.7c.2-.3.4-.5.6-.8l5.1 1.5c-.2.3-.4.5-.6.8l-5.1-1.5z"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st274",
    d: "M119.4 133.8v-1l2.1.6v1l-2.1-.6zm38.4 11.6c.2-.3.4-.5.6-.8l5.1 1.5c-.2.3-.4.5-.6.8l-5.1-1.5z"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st275",
    d: "M119.4 134.5v-1l2.1.6v1l-2.1-.6zm37.9 11.4c.2-.3.4-.5.6-.8l5.1 1.5c-.2.3-.4.5-.6.8l-5.1-1.5z"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st275",
    d: "M119.4 135.1v-1l2.1.6v1l-2.1-.6zm37.5 11.4c.2-.3.4-.5.7-.8l5.1 1.5c-.2.3-.4.5-.7.8l-5.1-1.5z"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st275",
    d: "M119.5 135.8v-1l2.1.6v1l-2.1-.6zm37 11.2c.2-.3.4-.5.7-.8l5.1 1.5c-.2.3-.4.5-.7.8l-5.1-1.5z"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st112",
    d: "M119.5 136.5v-1l2.1.6v1l-2.1-.6zm36.5 11c.2-.3.4-.5.7-.8l5.1 1.5c-.2.3-.4.5-.7.8l-5.1-1.5z"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st112",
    d: "M119.5 137.1c0-.3 0-.7-.1-1l2.1.6c0 .3 0 .7.1 1l-2.1-.6zm36.1 10.9c.2-.3.5-.5.7-.8l5.1 1.5c-.2.3-.4.5-.7.8l-5.1-1.5z"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st112",
    d: "M119.6 137.8c0-.3 0-.7-.1-1l2.1.6c0 .3 0 .7.1 1l-2.1-.6zm35.5 10.7c.2-.3.5-.5.7-.8l5.1 1.5c-.2.3-.5.5-.7.8l-5.1-1.5z"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st276",
    d: "M119.6 138.5c0-.3-.1-.7-.1-1l2.1.6c0 .3.1.7.1 1l-2.1-.6zm35.1 10.5c.2-.2.5-.5.7-.8l5.1 1.5c-.2.3-.5.5-.7.8l-5.1-1.5z"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st276",
    d: "M119.7 139.1c0-.3-.1-.7-.1-1l2.1.6c0 .3.1.7.1 1l-2.1-.6zm34.5 10.5c.2-.3.5-.5.7-.8l5.1 1.5c-.2.3-.5.5-.7.8l-5.1-1.5z"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st276",
    d: "M119.8 139.8c0-.3-.1-.7-.1-1l2.1.6c0 .3.1.7.1 1l-2.1-.6zm33.9 10.3c.2-.3.5-.5.7-.8l5.1 1.5c-.2.3-.5.5-.7.8l-5.1-1.5z"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st277",
    d: "M119.8 140.5c0-.3-.1-.7-.1-1l2.1.6c0 .3.1.7.1 1l-2.1-.6zm33.4 10.1.7-.7 5.1 1.6c-.2.3-.5.5-.7.7l-5.1-1.6z"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st278",
    d: "M119.9 141.2c0-.3-.1-.7-.1-1l2.1.6c0 .3.1.7.1 1l-2.1-.6zm32.8 9.9c.3-.2.5-.5.8-.8l5.2 1.6c-.2.3-.5.5-.7.8l-5.3-1.6z"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st278",
    d: "M120 141.8c0-.3-.1-.7-.1-1l2.1.6c0 .3.1.7.1 1l-2.1-.6zm32.2 9.8c.3-.2.5-.5.8-.8l5.2 1.6c-.2.3-.5.5-.7.8l-5.3-1.6z"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st278",
    d: "M120.1 142.5c-.1-.3-.1-.7-.1-1l2.1.6c.1.3.1.7.2 1l-2.2-.6zm31.6 9.5c.3-.2.5-.5.8-.7l5.2 1.6c-.3.3-.5.5-.8.7l-5.2-1.6z"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st279",
    d: "M120.2 143.2c-.1-.3-.1-.7-.2-1l2.1.6c.1.3.1.7.2 1l-2.1-.6zm30.9 9.3c.3-.2.5-.5.8-.7l5.2 1.6-.8.8-5.2-1.7z"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st279",
    d: "M120.3 143.9c-.1-.3-.1-.7-.2-1l2.2.7c.1.3.1.7.2 1l-2.2-.7zm30.3 9.1c.3-.2.5-.5.8-.7l5.2 1.6-.8.8-5.2-1.7z"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st108",
    d: "M120.5 144.6c-.1-.3-.1-.7-.2-1l2.2.7c.1.4.1.7.2 1.1l-2.2-.8zm29.5 8.9c.3-.2.6-.5.8-.7l5.2 1.6c-.3.2-.5.5-.8.7l-5.2-1.6z"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "M120.6 145.3c-.1-.3-.1-.7-.2-1l2.2.7c.1.4.2.7.2 1l-2.2-.7zm28.8 8.7c.3-.2.6-.5.9-.7l5.2 1.6c-.3.3-.6.5-.8.7l-5.3-1.6z"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "M120.8 146c-.1-.3-.1-.7-.2-1l2.2.7c.1.4.2.7.3 1l-2.3-.7zm28.1 8.5c.3-.2.6-.5.9-.7l5.3 1.6c-.3.3-.6.5-.8.7l-5.4-1.6z"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "M120.9 146.7c-.1-.4-.2-.7-.2-1.1l2.2.7c.1.4.2.7.3 1.1l-2.3-.7zm27.4 8.2c.3-.2.6-.5.9-.7l5.3 1.6c-.3.2-.6.5-.8.7l-5.4-1.6z"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "M121.1 147.4c-.1-.3-.2-.7-.3-1.1l2.3.7c.1.4.2.7.3 1.1l-2.3-.7zm26.5 8c.3-.2.6-.5.9-.7l5.3 1.6c-.3.2-.6.5-.9.7l-5.3-1.6z"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "M121.3 148.1c-.1-.3-.2-.7-.3-1.1l2.3.7c.1.4.2.7.3 1.1l-2.3-.7zm25.7 7.8c.3-.2.6-.5 1-.7l5.4 1.6c-.3.2-.6.5-.9.7l-5.5-1.6z"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st280",
    d: "M121.5 148.8c-.1-.4-.2-.7-.3-1.1l2.3.7c.1.4.2.7.4 1.1l-2.4-.7zm24.8 7.5c.3-.2.7-.4 1-.7l5.4 1.6c-.3.2-.6.5-.9.7l-5.5-1.6z"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st280",
    d: "M121.7 149.5c-.1-.4-.2-.7-.3-1.1l2.4.7c.1.4.3.7.4 1.1l-2.5-.7zm23.9 7.3c.3-.2.7-.4 1-.7l5.4 1.6c-.3.2-.6.5-.9.7l-5.5-1.6z"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st280",
    d: "M122 150.2c-.1-.4-.2-.7-.3-1.1l2.4.7c.1.4.3.7.4 1.1l-2.5-.7zm22.9 7c.4-.2.7-.4 1.1-.7l5.5 1.7c-.3.2-.6.5-1 .7l-5.6-1.7z"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st281",
    d: "M122.2 151c-.1-.4-.3-.7-.4-1.1l2.5.8c.2.4.3.8.5 1.1l-2.6-.8zm22 6.6c.4-.2.7-.4 1.1-.6l5.6 1.7c-.3.2-.7.5-1 .7l-5.7-1.8z"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st281",
    d: "M122.5 151.7c-.1-.4-.3-.7-.4-1.1l2.6.8c.2.4.4.8.6 1.1l-2.8-.8zm20.9 6.3 1.2-.6 5.6 1.7c-.3.2-.7.5-1 .7l-5.8-1.8z"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st281",
    d: "M122.8 152.5c-.2-.4-.3-.7-.4-1.1l2.6.8.6 1.2-2.8-.9zm19.8 5.9 1.2-.6 5.7 1.7c-.4.2-.7.5-1.1.7l-5.8-1.8z"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st282",
    d: "M123.1 153.2c-.2-.4-.3-.7-.5-1.1l2.8.8c.2.4.5.8.7 1.2l-3-.9zm18.6 5.6c.4-.2.9-.4 1.3-.6l5.8 1.8c-.4.2-.7.4-1.1.6l-6-1.8z"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st282",
    d: "M123.5 154c-.2-.4-.4-.7-.5-1.1l2.9.9c.3.4.5.8.8 1.2l-3.2-1zm17.2 5.2c.5-.2.9-.3 1.4-.5l6 1.8c-.4.2-.8.4-1.1.6l-6.3-1.9z"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st283",
    d: "M123.9 154.7c-.2-.4-.4-.8-.6-1.1l3.1.9c.3.4.6.9 1 1.3l-3.5-1.1zm15.7 4.8c.5-.1 1.1-.3 1.6-.5l6.2 1.9-1.2.6-6.6-2z"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st283",
    d: "M124.3 155.6c-.2-.4-.4-.8-.7-1.2l3.3 1c.4.5.8.9 1.2 1.3l-3.8-1.1zm14 4.2c.6-.1 1.2-.2 1.8-.4l6.4 1.9c-.4.2-.8.4-1.3.6l-6.9-2.1z"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st284",
    d: "M124.8 156.3c-.2-.4-.5-.8-.7-1.2l3.7 1.1c.5.5 1 1 1.6 1.4l-4.6-1.3zm12 3.7c.7 0 1.4-.1 2.1-.3l6.7 2c-.4.2-.9.4-1.3.6l-7.5-2.3z"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st284",
    d: "M125.4 157.2c-.3-.4-.5-.8-.8-1.2l4.1 1.3c.9.8 1.8 1.4 2.8 1.8l-6.1-1.9zm8.8 2.6c1.1.2 2.2.2 3.4 0l7.2 2.2c-.5.2-1 .4-1.4.6l-9.2-2.8z"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st284",
    d: "m126 158 16.4 4.9c.5-.2 1-.3 1.5-.5l-8.2-2.5c-1.2 0-2.3-.2-3.4-.6-.8-.3-1.5-.6-2.2-1.1l-5.1-1.5c.4.5.7.9 1 1.3z"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st285",
    d: "m126.8 158.9 14.5 4.4c.5-.1 1.1-.3 1.6-.5l-17.2-5.2c.3.4.7.9 1.1 1.3z"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st285",
    d: "m127.6 159.8 12.3 3.7c.6-.1 1.3-.2 1.9-.4l-15.5-4.7c.5.5.9 1 1.3 1.4z"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st285",
    d: "m128.8 160.8 9.5 2.9c.7 0 1.5-.1 2.2-.3l-13.4-4.1c.6.6 1.2 1.1 1.7 1.5z"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st286",
    d: "m139.2 163.6-11-3.3c1.3 1.2 2.8 2 4.4 2.6 2.1.8 4.3 1 6.6.7z"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st287",
    d: "M173.1 45.4c-13-4.7-32.7 17.1-44 48.5-11.3 31.4-9.8 60.7 3.2 65.4 13.1 4.7 32.8-17 44-48.5 11.3-31.4 9.8-60.7-3.2-65.4z"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st288",
    d: "M173.4 117.8c0-.1.2-.3.3-.2l-.3.6c0-.1-.1-.2 0-.4z"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st288",
    d: "M173.5 117.8c0 .1 0 .2.1.3l-.1.3c-.2-.1-.3-.4-.2-.6.1-.3.3-.4.5-.3l-.1.3c-.1-.2-.2-.1-.2 0z"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st289",
    d: "M173.3 117.7c-.1.2 0 .4.1.5l-.1.3c-.2-.1-.4-.5-.2-.9.1-.4.4-.6.7-.5h.1l-.1.3c-.2 0-.4.1-.5.3z"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st289",
    d: "M173.2 117.7c-.1.3 0 .6.2.7l-.1.3c-.3-.2-.5-.7-.3-1.1.2-.5.6-.8 1-.6h.1l-.1.3h-.1c-.4-.1-.6 0-.7.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173 117.6c-.1.4 0 .8.3 1l-.1.3c-.4-.2-.6-.8-.4-1.4.2-.6.7-1 1.2-.8 0 0 .1 0 .1.1l-.1.3h-.1c-.4-.2-.8.1-.9.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4680e2"
    }
  }), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st291",
    d: "M172.8 117.6c-.1.5 0 1.1.4 1.3l-.1.3c-.5-.3-.7-1-.5-1.7.2-.7.8-1.1 1.4-.9 0 0 .1 0 .1.1l-.1.3h-.1c-.4-.3-.9 0-1.1.6z"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st291",
    d: "M172.7 117.5c-.2.6 0 1.3.4 1.5l-.1.3c-.5-.3-.8-1.2-.5-1.9.3-.8 1-1.3 1.6-1 0 0 .1 0 .1.1l-.1.3s-.1 0-.1-.1c-.5-.2-1.1.1-1.3.8z"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st292",
    d: "M172.6 117.5c-.2.7 0 1.5.5 1.8l-.1.3c-.6-.4-.9-1.3-.6-2.2.3-1 1.1-1.5 1.8-1.2 0 0 .1 0 .1.1l-.1.3s-.1 0-.1-.1c-.6-.3-1.3.1-1.5 1z"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st292",
    d: "M172.4 117.4c-.3.8 0 1.7.6 2l-.1.3c-.7-.4-1-1.5-.7-2.4.3-1.1 1.2-1.6 2-1.3.1 0 .1 0 .2.1l-.1.3s-.1 0-.1-.1c-.7-.3-1.5.2-1.8 1.1z"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st293",
    d: "M172.3 117.3c-.3.9 0 1.9.6 2.3l-.1.3c-.7-.5-1.1-1.6-.7-2.7.4-1.1 1.4-1.8 2.2-1.4.1 0 .1.1.2.1l-.1.3c-.1 0-.1-.1-.2-.1-.8-.3-1.6.2-1.9 1.2z"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st293",
    d: "M172.1 117.2c-.3 1 0 2.1.7 2.6l-.1.3c-.8-.5-1.1-1.7-.8-2.9.4-1.3 1.5-2 2.5-1.6.1 0 .1.1.2.1l-.1.3c-.1 0-.1-.1-.2-.1-.9-.4-1.9.2-2.2 1.3z"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st294",
    d: "M172 117.2c-.4 1.1 0 2.3.7 2.8l-.1.3c-.9-.5-1.3-1.9-.9-3.2.4-1.4 1.6-2.2 2.7-1.7.1 0 .1.1.2.1l-.1.3c-.1 0-.1-.1-.2-.1-.9-.4-2 .3-2.3 1.5z"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st294",
    d: "M171.8 117.1c-.4 1.2 0 2.5.8 3.1l-.1.3c-1-.6-1.4-2.1-.9-3.4.5-1.5 1.8-2.3 2.9-1.8.1 0 .1.1.2.1l-.1.3c-.1 0-.1-.1-.2-.1-1-.6-2.2.2-2.6 1.5z"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st295",
    d: "M171.6 117.1c-.4 1.4 0 2.8.9 3.3l-.1.3c-1-.6-1.5-2.2-1-3.7.5-1.6 1.9-2.5 3.1-2 .1 0 .1.1.2.1l-.1.3c-.1 0-.1-.1-.2-.1-1-.5-2.3.3-2.8 1.8z"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st295",
    d: "M171.5 117c-.4 1.4 0 3 1 3.6l-.1.3c-1.1-.7-1.6-2.4-1.1-3.9.5-1.7 2-2.7 3.3-2.1.1 0 .1.1.2.1l-.1.3c-.1 0-.1-.1-.2-.1-1.2-.6-2.5.2-3 1.8z"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st296",
    d: "M171.3 116.9c-.5 1.5 0 3.2 1 3.8l-.1.3c-1.1-.7-1.7-2.5-1.1-4.2.6-1.8 2.2-2.9 3.5-2.3.1 0 .2.1.3.1l-.1.3c-.1 0-.1-.1-.2-.1-1.3-.5-2.7.5-3.3 2.1z"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st296",
    d: "M171.2 116.9c-.5 1.6 0 3.4 1.1 4.1l-.1.3c-1.2-.8-1.8-2.7-1.2-4.5.6-1.9 2.3-3 3.7-2.4.1 0 .2.1.3.1l-.1.3c-.1 0-.1-.1-.2-.1-1.4-.6-3 .4-3.5 2.2z"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st296",
    d: "M171.1 116.8c-.5 1.7 0 3.6 1.2 4.3l-.1.3c-1.3-.8-1.9-2.8-1.3-4.7.6-2.1 2.4-3.2 4-2.6.1 0 .2.1.3.1l-.1.3c-.1 0-.2-.1-.3-.1-1.5-.5-3.2.5-3.7 2.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.9 116.7c-.6 1.8 0 3.8 1.2 4.6l-.1.3c-1.3-.9-1.9-3-1.3-5 .7-2.2 2.5-3.4 4.2-2.7.1 0 .2.1.3.1l-.1.3c-.1 0-.2-.1-.3-.1-1.5-.6-3.3.5-3.9 2.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4d85e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.8 116.7c-.6 1.9 0 4 1.3 4.8l-.1.3c-1.4-.9-2-3.1-1.4-5.2.7-2.3 2.7-3.6 4.4-2.8.1 0 .2.1.3.2l-.1.3c-.1-.1-.2-.1-.3-.1-1.6-.8-3.5.4-4.1 2.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4e85e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.6 116.6c-.7 2.1 0 4.2 1.3 5.1l-.1.3c-1.5-1-2.1-3.3-1.5-5.5.8-2.4 2.8-3.7 4.6-2.9.1 0 .2.1.3.1l-.1.3c-.1-.1-.2-.1-.3-.1-1.6-.7-3.5.5-4.2 2.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4e87e3"
    }
  }), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st300",
    d: "M170.4 116.5c-.7 2.1 0 4.4 1.4 5.3l-.1.3c-1.6-1-2.2-3.4-1.5-5.7.8-2.5 3-3.9 4.8-3.1.1 0 .2.1.3.2l-.1.3c-.1-.1-.2-.1-.3-.2-1.7-.7-3.7.6-4.5 2.9z"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st300",
    d: "M170.3 116.5c-.7 2.2 0 4.6 1.5 5.6l-.1.3c-1.6-1.1-2.3-3.6-1.6-6 .8-2.6 3.1-4.1 5.1-3.2.1 0 .2.1.3.1l-.1.3c-.1-.1-.2-.1-.3-.1-1.9-.8-4 .5-4.8 3z"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st300",
    d: "M170.1 116.4c-.7 2.3 0 4.8 1.6 5.8l-.1.3c-1.7-1.1-2.4-3.7-1.7-6.2.8-2.7 3.2-4.2 5.2-3.4.1.1.2.1.3.2l-.1.3c-.1-.1-.2-.1-.3-.2-1.9-.8-4.1.7-4.9 3.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170 116.4c-.8 2.4 0 5 1.6 6.1l-.1.3c-1.8-1.2-2.5-3.9-1.7-6.5.9-2.8 3.3-4.4 5.5-3.5.1 0 .2.1.3.2l-.1.3c-.1-.1-.2-.1-.3-.2-2.1-.9-4.4.6-5.2 3.3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5086e5"
    }
  }), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st302",
    d: "M169.8 116.3c-.8 2.5 0 5.2 1.7 6.4l-.1.3c-1.8-1.2-2.6-4-1.8-6.7.9-3 3.4-4.6 5.7-3.7.1.1.2.1.3.2l-.1.3c-.1-.1-.2-.1-.3-.2-2.1-.9-4.5.6-5.4 3.4z"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st302",
    d: "M169.7 116.2c-.8 2.6-.1 5.4 1.7 6.6l-.1.3c-1.9-1.2-2.7-4.2-1.8-7 1-3.1 3.6-4.8 5.9-3.8.1.1.3.1.4.2l-.1.3c-.1-.1-.2-.1-.3-.2-2.3-.9-4.8.8-5.7 3.6z"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st303",
    d: "M169.6 116.2c-.9 2.7-.1 5.6 1.8 6.8l-.1.3c-2-1.3-2.8-4.3-1.9-7.2 1-3.1 3.7-4.9 6.1-3.9.1.1.3.1.4.2l-.1.3c-.1-.1-.2-.1-.4-.2-2.3-1-4.9.7-5.8 3.7z"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st303",
    d: "M169.4 116.1c-.9 2.8-.1 5.8 1.9 7.1l-.1.3c-2-1.3-2.9-4.5-2-7.5 1.1-3.3 3.9-5.1 6.3-4 .1.1.3.1.4.2l-.1.3c-.1-.1-.2-.1-.4-.2-2.3-1-5 .7-6 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.3 116c-.9 2.9-.1 6.1 1.9 7.4l-.1.3c-2.1-1.4-3-4.6-2-7.7 1.1-3.4 4-5.3 6.6-4.2.1.1.3.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-2.6-1.1-5.4.7-6.3 3.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5389e5"
    }
  }), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st305",
    d: "M169.1 116c-.9 3 0 6.3 2 7.6l-.1.3c-2.1-1.4-3.1-4.8-2.1-8 1.1-3.5 4.1-5.5 6.7-4.3.1.1.3.1.4.2l-.1.3c-.1-.1-.2-.1-.4-.2-2.5-1.1-5.4.7-6.4 4.1z"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st305",
    d: "M168.9 115.9c-1 3.1 0 6.5 2.1 7.9l-.1.3c-2.2-1.5-3.2-4.9-2.2-8.2 1.1-3.6 4.2-5.6 7-4.5.1.1.3.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-2.6-1.1-5.6.8-6.7 4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.8 115.8c-1 3.2-.1 6.7 2.1 8.1l-.1.3c-2.3-1.5-3.3-5.1-2.2-8.5 1.2-3.7 4.4-5.8 7.2-4.6.1.1.3.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-2.7-1.1-5.8.9-6.9 4.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#548be5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.6 115.8c-1 3.4-.1 6.9 2.2 8.4l-.1.3c-2.3-1.5-3.4-5.3-2.3-8.7 1.2-3.8 4.5-6 7.4-4.8.1.1.3.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-2.7-1.2-5.9.8-7.1 4.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#558be5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 115.7c-1.1 3.4-.1 7.1 2.2 8.6l-.1.3c-2.4-1.6-3.5-5.4-2.3-9 1.2-4 4.6-6.2 7.6-4.9.2.1.3.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-2.9-1.2-6.1.9-7.3 4.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#558de5"
    }
  }), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st309",
    d: "M168.3 115.7c-1.1 3.5-.1 7.3 2.3 8.9l-.1.3c-2.5-1.6-3.6-5.5-2.4-9.2 1.2-4.1 4.8-6.3 7.8-5 .2.1.3.1.4.2v.1l-.1.2c-.1-.1-.3-.2-.4-.2-2.9-1.4-6.2.8-7.5 4.7z"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st309",
    d: "M168.2 115.6c-1.2 3.6-.1 7.5 2.4 9.1l-.1.3c-2.5-1.7-3.6-5.7-2.4-9.5 1.3-4.2 4.9-6.5 8-5.2.1.1.3.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-3.1-1.2-6.6 1-7.8 5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.1 115.5c-1.2 3.8-.1 7.7 2.4 9.4l-.1.3c-2.6-1.7-3.7-5.8-2.5-9.7 1.4-4.3 5.1-6.7 8.2-5.3.2.1.3.1.5.2l-.1.3c-.1-.1-.3-.2-.4-.2-3.2-1.4-6.8.9-8 5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#568ee5"
    }
  }), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st311",
    d: "M167.9 115.5c-1.2 3.8-.1 7.9 2.5 9.6l-.1.3c-2.7-1.8-3.8-6-2.6-10 1.4-4.4 5.2-6.8 8.5-5.4.2.1.3.1.5.2l-.1.3c-.1-.1-.3-.1-.4-.2-3.4-1.4-7 .9-8.3 5.2z"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st311",
    d: "M167.7 115.4c-1.2 3.9-.1 8.1 2.6 9.9l-.1.3c-2.7-1.8-3.9-6.2-2.6-10.2 1.4-4.5 5.3-7 8.7-5.6.2.1.3.1.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-3.4-1.4-7.1.9-8.5 5.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.6 115.3c-1.3 4-.1 8.3 2.6 10.1l-.1.3c-2.8-1.9-4-6.3-2.7-10.5 1.5-4.6 5.4-7.2 8.9-5.7.2.1.3.1.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-3.4-1.4-7.2 1.1-8.6 5.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#598ee5"
    }
  }), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st313",
    d: "M167.4 115.3c-1.3 4.1-.1 8.5 2.7 10.4l-.1.3c-2.9-1.9-4.1-6.5-2.8-10.7 1.5-4.7 5.6-7.4 9.1-5.9.2.1.3.2.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-3.4-1.5-7.3 1-8.8 5.6z"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st313",
    d: "M167.3 115.2c-1.3 4.2-.1 8.7 2.7 10.6l-.1.3c-2.9-2-4.2-6.6-2.8-11 1.5-4.8 5.7-7.5 9.3-6 .2.1.3.1.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-3.5-1.5-7.6 1.1-9 5.8z"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st313",
    d: "M167.1 115.1c-1.4 4.3-.1 8.9 2.8 10.9l-.1.3c-3-2-4.3-6.8-2.9-11.2 1.5-4.9 5.8-7.7 9.5-6.1.2.1.3.1.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-3.6-1.6-7.7 1.1-9.2 5.8z"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st314",
    d: "M167 115.1c-1.4 4.4-.1 9.1 2.8 11.1l-.1.3c-3-2.1-4.4-6.9-2.9-11.5 1.6-5.1 5.9-7.9 9.7-6.3.2.1.3.1.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-3.7-1.5-7.9 1.2-9.4 6.1z"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st314",
    d: "M166.8 115c-1.4 4.5-.1 9.3 2.9 11.4l-.1.3c-3.1-2.1-4.5-7.1-3-11.7 1.6-5.2 6.1-8.1 10-6.4.2.1.3.2.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-3.8-1.7-8.1 1.1-9.7 6.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.7 115c-1.5 4.6-.1 9.5 2.9 11.6l-.1.3c-3.2-2.2-4.5-7.2-3.1-12 1.7-5.3 6.2-8.2 10.2-6.5.2.1.3.2.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-3.8-1.7-8.2 1.1-9.8 6.3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5c93e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5 114.9c-1.5 4.7-.1 9.7 3 11.8l-.1.3c-3.2-2.2-4.6-7.4-3.1-12.2 1.7-5.4 6.3-8.3 10.4-6.7.2.1.3.2.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-3.9-1.6-8.4 1.3-10.1 6.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5c93e7"
    }
  }), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st317",
    d: "M166.4 114.8c-1.5 4.8-.1 9.9 3.1 12.1l-.1.3c-3.3-2.3-4.7-7.5-3.2-12.5 1.7-5.5 6.5-8.6 10.6-6.8.2.1.4.2.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-4-1.7-8.6 1.3-10.3 6.6z"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st317",
    d: "M166.2 114.7c-1.6 4.9-.1 10.1 3.1 12.4l-.1.3c-3.4-2.3-4.8-7.7-3.2-12.7 1.8-5.6 6.6-8.7 10.8-7 .2.1.4.2.5.3l-.1.3c-.2-.1-.3-.2-.5-.2-4.1-1.8-8.8 1.2-10.5 6.6z"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st317",
    d: "M166.1 114.7c-1.6 5-.1 10.3 3.2 12.6l-.1.3c-3.4-2.4-4.9-7.8-3.3-13 1.8-5.7 6.7-8.9 11-7.1.2.1.3.2.5.2l-.1.3c-.2-.1-.3-.2-.5-.3-4.2-1.6-9 1.4-10.7 7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.9 114.6c-1.6 5.1-.1 10.5 3.3 12.8l-.1.3c-3.5-2.4-5-8-3.3-13.2 1.8-5.8 6.8-9 11.2-7.2.2.1.3.2.5.2l-.1.3c-.2-.1-.3-.2-.5-.3-4.3-1.7-9.2 1.5-11 7.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5f95e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8 114.6c-1.6 5.2-.2 10.7 3.3 13.1l-.1.3c-3.5-2.5-5.1-8.1-3.4-13.5 1.9-6 7-9.3 11.4-7.4.2.1.4.2.5.3l-.1.3c-.2-.1-.3-.2-.5-.2-4.3-1.9-9.3 1.3-11.1 7.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6095e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.6 114.5c-1.7 5.3-.2 10.9 3.4 13.3l-.1.3c-3.6-2.5-5.2-8.3-3.4-13.7 1.9-6.1 7.1-9.4 11.6-7.5.2.1.4.2.5.3l-.1.3c-.2-.1-.3-.2-.5-.2-4.4-2-9.5 1.3-11.4 7.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6096e7"
    }
  }), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st321",
    d: "M165.5 114.5c-1.7 5.4-.2 11.1 3.4 13.6l-.1.3c-3.7-2.6-5.3-8.4-3.5-14 1.9-6.2 7.3-9.6 11.9-7.6.2.1.4.2.5.2l-.1.3c-.2-.1-.4-.2-.5-.3-4.6-1.9-9.7 1.4-11.6 7.5z"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st321",
    d: "M165.3 114.4c-1.7 5.5-.1 11.3 3.5 13.8l-.1.3c-3.7-2.6-5.3-8.6-3.6-14.2 2-6.3 7.4-9.7 12.1-7.8.2.1.4.2.5.2l-.1.3c-.2-.1-.4-.2-.5-.3-4.6-1.8-9.9 1.6-11.8 7.7z"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st321",
    d: "M165.2 114.3c-1.7 5.6-.2 11.5 3.5 14.1l-.1.3c-3.8-2.7-5.4-8.7-3.6-14.4 2-6.4 7.5-10 12.3-7.9.2.1.4.2.5.3l-.1.3c-.2-.1-.3-.2-.5-.2-4.7-2.2-10.1 1.3-12 7.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165 114.3c-1.8 5.7-.2 11.7 3.6 14.3l-.1.3c-3.9-2.7-5.5-8.9-3.7-14.7 2.1-6.5 7.7-10.1 12.5-8.1.2.1.4.2.5.3l-.1.3-.6-.3c-4.6-2-10.1 1.5-12.1 7.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6296e7"
    }
  }), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st323",
    d: "M164.9 114.2c-1.8 5.8-.2 11.9 3.6 14.6l-.1.3c-3.9-2.8-5.6-9-3.7-15 2.1-6.6 7.8-10.3 12.7-8.2.2.1.4.2.5.2l-.1.3c-.2-.1-.4-.2-.5-.3-4.9-1.9-10.4 1.7-12.4 8.1z"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st323",
    d: "M164.7 114.1c-1.8 5.9-.2 12.1 3.7 14.8l-.1.3c-4-2.8-5.7-9.2-3.8-15.2 2.1-6.7 7.9-10.4 13-8.3.2.1.4.2.5.2l-.1.3c-.2-.1-.4-.2-.5-.3-5-2-10.6 1.7-12.7 8.2z"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st324",
    d: "M164.6 114c-1.9 6-.2 12.3 3.7 15.1l-.1.3c-4-2.9-5.8-9.3-3.8-15.4 2.1-6.8 8-10.6 13.1-8.5.2.1.4.2.5.3l-.1.3c-.2-.1-.3-.2-.5-.2-5-2.2-10.7 1.5-12.8 8.1z"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st324",
    d: "M164.4 114c-1.9 6.1-.2 12.5 3.8 15.3l-.1.3c-4.1-2.9-5.8-9.5-3.9-15.7 2.2-7 8.2-10.8 13.4-8.6.2.1.4.2.5.3l-.1.3-.6-.3c-5-2.1-10.8 1.6-13 8.4z"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st325",
    d: "M164.3 113.9c-2 6.1-.2 12.7 3.8 15.6l-.1.3c-4.1-3-5.9-9.6-4-15.9 2.2-7.1 8.3-10.9 13.6-8.7.2.1.4.2.5.2l-.1.3c-.2-.1-.4-.2-.5-.3-5.1-2.2-11.1 1.7-13.2 8.5z"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st325",
    d: "M164.1 113.9c-2 6.2-.2 12.9 3.9 15.8l-.1.3c-4.2-3-6-9.8-4-16.1 2.3-7.2 8.5-11.2 13.8-8.9l.6.3-.1.3c-.2-.1-.4-.2-.5-.3-5.3-2.3-11.4 1.6-13.6 8.6z"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st325",
    d: "M164 113.8c-2 6.4-.2 13.1 4 16.1l-.1.3c-4.3-3.1-6.1-9.9-4.1-16.4 2.3-7.3 8.6-11.3 14-9 .2.1.4.2.5.3l-.1.3c-.2-.1-.3-.2-.5-.2-5.4-2.5-11.5 1.5-13.7 8.6z"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st326",
    d: "M163.8 113.8c-2 6.4-.2 13.2 4 16.3l-.1.3c-4.3-3.1-6.2-10.1-4.1-16.6 2.3-7.4 8.7-11.5 14.2-9.2.2.1.4.2.5.3l-.1.3-.6-.3c-5.3-2.4-11.5 1.6-13.8 8.9z"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st326",
    d: "M163.7 113.7c-2.1 6.5-.2 13.4 4.1 16.5l-.1.3c-4.4-3.2-6.2-10.2-4.1-16.9 2.3-7.5 8.8-11.6 14.5-9.3.2.1.4.2.5.2l-.1.3c-.2-.1-.4-.2-.5-.3-5.7-2.2-12 1.9-14.3 9.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.5 113.6c-2.1 6.6-.2 13.7 4.1 16.8l-.1.3c-4.5-3.2-6.4-10.3-4.2-17.1 2.4-7.6 9-11.9 14.6-9.4l.6.3-.1.3c-.2-.1-.4-.2-.5-.3-5.6-2.5-12 1.7-14.4 9.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#699de8"
    }
  }), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st328",
    d: "M163.4 113.5c-2.1 6.7-.2 13.9 4.2 17l-.1.3c-4.5-3.3-6.4-10.5-4.2-17.4 2.4-7.7 9.1-12 14.9-9.6.2.1.4.2.5.2l-.1.3-.6-.3c-5.7-2.2-12.3 2-14.6 9.5z"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st328",
    d: "M163.2 113.5c-2.1 6.8-.2 14 4.2 17.2l-.1.3c-4.6-3.3-6.5-10.7-4.3-17.6 2.5-7.8 9.2-12.2 15.1-9.7.2.1.4.2.5.2l-.1.3c-.2-.1-.4-.2-.5-.3-5.8-2.3-12.4 1.9-14.8 9.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.1 113.4c-2.2 6.9-.3 14.2 4.3 17.5l-.1.3c-4.6-3.4-6.6-10.8-4.3-17.9 2.5-7.9 9.3-12.3 15.3-9.8.2.1.3.2.5.2l-.1.3c-.2-.1-.4-.2-.5-.2-6-2.5-12.7 1.8-15.1 9.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6a9ee8"
    }
  }), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st330",
    d: "M162.9 113.4c-2.2 7-.3 14.4 4.3 17.8l-.1.3c-4.7-3.4-6.7-11-4.4-18.1 2.6-8.1 9.5-12.5 15.5-10 .2.1.4.2.5.3l-.1.3c-.2-.1-.3-.2-.5-.2-5.9-2.7-12.7 1.7-15.2 9.6z"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st330",
    d: "M162.7 113.3c-2.2 7.1-.2 14.6 4.4 18l-.1.3c-4.7-3.5-6.7-11.1-4.5-18.4 2.6-8.2 9.6-12.7 15.7-10.1.2.1.4.2.5.2l-.1.3c-.2-.1-.4-.2-.5-.3-5.9-2.4-12.8 2-15.4 10z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.6 113.2c-2.2 7.2-.3 14.8 4.5 18.2l-.2.3c-4.8-3.5-6.8-11.3-4.5-18.6 2.6-8.3 9.7-12.9 16-10.3.2.1.3.2.5.2l-.1.3c-.2-.1-.4-.2-.5-.3-6.1-2.4-13.1 2.1-15.7 10.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6d9ee8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5 113.2c-2.3 7.3-.3 15 4.5 18.5l-.2.3c-4.8-3.6-6.9-11.4-4.6-18.9 2.6-8.4 9.9-13 16.1-10.4.2.1.4.2.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-6-2.6-13.2 1.9-15.7 10.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6da0e9"
    }
  }), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st333",
    d: "M162.3 113.1c-2.3 7.4-.3 15.2 4.5 18.7l-.1.3c-4.9-3.6-7-11.6-4.6-19.1 2.7-8.5 10-13.2 16.4-10.5.2.1.4.2.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-6.3-2.7-13.5 2-16.1 10.3z"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st333",
    d: "M162.2 113.1c-2.4 7.4-.3 15.4 4.6 19l-.1.3c-5-3.7-7.1-11.7-4.7-19.3 2.7-8.6 10.1-13.4 16.6-10.7.2.1.3.2.5.2l-.1.3c-.2-.1-.4-.2-.5-.2-6.4-2.8-13.7 1.9-16.3 10.4z"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st333",
    d: "M162 113c-2.4 7.6-.3 15.6 4.6 19.2l-.2.3c-5-3.7-7.1-11.8-4.7-19.6 2.7-8.7 10.3-13.5 16.8-10.8.2.1.3.2.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-6.3-2.7-13.7 2-16.4 10.6z"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st333",
    d: "M161.9 112.9c-2.4 7.7-.3 15.8 4.7 19.5l-.1.2c-5.1-3.8-7.2-12-4.8-19.8 2.7-8.8 10.4-13.7 17-10.9.2.1.3.2.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-6.6-2.8-14 2-16.7 10.7z"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st334",
    d: "M161.7 112.8c-2.5 7.8-.3 16 4.7 19.7l-.1.3c-5.1-3.8-7.3-12.2-4.8-20 2.8-9 10.5-13.9 17.2-11.1.2.1.3.2.5.2l-.1.3c-.2-.1-.4-.2-.5-.2-6.6-2.8-14.1 2.1-16.9 10.8z"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st334",
    d: "M161.6 112.8c-2.5 7.8-.3 16.1 4.8 19.9l-.2.3c-5.2-3.9-7.4-12.3-4.9-20.3 2.9-9 10.7-14.1 17.5-11.2.2.1.3.1.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-6.7-2.8-14.3 2.1-17.1 11z"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st335",
    d: "M161.4 112.7c-2.5 7.9-.3 16.3 4.9 20.2l-.2.3c-5.2-3.9-7.5-12.4-4.9-20.5 2.9-9.2 10.8-14.2 17.7-11.3.2.1.3.1.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-6.8-3-14.6 2-17.4 11z"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st335",
    d: "M161.2 112.7c-2.5 8-.3 16.5 4.9 20.4l-.1.3c-5.3-4-7.5-12.6-5-20.8 2.9-9.3 10.9-14.4 17.9-11.5.2.1.3.1.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-6.8-2.9-14.7 2.1-17.6 11.3z"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st335",
    d: "M161.1 112.6c-2.5 8.1-.3 16.7 4.9 20.7l-.1.3c-5.4-4-7.6-12.8-5-21 3-9.4 11.1-14.6 18.1-11.6.2.1.3.1.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-6.9-3-14.9 2.1-17.8 11.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.9 112.5c-2.6 8.2-.3 16.9 5 20.9l-.2.3c-5.4-4.1-7.7-12.9-5-21.3 3-9.5 11.2-14.8 18.3-11.8.2.1.3.1.5.2l-.1.3c-.2-.1-.3-.2-.5-.2-7-2.9-15 2.3-18 11.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#74a5e9"
    }
  }), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st337",
    d: "M160.8 112.5c-2.6 8.3-.3 17.1 5 21.1l-.2.3c-5.5-4.1-7.8-13-5.1-21.5 3-9.6 11.3-14.9 18.5-11.9.2.1.3.1.5.2l-.1.3c-.2-.1-.3-.1-.5-.2-7-3-15.1 2.2-18.1 11.7z"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st337",
    d: "M160.7 112.4c-2.6 8.4-.4 17.3 5.1 21.4l-.2.3c-5.5-4.2-7.8-13.2-5.1-21.7 3-9.7 11.4-15.1 18.7-12 .2.1.3.1.5.2l-.1.3c-.2-.1-.3-.1-.5-.2-7.2-3.2-15.4 2.1-18.4 11.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 112.3c-2.7 8.5-.4 17.5 5.1 21.6l-.2.3c-5.6-4.2-7.9-13.4-5.2-22 3.1-9.8 11.6-15.3 18.9-12.2.2.1.3.1.5.2l-.1.3c-.2-.1-.3-.1-.5-.2-7.1-3-15.5 2.4-18.5 12z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#76a5e9"
    }
  }), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st339",
    d: "M160.4 112.3c-2.7 8.6-.4 17.6 5.2 21.8l-.2.3c-5.6-4.3-8-13.5-5.3-22.2 3.1-10 11.7-15.5 19.2-12.3.1.1.3.1.4.2l-.1.3c-.2-.1-.3-.1-.5-.2-7.2-3.1-15.7 2.3-18.7 12.1z"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st339",
    d: "M160.2 112.2c-2.7 8.7-.4 17.8 5.2 22.1l-.2.3c-5.7-4.3-8.1-13.6-5.3-22.5 3.2-10 11.9-15.6 19.4-12.4.2.1.3.1.5.2l-.1.3c-.1-.1-.3-.1-.4-.2-7.5-3.2-16 2.3-19.1 12.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160 112.1c-2.8 8.8-.4 18 5.3 22.3l-.2.3c-5.7-4.4-8.1-13.8-5.3-22.7 3.2-10.2 12-15.8 19.6-12.6.1.1.3.1.4.2l-.1.3c-.2-.1-.3-.1-.5-.2-7.4-3.1-16 2.5-19.2 12.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#78a6eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9 112.1c-2.8 8.9-.4 18.2 5.3 22.6l-.2.3c-5.8-4.4-8.2-13.9-5.4-22.9 3.2-10.3 12.1-16 19.8-12.7.1.1.3.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-7.5-3.3-16.2 2.3-19.4 12.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#79a8eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.7 112c-2.8 8.9-.4 18.4 5.4 22.8l-.2.3c-5.8-4.5-8.3-14.1-5.4-23.2 3.3-10.4 12.2-16.1 20-12.9.1.1.3.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-7.6-3.2-16.4 2.5-19.7 12.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7aa8eb"
    }
  }), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st343",
    d: "M159.6 112c-2.8 9-.4 18.6 5.4 23l-.1.2c-5.9-4.5-8.3-14.2-5.5-23.4 3.3-10.5 12.3-16.3 20.2-13 .1.1.3.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-7.8-3.2-16.6 2.5-19.9 12.9z"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st343",
    d: "M159.4 111.9c-2.9 9.1-.4 18.8 5.4 23.3l-.2.3c-5.9-4.6-8.4-14.4-5.5-23.6 3.3-10.6 12.5-16.5 20.4-13.1.1.1.3.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-7.7-3.4-16.7 2.4-20 12.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.3 111.8c-2.9 9.2-.4 19 5.5 23.5l-.2.3c-6-4.6-8.5-14.5-5.5-23.9 3.4-10.7 12.6-16.7 20.6-13.3.1.1.3.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-7.9-3.3-17 2.6-20.3 13.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7babeb"
    }
  }), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st345",
    d: "M159.2 111.8c-2.9 9.3-.4 19.1 5.5 23.7l-.2.3c-6-4.7-8.6-14.7-5.6-24.1 3.4-10.8 12.8-16.8 20.9-13.4.1.1.3.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-8-3.4-17.2 2.5-20.5 13.2z"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st345",
    d: "M159 111.7c-3 9.4-.5 19.3 5.6 24l-.2.2c-6.1-4.7-8.7-14.8-5.7-24.4 3.4-10.9 12.9-17 21.1-13.5.1.1.3.1.4.2l-.1.3c-.1-.1-.2-.1-.4-.2-8-3.4-17.3 2.6-20.7 13.4z"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st346",
    d: "M158.8 111.6c-3 9.5-.4 19.5 5.7 24.2l-.2.3c-6.2-4.8-8.7-15-5.7-24.6 3.5-11.1 13-17.2 21.3-13.7.1 0 .2.1.4.2l-.1.3c-.1-.1-.3-.1-.4-.2-8.2-3.4-17.5 2.7-21 13.5z"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st346",
    d: "M158.7 111.6c-3 9.5-.4 19.7 5.7 24.4l-.2.3c-6.2-4.8-8.8-15.1-5.7-24.8 3.5-11.2 13.1-17.4 21.5-13.8.1 0 .2.1.3.2l-.1.3c-.1-.1-.2-.1-.4-.2-8.2-3.5-17.6 2.6-21.1 13.6z"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st347",
    d: "M158.5 111.5c-3 9.6-.5 19.9 5.7 24.7l-.2.3c-6.3-4.9-8.9-15.3-5.8-25.1 3.6-11.3 13.3-17.5 21.7-13.9.1 0 .2.1.3.2l-.1.3c-.1-.1-.2-.1-.3-.2-8.2-3.6-17.8 2.6-21.3 13.7z"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st347",
    d: "M158.4 111.4c-3.1 9.8-.5 20.1 5.8 24.9l-.2.2c-6.3-4.9-8.9-15.4-5.8-25.3 3.6-11.4 13.4-17.7 21.9-14.1.1 0 .2.1.3.1l-.1.3c-.1-.1-.2-.1-.3-.1-8.4-3.4-18.1 2.8-21.6 14z"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st347",
    d: "M158.2 111.4c-3.1 9.8-.5 20.2 5.8 25.2l-.2.3c-6.4-5-9-15.6-5.9-25.5 3.6-11.5 13.5-17.9 22.2-14.2.1 0 .2.1.3.1l-.1.3c-.1-.1-.2-.1-.3-.1-8.4-3.7-18.2 2.6-21.8 13.9z"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st347",
    d: "M158.1 111.3c-3.1 9.9-.5 20.4 5.8 25.4l-.2.3c-6.4-5-9.1-15.7-5.9-25.8 3.6-11.6 13.7-18 22.4-14.4.1 0 .2.1.3.1l-.1.3c-.1 0-.2-.1-.3-.1-8.5-3.6-18.4 2.8-22 14.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.9 111.3c-3.2 10-.5 20.6 5.9 25.6l-.2.3c-6.5-5.1-9.1-15.8-5.9-26 3.7-11.7 13.8-18.2 22.6-14.5.1 0 .2.1.3.1l-.1.3c-.1 0-.2-.1-.3-.1-8.7-3.7-18.6 2.7-22.3 14.3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#81adec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.8 111.2c-3.2 10.1-.5 20.8 5.9 25.9l-.2.2c-6.5-5.2-9.2-16-6-26.2 3.7-11.8 13.9-18.4 22.8-14.6.1 0 .2.1.3.1l-.1.3c-.1 0-.2-.1-.3-.1-8.7-3.7-18.7 2.7-22.4 14.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#81aeec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.6 111.1c-3.2 10.2-.5 21 6 26.1l-.2.3c-6.6-5.2-9.3-16.1-6-26.5 3.8-12 14.1-18.6 23-14.8.1 0 .2.1.3.1l-.1.3c-.1 0-.2-.1-.3-.1-8.8-3.7-18.9 2.9-22.7 14.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#83aeec"
    }
  }), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st351",
    d: "M157.5 111.1c-3.2 10.3-.5 21.1 6 26.3l-.2.3c-6.6-5.3-9.3-16.3-6.1-26.7 3.8-12 14.2-18.7 23.2-14.9.1 0 .2.1.3.1l-.1.3c-.1 0-.2-.1-.3-.1-8.8-3.8-19.1 2.8-22.8 14.7z"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st351",
    d: "M157.3 111c-3.3 10.4-.5 21.4 6.1 26.6l-.2.3c-6.7-5.3-9.4-16.4-6.1-26.9 3.8-12.2 14.3-18.9 23.4-15 .1 0 .2.1.2.1l-.1.3c-.1 0-.2-.1-.2-.1-8.9-4-19.3 2.7-23.1 14.7z"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st352",
    d: "M157.2 110.9c-3.3 10.5-.5 21.5 6.1 26.8l-.2.3c-6.7-5.4-9.5-16.6-6.2-27.1 3.8-12.3 14.5-19.1 23.7-15.2.1 0 .1.1.2.1l-.1.3c-.1 0-.2-.1-.2-.1-9.1-3.9-19.5 2.8-23.3 14.9z"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st352",
    d: "M157 110.9c-3.3 10.5-.6 21.7 6.1 27.1l-.2.3c-6.8-5.4-9.6-16.7-6.2-27.4 3.9-12.4 14.6-19.3 23.9-15.3l.2.1-.1.3c-.1 0-.2-.1-.2-.1-9.1-4-19.6 2.7-23.5 15z"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st352",
    d: "M156.9 110.8c-3.3 10.6-.6 21.9 6.2 27.3l-.2.3c-6.8-5.5-9.6-16.9-6.2-27.6 3.9-12.5 14.7-19.4 24.1-15.5.1 0 .1.1.2.1l-.1.3-.2-.1c-9.3-4-19.9 2.9-23.8 15.2z"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st353",
    d: "M156.7 110.8c-3.4 10.7-.6 22.1 6.2 27.5l-.2.3c-6.9-5.5-9.7-17-6.3-27.9 4-12.6 14.8-19.6 24.3-15.6.1 0 .1.1.2.1l-.1.3-.2-.1c-9.2-4-19.9 2.9-23.9 15.4z"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st353",
    d: "M156.6 110.7c-3.4 10.8-.6 22.2 6.2 27.8l-.2.3c-6.9-5.6-9.8-17.2-6.3-28.1 4-12.7 15-19.8 24.5-15.8l.2.1-.1.3c-.1 0-.1-.1-.2-.1-9.4-4-20.2 2.9-24.1 15.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.4 110.6c-3.4 10.9-.6 22.4 6.3 28l-.2.3c-7-5.7-9.8-17.3-6.4-28.3 4.1-12.9 15.1-20 24.7-15.9l.1.1.1.2-.2-.1c-9.5-4-20.4 3-24.4 15.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#89b3ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.3 110.6c-3.4 11-.6 22.6 6.3 28.2l-.2.2c-7-5.7-9.9-17.4-6.4-28.6 4.1-13 15.2-20.1 24.9-16l.1.1-.1.3-.1-.1c-9.5-4-20.5 3.1-24.5 15.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#89b3ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.1 110.5c-3.5 11.1-.6 22.8 6.4 28.4l-.2.3c-7.1-5.8-9.9-17.6-6.4-28.8 4.1-13 15.4-20.3 25.2-16.1l.1.1-.1.3-.2-.1c-9.6-4.1-20.7 3-24.8 15.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#89b5ee"
    }
  }), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st357",
    d: "M156 110.4c-3.5 11.1-.6 23 6.4 28.7l-.2.2c-7.1-5.8-10-17.7-6.5-29 4.1-13.2 15.5-20.5 25.4-16.3h.1l-.1.3-.1-.1c-9.7-4-20.9 3.2-25 16.2z"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st357",
    d: "M155.8 110.4c-3.5 11.3-.6 23.2 6.5 28.9l-.2.3c-7.1-5.9-10.1-17.9-6.5-29.3 4.2-13.3 15.6-20.6 25.6-16.4h.1l-.1.3h-.1c-9.8-4.2-21.1 3-25.3 16.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.7 110.3c-3.6 11.3-.6 23.3 6.5 29.1l-.2.2c-7.2-5.9-10.1-18-6.5-29.5 4.2-13.4 15.7-20.8 25.8-16.6h.1l-.1.3h-.1c-10-4.1-21.3 3.3-25.5 16.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8cb5ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5 110.2c-3.6 11.4-.7 23.5 6.5 29.4l-.2.3c-7.2-6-10.2-18.2-6.6-29.7 4.2-13.5 15.9-21 26-16.7l-.1.3h-.1c-9.8-4.3-21.3 3.1-25.5 16.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8db5ee"
    }
  }), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st360",
    d: "M155.4 110.2c-3.6 11.5-.7 23.7 6.5 29.6l-.2.2c-7.3-6-10.3-18.3-6.6-29.9 4.2-13.6 16-21.2 26.2-16.9l-.1.3h-.1c-9.9-4.2-21.5 3.2-25.7 16.7z"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st360",
    d: "M155.2 110.1c-3.7 11.6-.7 23.8 6.6 29.8l-.2.3c-7.3-6.1-10.3-18.5-6.7-30.2 4.3-13.7 16.2-21.3 26.4-17l-.1.3c-10-4.3-21.7 3.2-26 16.8z"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st361",
    d: "M155.1 110.1c-3.7 11.7-.7 24 6.6 30.1l-.2.2c-7.4-6.1-10.4-18.6-6.7-30.4 4.4-13.8 16.3-21.5 26.7-17.1l-.1.3c-10.2-4.4-22 3.2-26.3 16.9z"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st361",
    d: "M154.9 110c-3.7 11.8-.7 24.2 6.7 30.3l-.2.3c-7.4-6.2-10.5-18.8-6.7-30.7 4.4-13.9 16.4-21.7 26.8-17.3l-.1.3c-10.3-4.3-22.1 3.3-26.5 17.1z"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st362",
    d: "M154.8 109.9c-3.7 11.9-.7 24.4 6.7 30.5l-.2.3c-7.5-6.2-10.5-18.9-6.8-30.9 4.4-14 16.5-21.8 27-17.5l-.1.3c-10.3-4.3-22.2 3.4-26.6 17.3z"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st362",
    d: "M154.6 109.9c-3.7 11.9-.7 24.5 6.7 30.7l-.2.3c-7.5-6.3-10.6-19-6.8-31.1 4.5-14.1 16.6-22 27.2-17.6l-.1.3c-10.3-4.4-22.4 3.4-26.8 17.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.5 109.8c-3.8 12-.7 24.7 6.8 31l-.2.2c-7.6-6.3-10.6-19.2-6.8-31.3 4.5-14.2 16.7-22.1 27.4-17.7l-.1.3c-10.5-4.4-22.7 3.4-27.1 17.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#92b9ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.3 109.7c-3.8 12.1-.7 24.9 6.8 31.2l-.2.3c-7.6-6.4-10.7-19.3-6.8-31.6 4.5-14.3 16.8-22.3 27.6-17.8l-.1.3c-10.6-4.4-22.8 3.4-27.3 17.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#92bbee"
    }
  }), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st365",
    d: "M154.2 109.7c-3.8 12.2-.8 25.1 6.8 31.5l-.2.3c-7.7-6.5-10.8-19.5-6.9-31.8 4.5-14.5 17-22.5 27.8-18l-.1.3c-10.6-4.6-22.9 3.4-27.4 17.7z"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st365",
    d: "M154 109.6c-3.9 12.2-.8 25.2 6.9 31.7l-.2.2c-7.7-6.5-10.8-19.6-6.9-32 4.6-14.5 17.1-22.7 28-18.1l-.1.3c-10.8-4.5-23.1 3.5-27.7 17.9z"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st366",
    d: "M153.9 109.5c-3.9 12.4-.8 25.4 6.9 31.9l-.2.2c-7.7-6.6-10.9-19.7-7-32.2 4.6-14.6 17.2-22.8 28.2-18.3l-.1.3c-10.8-4.4-23.3 3.6-27.8 18.1z"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st366",
    d: "M153.7 109.5c-3.9 12.4-.8 25.6 7 32.1l-.2.3c-7.8-6.6-10.9-19.9-7-32.5 4.7-14.8 17.3-23 28.4-18.5l-.1.3c-10.9-4.5-23.5 3.7-28.1 18.3z"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st367",
    d: "M153.6 109.4c-3.9 12.5-.8 25.8 7 32.4l-.2.2c-7.8-6.7-11-20-7-32.7 4.7-14.9 17.5-23.1 28.6-18.6l-.1.3c-11.1-4.5-23.7 3.7-28.3 18.4z"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st367",
    d: "M153.4 109.4c-4 12.6-.8 25.9 7 32.6l-.2.2c-7.9-6.8-11.1-20.2-7.1-32.9 4.7-14.9 17.5-23.3 28.8-18.7l-.1.3c-11-4.6-23.7 3.7-28.4 18.5z"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st367",
    d: "M153.3 109.3c-4 12.7-.8 26.1 7.1 32.8l-.2.2c-7.9-6.8-11.1-20.3-7.1-33.2 4.7-15 17.6-23.4 29-18.9l-.1.3c-11.3-4.4-24 3.9-28.7 18.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.1 109.2c-4 12.8-.8 26.3 7.1 33l-.2.3c-8-6.9-11.2-20.5-7.1-33.4 4.8-15.2 17.8-23.6 29.1-19l-.1.3c-11.2-4.6-24.1 3.8-28.8 18.8z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#99beef"
    }
  }), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st369",
    d: "M153 109.1c-4 12.9-.8 26.4 7.1 33.3l-.2.2c-8-6.9-11.3-20.6-7.1-33.6 4.8-15.3 17.9-23.8 29.3-19.2l-.1.3c-11.3-4.5-24.3 3.9-29 19z"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st369",
    d: "M152.8 109.1c-4.1 12.9-.9 26.6 7.1 33.5l-.2.2c-8.1-7-11.3-20.8-7.2-33.8 4.8-15.3 18-23.9 29.5-19.3l-.1.3c-11.2-4.6-24.3 3.9-29.1 19.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.7 109c-4.1 13-.9 26.8 7.2 33.7l-.2.2c-8.1-7-11.4-20.9-7.2-34.1 4.9-15.4 18.1-24.1 29.7-19.5l-.1.3c-11.5-4.4-24.6 4.1-29.4 19.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9cc0ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5 109c-4.1 13.1-.9 27 7.2 33.9l-.2.3c-8.1-7.1-11.4-21.1-7.3-34.3 4.9-15.6 18.2-24.3 29.9-19.6l-.1.3c-11.4-4.6-24.6 4-29.5 19.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9cc1ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.3 108.9c-4.1 13.2-.9 27.1 7.2 34.2l-.2.2c-8.2-7.1-11.5-21.2-7.3-34.5 4.9-15.7 18.3-24.4 30.1-19.8l-.1.3c-11.5-4.6-24.8 4.1-29.7 19.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9cc1f1"
    }
  }), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st373",
    d: "M152.2 108.9c-4.2 13.3-.9 27.3 7.3 34.4l-.2.2c-8.2-7.2-11.5-21.3-7.3-34.7 5-15.8 18.5-24.6 30.3-19.9l-.1.3c-11.7-4.7-25.1 4-30 19.7z"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st373",
    d: "M152.1 108.8c-4.2 13.3-.9 27.4 7.3 34.6l-.2.2c-8.3-7.2-11.6-21.5-7.3-35 5-15.8 18.5-24.7 30.5-20.1l-.1.3c-11.9-4.5-25.3 4.3-30.2 20z"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st374",
    d: "M151.9 108.7c-4.2 13.4-.9 27.6 7.3 34.8l-.2.3c-8.3-7.3-11.6-21.6-7.4-35.2 5-16 18.7-24.9 30.7-20.2l-.1.3c-11.8-4.6-25.3 4.2-30.3 20z"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st374",
    d: "M151.8 108.7c-4.3 13.5-.9 27.8 7.3 35l-.2.2c-8.4-7.4-11.7-21.7-7.4-35.4 5.1-16.1 18.8-25.1 30.8-20.4l-.1.3c-11.8-4.6-25.5 4.3-30.4 20.3z"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st374",
    d: "M151.6 108.6c-4.3 13.6-1 27.9 7.4 35.3l-.2.3c-8.4-7.4-11.7-21.9-7.4-35.6 5.1-16.2 18.9-25.2 31-20.5l-.1.3c-12-4.8-25.7 4.2-30.7 20.2z"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st375",
    d: "M151.5 108.5c-4.3 13.7-1 28.1 7.4 35.5l-.2.2c-8.4-7.5-11.8-22-7.5-35.8 5.1-16.2 19-25.3 31.2-20.7l-.1.3c-12-4.6-25.8 4.4-30.8 20.5z"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st375",
    d: "M151.3 108.4c-4.3 13.8-1 28.3 7.4 35.7l-.2.2c-8.5-7.5-11.8-22.2-7.5-36 5.2-16.4 19.1-25.6 31.4-20.8l-.1.3c-12.1-4.6-25.9 4.5-31 20.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.1 108.4c-4.3 13.8-1 28.4 7.5 35.9l-.2.2c-8.5-7.6-11.9-22.3-7.5-36.3 5.2-16.5 19.2-25.7 31.6-21l-.1.3c-12.2-4.6-26.1 4.6-31.3 20.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a2c6f1"
    }
  }), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st377",
    d: "M151 108.3c-4.4 13.9-1 28.6 7.5 36.1l-.2.3c-8.6-7.6-12-22.5-7.5-36.5 5.2-16.6 19.3-25.9 31.8-21.1l-.1.3c-12.3-4.7-26.4 4.5-31.5 20.9z"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st377",
    d: "M150.8 108.3c-4.4 14-1 28.8 7.5 36.4l-.2.2c-8.6-7.7-12-22.6-7.6-36.7 5.2-16.6 19.4-26 32-21.3l-.1.3c-12.3-4.7-26.4 4.6-31.6 21.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.7 108.2c-4.4 14.1-1 29 7.6 36.6l-.2.2c-8.6-7.8-12.1-22.7-7.6-36.9 5.2-16.8 19.5-26.2 32.2-21.4l-.1.3c-12.5-4.7-26.7 4.6-31.9 21.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a6c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.6 108.2c-4.5 14.1-1 29.1 7.6 36.8l-.2.2c-8.7-7.8-12.1-22.9-7.6-37.2 5.3-16.8 19.7-26.3 32.3-21.6l-.1.3c-12.6-4.6-26.8 4.7-32 21.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a7c6f1"
    }
  }), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st380",
    d: "M150.4 108.1c-4.5 14.2-1 29.3 7.6 37l-.2.2c-8.7-7.9-12.2-23-7.6-37.4 5.3-16.9 19.7-26.5 32.5-21.7v.3c-12.7-4.7-27 4.8-32.3 21.6z"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st380",
    d: "M150.3 108c-4.5 14.3-1.1 29.4 7.6 37.3l-.2.2c-8.7-7.9-12.2-23.2-7.7-37.6 5.4-17 19.9-26.6 32.7-21.8l-.1.3c-12.7-4.8-27 4.7-32.3 21.6z"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st381",
    d: "M150.1 107.9c-4.5 14.4-1.1 29.6 7.6 37.5l-.2.2c-8.8-8-12.3-23.3-7.7-37.8 5.4-17.1 20-26.8 32.9-22v.3c-12.8-4.7-27.3 4.9-32.6 21.8z"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st381",
    d: "M149.9 107.9c-4.5 14.5-1.1 29.7 7.7 37.7l-.2.2c-8.8-8-12.3-23.4-7.7-38 5.4-17.2 20.1-27 33.1-22.2l-.1.3c-12.8-4.7-27.4 4.9-32.8 22z"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st382",
    d: "M149.8 107.8c-4.6 14.6-1.1 29.9 7.7 37.9l-.2.2c-8.9-8.1-12.3-23.6-7.7-38.3 5.4-17.3 20.2-27.1 33.3-22.3v.3c-13.1-4.7-27.7 5-33.1 22.2z"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st382",
    d: "M149.6 107.8c-4.6 14.6-1.1 30.1 7.7 38.2l-.2.2c-8.9-8.1-12.4-23.7-7.8-38.5 5.5-17.5 20.3-27.3 33.4-22.5l-.1.3c-12.8-4.8-27.5 5-33 22.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 107.7c-4.6 14.7-1.1 30.3 7.8 38.4l-.2.2c-9-8.2-12.4-23.9-7.8-38.7 5.5-17.6 20.4-27.4 33.6-22.6v.3c-13.1-4.8-27.9 5-33.4 22.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#accaf1"
    }
  }), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st384",
    d: "M149.3 107.6c-4.7 14.8-1.2 30.4 7.8 38.6l-.2.2c-9-8.3-12.5-24-7.8-38.9 5.5-17.6 20.5-27.6 33.8-22.8v.4c-13.2-4.8-28 5-33.6 22.5z"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st384",
    d: "M149.2 107.6c-4.7 14.9-1.2 30.6 7.8 38.8l-.2.2c-9-8.3-12.5-24.1-7.8-39.1 5.6-17.7 20.6-27.7 34-22.9v.3c-13.3-4.8-28.3 5.1-33.8 22.7z"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st384",
    d: "M149.1 107.5c-4.7 15-1.2 30.7 7.8 39l-.2.2c-9.1-8.4-12.6-24.3-7.8-39.3 5.6-17.8 20.7-27.9 34.1-23.1v.3c-13.4-4.8-28.4 5.2-33.9 22.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.9 107.4c-4.7 15-1.2 30.9 7.8 39.2l-.2.2c-9.1-8.4-12.7-24.4-7.9-39.6 5.6-17.9 20.9-28.1 34.4-23.2v.3c-13.4-4.7-28.5 5.4-34.1 23.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#afccf1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.7 107.4c-4.7 15.1-1.2 31 7.9 39.4l-.2.2c-9.1-8.5-12.7-24.5-7.9-39.8 5.7-18 20.9-28.2 34.5-23.4v.4c-13.5-4.8-28.6 5.3-34.3 23.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#b0cef1"
    }
  }), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st387",
    d: "M148.6 107.3c-4.8 15.2-1.2 31.2 7.9 39.7l-.2.2c-9.2-8.5-12.7-24.7-7.9-40 5.7-18.1 21.1-28.4 34.7-23.5v.3c-13.6-4.8-28.9 5.3-34.5 23.3z"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st387",
    d: "M148.4 107.2c-4.8 15.3-1.2 31.4 7.9 39.9l-.2.2c-9.2-8.6-12.8-24.8-8-40.2 5.7-18.2 21.1-28.5 34.9-23.7v.3c-13.6-4.7-28.9 5.5-34.6 23.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.3 107.2c-4.8 15.4-1.2 31.5 7.9 40.1l-.2.2c-9.2-8.7-12.8-25-8-40.4 5.8-18.3 21.2-28.7 35.1-23.8v.3c-13.7-4.9-29.1 5.4-34.8 23.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#b1cef3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.1 107.1c-4.8 15.4-1.3 31.7 8 40.3l-.2.2c-9.3-8.7-12.9-25.1-8-40.6 5.8-18.4 21.3-28.8 35.2-24v.3c-13.8-4.8-29.2 5.6-35 23.8z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#b3cef3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 107.1c-4.9 15.5-1.3 31.8 8 40.5l-.2.2c-9.3-8.8-12.9-25.2-8-40.9 5.8-18.5 21.4-29 35.4-24.1v.3c-13.9-4.8-29.5 5.6-35.2 24z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#b3d0f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8 107c-4.9 15.6-1.3 32 8 40.8l-.2.2c-9.4-8.8-13-25.4-8-41 5.8-18.6 21.6-29.1 35.6-24.3v.3c-14-4.9-29.6 5.6-35.4 24z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#b4d1f3"
    }
  }), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st392",
    d: "M147.7 106.9c-4.9 15.6-1.3 32.1 8 40.9l-.2.2c-9.4-8.9-13-25.5-8.1-41.3 5.9-18.7 21.7-29.3 35.8-24.4v.3c-14-4.7-29.7 5.8-35.5 24.3z"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st392",
    d: "M147.5 106.9c-5 15.7-1.3 32.3 8 41.2l-.2.2c-9.4-8.9-13-25.6-8.1-41.5 5.9-18.8 21.8-29.4 36-24.6v.3c-14-4.9-29.8 5.7-35.7 24.4z"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st392",
    d: "M147.4 106.8c-5 15.8-1.3 32.5 8.1 41.4l-.2.2c-9.4-9-13.1-25.8-8.1-41.7 6-18.8 21.9-29.6 36.1-24.7v.3c-14.2-4.9-30 5.8-35.9 24.5z"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st393",
    d: "M147.2 106.7c-5 15.9-1.3 32.6 8.1 41.6l-.2.2c-9.5-9.1-13.1-25.9-8.1-41.9 6-19 22-29.8 36.3-24.9v.4c-14.3-4.9-30.2 5.8-36.1 24.6z"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st393",
    d: "M147.1 106.7c-5 15.9-1.4 32.7 8.1 41.8l-.2.2c-9.5-9.1-13.2-26.1-8.1-42.1 6-19.1 22.1-29.9 36.5-25v.3C169 77 153 87.7 147.1 106.7z"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st394",
    d: "M146.9 106.6c-5 16-1.4 32.9 8.1 42l-.2.2c-9.5-9.2-13.2-26.2-8.1-42.3 6-19.2 22.2-30.1 36.6-25.1v.3c-14.4-4.9-30.4 5.9-36.4 24.9z"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st394",
    d: "M146.8 106.5c-5.1 16.1-1.4 33.1 8.1 42.2l-.2.2c-9.6-9.2-13.3-26.3-8.1-42.5 6-19.2 22.3-30.2 36.8-25.3v.3c-14.5-4.8-30.6 6.1-36.6 25.1z"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st395",
    d: "M146.6 106.5c-5.1 16.2-1.4 33.2 8.1 42.4l-.2.2c-9.6-9.3-13.3-26.5-8.2-42.7 6.1-19.3 22.3-30.4 37-25.5v.4c-14.5-4.9-30.6 6-36.7 25.2z"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st395",
    d: "M146.5 106.4c-5.1 16.2-1.4 33.4 8.2 42.6l-.2.2c-9.6-9.4-13.3-26.6-8.2-43 6.1-19.4 22.4-30.5 37.2-25.6v.3c-14.7-4.8-30.9 6.2-37 25.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.3 106.4c-5.1 16.3-1.5 33.5 8.2 42.8l-.2.2c-9.7-9.4-13.4-26.7-8.2-43.2 6.2-19.5 22.6-30.7 37.4-25.8v.3c-14.8-4.8-31.1 6.3-37.2 25.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#bdd4f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.2 106.3c-5.1 16.4-1.4 33.7 8.2 43.1l-.2.2c-9.7-9.5-13.4-26.9-8.2-43.3 6.2-19.6 22.7-30.8 37.5-25.9v.3c-14.8-5-31.2 6.1-37.3 25.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#bdd6f5"
    }
  }), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st398",
    d: "M146 106.2c-5.2 16.5-1.5 33.8 8.2 43.3l-.2.2c-9.7-9.5-13.4-27-8.2-43.6 6.2-19.7 22.8-31 37.7-26.1v.4c-14.9-4.9-31.3 6.3-37.5 25.8z"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st398",
    d: "M145.9 106.2c-5.2 16.5-1.5 34 8.2 43.4l-.2.2c-9.8-9.6-13.5-27.1-8.3-43.8 6.2-19.8 22.9-31.1 37.9-26.2v.3c-14.9-4.8-31.4 6.4-37.6 26.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.7 106.1c-5.2 16.6-1.5 34.1 8.2 43.7l-.2.2c-9.8-9.6-13.5-27.3-8.3-44 6.3-19.9 23-31.3 38-26.4v.3c-14.9-4.8-31.5 6.4-37.7 26.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#c1d7f5"
    }
  }), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st400",
    d: "M145.6 106c-5.3 16.7-1.5 34.3 8.2 43.9l-.2.2c-9.8-9.7-13.6-27.4-8.3-44.2 6.3-20 23.1-31.4 38.2-26.5v.3c-15-4.9-31.7 6.5-37.9 26.3z"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st400",
    d: "M145.4 106c-5.3 16.8-1.5 34.4 8.3 44.1l-.2.2c-9.8-9.8-13.6-27.5-8.3-44.4 6.3-20.1 23.1-31.6 38.4-26.7v.4c-15.2-5-31.9 6.4-38.2 26.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.3 105.9c-5.3 16.8-1.6 34.6 8.3 44.3l-.2.2c-9.9-9.8-13.6-27.7-8.3-44.6 6.3-20.2 23.3-31.7 38.5-26.8v.3c-15.2-4.9-32 6.6-38.3 26.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#c2d9f5"
    }
  }), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st402",
    d: "M145.1 105.8c-5.3 16.9-1.6 34.7 8.3 44.5l-.2.2c-9.9-9.9-13.7-27.8-8.3-44.8 6.4-20.3 23.4-31.9 38.7-27v.3c-15.3-4.8-32.2 6.7-38.5 26.8z"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st402",
    d: "M145 105.8c-5.4 17-1.6 34.9 8.3 44.7l-.2.2c-9.9-9.9-13.7-27.9-8.3-45 6.4-20.4 23.5-32 38.9-27.1v.3c-15.4-4.9-32.4 6.6-38.7 26.9z"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st403",
    d: "M144.8 105.7c-5.3 17-1.6 35 8.3 44.9l-.2.2c-10-10-13.7-28.1-8.3-45.2 6.4-20.5 23.6-32.2 39.1-27.3v.4c-15.5-4.9-32.5 6.7-38.9 27z"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st403",
    d: "M144.7 105.7c-5.4 17.1-1.6 35.1 8.3 45.1l-.2.2c-10-10-13.8-28.2-8.4-45.4 6.5-20.5 23.7-32.3 39.2-27.4v.3c-15.4-4.9-32.5 6.8-38.9 27.2z"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st403",
    d: "M144.5 105.6c-5.4 17.2-1.6 35.3 8.3 45.3l-.2.2c-10-10.1-13.8-28.3-8.4-45.6 6.5-20.6 23.8-32.5 39.4-27.6v.3c-15.5-4.9-32.7 6.9-39.1 27.4z"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st404",
    d: "M144.4 105.5c-5.4 17.3-1.6 35.4 8.4 45.5l-.2.2c-10.1-10.2-13.8-28.5-8.4-45.8 6.5-20.7 23.8-32.6 39.5-27.8v.3c-15.6-4.8-32.9 7-39.3 27.6z"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st404",
    d: "M144.2 105.5c-5.4 17.3-1.7 35.6 8.4 45.7l-.2.2c-10.1-10.2-13.9-28.6-8.4-46 6.5-20.8 23.9-32.8 39.7-27.9v.3c-15.7-4.9-33 7-39.5 27.7z"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st405",
    d: "M144.1 105.4c-5.5 17.4-1.7 35.7 8.4 45.9l-.2.2c-10.1-10.3-13.9-28.7-8.4-46.2 6.6-20.9 24-32.9 39.9-28v.3c-15.8-4.9-33.2 7.1-39.7 27.8z"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st405",
    d: "M143.9 105.3c-5.5 17.5-1.7 35.9 8.4 46.1l-.2.2c-10.1-10.3-13.9-28.8-8.4-46.4 6.6-21 24.1-33 40-28.2v.3c-15.8-4.8-33.2 7.2-39.8 28z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.8 105.3c-5.5 17.5-1.7 36 8.4 46.3l-.2.2c-10.2-10.4-14-29-8.4-46.6 6.6-21.1 24.2-33.2 40.2-28.4v.3c-15.9-4.8-33.4 7.2-40 28.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#cbdff6"
    }
  }), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st407",
    d: "M143.6 105.2c-5.5 17.6-1.7 36.1 8.4 46.5l-.2.2c-10.2-10.5-14-29.1-8.4-46.8 6.7-21.2 24.4-33.4 40.4-28.5v.3c-16-4.8-33.6 7.3-40.2 28.3z"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st407",
    d: "M143.4 105.2c-5.6 17.7-1.7 36.3 8.4 46.7l-.2.2c-10.2-10.5-14-29.2-8.4-47 6.7-21.3 24.4-33.5 40.5-28.6v.3c-16-4.9-33.6 7.2-40.3 28.4z"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st407",
    d: "M143.3 105.1c-5.6 17.7-1.8 36.4 8.4 46.9l-.2.2c-10.2-10.6-14-29.4-8.4-47.2 6.7-21.3 24.5-33.6 40.7-28.8v.3c-16.1-4.8-33.8 7.4-40.5 28.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.2 105c-5.6 17.8-1.8 36.6 8.4 47.1l-.2.2c-10.2-10.6-14.1-29.5-8.4-47.4 6.7-21.4 24.6-33.8 40.9-29v.3c-16.3-4.8-34 7.5-40.7 28.8z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#cedff6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 105c-5.6 17.9-1.8 36.7 8.4 47.3l-.2.2c-10.3-10.7-14.1-29.6-8.4-47.6 6.8-21.5 24.7-34 41-29.1v.3c-16.3-4.9-34.1 7.5-40.8 28.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#cfe2f6"
    }
  }), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st410",
    d: "M142.9 104.9c-5.7 17.9-1.8 36.8 8.4 47.5l-.2.2c-10.3-10.7-14.1-29.7-8.4-47.8 6.8-21.6 24.8-34.1 41.2-29.3v.3c-16.4-4.8-34.3 7.6-41 29.1z"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st410",
    d: "M142.7 104.8c-5.7 18-1.9 37 8.4 47.7l-.2.2c-10.3-10.8-14.2-29.9-8.4-48 6.8-21.7 24.8-34.3 41.3-29.4v.3c-16.4-4.8-34.3 7.7-41.1 29.2z"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st410",
    d: "M142.6 104.7c-5.7 18.1-1.9 37.1 8.4 47.9l-.2.2c-10.3-10.9-14.2-30-8.5-48.2 6.9-21.8 25-34.4 41.5-29.6v.3c-16.4-4.7-34.4 7.8-41.2 29.4z"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st410",
    d: "M142.4 104.7c-5.7 18.1-1.9 37.2 8.4 48.1l-.2.2c-10.4-10.9-14.2-30.1-8.5-48.4 6.9-21.9 25.1-34.5 41.7-29.7v.3c-16.5-4.8-34.6 7.8-41.4 29.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.2 104.6c-5.7 18.2-1.9 37.4 8.5 48.3l-.2.2c-10.4-11-14.2-30.3-8.5-48.6 6.9-22 25.2-34.7 41.8-29.9v.3c-16.5-4.7-34.7 7.9-41.6 29.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#d3e3f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.1 104.6c-5.7 18.3-1.9 37.5 8.5 48.5l-.2.2c-10.4-11-14.2-30.4-8.5-48.8 6.9-22.1 25.2-34.8 42-30v.3c-16.7-4.8-34.9 7.9-41.8 29.8z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#d4e3f8"
    }
  }), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st413",
    d: "M141.9 104.5c-5.8 18.4-1.9 37.7 8.5 48.7l-.2.2c-10.4-11.1-14.3-30.5-8.5-48.9 7-22.1 25.3-35 42.1-30.2v.3c-16.7-4.8-34.9 7.9-41.9 29.9z"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st413",
    d: "M141.8 104.5c-5.8 18.4-1.9 37.8 8.5 48.9l-.2.2c-10.5-11.2-14.3-30.7-8.5-49.1 7-22.2 25.4-35.1 42.3-30.3v.3c-16.8-4.9-35.1 7.9-42.1 30z"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st414",
    d: "M141.7 104.4c-5.8 18.5-2 37.9 8.5 49.1l-.2.2c-10.5-11.2-14.3-30.8-8.5-49.3 7-22.3 25.5-35.2 42.4-30.5v.3c-16.9-4.9-35.3 8-42.2 30.2z"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st414",
    d: "M141.5 104.3c-5.8 18.5-2 38.1 8.5 49.3l-.2.2c-10.5-11.3-14.3-30.9-8.5-49.5 7-22.4 25.6-35.4 42.6-30.7v.3c-16.9-4.8-35.4 8.2-42.4 30.4z"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st414",
    d: "M141.4 104.2c-5.9 18.6-2 38.2 8.5 49.5l-.2.2c-10.5-11.3-14.4-31-8.5-49.7 7-22.5 25.7-35.6 42.8-30.8v.3c-17.1-4.8-35.6 8.2-42.6 30.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.2 104.2c-5.9 18.7-2 38.3 8.5 49.6l-.2.2c-10.5-11.4-14.4-31.2-8.5-49.9 7.1-22.5 25.8-35.7 42.9-31v.3c-17.1-4.7-35.6 8.4-42.7 30.8z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#d9e8f8"
    }
  }), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st416",
    d: "M141 104.1c-5.9 18.7-2 38.4 8.5 49.8l-.2.2c-10.6-11.5-14.4-31.3-8.5-50.1 7.1-22.6 25.9-35.8 43.1-31.1v.3c-17.1-4.7-35.8 8.4-42.9 30.9z"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st416",
    d: "M140.9 104.1c-5.9 18.8-2.1 38.6 8.5 50l-.2.2c-10.6-11.5-14.4-31.4-8.5-50.3 7.2-22.7 25.9-36 43.2-31.3v.3c-17.2-4.7-35.9 8.4-43 31.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.7 104c-5.9 18.8-2.1 38.7 8.5 50.2l-.2.2c-10.6-11.6-14.4-31.5-8.5-50.5 7.2-22.8 26-36.1 43.4-31.4v.3c-17.3-4.7-36 8.5-43.2 31.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#dde8f8"
    }
  }), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st418",
    d: "M140.6 103.9c-5.9 18.9-2.1 38.8 8.5 50.4l-.2.2c-10.6-11.6-14.5-31.6-8.5-50.7 7.2-22.9 26.1-36.2 43.5-31.6v.3c-17.3-4.6-36.1 8.7-43.3 31.4z"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st418",
    d: "M140.4 103.9c-6 19-2.1 39 8.5 50.6l-.2.2c-10.6-11.7-14.5-31.8-8.5-50.9 7.2-23 26.2-36.4 43.7-31.7v.3c-17.4-4.7-36.3 8.6-43.5 31.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.3 103.8c-6 19-2.1 39.1 8.5 50.8l-.2.2c-10.6-11.8-14.5-31.9-8.5-51 7.2-23.1 26.3-36.5 43.8-31.9v.3c-17.5-4.7-36.4 8.7-43.6 31.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#dfeaf8"
    }
  }), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st420",
    d: "M140.2 103.8c-6 19.1-2.2 39.2 8.5 50.9l-.2.2c-10.7-11.8-14.5-32-8.5-51.2 7.3-23.2 26.4-36.7 44-32.1v.3c-17.6-4.6-36.6 8.8-43.8 31.9z"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st420",
    d: "M140 103.7c-6 19.2-2.2 39.3 8.4 51.1-.1.1-.2.1-.2.2-10.7-11.9-14.5-32.1-8.5-51.4 7.3-23.2 26.5-36.8 44.2-32.2v.3c-17.6-4.6-36.6 8.9-43.9 32z"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st421",
    d: "M139.9 103.6c-6.1 19.2-2.2 39.5 8.5 51.3l-.2.2c-10.7-11.9-14.5-32.3-8.5-51.6 7.4-23.3 26.6-36.9 44.3-32.4v.3c-17.7-4.5-36.9 9-44.1 32.2z"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st421",
    d: "M139.7 103.5c-6 19.3-2.2 39.6 8.5 51.5l-.2.2c-10.7-12-14.5-32.4-8.5-51.7 7.4-23.4 26.6-37.1 44.5-32.5v.3c-17.8-4.6-37 9-44.3 32.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.5 103.5c-6.1 19.3-2.2 39.7 8.5 51.6l-.2.2c-10.7-12-14.6-32.5-8.5-51.9 7.4-23.5 26.7-37.2 44.6-32.7v.3c-17.8-4.5-37 9.1-44.4 32.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e2eef9"
    }
  }), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st423",
    d: "M139.4 103.4c-6.1 19.4-2.3 39.8 8.4 51.8l-.2.2c-10.7-12.1-14.6-32.6-8.4-52.1 7.4-23.6 26.8-37.4 44.7-32.8v.3c-17.8-4.5-37.1 9.2-44.5 32.6z"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st423",
    d: "M139.2 103.4c-6.1 19.5-2.3 39.9 8.4 52l-.2.2c-10.7-12.2-14.6-32.7-8.4-52.3 7.4-23.6 26.9-37.5 44.9-33v.3c-17.9-4.5-37.3 9.2-44.7 32.8z"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st424",
    d: "M139.1 103.3c-6.1 19.5-2.3 40.1 8.4 52.2l-.2.2c-10.8-12.2-14.6-32.8-8.4-52.4 7.5-23.7 26.9-37.7 45-33.1v.3c-18-4.6-37.4 9.2-44.8 32.8z"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st424",
    d: "M138.9 103.2c-6.2 19.6-2.3 40.2 8.4 52.4l-.2.2c-10.8-12.3-14.6-33-8.4-52.6 7.5-23.8 27-37.8 45.2-33.3v.3c-18.1-4.6-37.5 9.3-45 33z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.8 103.2c-6.2 19.6-2.4 40.3 8.4 52.5l-.2.2c-10.8-12.4-14.6-33.1-8.4-52.8 7.5-23.9 27.1-37.9 45.3-33.4v.3c-18.1-4.5-37.6 9.4-45.1 33.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e7f0f9"
    }
  }), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st426",
    d: "M138.7 103.1c-6.2 19.7-2.4 40.4 8.4 52.7-.1.1-.2.1-.2.2-10.8-12.4-14.6-33.2-8.4-53 7.5-24 27.2-38.1 45.5-33.6v.3c-18.3-4.5-37.9 9.6-45.3 33.4z"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st426",
    d: "M138.5 103c-6.2 19.8-2.4 40.5 8.4 52.9l-.2.2c-10.8-12.5-14.6-33.3-8.4-53.2 7.6-24.1 27.3-38.2 45.6-33.8v.3c-18.3-4.3-37.9 9.7-45.4 33.6z"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st426",
    d: "M138.3 103c-6.2 19.8-2.4 40.6 8.4 53.1l-.2.2c-10.8-12.5-14.6-33.4-8.4-53.3 7.6-24.1 27.3-38.3 45.8-33.9v.3c-18.3-4.5-38 9.6-45.6 33.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.2 102.9c-6.2 19.9-2.4 40.7 8.4 53.2l-.2.2c-10.8-12.6-14.6-33.6-8.4-53.5 7.6-24.2 27.4-38.5 45.9-34.1v.3c-18.4-4.4-38.1 9.8-45.7 33.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ebf0fb"
    }
  }), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st177",
    d: "M138 102.8c-6.3 19.9-2.4 40.9 8.4 53.4-.1.1-.2.1-.2.2-10.8-12.6-14.6-33.7-8.3-53.7 7.6-24.3 27.5-38.6 46-34.3v.3c-18.5-4.2-38.3 10-45.9 34.1z"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st428",
    d: "M137.9 102.8c-6.3 20-2.5 41 8.4 53.6l-.2.2c-10.8-12.7-14.6-33.8-8.3-53.8 7.7-24.4 27.6-38.8 46.2-34.4v.3c-18.6-4.5-38.5 9.9-46.1 34.1z"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st428",
    d: "M137.7 102.7c-6.3 20-2.5 41.1 8.4 53.7l-.3.2c-10.8-12.8-14.7-33.9-8.3-54 7.7-24.4 27.6-38.9 46.3-34.6v.3c-18.5-4.2-38.4 10.1-46.1 34.4z"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st428",
    d: "M137.6 102.7c-6.3 20.1-2.5 41.2 8.3 53.9l-.3.2c-10.8-12.8-14.6-34-8.3-54.2 7.7-24.5 27.7-39 46.4-34.7v.3c-18.5-4.4-38.4 10-46.1 34.5z"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st429",
    d: "M137.4 102.6c-6.3 20.1-2.5 41.3 8.3 54.1l-.2.2c-10.9-12.9-14.7-34.1-8.3-54.3C145 78 165 63.4 183.8 67.7v.3c-18.7-4.3-38.7 10.1-46.4 34.6z"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st430",
    d: "M137.3 102.6c-6.4 20.2-2.6 41.4 8.3 54.3-.1 0-.2.1-.2.2-10.9-12.9-14.7-34.2-8.3-54.5 7.8-24.7 27.9-39.3 46.8-35v.3c-18.8-4.5-38.9 10.1-46.6 34.7z"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st430",
    d: "M137.1 102.5c-6.4 20.3-2.6 41.5 8.3 54.4l-.2.1c-10.9-13-14.7-34.4-8.3-54.7 7.8-24.7 28-39.4 46.9-35.2v.3c-18.8-4.1-38.9 10.4-46.7 35.1z"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st431",
    d: "M137 102.4c-6.4 20.3-2.6 41.6 8.3 54.6-.1.1-.2.1-.3.1-10.9-13.1-14.6-34.5-8.2-54.9 7.8-24.8 28.1-39.5 47-35.3v.3c-18.9-4.2-39.1 10.5-46.8 35.2z"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st431",
    d: "M136.8 102.3c-6.4 20.4-2.6 41.7 8.3 54.8l-.2.1c-10.9-13.1-14.7-34.6-8.2-55 7.8-24.9 28.1-39.7 47.1-35.5v.3c-19-4.1-39.2 10.5-47 35.3z"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st432",
    d: "M136.7 102.3c-6.4 20.4-2.6 41.8 8.2 54.9l-.2.1c-10.9-13.2-14.6-34.7-8.2-55.2 7.8-25 28.2-39.8 47.3-35.6v.3c-19-4.1-39.3 10.6-47.1 35.5z"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st432",
    d: "M136.5 102.2c-6.4 20.5-2.7 41.9 8.2 55.1l-.3.1c-10.9-13.2-14.6-34.8-8.2-55.3 7.9-25 28.3-39.9 47.4-35.8v.3c-18.9-4.1-39.2 10.7-47.1 35.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.4 102.2c-6.5 20.5-2.7 42 8.2 55.3-.1 0-.2.1-.3.1-10.9-13.3-14.6-34.9-8.2-55.5C144 77 164.4 62 183.6 66.2v.3c-19-4.2-39.3 10.6-47.2 35.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f5f9fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2 102.1c-6.5 20.6-2.7 42.2 8.2 55.4l-.3.1c-10.9-13.4-14.6-35-8.1-55.6 7.9-25.2 28.4-40.2 47.7-36.1v.3c-19.2-4.1-39.6 10.8-47.5 35.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f6f9fc"
    }
  }), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st435",
    d: "M136.1 102c-6.5 20.6-2.7 42.2 8.1 55.5-.1 0-.2.1-.3.1-10.9-13.4-14.6-35.1-8.1-55.8 8-25.3 28.5-40.3 47.8-36.3v.3c-19.1-3.9-39.6 11.1-47.5 36.2z"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st435",
    d: "M135.9 102c-6.5 20.7-2.7 42.3 8.2 55.7-.1 0-.2.1-.3.1-10.9-13.5-14.6-35.2-8.1-56 8-25.3 28.6-40.4 48-36.4v.3c-19.3-4-39.8 11-47.8 36.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.8 101.9c-6.5 20.7-2.8 42.4 8.1 55.9-.1 0-.2.1-.3.1-10.9-13.5-14.6-35.3-8.1-56.1 8-25.5 28.6-40.6 48.1-36.6v.3c-19.3-4-39.9 11.1-47.8 36.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f9f9fc"
    }
  }), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st437",
    d: "M135.6 101.8c-6.5 20.7-2.8 42.5 8.1 56l-.3.1c-10.9-13.6-14.6-35.4-8.1-56.2 8-25.5 28.7-40.7 48.2-36.8v.3c-19.3-3.9-39.9 11.2-47.9 36.6z"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st437",
    d: "M135.5 101.8c-6.5 20.8-2.8 42.6 8.1 56.2l-.3.1c-10.9-13.7-14.6-35.5-8-56.4 8-25.6 28.8-40.9 48.3-36.9v.3c-19.5-4-40.1 11.2-48.1 36.7z"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st287",
    d: "M135.3 101.7c-6.5 20.8-2.8 42.7 8.1 56.3-.1 0-.2.1-.3.1-10.9-13.7-14.6-35.7-8-56.6 8.1-25.6 28.8-40.9 48.4-37.1v.3c-19.5-3.8-40.2 11.5-48.2 37z"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st287",
    d: "M135.2 101.6c-6.6 20.9-2.9 42.8 8 56.5l-.2.1c-10.9-13.7-14.6-35.7-8-56.7 8.1-25.7 28.9-41 48.5-37.1v.2c-19.5-3.9-40.3 11.4-48.3 37z"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st286",
    d: "m180.8 96-.1-.1-2.5-.5-12.7 26.8 5.1 2.6.5-1c1.9-4.1 3.7-8.4 5.3-13 1.8-5 3.2-10 4.4-14.8z"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st285",
    d: "M177.9 95.3 165.2 122l.4.2 12.7-26.8-.4-.1z"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st285",
    d: "M177.6 95.2 165 121.9l.3.2L178 95.3l-.4-.1z"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st284",
    d: "m177.3 95.2-12.6 26.6.4.2 12.7-26.7-.5-.1z"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st284",
    d: "m177.1 95.1-12.6 26.6.3.2 12.7-26.7-.4-.1z"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st284",
    d: "m176.8 95.1-12.6 26.4.4.2 12.6-26.6h-.4z"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st283",
    d: "M176.5 95 164 121.4l.4.2 12.5-26.5-.4-.1z"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st282",
    d: "m176.3 94.9-12.5 26.4.3.2L176.7 95l-.4-.1z"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st282",
    d: "m176 94.9-12.5 26.3.4.2L176.4 95l-.4-.1z"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st281",
    d: "m175.7 94.8-12.4 26.3.3.2 12.5-26.4-.4-.1z"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st281",
    d: "M175.4 94.8 163 120.9l.4.2 12.4-26.2-.4-.1z"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st281",
    d: "m175.2 94.7-12.4 26.1.3.2 12.5-26.2-.4-.1z"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st280",
    d: "m174.9 94.6-12.3 26.1.3.2 12.4-26.2-.4-.1z"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st280",
    d: "m174.6 94.6-12.3 26 .4.2L175 94.7l-.4-.1z"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "m174.3 94.5-12.2 25.9.3.2 12.3-26-.4-.1z"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m174.1 94.5-12.3 25.8.4.2 12.3-25.9-.4-.1z"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m173.8 94.4-12.2 25.8.3.2 12.3-25.9-.4-.1z"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st108",
    d: "m173.5 94.3-12.2 25.8.4.2 12.2-25.9-.4-.1z"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st108",
    d: "M173.3 94.3 161.1 120l.4.1 12.2-25.7-.4-.1z"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st279",
    d: "m173 94.2-12.1 25.6.3.2 12.2-25.7-.4-.1z"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st278",
    d: "m172.7 94.2-12.1 25.5.4.2 12.1-25.6-.4-.1z"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st278",
    d: "m172.5 94.1-12.1 25.5.4.2 12.1-25.6-.4-.1z"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st277",
    d: "m172.2 94.1-12.1 25.4.4.1 12.1-25.5h-.4z"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st276",
    d: "m171.9 94-12 25.3.4.2 12-25.4-.4-.1z"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st276",
    d: "m171.7 93.9-12 25.3.3.2L172.1 94l-.4-.1z"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st276",
    d: "m171.4 93.9-12 25.2.4.2 12-25.3-.4-.1z"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st112",
    d: "M171.1 93.8 159.2 119l.3.2 12-25.3-.4-.1z"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st112",
    d: "M170.8 93.8 159 118.9l.3.1 11.9-25.2h-.4z"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st275",
    d: "m170.6 93.7-11.9 25 .4.2L171 93.8l-.4-.1z"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st275",
    d: "m170.3 93.6-11.9 25 .4.2 11.9-25.1-.4-.1z"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st274",
    d: "m170 93.6-11.8 24.9.4.2 11.8-25-.4-.1z"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st273",
    d: "M169.8 93.5 158 118.4l.3.1 11.8-24.9-.3-.1z"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st273",
    d: "m169.5 93.5-11.8 24.7.4.2 11.8-24.8-.4-.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#eb7223"
    },
    d: "m169.2 93.4-11.7 24.7.3.2 11.8-24.8-.4-.1z"
  }), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st272",
    d: "M168.9 93.3 157.3 118l.3.2 11.7-24.8-.4-.1z"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st272",
    d: "M168.7 93.3 157 117.9l.4.1 11.7-24.6-.4-.1z"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st271",
    d: "m168.4 93.2-11.6 24.5.3.2 11.7-24.6-.4-.1z"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st271",
    d: "m168.1 93.2-11.6 24.4.4.2 11.6-24.5-.4-.1z"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st270",
    d: "m167.8 93.1-11.5 24.4.4.2 11.5-24.5-.4-.1z"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st270",
    d: "M167.6 93 156 117.4l.4.1L168 93.1l-.4-.1z"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st269",
    d: "m167.3 93-11.5 24.2.4.2 11.5-24.3-.4-.1z"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st269",
    d: "m167 92.9-11.4 24.2.3.2L167.4 93l-.4-.1z"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st268",
    d: "M166.7 92.9 155.3 117l.4.2L167.2 93l-.5-.1z"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st268",
    d: "m166.5 92.8-11.4 24.1.4.2 11.4-24.2-.4-.1z"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st267",
    d: "m166.2 92.8-11.4 24 .4.1 11.4-24.1h-.4z"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st267",
    d: "m165.9 92.7-11.3 23.9.3.2 11.4-24-.4-.1z"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st267",
    d: "m165.7 92.6-11.3 23.9.3.2 11.4-24-.4-.1z"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st266",
    d: "m165.4 92.6-11.3 23.8.4.2 11.3-23.9-.4-.1z"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st237",
    d: "m165.1 92.5-11.2 23.8.3.1 11.3-23.8-.4-.1z"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st237",
    d: "m164.9 92.5-11.3 23.6.4.2 11.3-23.7-.4-.1z"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "M164.6 92.4 153.4 116l.4.2L165 92.5l-.4-.1z"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "m164.3 92.3-11.2 23.6.4.2 11.2-23.7-.4-.1z"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "m164.1 92.3-11.2 23.5.4.2 11.2-23.6-.4-.1z"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "m163.8 92.2-11.1 23.4.3.2 11.2-23.5-.4-.1z"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st238",
    d: "m163.5 92.2-11.1 23.3.4.2 11.1-23.4-.4-.1z"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st239",
    d: "m163.2 92.1-11 23.3.4.2 11-23.4-.4-.1z"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st239",
    d: "m163 92.1-11 23.2.3.2 11.1-23.4h-.4z"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st240",
    d: "m162.7 92-11 23.2.4.1 11-23.2-.4-.1z"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st241",
    d: "M162.4 91.9 151.5 115l.3.2 11-23.2-.4-.1z"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st241",
    d: "m162.1 91.9-10.9 23 .4.2 11-23.1-.5-.1z"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st241",
    d: "m161.9 91.8-10.9 23 .3.2 11-23.1-.4-.1z"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st242",
    d: "m161.6 91.8-10.9 22.9.4.2L162 91.8h-.4z"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st242",
    d: "m161.3 91.7-10.8 22.8.4.2 10.8-22.9-.4-.1z"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st243",
    d: "m161 91.6-10.7 22.8.3.2 10.9-22.9-.5-.1z"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st243",
    d: "M160.8 91.6 150 114.3l.4.2 10.8-22.8-.4-.1z"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st244",
    d: "m160.5 91.5-10.7 22.7.3.2 10.8-22.8-.4-.1z"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st245",
    d: "M160.2 91.5 149.5 114l.4.2 10.7-22.7h-.4z"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st245",
    d: "m160 91.4-10.7 22.5.3.2 10.8-22.6-.4-.1z"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st245",
    d: "m159.7 91.3-10.6 22.5.3.2 10.7-22.6-.4-.1z"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st246",
    d: "m159.4 91.3-10.6 22.4.4.2 10.6-22.5-.4-.1z"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st247",
    d: "m159.1 91.2-10.5 22.4.3.1 10.6-22.4-.4-.1z"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st248",
    d: "m158.9 91.2-10.6 22.2.4.2 10.6-22.3-.4-.1z"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st248",
    d: "m158.6 91.1-10.5 22.2.4.2L159 91.2l-.4-.1z"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st249",
    d: "m158.3 91-10.5 22.2.4.2 10.5-22.3-.4-.1z"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st249",
    d: "m158.1 91-10.5 22.1.4.2 10.5-22.2-.4-.1z"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st250",
    d: "m157.8 90.9-10.4 22 .3.2L158.2 91l-.4-.1z"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st250",
    d: "m157.5 90.9-10.4 21.9.4.2 10.4-22-.4-.1z"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st251",
    d: "m157.3 90.8-10.4 21.9.4.2 10.4-22-.4-.1z"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st251",
    d: "m157 90.8-10.4 21.8.4.2 10.4-22h-.4z"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st252",
    d: "m156.7 90.7-10.3 21.7.4.2 10.3-21.8-.4-.1z"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st252",
    d: "m156.5 90.6-10.3 21.7.3.2 10.4-21.8-.4-.1z"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st252",
    d: "m156.2 90.6-10.3 21.6.4.2 10.3-21.7-.4-.1z"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st253",
    d: "m155.9 90.5-10.2 21.6.3.2 10.3-21.7-.4-.1z"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st254",
    d: "M155.6 90.5 145.4 112l.4.1L156 90.5h-.4z"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st254",
    d: "m155.4 90.4-10.2 21.4.4.2 10.2-21.5-.4-.1z"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st256",
    d: "m155.1 90.3-5.3 11.1c-.5 1.2-1 2.3-1.6 3.3l-3.3 6.9.4.2 10.2-21.5h-.4z"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st256",
    d: "m154.8 90.3-4.4 9.2c-.1.5-.3 1.1-.5 1.6-.7 2-1.7 3.8-2.7 5.2l-2.5 5.3.4.2 10.1-21.4-.4-.1z"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st257",
    d: "m154.5 90.2.4.1-4.8 10.1c.2-.7.4-1.5.6-2.2l3.8-8zm-8 17c.4-.5.8-1 1.2-1.6l-2.8 6-.4-.2 2-4.2z"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st257",
    d: "m154.3 90.2.4.1-4 8.5c.1-.5.2-1.1.3-1.6l3.3-7zm-8.4 17.7c.3-.3.6-.6.9-1l-2.2 4.6-.4-.2 1.7-3.4z"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st257",
    d: "m154 90.1.4.1-3.5 7.5c.1-.5.1-.9.2-1.4l2.9-6.2zm-8.7 18.3c.3-.2.6-.5.8-.8l-1.8 3.8-.4-.2 1.4-2.8z"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st258",
    d: "m153.7 90 .4.1-3.1 6.6c.1-.4.1-.8.1-1.2l2.6-5.5zm-8.8 18.8c.3-.2.5-.4.7-.6l-1.5 3.1-.4-.2 1.2-2.3z"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st259",
    d: "m153.5 90 .4.1-2.8 5.8c0-.4 0-.7.1-1.1l2.3-4.8zm-9.1 19.1c.2-.1.5-.3.7-.5l-1.2 2.6-.4-.2.9-1.9z"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st259",
    d: "m153.2 89.9.4.1-2.4 5.2v-1l2-4.3zm-9.2 19.4c.2-.1.5-.3.7-.4l-1 2.1-.4-.2.7-1.5z"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st260",
    d: "m152.9 89.9.4.1-2.2 4.6v-.9l1.8-3.8zm-9.3 19.6.6-.3-.8 1.7-.4-.2.6-1.2z"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st260",
    d: "m152.6 89.8.4.1-1.9 4c0-.3 0-.5-.1-.8l1.6-3.3zm-9.4 19.8c.2-.1.4-.1.5-.2l-.6 1.4-.4-.2.5-1z"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st260",
    d: "m152.4 89.7.4.1-1.7 3.5c0-.3-.1-.5-.1-.7l1.4-2.9zm-9.5 20.1c.2 0 .4-.1.5-.2l-.5 1.1-.4-.2.4-.7z"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st261",
    d: "m152.1 89.7.4.1-1.5 3.1c0-.2-.1-.5-.1-.7l1.2-2.5zm-9.5 20.1c.2 0 .3-.1.5-.1l-.4.8-.4-.2.3-.5z"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st261",
    d: "m151.8 89.6.4.1-1.3 2.7c0-.2-.1-.4-.2-.6l1.1-2.2zm-9.6 20.3c.2 0 .3 0 .5-.1l-.3.6-.4-.2.2-.3z"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st262",
    d: "m151.5 89.6.4.1-1.1 2.3c-.1-.2-.1-.4-.2-.6l.9-1.8zm-9.6 20.3h.5l-.2.4-.2-.1-.1-.1v-.2z"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st263",
    d: "m151.3 89.5.4.1-1 2c-.1-.2-.1-.4-.2-.5l.8-1.6zm-9.6 20.3h.4l-.2.3c-.1-.1-.2-.1-.4-.2l.2-.1z"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st263",
    d: "m151 89.5.4.1-.8 1.7c-.1-.2-.1-.3-.2-.5l.6-1.3zm-9.6 20.3c.1 0 .3.1.4.1l-.1.2-.3-.3z"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st264",
    d: "m150.7 89.4.4.1-.7 1.4c-.1-.2-.1-.3-.2-.5l.5-1zm-9.6 20.3c.1 0 .3.1.4.1l-.1.1c-.1 0-.2-.1-.3-.2z"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st264",
    d: "m150.5 89.3.4.1-.6 1.2c-.1-.2-.2-.3-.3-.4l.5-.9zm-9.3 20.5c-.1 0-.2-.1-.2-.1h.1c.1 0 .1 0 .1.1z"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st264",
    d: "m150.2 89.3-.3.6c.1.1.2.2.3.4l.4-.9-.4-.1z"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m149.9 89.2-.2.5.3.3.3-.7-.4-.1z"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m149.7 89.2-.2.3.3.3.3-.6h-.4z"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st265",
    d: "m149.4 89.1-.1.2.3.3.2-.4h-.2c0-.1-.1-.1-.2-.1z"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "m149.1 89.1-.1.1c.1.1.2.1.3.2l.1-.3h-.3z"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st153",
    d: "M148.8 89c.1.1.2.1.3.2l.1-.2c-.1.1-.2 0-.4 0zM148.9 89.1l-.2-.1c.1 0 .2.1.2.1z"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "M148.5 88.9c-2.8-1-6.8 2.9-8.8 8.6-2.1 5.7-1.4 11.2 1.4 12.2s6.8-2.8 8.8-8.6c2.1-5.7 1.5-11.2-1.4-12.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#faecca"
    },
    d: "m191.5 78.2.3-.4-.2-.1-.1.5z"
  }), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st440",
    d: "m191.5 78.8.5-.8-.4-.3-.1.1v1z"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st440",
    d: "m191.5 79.4.8-1.2-.4-.2-.3.6c-.1.2-.1.5-.1.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m191.4 80 1.1-1.7-.4-.3-.6 1c0 .4-.1.7-.1 1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#faecc7"
    }
  }), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st442",
    d: "m191.4 80.7 1.3-2.2-.4-.3-.9 1.5v1z"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st442",
    d: "m191.3 81.3 1.6-2.6-.4-.3-1.2 1.9c.1.3.1.7 0 1z"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st443",
    d: "m191.3 81.9 1.9-3.1-.4-.2-1.5 2.4v.9z"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st443",
    d: "m191.2 82.5 2.2-3.6-.4-.2-1.8 2.8c.1.4 0 .7 0 1z"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st444",
    d: "m191.1 83.2 2.5-4.1-.4-.3-2.1 3.3c.1.5.1.8 0 1.1z"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st444",
    d: "m191.1 83.9 2.9-4.6-.4-.2-2.4 3.8c-.1.4-.1.7-.1 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m191 84.5 3.2-5.1-.4-.2-2.7 4.3c0 .4-.1.7-.1 1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f9eabe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.9 85.2 3.5-5.6-.4-.2-3 4.8c0 .4 0 .7-.1 1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f9eabd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.8 86 3.8-6.1-.4-.3-3.3 5.3c0 .4 0 .7-.1 1.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f9e8bd"
    }
  }), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st448",
    d: "m190.7 86.7 4.2-6.7-.4-.3-3.7 5.8c0 .4 0 .8-.1 1.2z"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st448",
    d: "m190.6 87.3 4.5-7.2-.4-.2-4 6.4c0 .3 0 .7-.1 1z"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st449",
    d: "m190.5 88.1 4.8-7.8-.4-.2-4.3 7c0 .3 0 .6-.1 1z"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st449",
    d: "m190.4 88.8 5.2-8.4-.4-.2-4.7 7.5c0 .4-.1.8-.1 1.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m190.3 89.6 5.6-9-.4-.3-5 8c-.1.5-.2.9-.2 1.3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f9e7b7"
    }
  }), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st451",
    d: "m190.1 90.3 5.9-9.5-.4-.3-5.4 8.6c.1.5 0 .8-.1 1.2z"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st451",
    d: "m190 91.1 6.3-10.1-.4-.2-5.8 9.2c0 .3 0 .7-.1 1.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m189.8 91.9 6.7-10.8-.4-.2-6.1 9.9c0 .3-.1.7-.2 1.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f9e7b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.7 92.7 7.1-11.4-.4-.2-6.5 10.5c-.1.3-.1.7-.2 1.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f8e4b4"
    }
  }), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st454",
    d: "m189.5 93.5 7.5-12-.4-.3-6.9 11.1c0 .4-.1.8-.2 1.2z"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st454",
    d: "m189.3 94.4 7.9-12.7-.4-.2-7.3 11.7c0 .3-.1.7-.2 1.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m189.2 95.2 8.4-13.4-.4-.2-7.7 12.4c-.2.4-.2.8-.3 1.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f8e5b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189 96.1 8.8-14.1-.4-.2-8.2 13.1c0 .4-.1.8-.2 1.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f8e5af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f8e2af"
    },
    d: "m189.2 96.2 8.8-14.1-.4-.2-8.5 13.7-.1.5.2.1z"
  }), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st458",
    d: "m189.5 96.4 8.7-14.1-.3-.3-8.8 14.2.4.2z"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st458",
    d: "m189.7 96.5 8.8-14-.4-.3-8.8 14.1.4.2z"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st459",
    d: "m190 96.6 8.7-14-.3-.2-8.8 14 .4.2z"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st459",
    d: "m190.3 96.8 8.7-14-.4-.3-8.7 14.1.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f8e3a9"
    },
    d: "m190.5 96.9 8.7-13.9-.4-.3-8.7 14 .4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f8e0a9"
    },
    d: "m190.8 97 8.7-13.9-.4-.2-8.7 13.9.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f8e0a8"
    },
    d: "m191.1 97.1 8.6-13.8-.4-.3-8.6 13.9.4.2z"
  }), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st463",
    d: "m191.3 97.3 8.6-13.8-.3-.3-8.7 13.9.4.2z"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st463",
    d: "m191.6 97.4 8.6-13.8-.4-.2-8.6 13.8.4.2z"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st464",
    d: "m191.8 97.5 8.6-13.7-.4-.3-8.5 13.8.3.2z"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st464",
    d: "m192.1 97.7 8.6-13.8-.4-.2-8.6 13.8.4.2z"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st465",
    d: "m192.4 97.8 8.5-13.7-.4-.2-8.5 13.7.4.2z"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st465",
    d: "m192.6 97.9 8.5-13.6-.3-.3-8.6 13.7.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f7e0a1"
    },
    d: "m192.9 98 8.5-13.6-.4-.2-8.5 13.7.4.1z"
  }), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st467",
    d: "m193.2 98.2 8.4-13.6-.3-.2-8.5 13.6.4.2z"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st467",
    d: "m193.4 98.3 8.5-13.5-.4-.3-8.5 13.6.4.2z"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st468",
    d: "m193.7 98.4 8.4-13.5-.4-.2-8.4 13.5.4.2z"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st468",
    d: "m193.9 98.6 8.4-13.5-.3-.3-8.4 13.6.3.2z"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st469",
    d: "m194.2 98.7 8.4-13.4-.4-.3-8.4 13.5.4.2z"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st469",
    d: "m194.5 98.8 8.3-13.4-.3-.2-8.4 13.4.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f7db9a"
    },
    d: "m194.7 98.9 8.4-13.3-.4-.3-8.4 13.4.4.2z"
  }), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st471",
    d: "m195 99.1 8.3-13.4-.4-.2-8.3 13.4.4.2z"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st471",
    d: "m195.3 99.2 8.2-13.3-.3-.2-8.3 13.3.4.2z"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st472",
    d: "m195.5 99.3 8.3-13.2-.4-.3-8.3 13.3.4.2z"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st472",
    d: "m195.8 99.5 8.2-13.2-.3-.3-8.3 13.3.4.2z"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st473",
    d: "m196.1 99.6 8.2-13.2-.4-.2-8.2 13.2.4.2z"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st473",
    d: "m196.3 99.7 8.2-13.1-.3-.3-8.3 13.2.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f6d993"
    },
    d: "m196.6 99.9 8.2-13.1-.4-.3-8.2 13.2.4.2z"
  }), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st475",
    d: "m196.9 100 8.1-13.1-.4-.2-8.2 13.1.5.2z"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st475",
    d: "m197.1 100.1 8.1-13-.3-.3-8.2 13.1.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f6da8f"
    },
    d: "m197.4 100.2 8.1-13-.4-.2-8.1 13.1.4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f6d88f"
    },
    d: "m197.6 100.4 8.1-13-.3-.2-8.1 13 .3.2z"
  }), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st478",
    d: "m197.9 100.5 8.1-12.9-.4-.3-8.1 13 .4.2z"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st478",
    d: "m198.2 100.6 8-12.9-.4-.2-8 12.9.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f6d68b"
    },
    d: "m198.4 100.8 8-12.9-.3-.3-8.1 13 .4.2z"
  }), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st480",
    d: "m198.7 100.9 8-12.8-.4-.3-8 12.9.4.2z"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st480",
    d: "m199 101 7.9-12.8-.3-.2-8.1 12.8.5.2z"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st481",
    d: "m199.2 101.1 8-12.7-.4-.3-8 12.8.4.2z"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st481",
    d: "m199.5 101.3 7.9-12.8-.3-.2-8 12.8.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f6d686"
    },
    d: "m199.7 101.4 7.9-12.7-.3-.2-7.9 12.7.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f5d486"
    },
    d: "m200 101.5 7.9-12.6-.4-.3-7.9 12.7.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f5d484"
    },
    d: "m200.3 101.7 7.9-12.6-.4-.3-7.9 12.7.4.2z"
  }), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st485",
    d: "m200.5 101.8 7.9-12.6-.4-.2-7.9 12.6.4.2z"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st485",
    d: "m200.8 101.9 7.8-12.5-.3-.3-7.9 12.6.4.2z"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st486",
    d: "m201.1 102.1 7.8-12.6-.4-.2-7.8 12.6.4.2z"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st486",
    d: "m201.3 102.2 7.8-12.5-.4-.3-7.8 12.6.4.2z"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st487",
    d: "m201.6 102.3 7.7-12.4-.3-.3-7.8 12.5.4.2z"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st487",
    d: "m201.9 102.4 7.7-12.4-.4-.2-7.7 12.4.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f5d27f"
    },
    d: "m202.1 102.6 7.7-12.4-.3-.2-7.8 12.4.4.2z"
  }), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st489",
    d: "m202.4 102.7 7.7-12.3-.4-.3-7.7 12.4.4.2z"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st489",
    d: "m202.6 102.8 7.7-12.3-.4-.2-7.7 12.3.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f5d27c"
    },
    d: "m202.9 102.9 7.7-12.2-.4-.3-7.7 12.4.4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f5d17c"
    },
    d: "m203.2 103.1 7.6-12.3-.4-.2-7.6 12.3.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f5d17a"
    },
    d: "M203.4 103.2 211 91l-.3-.2L203 103l.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f5cf7a"
    },
    d: "m203.7 103.3 7.6-12.1-.4-.3-7.6 12.2.4.2z"
  }), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st494",
    d: "m203.9 103.5 7.6-12.2-.4-.2-7.5 12.2.3.2z"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st494",
    d: "m204.2 103.6 7.6-12.1-.4-.2-7.6 12.1.4.2z"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st494",
    d: "m204.5 103.7 7.5-12-.3-.3-7.6 12.1.4.2z"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st495",
    d: "m204.7 103.9 7.5-12.1-.3-.2-7.6 12.1.4.2z"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st495",
    d: "m205 104 7.5-12-.4-.3-7.5 12.1.4.2z"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st496",
    d: "m205.3 104.1 7.4-11.9-.3-.3-7.5 12 .4.2z"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st496",
    d: "m205.5 104.3 7.5-12-.4-.2-7.5 11.9.4.3z"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st497",
    d: "m205.8 104.4 7.4-11.9-.4-.3-7.4 12 .4.2z"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st497",
    d: "m206.1 104.5 7.3-11.9-.3-.2-7.4 11.9.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4cd71"
    },
    d: "m206.3 104.6 7.4-11.8-.4-.2-7.4 11.8.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4cd70"
    },
    d: "m206.6 104.8 7.3-11.8-.3-.3-7.4 11.9.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4cb6f"
    },
    d: "m206.8 104.9 7.4-11.8-.4-.2-7.4 11.8.4.2z"
  }), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st501",
    d: "m207.1 105 7.3-11.7-.3-.2-7.4 11.7.4.2z"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st501",
    d: "m207.4 105.1 7.3-11.6-.4-.3L207 105l.4.1z"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st502",
    d: "m207.6 105.3 7.3-11.7-.4-.2-7.2 11.7.3.2z"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st502",
    d: "m207.9 105.4 7.3-11.6-.4-.3-7.3 11.7.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4cb6b"
    },
    d: "m208.2 105.5 7.2-11.6-.4-.2-7.2 11.6.4.2z"
  }), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st504",
    d: "m208.4 105.7 7.2-11.6-.3-.2-7.3 11.6.4.2z"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st504",
    d: "m208.7 105.8 7.2-11.5-.4-.3-7.2 11.6.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4ca68"
    },
    d: "m209 105.9 7.1-11.5-.3-.2-7.3 11.5.5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4c867"
    },
    d: "m209.2 106.1 7.1-11.5-.3-.2-7.2 11.5.4.2z"
  }), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st507",
    d: "m209.5 106.2 7.1-11.4-.4-.3-7.1 11.5.4.2z"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st507",
    d: "m209.7 106.3 7.1-11.4-.3-.2-7.1 11.4.3.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4c865"
    },
    d: "m210 106.4 7.1-11.3-.4-.3-7.1 11.4.4.2z"
  }), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st509",
    d: "m210.3 106.6 7-11.4-.4-.2-7 11.4.4.2z"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st509",
    d: "m210.5 106.7 7.1-11.3-.4-.2-7.1 11.3.4.2z"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st510",
    d: "m210.8 106.8 7-11.2-.3-.3-7.1 11.3.4.2z"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st510",
    d: "m211.1 107 7-11.3-.4-.2-7 11.3.4.2z"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st511",
    d: "m211.3 107.1 7-11.2-.4-.3-7 11.3.4.2z"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st511",
    d: "m211.6 107.2 6.9-11.1-.3-.3-7 11.2.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f3c65e"
    },
    d: "m211.9 107.3 6.9-11.1-.4-.2-6.9 11.2.4.1z"
  }), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st513",
    d: "m212.1 107.5 6.9-11.1-.3-.2-7 11.1.4.2z"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st513",
    d: "m212.4 107.6 6.9-11-.4-.3-6.9 11.1.4.2z"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st514",
    d: "m212.6 107.7 6.9-11-.4-.2-6.9 11 .4.2z"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st514",
    d: "m212.9 107.9 6.9-11-.4-.3-6.9 11.1.4.2z"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st515",
    d: "m213.2 108 6.8-11-.4-.2-6.8 11 .4.2z"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st515",
    d: "m213.4 108.1 6.8-10.9-.3-.2-6.9 10.9.4.2z"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st516",
    d: "m213.7 108.2 6.8-10.8-.4-.3-6.8 11 .4.1z"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st516",
    d: "m214 108.4 6.7-10.9-.3-.2-6.8 10.9.4.2z"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st516",
    d: "m214.2 108.5 6.8-10.8-.4-.2-6.8 10.8.4.2z"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st517",
    d: "m214.5 108.6 6.7-10.7-.4-.3-6.7 10.8.4.2z"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st517",
    d: "m214.7 108.8 6.7-10.8-.3-.2-6.8 10.8.4.2z"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st518",
    d: "m215 108.9 6.7-10.7-.4-.3-6.7 10.8.4.2z"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st518",
    d: "m215.3 109 6.6-10.7-.3-.2-6.7 10.7.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2c153"
    },
    d: "m215.5 109.2 6.7-10.7-.4-.2-6.7 10.7.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2c152"
    },
    d: "m215.8 109.3 6.6-10.6-.4-.3-6.6 10.7.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2bf52"
    },
    d: "m216.1 109.4 6.6-10.6-.4-.2-6.6 10.6.4.2z"
  }), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st522",
    d: "m216.3 109.5 6.6-10.5-.4-.3-6.6 10.7.4.1z"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st522",
    d: "m216.6 109.7 6.6-10.5-.4-.3-6.6 10.6.4.2z"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st523",
    d: "m216.8 109.8 6.6-10.5-.4-.2-6.5 10.5.3.2z"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st523",
    d: "m217.1 109.9 6.5-10.4-.3-.3-6.6 10.5.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2bf4e"
    },
    d: "m217.4 110.1 6.5-10.5-.4-.2-6.5 10.5.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2bd4e"
    },
    d: "m217.7 110.2 6.4-10.4-.3-.2-6.5 10.4.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2bd4d"
    },
    d: "m217.9 110.3 6.5-10.3-.4-.3-6.5 10.4.4.2z"
  }), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st527",
    d: "m218.2 110.4 6.4-10.3-.4-.2-6.4 10.4.4.1z"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st527",
    d: "m218.4 110.6 6.4-10.3-.3-.3-6.5 10.4.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2bd4a"
    },
    d: "m218.7 110.7 6.4-10.3-.4-.2-6.4 10.3.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2bb4a"
    },
    d: "m219 110.8 6.3-10.2-.3-.2-6.5 10.2.5.2z"
  }), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st530",
    d: "m219.2 111 6.4-10.2-.4-.3-6.4 10.3.4.2z"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st530",
    d: "m219.5 111.1 6.3-10.2-.3-.2-6.4 10.2.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2ba48"
    },
    d: "m219.7 111.2 6.4-10.1-.4-.3-6.3 10.2.3.2z"
  }), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st532",
    d: "m220 111.3 6.3-10-.4-.3-6.3 10.2.4.1z"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st532",
    d: "m220.3 111.5 6.2-10.1-.3-.2-6.3 10.1.4.2z"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st533",
    d: "m220.5 111.6 6.3-10-.4-.3-6.3 10.1.4.2z"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st533",
    d: "m220.8 111.7 6.2-10-.3-.2-6.3 10.1.4.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2ba44"
    },
    d: "m221.1 111.9 6.2-10-.4-.2-6.2 10 .4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1b844"
    },
    d: "m221.3 112 6.2-10-.3-.2-6.3 10 .4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1b843"
    },
    d: "m221.6 112.1 6.2-9.9-.4-.2-6.2 9.9.4.2z"
  }), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st537",
    d: "m221.9 112.3 6.1-9.9-.3-.3-6.2 10 .4.2z"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st537",
    d: "m222.1 112.4 6.2-9.9-.4-.2-6.2 9.9.4.2z"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st538",
    d: "m222.4 112.5 6.1-9.8-.4-.3-6.1 9.9.4.2z"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st538",
    d: "m222.6 112.6 6.1-9.8-.3-.2-6.2 9.8.4.2z"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st539",
    d: "m222.9 112.8 6.1-9.8-.4-.2-6.1 9.8.4.2z"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st539",
    d: "m223.2 112.9 6-9.7-.3-.3-6.1 9.8.4.2z"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st539",
    d: "m223.4 113 6.1-9.7-.4-.2-6.1 9.7.4.2z"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st540",
    d: "m223.7 113.2 6-9.7-.4-.3-6 9.8.4.2z"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st540",
    d: "m224 113.3 6-9.6-.4-.3-6 9.7.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1b63c"
    },
    d: "m224.2 113.4 6-9.6-.3-.2-6.1 9.6.4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1b43c"
    },
    d: "m224.5 113.5 6-9.5-.4-.3-6 9.7.4.1z"
  }), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st543",
    d: "m224.7 113.7 6-9.6-.4-.2-6 9.6.4.2z"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st543",
    d: "m225 113.8 5.9-9.5-.3-.2-6 9.5.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1b33a"
    },
    d: "m225.3 113.9 5.9-9.4-.4-.3-5.9 9.5.4.2z"
  }), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st545",
    d: "m225.5 114.1 5.9-9.5-.3-.2-6 9.5.4.2z"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st545",
    d: "m225.8 114.2 5.9-9.4-.4-.3-5.9 9.5.4.2z"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st546",
    d: "m226.1 114.3 5.8-9.4-.4-.2-5.8 9.4.4.2z"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st546",
    d: "m226.3 114.5 5.9-9.4-.4-.2-5.9 9.4.4.2z"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st547",
    d: "m226.6 114.6 5.8-9.3-.3-.3-5.9 9.4.4.2z"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st547",
    d: "m226.8 114.7 5.8-9.3-.3-.2-5.8 9.3.3.2z"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st548",
    d: "m227.1 114.8 5.8-9.2-.4-.3-5.8 9.3.4.2z"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st548",
    d: "m227.4 115 5.7-9.3-.3-.2-5.8 9.3.4.2z"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st548",
    d: "m227.7 115.1 5.7-9.2-.4-.2-5.8 9.2.5.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1b135"
    },
    d: "m227.9 115.2 5.7-9.2-.3-.2-5.8 9.2.4.2z"
  }), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st550",
    d: "m228.2 115.4 5.7-9.2-.4-.2-5.7 9.2.4.2z"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st550",
    d: "m228.4 115.5 5.7-9.1-.3-.3-5.8 9.2.4.2z"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st550",
    d: "m228.7 115.6 5.7-9.1-.4-.2-5.7 9.1.4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f0af33"
    },
    d: "m228.9 115.7 5.7-9-.4-.3-5.6 9.2.3.1z"
  }), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st552",
    d: "m229.2 115.9 5.6-9.1-.3-.2-5.7 9.1.4.2z"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st552",
    d: "m229.5 116 5.6-9-.4-.2-5.6 9 .4.2z"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st553",
    d: "m229.8 116.1 5.6-8.9-.4-.3-5.6 9 .4.2z"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st553",
    d: "m230 116.3 5.6-9-.4-.2-5.6 9 .4.2z"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st553",
    d: "m230.3 116.4 5.5-8.9-.3-.3-5.6 9 .4.2z"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st553",
    d: "m230.5 116.5 5.6-8.9-.4-.2-5.6 8.9.4.2z"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st554",
    d: "m230.8 116.7 5.5-8.9-.3-.2-5.6 8.9.4.2z"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st554",
    d: "m231.1 116.8 5.5-8.9-.4-.2-5.5 8.9.4.2z"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st555",
    d: "m231.3 116.9 5.5-8.8-.4-.2-5.5 8.8.4.2z"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st555",
    d: "m231.6 117 5.5-8.7-.4-.3-5.5 8.8.4.2z"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st555",
    d: "m231.9 117.2 5.4-8.8-.4-.2-5.4 8.8.4.2z"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st556",
    d: "m232.1 117.3 5.5-8.7-.4-.3-5.5 8.8.4.2z"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st556",
    d: "m232.4 117.4 5.4-8.7-.4-.2-5.4 8.7.4.2z"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m232.6 117.6 5.4-8.7-.3-.2-5.4 8.7.3.2z"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m232.9 117.7 5.4-8.7-.4-.2-5.4 8.7.4.2z"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st151",
    d: "m233.2 117.8 5.4-8.6-.4-.2-5.4 8.6.4.2z"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m233.4 117.9 5.4-8.6-.4-.2-5.4 8.6.4.2z"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m233.7 118.1 5.3-8.6-.3-.2-5.4 8.6.4.2z"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m234 118.2 5.3-8.5-.4-.3-5.3 8.6.4.2z"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m234.2 118.3 5.3-8.5-.3-.2-5.4 8.5.4.2z"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m234.5 118.5 5.3-8.5-.4-.3-5.3 8.6.4.2z"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st150",
    d: "m234.7 118.6 5.3-8.5-.3-.2-5.3 8.5.3.2z"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st557",
    d: "m235 118.7 5.3-8.4-.4-.2-5.3 8.4.4.2z"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st557",
    d: "m235.3 118.8 5.2-8.4-.3-.2-5.3 8.5.4.1z"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st557",
    d: "m235.5 119 5.3-8.4-.4-.2-5.3 8.4.4.2z"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st558",
    d: "m235.8 119.1 5.2-8.4-.4-.2-5.2 8.4.4.2z"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st558",
    d: "m236.1 119.2 5.2-8.3-.4-.2-5.2 8.3.4.2z"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st558",
    d: "m236.3 119.4 5.2-8.3-.4-.3-5.1 8.4.3.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#efa52a"
    },
    d: "m236.6 119.5 5.2-8.3-.4-.2-5.2 8.3.4.2z"
  }), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st560",
    d: "m239.1 120.7 5-8.1c-.8-.5-1.6-1-2.5-1.6l-5.2 8.3 2.7 1.4z"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st286",
    d: "M146.3 95.2c-1.1-.4-2.7 1.1-3.5 3.4-.8 2.3-.5 4.5.5 4.9 1.1.4 2.7-1.1 3.5-3.4.9-2.3.6-4.5-.5-4.9z"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st561",
    d: "m152.9 93.8.1-.3h-.1c-.1.1-.1.2 0 .3z"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st561",
    d: "m152.9 94.2.2-.6-.2-.1v.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m152.9 94.5.3-1h-.2l-.1.4v.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f7d3ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.9 95 .4-1.4h-.2l-.2.8v.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f6d1ba"
    }
  }), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st564",
    d: "m152.9 95.4.5-1.8h-.2l-.3 1.1v.7z"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st564",
    d: "m152.9 96 .7-2.3h-.2l-.5 1.6v.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m152.9 96.7.9-3-.2-.1-.6 2c-.1.4-.1.7-.1 1.1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f6d0b6"
    }
  }), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st566",
    d: "m152.9 97.2 1-3.5h-.2l-.8 2.6v.9z"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st566",
    d: "m153 97.2 1-3.4-.2-.1-1 3.4v.1h.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f6ceb3"
    },
    d: "m153.1 97.3 1-3.5-.2-.1-1 3.5.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f5cbb3"
    },
    d: "m153.2 97.3 1.1-3.5h-.2l-1 3.5h.1z"
  }), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st569",
    d: "m153.4 97.4 1-3.5-.2-.1-1 3.5.2.1z"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st569",
    d: "m153.5 97.4 1-3.5-.2-.1-1 3.5.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f5c9ae"
    },
    d: "m153.7 97.4 1-3.5h-.2l-1.1 3.5h.3z"
  }), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st571",
    d: "m153.8 97.5 1-3.6h-.2l-1 3.5.2.1z"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st571",
    d: "m153.9 97.5 1-3.5-.2-.1-1 3.6h.2z"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st572",
    d: "m154 97.6 1.1-3.6h-.2l-1.1 3.5.2.1z"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st572",
    d: "m154.2 97.6 1-3.6h-.2l-1 3.6h.2z"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st573",
    d: "m154.3 97.7 1-3.6-.2-.1-1 3.6.2.1z"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st573",
    d: "m154.4 97.7 1.1-3.6h-.2l-1.1 3.5.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f5c6a7"
    },
    d: "m154.6 97.7 1-3.6h-.2l-1 3.6h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4c4a7"
    },
    d: "m154.7 97.8 1-3.6-.2-.1-1 3.6.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4c4a6"
    },
    d: "m154.8 97.8 1.1-3.6h-.3l-1 3.6h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4c4a4"
    },
    d: "m154.9 97.9 1.1-3.7h-.2l-1.1 3.6.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4c2a4"
    },
    d: "m155.1 97.9 1-3.6-.2-.1-1 3.7h.2z"
  }), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st579",
    d: "m155.2 98 1.1-3.7h-.3l-1 3.6.2.1z"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st579",
    d: "m155.3 98 1.1-3.7h-.2l-1.1 3.6.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4c0a0"
    },
    d: "m155.5 98.1 1-3.7-.2-.1-1 3.7.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4bfa0"
    },
    d: "m155.6 98.1 1-3.7h-.1l-1.1 3.6.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4bf9f"
    },
    d: "m155.7 98.1 1.1-3.7h-.2l-1.1 3.7h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f4bf9d"
    },
    d: "m155.8 98.2 1.1-3.7-.2-.1-1.1 3.7.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f3bd9d"
    },
    d: "m156 98.2 1-3.7-.1-.1-1.1 3.8h.2z"
  }), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st585",
    d: "m156.1 98.3 1.1-3.8h-.2l-1.1 3.7.2.1z"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st585",
    d: "m156.2 98.3 1.1-3.7-.2-.1-1.1 3.7.2.1z"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st586",
    d: "m156.4 98.4 1.1-3.8-.3-.1-1 3.8.2.1z"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st586",
    d: "m156.5 98.4 1.1-3.8h-.2l-1.1 3.7.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f3bb98"
    },
    d: "m156.6 98.4 1.1-3.7-.2-.1-1.1 3.8h.2z"
  }), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st588",
    d: "m156.8 98.5 1-3.8-.2-.1-1.1 3.8.3.1z"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st588",
    d: "m156.9 98.5 1.1-3.8h-.2l-1.1 3.8h.2z"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st589",
    d: "m157 98.6 1.1-3.8-.2-.1-1.1 3.8.2.1z"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st589",
    d: "m157.1 98.6 1.1-3.8-.1-.1-1.2 3.8.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f3b892"
    },
    d: "m157.3 98.7 1.1-3.9h-.2l-1.1 3.8.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2b692"
    },
    d: "m157.4 98.7 1.1-3.9h-.2l-1.1 3.8.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2b691"
    },
    d: "m157.5 98.7 1.1-3.8-.1-.1-1.2 3.9h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2b68f"
    },
    d: "m157.7 98.8 1.1-3.9h-.2l-1.2 3.8.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2b48f"
    },
    d: "m157.8 98.8 1.1-3.9h-.2l-1.1 3.9h.2z"
  }), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st595",
    d: "m157.9 98.9 1.2-3.9-.3-.1-1.1 3.9.2.1z"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st595",
    d: "m158 98.9 1.2-3.9h-.2l-1.2 3.8.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2b28b"
    },
    d: "m158.2 99 1.1-4h-.2l-1.1 3.9.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2b18b"
    },
    d: "m158.3 99 1.1-3.9-.2-.1-1.1 3.9.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2b189"
    },
    d: "m158.4 99 1.2-3.9h-.2l-1.2 3.9h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2b288"
    },
    d: "m158.6 99.1 1.1-4h-.2l-1.1 3.9.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f2af88"
    },
    d: "m158.7 99.1 1.1-3.9-.2-.1-1.1 4h.2z"
  }), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st601",
    d: "m158.8 99.2 1.2-4-.2-.1-1.2 4 .2.1z"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st601",
    d: "m158.9 99.2 1.2-4h-.2l-1.2 3.9.2.1z"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st602",
    d: "m159.1 99.3 1.1-4-.2-.1-1.1 4 .2.1z"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st602",
    d: "m159.2 99.3 1.2-4-.2-.1-1.2 4 .2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1ae82"
    },
    d: "m159.3 99.3 1.2-4h-.2l-1.1 4h.1z"
  }), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st604",
    d: "m159.5 99.4 1.1-4-.2-.1-1.1 4 .2.1z"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st604",
    d: "m159.6 99.4 1.2-4-.2-.1-1.2 4.1h.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1ac80"
    },
    d: "m159.7 99.5 1.2-4.1h-.2l-1.2 4 .2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1ab80"
    },
    d: "m159.8 99.5 1.2-4-.2-.1-1.1 4.1h.1z"
  }), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st607",
    d: "m160 99.6 1.2-4.1-.2-.1-1.2 4.1.2.1z"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st607",
    d: "m160.1 99.6 1.2-4.1h-.2l-1.2 4 .2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1a97c"
    },
    d: "m160.2 99.6 1.2-4-.2-.1-1.1 4.1h.1z"
  }), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st609",
    d: "m160.4 99.7 1.2-4.1-.2-.1-1.2 4.1.2.1z"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st609",
    d: "m160.5 99.7 1.2-4.1h-.2l-1.2 4.1h.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f0a779"
    },
    d: "m160.6 99.8 1.2-4.2h-.2l-1.2 4.1.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f0a579"
    },
    d: "m160.8 99.8 1.1-4.1-.1-.1-1.2 4.2h.2z"
  }), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st612",
    d: "m160.9 99.9 1.2-4.2h-.2l-1.2 4.1.2.1z"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st612",
    d: "m161 99.9 1.2-4.2h-.2l-1.2 4.1.2.1z"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st613",
    d: "m161.1 99.9 1.2-4.1-.1-.1-1.2 4.2h.1zM161.3 100l1.2-4.2h-.2l-1.2 4.1.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f0a274"
    },
    d: "m161.4 100 1.2-4.2h-.2l-1.2 4.2h.2z"
  }), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st615",
    d: "m161.5 100.1 1.3-4.2-.3-.1-1.2 4.2.2.1z"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st615",
    d: "m161.7 100.1 1.2-4.2h-.2l-1.2 4.2h.2z"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st616",
    d: "m161.8 100.2 1.2-4.3h-.2l-1.2 4.2.2.1z"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st616",
    d: "m161.9 100.2 1.2-4.2-.2-.1-1.2 4.2.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f0a06f"
    },
    d: "m162 100.2 1.3-4.2h-.2l-1.2 4.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ef9e6f"
    },
    d: "m162.2 100.3 1.2-4.3h-.2l-1.2 4.2.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ef9e6e"
    },
    d: "m162.3 100.3 1.2-4.2-.1-.1-1.3 4.3h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ef9e6c"
    },
    d: "m162.4 100.4 1.3-4.3-.2-.1-1.2 4.3.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ef9d6c"
    },
    d: "m162.6 100.4 1.2-4.3h-.2l-1.2 4.3h.2z"
  }), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st622",
    d: "m162.7 100.5 1.2-4.3-.1-.1-1.3 4.3.2.1z"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st622",
    d: "m162.8 100.5 1.3-4.3-.2-.1-1.3 4.3.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ef9b68"
    },
    d: "m162.9 100.5 1.3-4.3h-.2l-1.2 4.3h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ef9968"
    },
    d: "m163.1 100.6 1.3-4.3-.3-.1-1.2 4.3.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ef9967"
    },
    d: "m163.2 100.6 1.3-4.3-.2-.1-1.3 4.4h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ef9966"
    },
    d: "m163.3 100.7 1.3-4.4h-.2l-1.2 4.3.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ef9766"
    },
    d: "m163.5 100.7 1.2-4.4h-.2l-1.2 4.4h.2z"
  }), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st628",
    d: "m163.6 100.8 1.3-4.4-.2-.1-1.3 4.4.2.1z"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st628",
    d: "m163.7 100.8 1.3-4.4h-.2l-1.3 4.3.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ef9762"
    },
    d: "m163.9 100.8 1.2-4.4h-.1l-1.3 4.4h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee9562"
    },
    d: "m164 100.9 1.3-4.4-.2-.1-1.3 4.4.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee9561"
    },
    d: "m164.1 100.9 1.3-4.4h-.2l-1.3 4.4h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee955f"
    },
    d: "m164.2 101 1.3-4.5h-.2l-1.2 4.4.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee935f"
    },
    d: "m164.4 101 1.3-4.4-.2-.1-1.3 4.5h.2z"
  }), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st634",
    d: "m164.5 101.1 1.3-4.5h-.2l-1.3 4.4.2.1z"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st634",
    d: "m164.7 101.1 1.2-4.5h-.2l-1.3 4.4.3.1z"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st635",
    d: "m164.8 101.2 1.3-4.5-.2-.1-1.3 4.5.2.1z"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st635",
    d: "m164.9 101.2 1.3-4.5h-.2l-1.3 4.4.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee915a"
    },
    d: "m165 101.2 1.3-4.5h-.2l-1.3 4.5h.2z"
  }), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st637",
    d: "m165.2 101.3 1.3-4.5-.2-.1-1.3 4.5.2.1z"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st637",
    d: "m165.3 101.3 1.3-4.5h-.2l-1.3 4.5h.2z"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st638",
    d: "m165.4 101.4 1.3-4.6h-.2l-1.3 4.5.2.1z"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st638",
    d: "m165.6 101.4 1.3-4.5-.2-.1-1.4 4.5.3.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee8e56"
    },
    d: "m165.7 101.5 1.3-4.6h-.2l-1.3 4.5.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee8c56"
    },
    d: "m165.8 101.5 1.3-4.6h-.2l-1.3 4.5.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee8c54"
    },
    d: "m165.9 101.5 1.4-4.5-.2-.1-1.4 4.6h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee8c53"
    },
    d: "m166.1 101.6 1.3-4.6-.2-.1-1.3 4.6.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ed8b53"
    },
    d: "m166.2 101.6 1.3-4.6h-.2l-1.3 4.6h.2z"
  }), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st644",
    d: "m166.3 101.7 1.4-4.6-.2-.1-1.4 4.6.2.1z"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st644",
    d: "m166.5 101.7 1.3-4.6-.2-.1-1.4 4.6.3.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ed8950"
    },
    d: "m166.6 101.8 1.3-4.7h-.2l-1.3 4.6.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ed8850"
    },
    d: "m166.7 101.8 1.4-4.6-.3-.1-1.3 4.6.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ed884e"
    },
    d: "m166.9 101.8 1.3-4.6-.2-.1-1.4 4.7h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ed884d"
    },
    d: "m167 101.9 1.3-4.7h-.2l-1.3 4.6.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ed864d"
    },
    d: "m167.1 101.9 1.4-4.6-.3-.1-1.3 4.7h.2z"
  }), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st650",
    d: "m167.2 102 1.4-4.7-.2-.1-1.4 4.7.2.1z"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st650",
    d: "m167.4 102 1.3-4.7h-.2l-1.3 4.7h.2z"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st651",
    d: "m167.5 102.1 1.3-4.8h-.1l-1.4 4.7.2.1z"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st651",
    d: "m167.6 102.1 1.4-4.7-.2-.1-1.4 4.7.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ed8448"
    },
    d: "m167.8 102.1 1.3-4.7h-.2l-1.4 4.7h.3z"
  }), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st653",
    d: "m167.9 102.2 1.3-4.8h-.1l-1.4 4.7.2.1z"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st653",
    d: "m168 102.2 1.4-4.7-.2-.1-1.4 4.8h.2z"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st654",
    d: "m168.1 102.3 1.4-4.8h-.2l-1.4 4.7.2.1z"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st654",
    d: "m168.3 102.3 1.4-4.8h-.3l-1.3 4.8h.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ed8245"
    },
    d: "m168.4 102.4 1.4-4.8-.2-.1-1.4 4.8.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ec8044"
    },
    d: "m168.5 102.4 1.4-4.8h-.2l-1.4 4.7.2.1z"
  }), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st657",
    d: "m168.7 102.5 1.3-4.9h-.2l-1.4 4.8.3.1z"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st657",
    d: "m168.8 102.5 1.4-4.8-.2-.1-1.4 4.8.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ec7f42"
    },
    d: "m168.9 102.5 1.4-4.8-.2-.1-1.4 4.9h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ec7f41"
    },
    d: "m169 102.6 1.4-4.9h-.1l-1.5 4.8.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ec7d40"
    },
    d: "m169.2 102.6 1.4-4.8-.2-.1-1.4 4.9h.2z"
  }), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st661",
    d: "m169.3 102.7 1.4-4.9-.2-.1-1.4 4.9.2.1z"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st661",
    d: "m169.4 102.7 1.4-4.9h-.1l-1.5 4.8.2.1z"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st662",
    d: "m169.6 102.8 1.4-4.9-.2-.1-1.4 4.9.2.1z"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st662",
    d: "m169.7 102.8 1.4-4.9-.2-.1-1.4 4.9.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ec7b3d"
    },
    d: "m169.8 102.8 1.5-4.9h-.3l-1.4 4.9h.2z"
  }), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st664",
    d: "m169.9 102.9 1.5-4.9-.2-.1-1.5 4.9.2.1z"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st664",
    d: "m170.1 102.9 1.4-4.9-.2-.1-1.4 5h.2z"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st665",
    d: "m170.2 103 1.4-5h-.2l-1.4 4.9.2.1z"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st665",
    d: "m170.3 103 1.5-4.9-.2-.1-1.4 4.9.1.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ec7939"
    },
    d: "m170.5 103.1 1.4-5-.2-.1-1.4 5 .2.1z"
  }), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st667",
    d: "m170.6 103.1 1.4-5h-.2l-1.4 4.9.2.1z"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st667",
    d: "m170.7 103.1 1.5-5h-.2l-1.5 5h.2z"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st668",
    d: "m170.8 103.2 1.5-5-.2-.1-1.4 5 .1.1z"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st668",
    d: "m171 103.2 1.4-5h-.2l-1.4 5h.2z"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st669",
    d: "m171.1 103.3 1.5-5.1h-.2l-1.5 5 .2.1z"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st669",
    d: "m171.2 103.3 1.5-5-.2-.1-1.4 5 .1.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#eb7534"
    },
    d: "m171.4 103.4 1.4-5.1h-.2l-1.4 5 .2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#eb7334"
    },
    d: "m171.5 103.4 1.5-5.1h-.2l-1.5 5 .2.1z"
  }), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st672",
    d: "m171.6 103.4 1.5-5-.2-.1-1.4 5.1h.1z"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st672",
    d: "m171.7 103.5 1.5-5.1h-.2l-1.4 5 .1.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#eb7232"
    },
    d: "m171.9 103.5 1.5-5.1h-.2l-1.5 5.1h.2z"
  }), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st674",
    d: "m172 103.6 1.5-5.1-.2-.1-1.5 5.1.2.1z"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st674",
    d: "m172.1 103.6 1.5-5.1h-.2l-1.4 5.1h.1z"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st675",
    d: "m172.3 103.7 1.5-5.2h-.2l-1.5 5.1.2.1z"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st675",
    d: "m172.4 103.7 1.5-5.1-.2-.1-1.5 5.1.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#eb6f2e"
    },
    d: "m172.5 103.7 1.5-5.1-.2-.1-1.4 5.2h.1z"
  }), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st677",
    d: "m172.7 103.8 1.5-5.2h-.2l-1.5 5.1.2.1z"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st677",
    d: "m172.8 103.8 1.5-5.1-.2-.1-1.5 5.2h.2z"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st678",
    d: "m172.9 103.9 1.5-5.2-.2-.1-1.5 5.2.2.1z"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st678",
    d: "m173 103.9 1.6-5.2h-.2l-1.5 5.2h.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#eb6e2b"
    },
    d: "m173.2 104 1.5-5.2-.2-.1-1.5 5.2.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#eb6c2b"
    },
    d: "m173.3 104 1.5-5.2-.2-.1-1.5 5.2.2.1z"
  }), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st681",
    d: "m173.4 104 1.6-5.2h-.3l-1.4 5.2h.1z"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st681",
    d: "m173.6 104.1 1.5-5.3h-.2l-1.5 5.2.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#eb6b2a"
    },
    d: "m173.7 104.1 1.5-5.2-.2-.1-1.5 5.3h.2z"
  }), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st683",
    d: "m173.8 104.2 1.5-5.3h-.2l-1.5 5.2.2.1z"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st683",
    d: "m173.9 104.2 1.6-5.3h-.2l-1.5 5.3h.1z"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st683",
    d: "m174.1 104.3 1.5-5.3-.2-.1-1.5 5.3.2.1z"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st684",
    d: "m174.2 104.3 1.5-5.3h-.1l-1.6 5.2.2.1zM174.3 104.3l1.6-5.3h-.2l-1.5 5.3h.1z"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st684",
    d: "m174.5 104.4 1.5-5.3-.2-.1-1.5 5.3.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ea6626"
    },
    d: "m174.6 104.4 1.5-5.3h-.1l-1.6 5.3h.2z"
  }), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st686",
    d: "m174.7 104.5 1.6-5.4h-.2l-1.6 5.3.2.1z"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st686",
    d: "m174.9 104.5 1.5-5.3-.2-.1-1.5 5.4h.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ea6524"
    },
    d: "m175 104.6 1.6-5.4h-.3l-1.5 5.3.2.1z"
  }), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st688",
    d: "m175.1 104.6 1.6-5.4h-.2l-1.6 5.3.2.1z"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st688",
    d: "m175.2 104.6 1.6-5.3-.2-.1-1.5 5.4h.1z"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st688",
    d: "m175.4 104.7 1.5-5.4h-.2l-1.5 5.3.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ea6323"
    },
    d: "m175.5 104.7 1.6-5.4h-.2l-1.6 5.4h.2z"
  }), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st690",
    d: "m175.7 104.8 1.5-5.4-.2-.1-1.6 5.4.3.1z"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st690",
    d: "m175.8 104.8 1.5-5.4h-.1l-1.6 5.4h.2z"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st691",
    d: "m175.9 104.9 1.6-5.5h-.2l-1.6 5.4.2.1z"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st691",
    d: "m176 104.9 1.6-5.4-.2-.1-1.6 5.4.2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ea6121"
    },
    d: "m176.2 105 1.5-5.5-.2-.1-1.5 5.5.2.1z"
  }), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st693",
    d: "m176.3 105 1.6-5.5h-.2l-1.6 5.4.2.1z"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st693",
    d: "m176.4 105 1.6-5.4-.2-.1-1.6 5.5h.2z"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st694",
    d: "m176.6 105.1 1.6-5.5-.3-.1-1.6 5.5.3.1z"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st694",
    d: "m176.7 105.1 1.6-5.5h-.2l-1.6 5.5h.2z"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st694",
    d: "m176.8 105.2 1.6-5.5-.1-.1h-.1l-1.6 5.5.2.1z"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st285",
    d: "m176.9 105.2 1.6-5.5h-.1l-.1-.1-1.6 5.5.2.1z"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st285",
    d: "m177.1 105.3 1.6-5.6H178.4l-1.5 5.5.2.1z"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st285",
    d: "m177 105.2.2.1 1.4-5.1.1-.4-.1-.1-1.6 5.5z"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st286",
    d: "m177.1 105.3.5.1 1.1-5.7-1.6 5.6z"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "m246.2 212.8-22.3-11.5c-3.9 5.1-7 8.8-7 8.8 5.9 8.6 19.2 13.4 19.2 13.4 4.5-2.1 7.6-6 10.1-10.7z"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st155",
    d: "M246.3 212.6 224 201.1l-.2.3 22.3 11.5.2-.3z"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st156",
    d: "M246.4 212.4 224.1 201l-.2.2 22.3 11.5.2-.3z"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m246.5 212.2-22.2-11.4-.2.3 22.2 11.4.2-.3z"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m246.6 212-22.2-11.4-.2.3 22.2 11.4.2-.3z"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m246.7 211.8-22.2-11.4-.2.3 22.2 11.4.2-.3z"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st157",
    d: "m246.7 211.6-22.1-11.3-.1.2 22.1 11.4.1-.3z"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m246.8 211.5-22-11.4-.2.3 22.1 11.3.1-.2z"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m246.9 211.3-22-11.4-.2.3 22.1 11.3.1-.2z"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m247 211.1-22-11.3-.2.2 22.1 11.4.1-.3z"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m247.1 210.9-21.9-11.3-.2.2 22 11.4.1-.3z"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m247.2 210.7-21.9-11.3-.2.3 22 11.3.1-.3z"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st158",
    d: "m247.3 210.5-21.9-11.3-.2.3 22 11.3.1-.3z"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st159",
    d: "m247.4 210.3-21.8-11.2-.2.2 21.9 11.3.1-.3z"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st159",
    d: "m247.5 210.1-21.8-11.2-.2.3 21.8 11.2.2-.3z"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st160",
    d: "m247.6 209.9-21.8-11.2-.2.3 21.8 11.2.2-.3z"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st160",
    d: "m247.7 209.7-21.8-11.1-.2.2 21.8 11.2.2-.3z"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st160",
    d: "M247.7 209.6 226 198.4l-.1.2 21.7 11.2.1-.2z"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st174",
    d: "m247.8 209.3-21.6-11.1-.2.3 21.7 11.1.1-.3z"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st174",
    d: "m247.9 209.2-21.6-11.1-.2.2 21.7 11.1.1-.2z"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st174",
    d: "m248 209-21.6-11.1-.2.2 21.7 11.2.1-.3z"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "m248.1 208.8-21.5-11.1-.2.3 21.6 11.1.1-.3z"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "m248.2 208.6-21.5-11.1-.2.3 21.6 11.1.1-.3z"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "m248.3 208.4-21.5-11-.2.2 21.5 11.1.2-.3z"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "m248.4 208.2-21.5-11-.2.2 21.5 11.1.2-.3z"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st161",
    d: "M248.4 208 227 197l-.1.3 21.4 11 .1-.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f3f9fb"
    },
    d: "m248.5 207.8-21.3-11-.2.3 21.4 11 .1-.3z"
  }), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st431",
    d: "m248.6 207.6-21.3-10.9-.2.2 21.4 11 .1-.3z"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st431",
    d: "m248.7 207.4-21.3-10.9-.2.3 21.4 10.9.1-.3z"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st431",
    d: "m248.8 207.2-21.2-10.9-.2.3 21.3 10.9.1-.3z"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st431",
    d: "m248.9 207-21.2-10.9-.2.3 21.2 10.9.2-.3z"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st431",
    d: "M248.9 206.8 227.8 196l-.2.2 21.2 10.9.1-.3z"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st175",
    d: "m249 206.6-21.1-10.8-.2.3 21.2 10.8.1-.3z"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st175",
    d: "M249.1 206.5 228 195.6l-.1.3 21.1 10.8.1-.2z"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st175",
    d: "m249.2 206.2-21-10.7-.2.2 21.1 10.8.1-.3z"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st175",
    d: "m249.3 206-21-10.7-.2.2 21.1 10.8.1-.3z"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st175",
    d: "m249.4 205.9-21-10.8-.2.3 21 10.8.2-.3z"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st236",
    d: "m249.4 205.7-20.9-10.8-.2.3 21 10.8.1-.3z"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st429",
    d: "m249.5 205.5-20.8-10.8-.2.3 20.9 10.8.1-.3z"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st429",
    d: "m249.6 205.3-20.8-10.7-.2.2 20.9 10.8.1-.3z"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st176",
    d: "m249.7 205.1-20.8-10.7-.2.3 20.9 10.7.1-.3z"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st176",
    d: "M249.8 204.9 229 194.2l-.2.3 20.8 10.7.2-.3z"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st176",
    d: "m249.8 204.7-20.7-10.6-.1.2 20.7 10.7.1-.3z"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st176",
    d: "m249.9 204.5-20.6-10.6-.2.2 20.7 10.7.1-.3z"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st428",
    d: "m250 204.3-20.6-10.6-.2.3 20.7 10.6.1-.3z"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st177",
    d: "m250.1 204.1-20.6-10.6-.2.3 20.7 10.6.1-.3z"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st177",
    d: "m250.2 203.9-20.6-10.6-.2.3 20.6 10.6.2-.3z"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st177",
    d: "m250.2 203.7-20.5-10.5-.1.2 20.5 10.6.1-.3z"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st177",
    d: "M250.3 203.5 229.9 193l-.2.3 20.5 10.5.1-.3z"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st177",
    d: "M250.4 203.3 230 192.8l-.2.3 20.5 10.5.1-.3z"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st177",
    d: "m250.5 203.1-20.4-10.4-.2.2 20.5 10.5.1-.3z"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st178",
    d: "m250.6 202.9-20.4-10.4-.2.2 20.4 10.5.2-.3z"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st178",
    d: "m250.6 202.7-20.3-10.4-.1.3 20.3 10.4.1-.3z"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st178",
    d: "m250.7 202.5-20.2-10.4-.2.3 20.3 10.4.1-.3z"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st178",
    d: "m250.8 202.3-20.2-10.4-.2.3 20.3 10.4.1-.3z"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st178",
    d: "m250.9 202.2-20.2-10.4-.2.2 20.3 10.4.1-.2z"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st235",
    d: "m251 202-20.2-10.4-.2.3 20.3 10.3.1-.2z"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st235",
    d: "m251.1 201.7-20.2-10.3-.1.3 20.1 10.3.2-.3z"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st235",
    d: "M251.1 201.6 231 191.2l-.1.3 20.1 10.3.1-.2z"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st179",
    d: "m251.2 201.3-20-10.3-.2.3 20.1 10.4.1-.4z"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st179",
    d: "m251.3 201.2-20-10.3-.2.2 20.1 10.4.1-.3z"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st179",
    d: "m251.4 201-20-10.3-.2.3 20 10.3.2-.3z"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st179",
    d: "m251.5 200.8-20-10.3-.2.3 20 10.3.2-.3z"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st179",
    d: "m251.5 200.6-19.9-10.3-.2.3 20 10.3.1-.3z"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st234",
    d: "m251.6 200.4-19.9-10.2-.2.2 20 10.3.1-.3z"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st234",
    d: "M251.7 200.2 231.8 190l-.1.2 19.9 10.3.1-.3z"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st234",
    d: "m251.8 200-19.9-10.2-.1.3 19.9 10.2.1-.3z"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st696",
    d: "m251.9 199.8-19.8-10.2-.2.3 19.8 10.2.2-.3z"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st696",
    d: "m251.9 199.6-19.7-10.2-.2.3 19.8 10.2.1-.3z"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st696",
    d: "m252 199.4-19.7-10.1-.2.2 19.8 10.2.1-.3z"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st180",
    d: "m252.1 199.2-19.7-10.1-.2.3 19.8 10.1.1-.3z"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st180",
    d: "m252.2 199-19.7-10.1-.2.3 19.8 10.1.1-.3z"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st180",
    d: "m252.3 198.8-19.7-10.1-.1.3 19.6 10.1.2-.3z"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st180",
    d: "m252.4 198.6-19.7-10.1-.1.3 19.6 10.1.2-.3z"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st180",
    d: "m252.4 198.4-19.6-10-.1.2 19.6 10.1.1-.3z"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st181",
    d: "m252.5 198.2-19.5-10-.2.3 19.6 10 .1-.3z"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st181",
    d: "m252.6 198-19.5-10-.2.3 19.6 10 .1-.3z"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st181",
    d: "m252.7 197.8-19.5-10-.2.3 19.5 10 .2-.3z"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st181",
    d: "m252.8 197.6-19.5-10-.2.3 19.5 10.1.2-.4z"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st697",
    d: "m252.8 197.5-19.4-10-.2.2 19.5 10 .1-.2z"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st697",
    d: "m252.9 197.3-19.4-10-.2.3 19.5 9.9.1-.2z"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st233",
    d: "m253 197.1-19.4-10-.1.3 19.4 9.9.1-.2z"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st233",
    d: "m253.1 196.9-19.4-10-.1.3 19.4 10 .1-.3z"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st698",
    d: "m253.2 196.7-19.4-10-.1.3 19.4 10 .1-.3z"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st698",
    d: "m253.3 196.5-19.4-10-.1.3 19.3 10 .2-.3z"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st182",
    d: "m253.3 196.3-19.3-9.9-.1.2 19.3 10 .1-.3z"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st182",
    d: "m253.4 196.1-19.3-9.9-.1.3 19.3 9.9.1-.3z"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st182",
    d: "m253.5 195.9-19.3-9.9-.1.3 19.3 9.9.1-.3z"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st182",
    d: "m253.6 195.7-19.3-9.9-.1.3 19.3 9.9.1-.3z"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st183",
    d: "m253.7 195.5-19.3-9.9-.1.3 19.3 9.9.1-.3z"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st183",
    d: "m253.8 195.3-19.3-9.8-.1.2 19.3 9.9.1-.3z"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st183",
    d: "m253.9 195.1-19.2-9.9-.2.3 19.2 9.9.2-.3z"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st183",
    d: "m254 194.9-19.2-9.8-.2.2 19.2 9.9.2-.3z"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st183",
    d: "m254 194.8-19.2-9.9-.1.3 19.2 9.8.1-.2z"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st232",
    d: "m254.1 194.6-19.2-9.9-.1.3 19.2 9.9.1-.3z"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st232",
    d: "m254.2 194.4-19.2-9.9-.1.3 19.2 9.8.1-.2z"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st699",
    d: "m254.3 194.2-19.2-9.9-.1.3 19.2 9.9.1-.3z"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st699",
    d: "m254.4 194-19.2-9.9-.1.3 19.2 9.9.1-.3z"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st699",
    d: "m254.5 193.8-19.2-9.8-.1.2 19.2 9.9.1-.3z"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st699",
    d: "m254.6 193.6-19.2-9.8-.1.2 19.1 9.9.2-.3z"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st184",
    d: "m254.7 193.4-19.2-9.8-.1.3 19.1 9.8.2-.3z"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st184",
    d: "m254.8 193.2-19.2-9.8-.1.3 19.1 9.8.2-.3z"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st231",
    d: "m254.9 193-19.2-9.8-.1.3 19.1 9.8.2-.3z"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st231",
    d: "m254.9 192.8-19.1-9.8-.1.3 19.1 9.8.1-.3z"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st231",
    d: "m255 192.7-19.1-9.9-.1.3 19.1 9.8.1-.2z"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st231",
    d: "m255.1 192.5-19.1-9.9-.1.3 19.1 9.8.1-.2z"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st231",
    d: "m255.2 192.3-19.1-9.9-.1.3 19.1 9.8.1-.2z"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st231",
    d: "m255.3 192.1-19.1-9.9-.2.3 19.2 9.9.1-.3z"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st185",
    d: "m255.4 191.9-19.1-9.9-.2.3 19.2 9.9.1-.3z"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st185",
    d: "m255.5 191.7-19.1-9.8-.2.2 19.2 9.9.1-.3z"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st185",
    d: "m255.6 191.5-19.2-9.8-.1.3 19.2 9.8.1-.3z"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st185",
    d: "m255.7 191.3-19.2-9.8-.1.3 19.2 9.8.1-.3z"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st185",
    d: "m255.8 191.2-19.2-9.9-.1.3 19.2 9.8.1-.2z"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st186",
    d: "m255.9 190.9-19.2-9.8-.1.3 19.2 9.8.1-.3z"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st186",
    d: "m256 190.8-19.2-9.9-.1.3 19.1 9.8.2-.2z"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st186",
    d: "m256.1 190.6-19.2-9.9-.2.3 19.2 9.9.2-.3z"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st186",
    d: "m256.2 190.4-19.3-9.9c0 .1-.1.2-.1.3l19.2 9.9.2-.3z"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st186",
    d: "m256.3 190.2-19.3-9.9c0 .1-.1.2-.1.3l19.2 9.9.2-.3z"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st186",
    d: "m256.4 190-19.3-9.9-.1.3 19.2 9.9.2-.3z"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st230",
    d: "m256.5 189.8-19.3-9.9c0 .1-.1.2-.1.3l19.3 9.9.1-.3z"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st230",
    d: "m256.6 189.7-19.4-10-.1.3 19.3 9.9.2-.2z"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st700",
    d: "m256.7 189.5-19.4-10-.1.3 19.3 9.9.2-.2z"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st700",
    d: "m256.8 189.3-19.4-10c0 .1-.1.2-.1.3l19.4 10 .1-.3z"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st700",
    d: "m256.9 189.1-19.5-10c0 .1-.1.2-.1.3l19.4 10 .2-.3z"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st700",
    d: "m257 188.9-19.5-10c0 .1-.1.2-.1.3l19.4 10 .2-.3z"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st701",
    d: "m257.1 188.7-19.5-10c0 .1-.1.2-.1.3l19.5 10 .1-.3z"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st701",
    d: "m257.2 188.6-19.6-10.1c0 .1-.1.2-.1.3l19.5 10 .2-.2z"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st187",
    d: "m257.3 188.4-19.6-10.1c0 .1-.1.2-.1.3l19.6 10 .1-.2z"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st702",
    d: "m257.4 188.2-19.7-10.1c0 .1-.1.2-.1.3l19.6 10.1.2-.3z"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st702",
    d: "m257.5 188-19.7-10.1c0 .1 0 .2-.1.3l19.7 10.1.1-.3z"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st702",
    d: "m257.6 187.8-19.8-10.2c0 .1 0 .2-.1.3l19.7 10.1.2-.2z"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st702",
    d: "m257.8 187.6-19.9-10.2c0 .1 0 .2-.1.3l19.8 10.2.2-.3z"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st703",
    d: "M257.9 187.5 238 177.3c0 .1 0 .2-.1.3l19.8 10.2.2-.3z"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st703",
    d: "M258 187.3 238 177c0 .1 0 .2-.1.3l19.9 10.2.2-.2z"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st703",
    d: "M258.1 187.1 238 176.8c0 .1 0 .2-.1.3l20 10.3.2-.3z"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st703",
    d: "M258.2 186.9 238 176.6v.3l20 10.3.2-.3z"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st703",
    d: "M258.3 186.7 238 176.3v.3l20.1 10.3.2-.2z"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st704",
    d: "m258.4 186.6-20.3-10.4v.3l20.2 10.4.1-.3z"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st704",
    d: "M258.5 186.4 238 175.9v.3l20.3 10.4.2-.2z"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st704",
    d: "M258.6 186.2 238 175.6v.3l20.4 10.5.2-.2z"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st705",
    d: "m258.8 186-20.7-10.6v.4l20.5 10.5.2-.3z"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st705",
    d: "M258.9 185.8 238 175.1v.4l20.6 10.6.3-.3z"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st705",
    d: "m259 185.7-21-10.8v.4l20.8 10.6.2-.2z"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st705",
    d: "M259.1 185.5 238 174.7v.3l20.9 10.7.2-.2z"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st705",
    d: "M259.2 185.3 238 174.4v.3l21.1 10.9.1-.3z"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st705",
    d: "M259.3 185.1 238 174.2v.3l21.2 10.9.1-.3z"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st706",
    d: "M259.5 185 238 173.9v.4l21.3 10.9.2-.2z"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st706",
    d: "m259.6 184.8-21.7-11.2.1.4 21.4 11 .2-.2z"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st707",
    d: "m259.7 184.6-21.8-11.2.1.4 21.5 11.1.2-.3z"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st707",
    d: "m259.8 184.4-21.9-11.2v.4l21.7 11.1.2-.3z"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st707",
    d: "m259.9 184.3-22-11.4v.4l21.9 11.2.1-.2z"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st708",
    d: "m260.1 184.1-22.2-11.4v.4l22 11.2.2-.2z"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st708",
    d: "m260.2 183.9-22.3-11.4v.3l22.1 11.4.2-.3z"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st708",
    d: "m260.3 183.7-22.4-11.5v.4l22.2 11.4.2-.3z"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st708",
    d: "M260.4 183.6 237.9 172v.3l22.4 11.5.1-.2z"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st708",
    d: "m260.6 183.4-22.7-11.7v.4l22.5 11.6.2-.3z"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st709",
    d: "m260.7 183.2-22.8-11.7v.4l22.6 11.6.2-.3z"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st709",
    d: "m260.8 183.1-22.9-11.8v.3l22.7 11.7.2-.2z"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st709",
    d: "M261 182.9 237.9 171v.4l22.9 11.7.2-.2z"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st709",
    d: "m261.1 182.7-23.2-11.9v.4l23 11.8.2-.3z"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st710",
    d: "m261.2 182.6-23.3-12v.3l23.1 11.9.2-.2z"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st710",
    d: "m261.4 182.4-23.5-12.1v.4l23.3 11.9.2-.2z"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st710",
    d: "m261.5 182.2-23.6-12.1v.3l23.4 12c.1 0 .1-.1.2-.2z"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st710",
    d: "m261.6 182-23.7-12.2v.4l23.5 12.1.2-.3z"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st710",
    d: "m261.8 181.9-23.9-12.3v.4l23.7 12.2c0-.2.1-.2.2-.3z"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st228",
    d: "m261.9 181.7-24-12.3v.3l23.8 12.3.2-.3z"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st228",
    d: "m262 181.5-24.1-12.4v.4l23.9 12.3.2-.3z"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st228",
    d: "m262.2 181.4-24.3-12.5v.4l24.1 12.3.2-.2z"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st228",
    d: "M262.3 181.2 238 168.7l-.1.3 24.2 12.5.2-.3z"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st228",
    d: "M262.5 181 238 168.5v.3l24.3 12.5c0-.1.1-.2.2-.3z"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st192",
    d: "M262.6 180.9 238 168.3v.3l24.4 12.5.2-.2z"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st711",
    d: "M262.8 180.7 238 168v.3l24.5 12.7.3-.3z"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st711",
    d: "M262.9 180.6 238 167.8v.3l24.7 12.7c0-.1.1-.2.2-.2z"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st711",
    d: "m263 180.4-24.9-12.8-.1.3 24.8 12.7.2-.2z"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st711",
    d: "m263.2 180.2-25.1-12.9v.3l24.9 12.8.2-.2z"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st227",
    d: "m263.3 180.1-25.2-12.9v.3l25 12.8.2-.2z"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st227",
    d: "m263.5 179.9-25.3-13v.3l25.1 12.9.2-.2z"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st193",
    d: "m263.6 179.7-25.4-13c0 .1 0 .2-.1.3l25.3 13c.1-.1.2-.2.2-.3z"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st193",
    d: "m263.8 179.6-25.5-13.1c0 .1 0 .2-.1.3l25.4 13c0-.1.1-.1.2-.2z"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st193",
    d: "m263.9 179.4-25.6-13.2c0 .1 0 .2-.1.3l25.5 13.1.2-.2z"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st193",
    d: "M264.1 179.3 238.3 166c0 .1-.1.2-.1.3l25.6 13.1.3-.1z"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st193",
    d: "m264.2 179.1-25.8-13.3c0 .1-.1.2-.1.3l25.7 13.2c.1 0 .2-.1.2-.2z"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st193",
    d: "m264.4 179-25.9-13.3c0 .1-.1.2-.1.3l25.8 13.2.2-.2z"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st193",
    d: "m264.5 178.8-26-13.4c0 .1-.1.2-.1.3l25.9 13.3c.1 0 .2-.1.2-.2z"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st712",
    d: "m264.7 178.7-26.1-13.4c0 .1-.1.2-.1.3l26 13.4.2-.3z"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st712",
    d: "M264.9 178.5 238.7 165c0 .1-.1.2-.1.3l26.1 13.4.2-.2z"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st712",
    d: "m265 178.3-26.3-13.5c0 .1-.1.2-.1.3l26.1 13.4c.2 0 .2-.1.3-.2z"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st712",
    d: "m265.2 178.2-26.3-13.5c-.1.1-.1.2-.1.3l26.2 13.5.2-.3z"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st712",
    d: "M265.4 178 239 164.5c-.1.1-.1.2-.2.3l26.3 13.5.3-.3z"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st713",
    d: "m265.5 177.9-26-13.4-.4-.2c-.1.1-.1.2-.2.3l26.3 13.5.3-.2z"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st713",
    d: "m265.7 177.7-23-11.8-3.6-1.6-.1.1 26.4 13.5.3-.2z"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st713",
    d: "m265.8 177.6-20.2-10.4-4.9-2.1 24.8 12.7c.2-.1.3-.2.3-.2z"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st713",
    d: "m266 177.4-17.2-8.8-4.4-2 21.4 11 .2-.2z"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st713",
    d: "m266.2 177.3-14-7.2-4.6-2 18.4 9.4c0-.1.1-.2.2-.2z"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st714",
    d: "m266.4 177.1-11.3-5.7-4.6-2.1 15.6 8 .3-.2z"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st714",
    d: "m266.5 177-8-4.1-4.9-2.1 12.6 6.5c.2-.2.2-.3.3-.3z"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st714",
    d: "m266.7 176.8-5-2.5-4.8-2.2 9.5 4.9.3-.2z"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st195",
    d: "m266.9 176.7-2.3-1.2h-.1l-4.7-2.1 6.8 3.5c.1-.1.2-.1.3-.2z"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st195",
    d: "m267 176.5-1.5-.8c-.5-.1-.9-.2-1-.3l-1.2-.5 3.5 1.8.2-.2z"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st195",
    d: "m267.2 176.4-.8-.4c-.4-.1-.9-.2-1.2-.3l1.8.9.2-.2z"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st715",
    d: "m267.4 176.2-.1-.1c-.3-.1-.7-.2-1.2-.3l1.1.6.2-.2z"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st715",
    d: "M267.4 176.2c-.1 0-.3-.1-.5-.1l.5.1z"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st101",
    d: "m237.3 163.6-2.4-1.2c.1.2.3.4.6.5l1.8.7z"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st102",
    d: "m238.5 164-3.7-1.8v.2c0 .1.1.2.2.3l1.3.6 2.2.7z"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st102",
    d: "m238.7 163.8-3.9-1.9v.4l3.6 1.7.3-.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m238.8 163.5-3.9-1.9c-.1.1-.1.3-.1.4l3.8 1.9.2-.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e46721"
    }
  }), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st104",
    d: "m239 163.3-4-1.9c-.1.1-.1.2-.2.3l3.9 1.9.3-.3z"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st104",
    d: "m239.1 163.1-3.9-1.9-.2.3h-.1l4 1.9.2-.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e66620"
    },
    d: "m239.3 162.9-4-1.9-.2.3 3.9 1.9.3-.3z"
  }), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st105",
    d: "m239.4 162.7-4-1.9-.2.3 4 1.9.2-.3z"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st105",
    d: "m239.6 162.5-4-2-.2.4 3.9 1.9.3-.3z"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st105",
    d: "m239.7 162.3-4-2-.2.4 4 1.9.2-.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e86520"
    },
    d: "m239.8 162.1-3.9-2-.3.3 4 2 .2-.3z"
  }), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "m240 161.9-4-2-.2.3 4 2 .2-.3z"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "m240.1 161.6-4-1.9-.2.3 4 2 .2-.4z"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "m240.3 161.4-4-1.9-.2.3 4 1.9.2-.3z"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "m240.4 161.2-4-1.9-.2.3 4 1.9.2-.3z"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "m240.6 161-4-1.9-.3.3 4.1 1.9.2-.3z"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "m240.7 160.8-4-2-.2.4 4 1.9.2-.3z"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "m240.9 160.6-4.1-2-.2.4 4 1.9.3-.3z"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st106",
    d: "m241 160.4-4-2-.2.3 4 2 .2-.3z"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m241.1 160.2-4-2-.2.3 4 2 .2-.3z"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m241.3 160-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m241.4 159.7-4-1.9-.2.3 4 2 .2-.4z"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m241.6 159.5-4.1-2-.2.4 4 1.9.3-.3z"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m241.7 159.3-4.1-2-.2.4 4.1 1.9.2-.3z"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st107",
    d: "m241.8 159.1-4-2-.2.4 4 1.9.2-.3z"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st108",
    d: "m242 158.9-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st108",
    d: "m242.1 158.7-4-2-.2.3 4 2 .2-.3z"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st108",
    d: "m242.2 158.4-4-1.9-.2.3 4 2 .2-.4z"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st108",
    d: "m242.4 158.2-4.1-1.9-.2.3 4.1 2 .2-.4z"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st109",
    d: "m242.5 158-4-2-.3.4 4.1 1.9.2-.3z"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st109",
    d: "m242.7 157.8-4.1-2-.2.3 4 2 .3-.3z"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st109",
    d: "m242.8 157.6-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st110",
    d: "m242.9 157.4-4.1-2-.1.3 4 2 .2-.3z"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st110",
    d: "m243.1 157.1-4.1-1.9-.2.3 4.1 2 .2-.4z"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st111",
    d: "m243.2 156.9-4.1-2-.2.4 4.1 2 .2-.4z"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st111",
    d: "m243.3 156.7-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st112",
    d: "m243.5 156.5-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st112",
    d: "m243.6 156.3-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st112",
    d: "m243.7 156-4.1-1.9-.2.3 4.1 2 .2-.4z"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st113",
    d: "m243.9 155.8-4.1-2-.2.4 4.1 1.9.2-.3z"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st113",
    d: "m244 155.6-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st114",
    d: "m244.1 155.4-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st115",
    d: "m244.2 155.2-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st115",
    d: "m244.4 155-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st115",
    d: "m244.5 154.7-4.1-1.9-.2.3 4.1 2 .2-.4z"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st116",
    d: "m244.6 154.5-4.1-2-.2.4 4.1 1.9.2-.3z"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st116",
    d: "m244.8 154.3-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st117",
    d: "m244.9 154.1-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st117",
    d: "m245 153.9-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st118",
    d: "m245.1 153.6-4.1-2-.2.4 4.1 2 .2-.4z"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st119",
    d: "m245.3 153.4-4.2-2-.1.4 4.1 2 .2-.4z"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st119",
    d: "m245.4 153.2-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st120",
    d: "m245.5 153-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st120",
    d: "m245.6 152.8-4.1-2-.2.3 4.2 2 .1-.3z"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st121",
    d: "m245.8 152.5-4.2-2-.1.4 4.1 2 .2-.4z"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st122",
    d: "m245.9 152.3-4.1-2-.2.4 4.1 2 .2-.4z"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st123",
    d: "m246 152.1-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st123",
    d: "m246.1 151.9-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st124",
    d: "m246.2 151.6-4.1-2-.2.4 4.2 2 .1-.4z"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st124",
    d: "m246.4 151.4-4.1-2-.2.4 4.1 2 .2-.4z"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st125",
    d: "m246.5 151.2-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st125",
    d: "m246.6 151-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st126",
    d: "m246.7 150.8-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st126",
    d: "m246.8 150.5-4.1-2-.2.4 4.2 2 .1-.4z"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st127",
    d: "m247 150.3-4.2-2-.1.3 4.1 2.1.2-.4z"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st128",
    d: "m247.1 150.1-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st128",
    d: "m247.2 149.9-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st129",
    d: "m247.3 149.6-4.1-2-.2.4 4.1 2 .2-.4z"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st129",
    d: "m247.4 149.4-4.1-2-.2.3 4.2 2.1.1-.4z"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st130",
    d: "m247.6 149.2-4.2-2-.2.3 4.2 2 .2-.3z"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st130",
    d: "m247.7 149-4.2-2-.1.3 4.1 2 .2-.3z"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st131",
    d: "m247.8 148.7-4.1-2-.2.4 4.1 2 .2-.4z"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st132",
    d: "m247.9 148.5-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st132",
    d: "m248 148.3-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st133",
    d: "m248.1 148-4.1-2-.2.4 4.2 2 .1-.4z"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st133",
    d: "m248.2 147.8-4.1-2-.2.3 4.2 2 .1-.3z"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st133",
    d: "m248.3 147.6-4.1-2-.1.3 4.1 2 .1-.3z"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st134",
    d: "m248.5 147.4-4.2-2-.1.3 4.1 2 .2-.3z"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st134",
    d: "m248.6 147.1-4.1-2-.2.4 4.1 2 .2-.4z"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st135",
    d: "m248.7 146.9-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st135",
    d: "m248.8 146.7-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m248.9 146.4-4.1-2-.2.4 4.1 2 .2-.4z"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m249 146.2-4.1-2-.2.4 4.2 1.9.1-.3z"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st136",
    d: "m249.1 146-4.1-2-.2.3 4.2 2 .1-.3z"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st137",
    d: "m249.2 145.8-4.1-2-.1.3 4.1 2 .1-.3z"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st137",
    d: "m249.3 145.5-4.1-2-.1.4 4.1 2 .1-.4z"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st719",
    d: "m249.4 145.3-4.1-2-.1.4 4.1 2 .1-.4z"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st719",
    d: "m249.5 145.1-4.1-2-.1.3 4.1 2 .1-.3z"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st719",
    d: "m249.7 144.9-4.2-2-.1.3 4.1 2 .2-.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee9827"
    },
    d: "m249.8 144.6-4.1-2-.2.4 4.1 2 .2-.4z"
  }), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st721",
    d: "m249.9 144.4-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st721",
    d: "m250 144.1-4.1-1.9-.2.3 4.1 2 .2-.4z"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st721",
    d: "m250.1 143.9-4.1-2-.2.4 4.1 2 .2-.4z"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st722",
    d: "m250.2 143.7-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st722",
    d: "m250.3 143.4-4.1-1.9-.2.3 4.1 2 .2-.4z"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st723",
    d: "m250.4 143.2-4.1-2-.2.4 4.1 2 .2-.4z"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st723",
    d: "m250.5 143-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st724",
    d: "m250.6 142.8-4.1-2-.2.3 4.1 2 .2-.3z"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st724",
    d: "m250.7 142.5-4.1-2-.2.4 4.1 2 .2-.4z"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st725",
    d: "m250.8 142.3-4.1-2-.2.4 4.1 2 .2-.4z"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st725",
    d: "m250.9 142.1-4.1-2-.1.3 4 2 .2-.3z"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st726",
    d: "m251 141.8-4.1-1.9-.1.3 4 2 .2-.4z"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st726",
    d: "m251.1 141.6-4.1-2-.1.4 4 1.9.2-.3z"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st727",
    d: "m251.2 141.3-4.1-1.9-.1.3 4 2 .2-.4z"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st727",
    d: "m251.3 141.1-4.1-2-.1.4 4 2 .2-.4z"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st560",
    d: "m251.4 140.9-4.1-2-.1.4 4 1.9.2-.3z"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st560",
    d: "m251.5 140.7-4.1-2-.1.3 4 2 .2-.3z"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st558",
    d: "m251.6 140.4-4.1-2-.1.4 4 2 .2-.4z"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st558",
    d: "m251.7 140.2-4.1-2-.1.4 4 1.9.2-.3z"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st728",
    d: "m251.8 139.9-4.1-1.9-.1.3 4 2 .2-.4z"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st728",
    d: "m251.8 139.7-4-1.9-.1.3 4 2 .1-.4z"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st729",
    d: "m252 139.5-4.1-2-.1.4 4 1.9.2-.3z"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st729",
    d: "m252 139.2-4-1.9-.1.3 4 2 .1-.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f0ac2b"
    },
    d: "m252.1 139-4-2-.1.4 4 1.9.1-.3z"
  }), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st731",
    d: "m252.2 138.8-4-2-.1.3 4 2 .1-.3z"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st731",
    d: "m252.3 138.5-4-1.9-.2.3 4.1 2 .1-.4z"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st731",
    d: "m252.4 138.3-4-2-.2.4 4.1 1.9.1-.3z"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st732",
    d: "m252.5 138-4-1.9-.2.3 4.1 2 .1-.4z"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st732",
    d: "m252.6 137.8-4-1.9-.2.3 4.1 2 .1-.4z"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st733",
    d: "m252.7 137.6-4-2-.2.4 4 1.9.2-.3z"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st733",
    d: "m252.8 137.3-4-1.9-.2.3 4 2 .2-.4z"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st734",
    d: "m252.8 137.1-3.9-2-.2.4 4 1.9.1-.3z"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st734",
    d: "m252.9 136.9-4-2-.1.4 4 1.9.1-.3z"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st734",
    d: "m253 136.6-4-1.9-.1.3 4 2 .1-.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1b42c"
    },
    d: "m253.1 136.4-4-2-.1.4 4 1.9.1-.3z"
  }), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st736",
    d: "m253.2 136.1-4-1.9-.1.4 4 1.9.1-.4z"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st736",
    d: "m253.3 135.9-4-1.9-.1.3 4 1.9.1-.3z"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st736",
    d: "m253.4 135.7-4-2-.1.4 3.9 1.9.2-.3z"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st737",
    d: "m253.5 135.4-4-1.9-.2.3 4 2 .2-.4z"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st737",
    d: "m253.5 135.2-3.9-2-.2.4 4 1.9.1-.3z"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st738",
    d: "m253.6 134.9-3.9-1.9-.2.4 4 1.9.1-.4z"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st738",
    d: "m253.7 134.7-4-1.9-.1.3 4 1.9.1-.3z"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st738",
    d: "m253.8 134.4-4-1.9-.1.4 4 1.9.1-.4z"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st739",
    d: "m253.9 134.2-4-1.9-.1.4 3.9 1.9.2-.4z"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st739",
    d: "M253.9 133.9 250 132l-.1.4 3.9 1.9.1-.4z"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st740",
    d: "m254 133.7-3.9-1.9-.1.4 3.9 1.9.1-.4z"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st740",
    d: "m254.1 133.5-3.9-1.9-.2.3 4 1.9.1-.3z"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st740",
    d: "m254.2 133.2-3.9-1.9-.2.4 4 1.9.1-.4z"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st741",
    d: "m254.3 133-4-1.9-.1.4 3.9 1.9.2-.4z"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st741",
    d: "m254.3 132.7-3.9-1.9-.1.4 3.9 1.9.1-.4z"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st741",
    d: "m254.4 132.5-3.9-1.9-.1.4 3.9 1.9.1-.4z"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st742",
    d: "m254.5 132.2-3.9-1.9-.1.4 3.9 1.9.1-.4z"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st742",
    d: "m254.6 132-3.9-1.9-.2.4 3.9 1.9.2-.4z"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st742",
    d: "m254.6 131.8-3.8-1.9-.2.3 3.9 1.9.1-.3z"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st742",
    d: "m254.7 131.5-3.9-1.9-.1.4 3.9 1.9.1-.4z"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st743",
    d: "m254.8 131.3-3.9-1.9-.1.4 3.9 1.8.1-.3z"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st743",
    d: "m254.9 131-3.9-1.9-.1.4 3.8 1.9.2-.4z"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st744",
    d: "m254.9 130.8-3.8-1.9-.1.4 3.8 1.8.1-.3z"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st744",
    d: "m255 130.5-3.8-1.8-.2.3 3.9 1.9.1-.4z"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st744",
    d: "m255.1 130.3-3.9-1.9-.1.4 3.9 1.9.1-.4z"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st744",
    d: "m255.2 130-3.9-1.8-.1.3 3.8 1.9.2-.4z"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st744",
    d: "m255.2 129.8-3.8-1.9-.1.4 3.8 1.9.1-.4z"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st744",
    d: "m255.3 129.5-3.8-1.8-.2.3 3.9 1.9.1-.4z"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st745",
    d: "m255.4 129.3-3.9-1.9-.1.4 3.9 1.9.1-.4z"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st745",
    d: "m255.4 129-3.8-1.8-.1.4 3.8 1.8.1-.4z"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st745",
    d: "m255.5 128.8-3.8-1.9-.1.4 3.8 1.9.1-.4z"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st745",
    d: "m255.6 128.5-3.8-1.8-.1.3 3.8 1.9.1-.4z"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st745",
    d: "m255.6 128.3-3.8-1.8-.1.3 3.8 1.9.1-.4z"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st745",
    d: "m255.7 128.1-3.8-1.9-.1.4 3.8 1.8.1-.3z"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st745",
    d: "m255.8 127.8-3.8-1.9-.1.4 3.8 1.9.1-.4z"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st745",
    d: "m255.8 127.5-3.8-1.8-.1.4 3.8 1.8.1-.4z"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st745",
    d: "m255.9 127.3-3.8-1.8-.1.3 3.8 1.9.1-.4z"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st745",
    d: "m252.1 125.6 3.8 1.8c1.6-6.2 2.7-12.6 3.2-19.5l-1.1-.4c-.6-.3-1.3-.2-1.9.1-.6.4-.9.9-1 1.6-.2 3.2-.9 8.9-3 16.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m238.2 166.5 5.9 3.2c.2-1.1.5-2 .9-2.6l1.4.4-7.3-3.2c-.4.5-.7 1.3-.9 2.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#31568c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.2 166.9 5.9 3.2c0-.2.1-.4.1-.7l-5.9-3.2c-.1.3-.1.5-.1.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#32578c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.1 167.4 5.9 3.2c0-.2.1-.4.1-.7l-5.9-3.2c0 .2-.1.5-.1.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#33578e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238 167.8 6 3.2c0-.2 0-.4.1-.7l-5.9-3.2c-.1.3-.1.5-.2.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#34598e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238 168.3 6 3.2c0-.2 0-.5.1-.7l-6-3.2c-.1.2-.1.4-.1.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#355b90"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238 168.7 6 3.2v-.7l-6-3.2v.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#365b90"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.9 169.2 6 3.2v-.7l-6-3.2c.1.2 0 .5 0 .7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#375d92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.9 169.6 6 3.2v-.7l-6-3.2v.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#385e93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.9 170.1 6 3.2v-.7l-6-3.2v.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#395e93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.9 170.6 6 3.2v-.7l-6-3.2v.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3a6095"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.9 171.1 6 3.2v-.7l-6-3.2v.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3b6095"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.9 171.5 6 3.2v-.7l-6-3.2v.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3c6297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.9 172 6 3.3v-.7l-6-3.3v.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3d6497"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.9 172.5 6 3.3v-.7l-6-3.2v.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3e6599"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.9 173 6 3.3v-.7l-6-3.3v.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3f659a"
    }
  }), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st761",
    d: "m237.9 173.4 6 3.3v-.7l-6-3.3v.7z"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st761",
    d: "m238 173.9 6 3.3v-.7l-6-3.3c-.1.3-.1.5 0 .7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m238 174.4 6 3.3c0-.2 0-.4-.1-.7l-6-3.3c.1.3.1.5.1.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#42699c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238 174.9 6 3.3v-.1s0-.3-.1-.7l-6-3.3c.1.4.1.6.1.8z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#43699d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.1 175.4 6 3.3v-.7l-6-3.3v.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#446b9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.1 175.9 6 3.2v-.7l-6-3.3V175.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#456c9f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238 176.3 6 3.2c0-.2.1-.5.1-.7l-6-3.2c0 .3 0 .5-.1.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#466ea1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238 176.8 5.9 3.2c0-.2.1-.4.1-.7l-6-3.2v.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#476ea2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.9 177.2 5.9 3.2c.1-.2.1-.4.1-.6l-6-3.2c.1.2 0 .4 0 .6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4970a2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.8 177.6 5.9 3.2c.1-.2.1-.4.2-.6L238 177c-.1.2-.2.4-.2.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4970a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.7 178 5.9 3.2c.1-.2.1-.4.2-.6l-5.9-3.2c-.1.2-.2.4-.2.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4a72a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.5 178.4 5.9 3.2c.1-.2.1-.4.2-.6l-5.9-3.2c0 .2-.1.4-.2.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4b72a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.4 178.8 5.9 3.2c.1-.2.1-.4.2-.6l-5.9-3.2c-.1.2-.1.4-.2.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4d73a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.2 179.2 5.9 3.2c.1-.2.2-.4.2-.6l-5.9-3.2c0 .2-.1.4-.2.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4d75a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.1 179.6 5.9 3.2c.1-.2.2-.4.2-.6l-5.9-3.2c-.1.2-.2.4-.2.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4f77a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.9 180 5.9 3.2c.1-.2.2-.4.2-.6l-5.9-3.2c0 .2-.1.4-.2.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4f77a9"
    }
  }), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st776",
    d: "m236.7 180.3 5.9 3.2.3-.6-5.9-3.2c-.1.3-.2.5-.3.6z"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st776",
    d: "m236.5 180.7 5.9 3.2.3-.6-5.9-3.2c-.1.3-.2.4-.3.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m236.3 181.1 6 3.2.3-.6-5.9-3.2c-.2.2-.3.4-.4.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#537aae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.1 181.5 6 3.2.3-.6-6-3.2-.3.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#547cae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.9 181.8 6 3.2.3-.6-6-3.2c-.1.3-.2.4-.3.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#557cb0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.7 182.2 6 3.2c.1-.2.2-.4.3-.5l-6-3.2c-.1.1-.2.3-.3.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#577eb0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.5 182.5 6 3.2c.1-.2.2-.4.3-.5l-6-3.2c-.1.2-.2.4-.3.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5780b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.3 182.9 6 3.2c.1-.2.2-.4.3-.5l-6-3.2c-.1.1-.2.3-.3.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5980b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.1 183.3 6 3.3c.1-.2.2-.4.3-.5l-6-3.2c-.1 0-.2.2-.3.4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5a80b3"
    }
  }), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st784",
    d: "m234.8 183.6 6 3.3c.1-.2.2-.4.3-.5l-6-3.2c0 .1-.1.2-.3.4z"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st784",
    d: "m234.6 183.9 6 3.3c.1-.2.2-.4.3-.5l-6-3.3c-.1.2-.2.4-.3.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m234.4 184.3 6 3.3c.1-.2.2-.4.3-.5l-6-3.3c-.1.2-.2.3-.3.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5d84b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.2 184.6 6 3.3c.1-.2.2-.4.3-.5l-6-3.3c-.1.2-.2.4-.3.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5f85b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.9 185 6.1 3.3c.1-.2.2-.4.3-.5l-6-3.3c-.1.1-.3.3-.4.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5f87b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.7 185.3 6.1 3.3c.1-.2.2-.3.3-.5l-6.1-3.3c-.1.2-.2.4-.3.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6189b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.4 185.7 6.1 3.3c.1-.2.2-.3.3-.5l-6.1-3.3c0 .1-.1.3-.3.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#628abb"
    }
  }), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st790",
    d: "m233.2 186 6.1 3.3.3-.5-6.1-3.3c-.1.2-.2.3-.3.5z"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st791",
    d: "m232.9 186.4 6.1 3.3.4-.5-6.1-3.3c-.1.1-.2.3-.4.5z"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st791",
    d: "m232.7 186.7 6.1 3.3c.1-.2.2-.3.4-.5l-6.1-3.3-.4.5z"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st792",
    d: "m232.4 187 6.1 3.3.4-.5-6.1-3.3c-.1.2-.2.4-.4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#688ebf"
    },
    d: "m232.2 187.4 6.1 3.3.4-.5-6.1-3.3-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6a91c1"
    },
    d: "m231.9 187.7 6.2 3.3.4-.5-6.2-3.3-.4.5z"
  }), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st795",
    d: "m231.7 188 6.1 3.4.4-.5-6.1-3.4-.4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6c93c3"
    },
    d: "m231.4 188.4 6.2 3.3.4-.5-6.2-3.3-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6d93c5"
    },
    d: "m231.1 188.7 6.3 3.4.3-.6-6.2-3.3-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6e95c5"
    },
    d: "m230.9 189 6.2 3.4.4-.5-6.2-3.4-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7095c7"
    },
    d: "m230.6 189.4 6.3 3.3.3-.5-6.2-3.3-.4.5z"
  }), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st800",
    d: "m230.3 189.7 6.3 3.4.4-.5-6.3-3.4-.4.5z"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st801",
    d: "m230.1 190 6.2 3.4.4-.5-6.2-3.4-.4.5z"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st802",
    d: "m229.8 190.3 6.3 3.4.4-.5-6.3-3.4-.4.5z"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st802",
    d: "m229.5 190.7 6.3 3.4.4-.5-6.3-3.4-.4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#769dcd"
    },
    d: "m229.3 191 6.3 3.4.4-.5-6.3-3.4-.4.5z"
  }), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st804",
    d: "m229 191.3 6.3 3.4.4-.5-6.3-3.4-.4.5z"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st805",
    d: "m228.7 191.6 6.4 3.5.3-.5-6.3-3.5-.4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#79a0cf"
    },
    d: "m228.4 192 6.4 3.4.4-.5-6.4-3.4-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7aa0d1"
    },
    d: "m228.2 192.3 6.3 3.4.4-.5-6.3-3.4-.4.5z"
  }), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st808",
    d: "m227.9 192.6 6.4 3.5.4-.5-6.4-3.5-.4.5z"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st809",
    d: "m227.6 192.9 6.4 3.5.4-.5-6.4-3.5-.4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7fa4d4"
    },
    d: "m227.3 193.2 6.4 3.5.4-.5-6.4-3.4-.4.4z"
  }), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st811",
    d: "m227 193.6 6.5 3.5.4-.5-6.5-3.5-.4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#80a7d7"
    },
    d: "m226.7 193.9 6.5 3.5.4-.5-6.4-3.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#82a8d7"
    },
    d: "m226.4 194.2 6.5 3.5.4-.5-6.4-3.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#82aad7"
    },
    d: "m226.2 194.5 6.5 3.5.4-.5-6.5-3.5-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#83aad9"
    },
    d: "m225.9 194.8 6.5 3.6.4-.5-6.5-3.5-.4.4z"
  }), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st816",
    d: "m225.6 195.1 6.5 3.6.4-.5-6.5-3.5-.4.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#87aeda"
    },
    d: "m225.3 195.5 6.6 3.5.4-.5-6.6-3.5-.4.5z"
  }), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st818",
    d: "m225 195.8 6.6 3.6.4-.5-6.6-3.6-.4.5z"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st819",
    d: "m224.7 196.1 6.6 3.6.4-.5-6.6-3.6-.4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8ab2df"
    },
    d: "m224.4 196.4 6.6 3.6.5-.5-6.6-3.6-.5.5z"
  }), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st821",
    d: "m224.1 196.7 6.7 3.6.4-.5-6.6-3.5-.5.4z"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st822",
    d: "m223.8 197 6.7 3.7.4-.5-6.6-3.6-.5.4z"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st822",
    d: "m223.5 197.4 6.7 3.6.4-.5-6.6-3.6-.5.5z"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st823",
    d: "m223.2 197.7 6.7 3.6.5-.5-6.7-3.6-.5.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#90b7e4"
    },
    d: "m222.9 198 6.8 3.6.4-.5-6.7-3.6-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#93b9e4"
    },
    d: "m222.6 198.3 6.8 3.6.4-.4-6.7-3.7-.5.5z"
  }), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st826",
    d: "m222.3 198.6 6.8 3.7.4-.5-6.7-3.7-.5.5z"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st827",
    d: "m222 198.9 6.8 3.7.4-.5-6.7-3.7-.5.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#97bce9"
    },
    d: "m221.7 199.2 6.9 3.7.4-.5-6.8-3.7-.5.5z"
  }), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st829",
    d: "m221.4 199.5 6.9 3.7.4-.5-6.8-3.6-.5.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#99beea"
    },
    d: "m221.1 199.8 6.9 3.7.4-.4-6.8-3.7-.5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9ac0ec"
    },
    d: "m220.8 200.1 6.9 3.8.4-.5-6.8-3.7-.5.4z"
  }), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st832",
    d: "m220.5 200.4 6.9 3.8.4-.5-6.8-3.7-.5.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9cc3ef"
    },
    d: "m220.2 200.8 7 3.7.4-.5-6.9-3.7-.5.5z"
  }), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st834",
    d: "m219.9 201.1 7 3.7.4-.4-6.9-3.8-.5.5z"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st835",
    d: "m219.6 201.4 7 3.8.4-.5-7-3.8-.4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a1c6f1"
    },
    d: "m219.3 201.7 7 3.8.4-.5-7-3.8-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a3c8f2"
    },
    d: "m219 202 7 3.8.4-.5-7-3.8-.4.5z"
  }), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st838",
    d: "m218.7 202.3 7 3.8.5-.5-7.1-3.8-.4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a5c9f5"
    },
    d: "m218.3 202.6 7.1 3.8.5-.4-7.1-3.9-.5.5z"
  }), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st840",
    d: "m218 202.9 7.2 3.8.4-.4-7.1-3.9-.5.5z"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st841",
    d: "m217.7 203.2 7.2 3.9.4-.5-7.1-3.9-.5.5z"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st841",
    d: "m217.4 203.5 7.2 3.9.4-.5-7.1-3.9-.5.5z"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st842",
    d: "m217.1 203.8 7.2 3.9.4-.5-7.1-3.9-.5.5z"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st842",
    d: "m216.8 204.1 7.2 3.9.4-.5-7.1-3.9-.5.5z"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st842",
    d: "m216.5 204.4 7.2 3.9.5-.4-7.3-3.9-.4.4z"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st843",
    d: "m216.1 204.7 7.3 4 .5-.5-7.3-3.9-.5.4z"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st843",
    d: "m215.8 205 7.4 4 .4-.5-7.3-3.9-.5.4z"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st843",
    d: "m215.5 205.3 7.4 4 .4-.5-7.3-3.9-.5.4z"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st843",
    d: "m215.2 205.6 7.4 4 .4-.5-7.3-3.9-.5.4z"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st844",
    d: "m214.9 205.9 7.4 4 .4-.4-7.4-4-.4.4z"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st844",
    d: "m214.5 206.2 7.5 4.1.4-.5-7.4-4-.5.4z"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st844",
    d: "m214.2 206.5 7.5 4.1.5-.5-7.5-4-.5.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.2 206.6c.1.2.2.4.4.6l6.9 3.7.4-.5-7.5-4.1-.2.3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#adcef5"
    }
  }), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st846",
    d: "m215 207.9 6.2 3.3.4-.5-7.3-3.9c.3.4.5.7.7 1.1z"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st847",
    d: "m215.4 208.6 5.5 2.9.4-.5-6.5-3.5c.2.4.4.7.6 1.1z"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st847",
    d: "m215.9 209.3 4.7 2.6c.1-.2.3-.3.4-.5l-5.8-3.2c.2.4.4.7.7 1.1z"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st848",
    d: "m216.3 210 4 2.1c.1-.1.3-.3.4-.5l-5.1-2.7c.3.4.5.8.7 1.1z"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st848",
    d: "m216.9 210.8 3.2 1.7c.1-.1.3-.3.4-.5l-4.4-2.4c.3.4.5.8.8 1.2z"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st226",
    d: "m217.6 211.7 2.2 1.2c.1-.1.2-.3.4-.5l-3.6-1.9c.3.4.7.8 1 1.2z"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st226",
    d: "m218.8 212.8.7.4c.1-.1.2-.3.4-.5l-2.7-1.5c.5.6 1 1.1 1.6 1.6z"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st226",
    d: "m219.4 213.2.1.1s0-.1.1-.3l-1.5-.8c.4.3.8.7 1.3 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m242.4 218.6-3.7 3.3c1.4-.9 2.6-2 3.7-3.3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6189bb"
    }
  }), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st790",
    d: "m243.4 217.4-5.8 5.3c.9-.5 1.8-1.1 2.6-1.8l1.1-1c.7-.8 1.4-1.6 2.1-2.5z"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st791",
    d: "m244.1 216.3-7.5 6.8c.5-.3 1-.5 1.5-.8l4.9-4.5c.4-.4.8-.9 1.1-1.5z"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st792",
    d: "m244.7 215.5-8.7 7.9h.1c.3-.1.6-.3.9-.4l6.8-6.2c.3-.4.6-.9.9-1.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m245.2 214.7-1.8 1.6c-1.2 1.4-2.5 2.6-4 3.7l-3.7 3.4c.2.1.3.1.3.1l.1-.1 8.2-7.5c.4-.4.7-.8.9-1.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6990c1"
    }
  }), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st795",
    d: "M245.7 213.9c-.2.4-.4.8-.7 1.1l-2.3 2.1c.6-.7 1.2-1.4 1.7-2.1l1.3-1.1zm-7.5 6.8c.7-.4 1.4-.9 2.1-1.3l-4.4 4c-.1 0-.2-.1-.4-.2l2.7-2.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246 213.3c-.2.4-.4.7-.6 1.1l-1.4 1.3c.4-.5.8-1 1.1-1.6l.9-.8zm-8.7 7.9c.5-.2 1-.5 1.4-.8l-3.1 2.9-.4-.2 2.1-1.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6c93c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4 212.6c-.2.3-.4.7-.6 1l-1 1c.3-.4.6-.9.9-1.3l.7-.7zm-9.6 8.7.2.1c.3-.1.5-.3.8-.4l-2.4 2.2-.4-.2 1.8-1.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6f95c5"
    }
  }), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st800",
    d: "M246.7 211.9c-.2.3-.3.7-.5 1l-.8.7c.3-.4.5-.8.8-1.2l.5-.5zm-10.2 9.3c.3.1.4.2.4.2l-1.9 1.7-.4-.2 1.9-1.7z"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st801",
    d: "M247 211.3c-.2.3-.3.6-.5.9l-.6.6c.2-.4.4-.7.6-1.1l.5-.4zm-10.7 9.8c.2.1.3.1.4.2l-1.9 1.7-.4-.2 1.9-1.7z"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st802",
    d: "M247.3 210.7c-.1.3-.3.6-.4.9l-.5.5c.2-.3.4-.7.6-1l.3-.4zM236 221l.4.1-1.8 1.7-.4-.2 1.8-1.6z"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st804",
    d: "M247.6 210.1c-.1.3-.3.6-.4.9l-.4.4c.2-.3.4-.7.5-1l.3-.3zm-11.9 10.8.4.2-1.8 1.7-.4-.2 1.8-1.7z"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st805",
    d: "M247.9 209.5c-.1.3-.3.6-.4.9l-.3.3c.2-.3.3-.7.5-1l.2-.2zm-12.4 11.3.4.2-1.8 1.7-.4-.2 1.8-1.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.1 208.9c-.1.3-.3.6-.4.9l-.3.3c.2-.3.3-.6.5-1l.2-.2zm-12.9 11.8.4.2-1.8 1.7-.4-.2 1.8-1.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7aa0cf"
    }
  }), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st808",
    d: "M248.4 208.4c-.1.3-.3.6-.4.9l-.2.2c.2-.3.3-.6.5-.9l.1-.2zM235 220.6l.4.2-1.8 1.7-.4-.2 1.8-1.7z"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st809",
    d: "M248.6 207.8c-.1.3-.2.6-.4.9l-.2.2c.1-.3.3-.6.4-.9l.2-.2zm-13.9 12.7.4.2-1.8 1.7-.4-.2 1.8-1.7z"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st811",
    d: "M248.8 207.3c-.1.3-.2.5-.3.8l-.1.1c.1-.3.2-.6.4-.9zm-14.3 13.1.4.2-1.8 1.7-.4-.2 1.8-1.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.1 206.6c-.1.3-.2.6-.4.8l-.1.1c.2-.2.3-.5.5-.9zm-14.9 13.6.4.2-1.8 1.7-.4-.2 1.8-1.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#80a8d7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.3 206.1c-.1.3-.2.6-.3.8l-.1.1c.1-.3.2-.6.4-.9zm-15.4 14 .4.2-1.8 1.7-.4-.2 1.8-1.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#82aad9"
    }
  }), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st816",
    d: "m249.5 205.5-.3.8h-.1c.2-.2.3-.5.4-.8zM233.7 220l.4.2-1.8 1.6-.4-.2 1.8-1.6z"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st818",
    d: "m249.7 205-.3.8c.1-.2.2-.5.3-.8zm-16.3 14.9.4.2-1.8 1.6-.4-.2 1.8-1.6z"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st819",
    d: "m233.2 219.8.4.2-1.8 1.6-.4-.2 1.8-1.6zm16.4-14.5.3-.7-.3.7z"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st821",
    d: "m232.9 219.7.4.2-1.8 1.6-.4-.2 1.8-1.6zm17-15v-.1.1z"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st822",
    d: "m232.7 219.5-1.8 1.7.4.1 1.7-1.6-.3-.2z"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st823",
    d: "m232.4 219.4-1.7 1.6.3.2 1.8-1.6-.4-.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#91b7e4"
    },
    d: "m232.2 219.3-1.8 1.6.4.2 1.8-1.6-.4-.2z"
  }), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st826",
    d: "m231.9 219.2-1.7 1.6.3.2 1.8-1.6-.4-.2z"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st827",
    d: "m231.7 219.1-1.8 1.6.4.2 1.8-1.7-.4-.1z"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st829",
    d: "m231.5 218.9-1.8 1.6.4.2 1.7-1.6-.3-.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9ac0ea"
    },
    d: "m231.2 218.8-1.7 1.6.3.2 1.8-1.6-.4-.2z"
  }), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st832",
    d: "m231 218.7-1.8 1.6.4.2 1.7-1.6-.3-.2z"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st834",
    d: "m230.7 218.6-1.7 1.6.3.2 1.8-1.7-.4-.1z"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st835",
    d: "m230.5 218.4-1.8 1.6.4.2 1.7-1.6-.3-.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a1c8f1"
    },
    d: "m230.2 218.3-1.7 1.6.4.2 1.7-1.6-.4-.2z"
  }), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st838",
    d: "m230 218.2-1.7 1.6.3.2 1.8-1.6-.4-.2z"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st840",
    d: "m229.8 218.1-1.8 1.5.4.2 1.7-1.6-.3-.1z"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st841",
    d: "m229.5 217.9-1.7 1.6.3.2 1.8-1.6-.4-.2z"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st841",
    d: "m229.3 217.8-1.7 1.6.3.2 1.8-1.6-.4-.2z"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st841",
    d: "m229.1 217.7-1.8 1.5.4.2 1.7-1.5-.3-.2z"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st842",
    d: "m228.8 217.5-1.7 1.6.4.2 1.7-1.6-.4-.2z"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st842",
    d: "m228.6 217.4-1.7 1.6.3.2 1.7-1.6-.3-.2z"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st842",
    d: "m228.4 217.3-1.7 1.5.3.2 1.7-1.5-.3-.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a8cef5"
    },
    d: "m228.1 217.1-1.7 1.6.4.2 1.7-1.6-.4-.2z"
  }), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st843",
    d: "m227.9 217-1.7 1.5.3.2 1.7-1.5-.3-.2z"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st843",
    d: "m227.7 216.8-1.7 1.6.3.2 1.7-1.5-.3-.3z"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st843",
    d: "m227.5 216.7-1.7 1.6.3.2 1.7-1.6-.3-.2z"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st843",
    d: "m227.2 216.6-1.7 1.5.4.2 1.7-1.5-.4-.2z"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st844",
    d: "m227 216.4-1.7 1.6.4.2 1.7-1.6-.4-.2z"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st844",
    d: "m226.8 216.3-1.7 1.5.3.2 1.7-1.5-.3-.2z"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st844",
    d: "m226.6 216.1-1.7 1.6.3.2 1.7-1.6-.3-.2z"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st844",
    d: "m226.3 216-1.6 1.5.3.2 1.7-1.5-.4-.2z"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st844",
    d: "m226.1 215.8-1.7 1.6.4.2 1.7-1.5-.4-.3z"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st846",
    d: "m225.9 215.7-1.7 1.5.4.3 1.6-1.6-.3-.2z"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st846",
    d: "m225.7 215.6-1.7 1.5.3.2 1.7-1.5-.3-.2z"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st847",
    d: "m225.5 215.4-1.7 1.5.3.3 1.7-1.6-.3-.2z"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st847",
    d: "m225.3 215.3-1.7 1.5.3.2 1.7-1.5-.3-.2z"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st847",
    d: "m225 215.1-1.6 1.5.3.2 1.6-1.5-.3-.2z"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st848",
    d: "m224.8 214.9-1.6 1.5.3.3 1.7-1.5-.4-.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#b0d1f5"
    },
    d: "m224.6 214.8-1.6 1.5.3.2 1.6-1.5-.3-.2z"
  }), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st226",
    d: "m224.4 214.6-1.6 1.5.3.3 1.6-1.5-.3-.3z"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st226",
    d: "m224.2 214.5-1.6 1.5.3.2 1.6-1.5-.3-.2z"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st226",
    d: "m224 214.3-1.6 1.5.3.3 1.6-1.5-.3-.3z"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st196",
    d: "m223.8 214.2-1.6 1.5.2.2 1.7-1.5-.3-.2z"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st196",
    d: "m223.6 214-1.6 1.5.2.2 1.7-1.4-.3-.3z"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st196",
    d: "m223.4 213.9-1.6 1.4.3.3 1.6-1.5-.3-.2z"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st196",
    d: "m223.2 213.7-1.6 1.5.3.2 1.6-1.5-.3-.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#b2d4f7"
    },
    d: "m223 213.5-1.6 1.5.3.3 1.6-1.5-.3-.3z"
  }), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st195",
    d: "m222.8 213.4-1.6 1.5.3.3 1.6-1.5-.3-.3z"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st195",
    d: "m222.6 213.2-1.6 1.5.3.2 1.6-1.4-.3-.3z"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st195",
    d: "m222.4 213.1-1.6 1.4.3.2 1.6-1.4-.3-.2z"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st195",
    d: "m222.2 212.9-1.6 1.4.3.3 1.6-1.5-.3-.2z"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st714",
    d: "m222 212.7-1.6 1.5.3.2 1.6-1.4-.3-.3z"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st714",
    d: "m221.8 212.5-1.6 1.5.3.2 1.6-1.4-.3-.3z"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st713",
    d: "m221.6 212.4-1.6 1.4.3.3 1.6-1.4c-.1-.2-.2-.3-.3-.3z"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st713",
    d: "m221.4 212.2-1.5 1.4.2.3 1.6-1.4-.3-.3z"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st713",
    d: "m221.2 212-1.5 1.4.2.3 1.6-1.4-.3-.3z"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st194",
    d: "m221 211.8-1.5 1.4v.1l.2.2 1.6-1.4-.3-.3z"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st194",
    d: "m220.9 211.7-.4.4c-.5.6-.8 1-.9 1.2l.1.1 1.5-1.4-.3-.3z"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    className: "coming-soon_svg__st712",
    d: "m219.8 212.8 1.1-1-.1-.1c-.4.4-.8.8-1 1.1z"
  })));
};

export { SvgComingSoon as ReactComponent };
export default __webpack_public_path__ + "9db451b8d08b224da675cfc575a5f778.svg";